import Gd from "pica";
const Ar = {
  background: "#ffffff",
  primary: "",
  titles: "#503e3e",
  accent: "#ff0054",
  subtitle: "#d7b146"
}, Jd = {
  primary: Ar.accent,
  accent: "#000000",
  background: Ar.background,
  titles: "",
  subtitle: Ar.subtitle
}, Yd = "id", Am = 8, Kd = {
  defs: !0,
  style: !0,
  feOffset: !0,
  feGaussianBlur: !0,
  feFlood: !0,
  feComposite: !0,
  filter: !0
}, Xd = "http://www.w3.org/2000/svg", Mh = typeof window < "u" && window.innerWidth >= 1200 && window.innerWidth < 1400, Dh = 200, jh = 300;
var na = /* @__PURE__ */ ((r) => (r.QRCode = "qrcode", r.PLV = "plv", r.Online = "online", r))(na || {});
const $d = (r, t, e = 1, n = !1) => {
  const { x: i, y: s, width: c, height: o } = r;
  let l = o;
  s < 0 ? l = l + s : s > t ? l = s - t : l = l;
  const f = l * e, d = c * e, b = n ? i : i + c / 2 - d / 2, _ = Math.max(0, s) + Math.min(o, s + o) / 2 - f / 2;
  return {
    visibleHeight: l,
    x: b,
    y: _,
    width: d,
    height: f
  };
};
async function Zd(r) {
  return new Promise((t) => {
    const e = new FileReader();
    e.onload = () => t(e.result), e.readAsDataURL(r);
  });
}
const pc = 800, Ll = 36e6;
async function Qd(r, t, e) {
  try {
    const n = Gd(), i = await createImageBitmap(r), s = i.width, c = i.height;
    let o = s, l = c;
    if (t !== void 0 && e !== void 0 ? (o = t, l = e) : t !== void 0 ? (o = t, l = Math.floor(c * t / s)) : e !== void 0 ? (l = e, o = Math.floor(s * e / c)) : s > pc && (o = pc, l = Math.floor(c * pc / s)), o * l > Ll) {
      const y = Math.sqrt(
        Ll / (o * l)
      );
      o = Math.floor(o * y), l = Math.floor(l * y);
    }
    const f = document.createElement("canvas");
    f.width = s, f.height = c, f.getContext("2d").drawImage(i, 0, 0), i.close();
    const b = document.createElement("canvas");
    b.width = o, b.height = l, await n.resize(f, b, {});
    const _ = await new Promise((y, x) => {
      b.toBlob(
        (E) => E ? y(E) : x(new Error("Failed to create blob")),
        "image/png"
      );
    });
    return { base64: await Zd(_), sizeInBytes: _.size, mimeType: r.type };
  } catch (n) {
    return console.error("Error resizing image:", n), null;
  }
}
async function t2(r) {
  try {
    const t = await fetch(r);
    if (!t.ok)
      return "";
    const e = await t.blob(), n = await Qd(e);
    return n ? n.base64 : "";
  } catch (t) {
    throw new Error(`Failed to convert image to base64: ${t}`);
  }
}
const e2 = async (r, t, e, n, i, s, c) => {
  const o = document.createElementNS(
    "http://www.w3.org/2000/svg",
    "image"
  ), l = s ?? t, f = c ?? e;
  let d;
  return typeof r == "function" ? d = await r(l, f) : d = await t2(r), o.setAttribute("id", Yd), o.setAttribute("href", d), o.setAttribute("transform", `translate(${n} ${i})`), o.setAttribute("width", `${t}`), o.setAttribute("height", `${e}`), o;
}, r2 = async (r, t, e = 1, n = !1) => {
  if (!t)
    return;
  const i = t.querySelector(
    "#logo-container"
  );
  if (!i)
    return;
  const s = t.getBBox().height, c = i.getBBox();
  if (c.width === 0)
    return;
  const { x: o, y: l, width: f, height: d } = $d(
    c,
    s,
    e,
    n
  );
  if (!i)
    return;
  const b = i.getBoundingClientRect(), _ = b.width > 0 ? b.width / c.width : 1, g = b.height > 0 ? b.height / c.height : 1;
  for (let x = 0; x < i.children.length; x++) {
    const E = i.children[x];
    E instanceof SVGElement && E.setAttribute("opacity", "0");
  }
  const y = await e2(
    r,
    f,
    d,
    o,
    l,
    f * _,
    d * g
  );
  y.id = "logo-svg", i.setAttribute("stroke", "transparent"), i.setAttribute("stroke-width", "0px"), i.setAttribute("fill", "none"), i.appendChild(y);
};
function n2(r) {
  const t = r.getBBox(), e = t.width, n = t.height;
  return {
    width: e,
    height: n,
    x: t.x + (t.width - e) / 2,
    y: t.y + (t.height - n) / 2,
    transform: r?.getAttribute("transform") || ""
  };
}
function i2(r) {
  const t = document.createElementNS(Xd, "image");
  return t.setAttribute("id", "qr-code-img"), t.setAttribute("class", "qr-code-img"), t.setAttribute("href", r.qrCodeURL), t.setAttribute("x", `${r.x}`), t.setAttribute("y", `${r.y}`), t.width.baseVal.value = r.width, t.height.baseVal.value = r.height, t;
}
function s2(r, t, e) {
  if (!e)
    return;
  const n = e.querySelector(
    "#qrcode"
  );
  if (!n)
    return;
  const i = {
    qrCodeURL: t,
    ...n2(n)
  };
  Array.from(n.children).forEach((c) => {
    c instanceof SVGElement && (r.posa?.flags?.qrCodeNoBg ? c.setAttribute("fill", "#0000") : c.setAttribute("fill", "white"));
  });
  const s = i2(i);
  s.id = "qr-code-img", n.appendChild(s);
}
function a2(r, t) {
  if (r.shortId?.toLowerCase() === "paris" && r.format !== "stickers10x10" && r.format !== "stickers_dome") {
    let e = t.querySelector("style");
    e || (e = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "style"
    ), t.appendChild(e)), e.textContent += "#qr-code-img, .qr-code-img { transform: rotate(-14.5deg); transform-origin: center; transform-box: fill-box; }";
  }
}
function o2(r, t = 40) {
  if (!r)
    return "#000";
  const e = r.replace(/^#/, ""), n = parseInt(e.slice(0, 2), 16), i = parseInt(e.slice(2, 4), 16), s = parseInt(e.slice(4, 6), 16), c = t / 100, o = n + (255 - n) * c, l = i + (255 - i) * c, f = s + (255 - s) * c;
  return "#" + [o, l, f].map((d) => Math.round(d).toString(16).padStart(2, "0")).join("");
}
function qh(r, t, e, n) {
  if (n && console.log("visitSVGChildRecursive", r), r.id === "title") {
    lu(r, e.accent || Ar.accent);
    return;
  }
  if (r.id === "background") {
    r.setAttribute(
      "fill",
      e.background || Ar.background
    );
    for (let s = 0; s < r.children.length; s++) {
      const c = r.children[s];
      c.tagName === "circle" && c.removeAttribute("fill");
    }
    return;
  }
  if (r.id === "EFFECTS") {
    lu(
      r,
      e.background || Ar.background
    );
    return;
  }
  for (let s = 0; s < r.children.length; s++) {
    const c = r.children[s];
    qh(c, t, e);
  }
  if (r.id || Kd[r.tagName])
    return;
  let i = r.getAttribute("fill");
  if (i || (r.setAttribute("fill", "black"), i = "black"), t.flags?.colorWhiteAsBackground)
    switch (i?.toLowerCase()) {
      case "white":
      case "#fff":
      case "#ffff":
      case "#ffffff":
      case "#ffffffff":
        n && console.log(
          "visitSVGChildRecursive",
          r,
          e.accent || Ar.background
        ), r.setAttribute(
          "fill",
          e.background || Ar.background
        );
        break;
    }
  switch (i.toLowerCase()) {
    case "black":
    case "#000000":
    case "#000":
      n && console.log(
        "visitSVGChildRecursive",
        r,
        e.accent || Ar.accent
      ), r.setAttribute("fill", e.accent || Ar.accent);
      break;
    case "#fc0353":
    case "#fe0154":
    case "#ff0057":
    case "#ff0054":
    case "#212529":
    case "#423233":
      n && console.log(
        "visitSVGChildRecursive",
        r,
        e.primary || Ar.primary
      ), r.setAttribute("fill", e.primary || Ar.primary);
      break;
    case "#fc96b9":
    case "#ff9abc":
      n && console.log(
        "visitSVGChildRecursive",
        r,
        e.primary || Ar.accent
      ), r.setAttribute(
        "fill",
        o2(e.primary || Ar.accent)
      );
      break;
    case "#d7b146":
      n && console.log(
        "visitSVGChildRecursive",
        r,
        e.subtitle || Ar.subtitle
      ), r.setAttribute(
        "fill",
        e.subtitle || Ar.subtitle
      );
      break;
  }
}
function lu(r, t) {
  if (r.setAttribute("fill", t), !!r.children.length)
    for (let e = 0; e < r.children.length; e++) {
      const n = r.children[e];
      lu(n, t);
    }
}
function c2(r, t, e, n) {
  for (let i = 0; i < e.children.length; i++) {
    const s = e.children[i];
    qh(s, r, t, n);
  }
  a2(r, e);
}
function xm(r, t, e, n) {
  const i = Math.min(e / r, n / t);
  return {
    width: Math.floor(r * i),
    height: Math.floor(t * i)
  };
}
const u2 = 150, l2 = 25.4, f2 = u2 / l2;
function h2() {
  return f2;
}
function Cu(r) {
  switch (r) {
    case "poster_a2":
      return [420, 594];
    case "poster_a3":
      return [297, 420];
    case "poster_a4":
      return [210, 297];
    case "businesscardsstandard":
      return [85, 55];
    case "kakemono":
      return [850, 2e3];
    case "chevalet_a5":
    case "flyer_a5":
      return [148, 210];
    case "chevalet_a6":
    case "flyer_a6":
      return [105, 148];
    case "stickers10x10":
      return [100, 100];
    case "stickers_dome":
      return [75, 75];
    case "a_long":
      return [210, 74];
    case "online-ig-story":
      return [1080, 1920];
    case "online-ig-post":
      return [1200, 1200];
    case "table_set":
    case "paper_menu":
    case "delivery_bag":
    case "print_on_packaging":
    case "print_on_bag":
      return [300, 300];
  }
}
function Sl(r) {
  return r ? r?.normalize("NFD").replace(" ", "_").replace(/[\u0300-\u036f]/g, "").replace(/[\s\.']+/g, "").toLowerCase() ?? "" : "";
}
const d2 = (r) => {
  switch (r.place) {
    case na.Online:
      return `${r.jetpackFrontEndURL}/?v=${r.configID}&utm_medium=qrcode&utm_source=social_networks`;
    case na.QRCode:
      return `${r.jetpackFrontEndURL}/?v=${r.configID}&utm_medium=qrcode`;
    case na.PLV:
      if (!r.posa)
        throw new Error("Must provide POSA");
      const t = Sl(r.posa.format), e = Sl(r.posa.shortId);
      let n = "";
      return e && (n += "&utm_campaign=" + e), t && (n += "&utm_source=" + t), `${r.jetpackFrontEndURL}/?v=${r.configID}&utm_medium=qrcode${n}`;
  }
};
function Nm(r) {
  const [t, e] = Cu(r), n = e / t;
  switch (r) {
    case "online-ig-post":
    case "online-ig-story":
    case "stickers10x10":
    case "stickers_dome":
    case "chevalet_a5":
    case "chevalet_a6":
    case "poster_a2":
    case "poster_a3":
    case "poster_a4":
    case "kakemono":
    case "table_set":
    case "paper_menu":
    case "delivery_bag":
    case "print_on_packaging":
    case "print_on_bag":
    case "flyer_a5":
    case "flyer_a6":
    case "a_long":
    case "businesscardsstandard":
      return Math.trunc(Mh ? Dh * n : jh * n);
  }
}
async function Lm(r) {
  const t = await createImageBitmap(r), e = t.width, n = t.height;
  return t.close(), { width: e, height: n };
}
function Sm(r) {
  switch (r) {
    case "online-ig-post":
    case "chevalet_a5":
    case "chevalet_a6":
    case "poster_a2":
    case "poster_a3":
    case "poster_a4":
    case "stickers10x10":
    case "stickers_dome":
    case "kakemono":
    case "table_set":
    case "paper_menu":
    case "delivery_bag":
    case "print_on_packaging":
    case "print_on_bag":
    case "flyer_a5":
    case "flyer_a6":
    case "online-ig-story":
    case "a_long":
    case "businesscardsstandard":
      return Mh ? Dh : jh;
  }
}
function kl(r, t) {
  const n = `${`${r.cdnUrl}/${r.posa.ratio}_${r.posa.shortId.toLowerCase().replaceAll(" ", "")}_${r.language === "fr" ? "fr" : "en"}`}_${r.wording ?? "cadeau"}.svg`;
  return t.log && console.log(
    "build_CDN_Base_URL_for_POSA",
    {
      isCustom: r.posa.isCustom,
      ratio: r.posa.ratio,
      format: r.posa.format,
      language: r.language
    },
    n
  ), n;
}
function xe(r) {
  "@babel/helpers - typeof";
  return xe = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, xe(r);
}
var fn = Uint8Array, Vr = Uint16Array, Ru = Int32Array, Iu = new fn([
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  3,
  4,
  4,
  4,
  4,
  5,
  5,
  5,
  5,
  0,
  /* unused */
  0,
  0,
  /* impossible */
  0
]), Fu = new fn([
  0,
  0,
  0,
  0,
  1,
  1,
  2,
  2,
  3,
  3,
  4,
  4,
  5,
  5,
  6,
  6,
  7,
  7,
  8,
  8,
  9,
  9,
  10,
  10,
  11,
  11,
  12,
  12,
  13,
  13,
  /* unused */
  0,
  0
]), El = new fn([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), Uh = function(r, t) {
  for (var e = new Vr(31), n = 0; n < 31; ++n)
    e[n] = t += 1 << r[n - 1];
  for (var i = new Ru(e[30]), n = 1; n < 30; ++n)
    for (var s = e[n]; s < e[n + 1]; ++s)
      i[s] = s - e[n] << 5 | n;
  return { b: e, r: i };
}, zh = Uh(Iu, 2), p2 = zh.b, fu = zh.r;
p2[28] = 258, fu[258] = 28;
var g2 = Uh(Fu, 0), Pl = g2.r, hu = new Vr(32768);
for (var Oe = 0; Oe < 32768; ++Oe) {
  var ui = (Oe & 43690) >> 1 | (Oe & 21845) << 1;
  ui = (ui & 52428) >> 2 | (ui & 13107) << 2, ui = (ui & 61680) >> 4 | (ui & 3855) << 4, hu[Oe] = ((ui & 65280) >> 8 | (ui & 255) << 8) >> 1;
}
var ia = (function(r, t, e) {
  for (var n = r.length, i = 0, s = new Vr(t); i < n; ++i)
    r[i] && ++s[r[i] - 1];
  var c = new Vr(t);
  for (i = 1; i < t; ++i)
    c[i] = c[i - 1] + s[i - 1] << 1;
  var o;
  if (e) {
    o = new Vr(1 << t);
    var l = 15 - t;
    for (i = 0; i < n; ++i)
      if (r[i])
        for (var f = i << 4 | r[i], d = t - r[i], b = c[r[i] - 1]++ << d, _ = b | (1 << d) - 1; b <= _; ++b)
          o[hu[b] >> l] = f;
  } else
    for (o = new Vr(n), i = 0; i < n; ++i)
      r[i] && (o[i] = hu[c[r[i] - 1]++] >> 15 - r[i]);
  return o;
}), Hi = new fn(288);
for (var Oe = 0; Oe < 144; ++Oe)
  Hi[Oe] = 8;
for (var Oe = 144; Oe < 256; ++Oe)
  Hi[Oe] = 9;
for (var Oe = 256; Oe < 280; ++Oe)
  Hi[Oe] = 7;
for (var Oe = 280; Oe < 288; ++Oe)
  Hi[Oe] = 8;
var xo = new fn(32);
for (var Oe = 0; Oe < 32; ++Oe)
  xo[Oe] = 5;
var m2 = /* @__PURE__ */ ia(Hi, 9, 0), b2 = /* @__PURE__ */ ia(xo, 5, 0), Hh = function(r) {
  return (r + 7) / 8 | 0;
}, w2 = function(r, t, e) {
  return (e == null || e > r.length) && (e = r.length), new fn(r.subarray(t, e));
}, Un = function(r, t, e) {
  e <<= t & 7;
  var n = t / 8 | 0;
  r[n] |= e, r[n + 1] |= e >> 8;
}, $s = function(r, t, e) {
  e <<= t & 7;
  var n = t / 8 | 0;
  r[n] |= e, r[n + 1] |= e >> 8, r[n + 2] |= e >> 16;
}, gc = function(r, t) {
  for (var e = [], n = 0; n < r.length; ++n)
    r[n] && e.push({ s: n, f: r[n] });
  var i = e.length, s = e.slice();
  if (!i)
    return { t: Wh, l: 0 };
  if (i == 1) {
    var c = new fn(e[0].s + 1);
    return c[e[0].s] = 1, { t: c, l: 1 };
  }
  e.sort(function(et, Q) {
    return et.f - Q.f;
  }), e.push({ s: -1, f: 25001 });
  var o = e[0], l = e[1], f = 0, d = 1, b = 2;
  for (e[0] = { s: -1, f: o.f + l.f, l: o, r: l }; d != i - 1; )
    o = e[e[f].f < e[b].f ? f++ : b++], l = e[f != d && e[f].f < e[b].f ? f++ : b++], e[d++] = { s: -1, f: o.f + l.f, l: o, r: l };
  for (var _ = s[0].s, n = 1; n < i; ++n)
    s[n].s > _ && (_ = s[n].s);
  var g = new Vr(_ + 1), y = du(e[d - 1], g, 0);
  if (y > t) {
    var n = 0, x = 0, E = y - t, N = 1 << E;
    for (s.sort(function(Q, X) {
      return g[X.s] - g[Q.s] || Q.f - X.f;
    }); n < i; ++n) {
      var H = s[n].s;
      if (g[H] > t)
        x += N - (1 << y - g[H]), g[H] = t;
      else
        break;
    }
    for (x >>= E; x > 0; ) {
      var q = s[n].s;
      g[q] < t ? x -= 1 << t - g[q]++ - 1 : ++n;
    }
    for (; n >= 0 && x; --n) {
      var F = s[n].s;
      g[F] == t && (--g[F], ++x);
    }
    y = t;
  }
  return { t: new fn(g), l: y };
}, du = function(r, t, e) {
  return r.s == -1 ? Math.max(du(r.l, t, e + 1), du(r.r, t, e + 1)) : t[r.s] = e;
}, Cl = function(r) {
  for (var t = r.length; t && !r[--t]; )
    ;
  for (var e = new Vr(++t), n = 0, i = r[0], s = 1, c = function(l) {
    e[n++] = l;
  }, o = 1; o <= t; ++o)
    if (r[o] == i && o != t)
      ++s;
    else {
      if (!i && s > 2) {
        for (; s > 138; s -= 138)
          c(32754);
        s > 2 && (c(s > 10 ? s - 11 << 5 | 28690 : s - 3 << 5 | 12305), s = 0);
      } else if (s > 3) {
        for (c(i), --s; s > 6; s -= 6)
          c(8304);
        s > 2 && (c(s - 3 << 5 | 8208), s = 0);
      }
      for (; s--; )
        c(i);
      s = 1, i = r[o];
    }
  return { c: e.subarray(0, n), n: t };
}, Zs = function(r, t) {
  for (var e = 0, n = 0; n < t.length; ++n)
    e += r[n] * t[n];
  return e;
}, Vh = function(r, t, e) {
  var n = e.length, i = Hh(t + 2);
  r[i] = n & 255, r[i + 1] = n >> 8, r[i + 2] = r[i] ^ 255, r[i + 3] = r[i + 1] ^ 255;
  for (var s = 0; s < n; ++s)
    r[i + s + 4] = e[s];
  return (i + 4 + n) * 8;
}, Rl = function(r, t, e, n, i, s, c, o, l, f, d) {
  Un(t, d++, e), ++i[256];
  for (var b = gc(i, 15), _ = b.t, g = b.l, y = gc(s, 15), x = y.t, E = y.l, N = Cl(_), H = N.c, q = N.n, F = Cl(x), et = F.c, Q = F.n, X = new Vr(19), V = 0; V < H.length; ++V)
    ++X[H[V] & 31];
  for (var V = 0; V < et.length; ++V)
    ++X[et[V] & 31];
  for (var I = gc(X, 7), G = I.t, A = I.l, C = 19; C > 4 && !G[El[C - 1]]; --C)
    ;
  var M = f + 5 << 3, D = Zs(i, Hi) + Zs(s, xo) + c, at = Zs(i, _) + Zs(s, x) + c + 14 + 3 * C + Zs(X, G) + 2 * X[16] + 3 * X[17] + 7 * X[18];
  if (l >= 0 && M <= D && M <= at)
    return Vh(t, d, r.subarray(l, l + f));
  var ot, ft, rt, ht;
  if (Un(t, d, 1 + (at < D)), d += 2, at < D) {
    ot = ia(_, g, 0), ft = _, rt = ia(x, E, 0), ht = x;
    var Lt = ia(G, A, 0);
    Un(t, d, q - 257), Un(t, d + 5, Q - 1), Un(t, d + 10, C - 4), d += 14;
    for (var V = 0; V < C; ++V)
      Un(t, d + 3 * V, G[El[V]]);
    d += 3 * C;
    for (var vt = [H, et], S = 0; S < 2; ++S)
      for (var j = vt[S], V = 0; V < j.length; ++V) {
        var z = j[V] & 31;
        Un(t, d, Lt[z]), d += G[z], z > 15 && (Un(t, d, j[V] >> 5 & 127), d += j[V] >> 12);
      }
  } else
    ot = m2, ft = Hi, rt = b2, ht = xo;
  for (var V = 0; V < o; ++V) {
    var J = n[V];
    if (J > 255) {
      var z = J >> 18 & 31;
      $s(t, d, ot[z + 257]), d += ft[z + 257], z > 7 && (Un(t, d, J >> 23 & 31), d += Iu[z]);
      var $ = J & 31;
      $s(t, d, rt[$]), d += ht[$], $ > 3 && ($s(t, d, J >> 5 & 8191), d += Fu[$]);
    } else
      $s(t, d, ot[J]), d += ft[J];
  }
  return $s(t, d, ot[256]), d + ft[256];
}, v2 = /* @__PURE__ */ new Ru([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]), Wh = /* @__PURE__ */ new fn(0), y2 = function(r, t, e, n, i, s) {
  var c = s.z || r.length, o = new fn(n + c + 5 * (1 + Math.ceil(c / 7e3)) + i), l = o.subarray(n, o.length - i), f = s.l, d = (s.r || 0) & 7;
  if (t) {
    d && (l[0] = s.r >> 3);
    for (var b = v2[t - 1], _ = b >> 13, g = b & 8191, y = (1 << e) - 1, x = s.p || new Vr(32768), E = s.h || new Vr(y + 1), N = Math.ceil(e / 3), H = 2 * N, q = function(dt) {
      return (r[dt] ^ r[dt + 1] << N ^ r[dt + 2] << H) & y;
    }, F = new Ru(25e3), et = new Vr(288), Q = new Vr(32), X = 0, V = 0, I = s.i || 0, G = 0, A = s.w || 0, C = 0; I + 2 < c; ++I) {
      var M = q(I), D = I & 32767, at = E[M];
      if (x[D] = at, E[M] = D, A <= I) {
        var ot = c - I;
        if ((X > 7e3 || G > 24576) && (ot > 423 || !f)) {
          d = Rl(r, l, 0, F, et, Q, V, G, C, I - C, d), G = X = V = 0, C = I;
          for (var ft = 0; ft < 286; ++ft)
            et[ft] = 0;
          for (var ft = 0; ft < 30; ++ft)
            Q[ft] = 0;
        }
        var rt = 2, ht = 0, Lt = g, vt = D - at & 32767;
        if (ot > 2 && M == q(I - vt))
          for (var S = Math.min(_, ot) - 1, j = Math.min(32767, I), z = Math.min(258, ot); vt <= j && --Lt && D != at; ) {
            if (r[I + rt] == r[I + rt - vt]) {
              for (var J = 0; J < z && r[I + J] == r[I + J - vt]; ++J)
                ;
              if (J > rt) {
                if (rt = J, ht = vt, J > S)
                  break;
                for (var $ = Math.min(vt, J - 2), nt = 0, ft = 0; ft < $; ++ft) {
                  var lt = I - vt + ft & 32767, ct = x[lt], bt = lt - ct & 32767;
                  bt > nt && (nt = bt, at = lt);
                }
              }
            }
            D = at, at = x[D], vt += D - at & 32767;
          }
        if (ht) {
          F[G++] = 268435456 | fu[rt] << 18 | Pl[ht];
          var xt = fu[rt] & 31, Et = Pl[ht] & 31;
          V += Iu[xt] + Fu[Et], ++et[257 + xt], ++Q[Et], A = I + rt, ++X;
        } else
          F[G++] = r[I], ++et[r[I]];
      }
    }
    for (I = Math.max(I, A); I < c; ++I)
      F[G++] = r[I], ++et[r[I]];
    d = Rl(r, l, f, F, et, Q, V, G, C, I - C, d), f || (s.r = d & 7 | l[d / 8 | 0] << 3, d -= 7, s.h = E, s.p = x, s.i = I, s.w = A);
  } else {
    for (var I = s.w || 0; I < c + f; I += 65535) {
      var Pt = I + 65535;
      Pt >= c && (l[d / 8 | 0] = f, Pt = c), d = Vh(l, d + 1, r.subarray(I, Pt));
    }
    s.i = c;
  }
  return w2(o, 0, n + Hh(d) + i);
}, Gh = function() {
  var r = 1, t = 0;
  return {
    p: function(e) {
      for (var n = r, i = t, s = e.length | 0, c = 0; c != s; ) {
        for (var o = Math.min(c + 2655, s); c < o; ++c)
          i += n += e[c];
        n = (n & 65535) + 15 * (n >> 16), i = (i & 65535) + 15 * (i >> 16);
      }
      r = n, t = i;
    },
    d: function() {
      return r %= 65521, t %= 65521, (r & 255) << 24 | (r & 65280) << 8 | (t & 255) << 8 | t >> 8;
    }
  };
}, _2 = function(r, t, e, n, i) {
  if (!i && (i = { l: 1 }, t.dictionary)) {
    var s = t.dictionary.subarray(-32768), c = new fn(s.length + r.length);
    c.set(s), c.set(r, s.length), r = c, i.w = s.length;
  }
  return y2(r, t.level == null ? 6 : t.level, t.mem == null ? i.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(r.length))) * 1.5) : 20 : 12 + t.mem, e, n, i);
}, Jh = function(r, t, e) {
  for (; e; ++t)
    r[t] = e, e >>>= 8;
}, A2 = function(r, t) {
  var e = t.level, n = e == 0 ? 0 : e < 6 ? 1 : e == 9 ? 3 : 2;
  if (r[0] = 120, r[1] = n << 6 | (t.dictionary && 32), r[1] |= 31 - (r[0] << 8 | r[1]) % 31, t.dictionary) {
    var i = Gh();
    i.p(t.dictionary), Jh(r, 2, i.d());
  }
};
function pu(r, t) {
  t || (t = {});
  var e = Gh();
  e.p(r);
  var n = _2(r, t, t.dictionary ? 6 : 2, 4);
  return A2(n, t), Jh(n, n.length - 4, e.d()), n;
}
var x2 = typeof TextDecoder < "u" && /* @__PURE__ */ new TextDecoder(), N2 = 0;
try {
  x2.decode(Wh, { stream: !0 }), N2 = 1;
} catch {
}
function L2(r) {
  if (Array.isArray(r)) return r;
}
function S2(r, t) {
  var e = r == null ? null : typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
  if (e != null) {
    var n, i, s, c, o = [], l = !0, f = !1;
    try {
      if (s = (e = e.call(r)).next, t !== 0) for (; !(l = (n = s.call(e)).done) && (o.push(n.value), o.length !== t); l = !0) ;
    } catch (d) {
      f = !0, i = d;
    } finally {
      try {
        if (!l && e.return != null && (c = e.return(), Object(c) !== c)) return;
      } finally {
        if (f) throw i;
      }
    }
    return o;
  }
}
function Il(r, t) {
  (t == null || t > r.length) && (t = r.length);
  for (var e = 0, n = Array(t); e < t; e++) n[e] = r[e];
  return n;
}
function k2(r, t) {
  if (r) {
    if (typeof r == "string") return Il(r, t);
    var e = {}.toString.call(r).slice(8, -1);
    return e === "Object" && r.constructor && (e = r.constructor.name), e === "Map" || e === "Set" ? Array.from(r) : e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? Il(r, t) : void 0;
  }
}
function E2() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Fl(r, t) {
  return L2(r) || S2(r, t) || k2(r, t) || E2();
}
function Ol(r, t = "utf8") {
  return new TextDecoder(t).decode(r);
}
const P2 = new TextEncoder();
function C2(r) {
  return P2.encode(r);
}
const R2 = 1024 * 8, I2 = (() => {
  const r = new Uint8Array(4), t = new Uint32Array(r.buffer);
  return !((t[0] = 1) & r[0]);
})(), mc = {
  int8: globalThis.Int8Array,
  uint8: globalThis.Uint8Array,
  int16: globalThis.Int16Array,
  uint16: globalThis.Uint16Array,
  int32: globalThis.Int32Array,
  uint32: globalThis.Uint32Array,
  uint64: globalThis.BigUint64Array,
  int64: globalThis.BigInt64Array,
  float32: globalThis.Float32Array,
  float64: globalThis.Float64Array
};
class Ou {
  /**
   * Reference to the internal ArrayBuffer object.
   */
  buffer;
  /**
   * Byte length of the internal ArrayBuffer.
   */
  byteLength;
  /**
   * Byte offset of the internal ArrayBuffer.
   */
  byteOffset;
  /**
   * Byte length of the internal ArrayBuffer.
   */
  length;
  /**
   * The current offset of the buffer's pointer.
   */
  offset;
  lastWrittenByte;
  littleEndian;
  _data;
  _mark;
  _marks;
  /**
   * Create a new IOBuffer.
   * @param data - The data to construct the IOBuffer with.
   * If data is a number, it will be the new buffer's length<br>
   * If data is `undefined`, the buffer will be initialized with a default length of 8Kb<br>
   * If data is an ArrayBuffer, SharedArrayBuffer, an ArrayBufferView (Typed Array), an IOBuffer instance,
   * or a Node.js Buffer, a view will be created over the underlying ArrayBuffer.
   * @param options - An object for the options.
   * @returns A new IOBuffer instance.
   */
  constructor(t = R2, e = {}) {
    let n = !1;
    typeof t == "number" ? t = new ArrayBuffer(t) : (n = !0, this.lastWrittenByte = t.byteLength);
    const i = e.offset ? e.offset >>> 0 : 0, s = t.byteLength - i;
    let c = i;
    (ArrayBuffer.isView(t) || t instanceof Ou) && (t.byteLength !== t.buffer.byteLength && (c = t.byteOffset + i), t = t.buffer), n ? this.lastWrittenByte = s : this.lastWrittenByte = 0, this.buffer = t, this.length = s, this.byteLength = s, this.byteOffset = c, this.offset = 0, this.littleEndian = !0, this._data = new DataView(this.buffer, c, s), this._mark = 0, this._marks = [];
  }
  /**
   * Checks if the memory allocated to the buffer is sufficient to store more
   * bytes after the offset.
   * @param byteLength - The needed memory in bytes.
   * @returns `true` if there is sufficient space and `false` otherwise.
   */
  available(t = 1) {
    return this.offset + t <= this.length;
  }
  /**
   * Check if little-endian mode is used for reading and writing multi-byte
   * values.
   * @returns `true` if little-endian mode is used, `false` otherwise.
   */
  isLittleEndian() {
    return this.littleEndian;
  }
  /**
   * Set little-endian mode for reading and writing multi-byte values.
   * @returns This.
   */
  setLittleEndian() {
    return this.littleEndian = !0, this;
  }
  /**
   * Check if big-endian mode is used for reading and writing multi-byte values.
   * @returns `true` if big-endian mode is used, `false` otherwise.
   */
  isBigEndian() {
    return !this.littleEndian;
  }
  /**
   * Switches to big-endian mode for reading and writing multi-byte values.
   * @returns This.
   */
  setBigEndian() {
    return this.littleEndian = !1, this;
  }
  /**
   * Move the pointer n bytes forward.
   * @param n - Number of bytes to skip.
   * @returns This.
   */
  skip(t = 1) {
    return this.offset += t, this;
  }
  /**
   * Move the pointer n bytes backward.
   * @param n - Number of bytes to move back.
   * @returns This.
   */
  back(t = 1) {
    return this.offset -= t, this;
  }
  /**
   * Move the pointer to the given offset.
   * @param offset - The offset to move to.
   * @returns This.
   */
  seek(t) {
    return this.offset = t, this;
  }
  /**
   * Store the current pointer offset.
   * @see {@link IOBuffer#reset}
   * @returns This.
   */
  mark() {
    return this._mark = this.offset, this;
  }
  /**
   * Move the pointer back to the last pointer offset set by mark.
   * @see {@link IOBuffer#mark}
   * @returns This.
   */
  reset() {
    return this.offset = this._mark, this;
  }
  /**
   * Push the current pointer offset to the mark stack.
   * @see {@link IOBuffer#popMark}
   * @returns This.
   */
  pushMark() {
    return this._marks.push(this.offset), this;
  }
  /**
   * Pop the last pointer offset from the mark stack, and set the current
   * pointer offset to the popped value.
   * @see {@link IOBuffer#pushMark}
   * @returns This.
   */
  popMark() {
    const t = this._marks.pop();
    if (t === void 0)
      throw new Error("Mark stack empty");
    return this.seek(t), this;
  }
  /**
   * Move the pointer offset back to 0.
   * @returns This.
   */
  rewind() {
    return this.offset = 0, this;
  }
  /**
   * Make sure the buffer has sufficient memory to write a given byteLength at
   * the current pointer offset.
   * If the buffer's memory is insufficient, this method will create a new
   * buffer (a copy) with a length that is twice (byteLength + current offset).
   * @param byteLength - The needed memory in bytes.
   * @returns This.
   */
  ensureAvailable(t = 1) {
    if (!this.available(t)) {
      const n = (this.offset + t) * 2, i = new Uint8Array(n);
      i.set(new Uint8Array(this.buffer)), this.buffer = i.buffer, this.length = n, this.byteLength = n, this._data = new DataView(this.buffer);
    }
    return this;
  }
  /**
   * Read a byte and return false if the byte's value is 0, or true otherwise.
   * Moves pointer forward by one byte.
   * @returns The read boolean.
   */
  readBoolean() {
    return this.readUint8() !== 0;
  }
  /**
   * Read a signed 8-bit integer and move pointer forward by 1 byte.
   * @returns The read byte.
   */
  readInt8() {
    return this._data.getInt8(this.offset++);
  }
  /**
   * Read an unsigned 8-bit integer and move pointer forward by 1 byte.
   * @returns The read byte.
   */
  readUint8() {
    return this._data.getUint8(this.offset++);
  }
  /**
   * Alias for {@link IOBuffer#readUint8}.
   * @returns The read byte.
   */
  readByte() {
    return this.readUint8();
  }
  /**
   * Read `n` bytes and move pointer forward by `n` bytes.
   * @param n - Number of bytes to read.
   * @returns The read bytes.
   */
  readBytes(t = 1) {
    return this.readArray(t, "uint8");
  }
  /**
   * Creates an array of corresponding to the type `type` and size `size`.
   * For example type `uint8` will create a `Uint8Array`.
   * @param size - size of the resulting array
   * @param type - number type of elements to read
   * @returns The read array.
   */
  readArray(t, e) {
    const n = mc[e].BYTES_PER_ELEMENT * t, i = this.byteOffset + this.offset, s = this.buffer.slice(i, i + n);
    if (this.littleEndian === I2 && e !== "uint8" && e !== "int8") {
      const o = new Uint8Array(this.buffer.slice(i, i + n));
      o.reverse();
      const l = new mc[e](o.buffer);
      return this.offset += n, l.reverse(), l;
    }
    const c = new mc[e](s);
    return this.offset += n, c;
  }
  /**
   * Read a 16-bit signed integer and move pointer forward by 2 bytes.
   * @returns The read value.
   */
  readInt16() {
    const t = this._data.getInt16(this.offset, this.littleEndian);
    return this.offset += 2, t;
  }
  /**
   * Read a 16-bit unsigned integer and move pointer forward by 2 bytes.
   * @returns The read value.
   */
  readUint16() {
    const t = this._data.getUint16(this.offset, this.littleEndian);
    return this.offset += 2, t;
  }
  /**
   * Read a 32-bit signed integer and move pointer forward by 4 bytes.
   * @returns The read value.
   */
  readInt32() {
    const t = this._data.getInt32(this.offset, this.littleEndian);
    return this.offset += 4, t;
  }
  /**
   * Read a 32-bit unsigned integer and move pointer forward by 4 bytes.
   * @returns The read value.
   */
  readUint32() {
    const t = this._data.getUint32(this.offset, this.littleEndian);
    return this.offset += 4, t;
  }
  /**
   * Read a 32-bit floating number and move pointer forward by 4 bytes.
   * @returns The read value.
   */
  readFloat32() {
    const t = this._data.getFloat32(this.offset, this.littleEndian);
    return this.offset += 4, t;
  }
  /**
   * Read a 64-bit floating number and move pointer forward by 8 bytes.
   * @returns The read value.
   */
  readFloat64() {
    const t = this._data.getFloat64(this.offset, this.littleEndian);
    return this.offset += 8, t;
  }
  /**
   * Read a 64-bit signed integer number and move pointer forward by 8 bytes.
   * @returns The read value.
   */
  readBigInt64() {
    const t = this._data.getBigInt64(this.offset, this.littleEndian);
    return this.offset += 8, t;
  }
  /**
   * Read a 64-bit unsigned integer number and move pointer forward by 8 bytes.
   * @returns The read value.
   */
  readBigUint64() {
    const t = this._data.getBigUint64(this.offset, this.littleEndian);
    return this.offset += 8, t;
  }
  /**
   * Read a 1-byte ASCII character and move pointer forward by 1 byte.
   * @returns The read character.
   */
  readChar() {
    return String.fromCharCode(this.readInt8());
  }
  /**
   * Read `n` 1-byte ASCII characters and move pointer forward by `n` bytes.
   * @param n - Number of characters to read.
   * @returns The read characters.
   */
  readChars(t = 1) {
    let e = "";
    for (let n = 0; n < t; n++)
      e += this.readChar();
    return e;
  }
  /**
   * Read the next `n` bytes, return a UTF-8 decoded string and move pointer
   * forward by `n` bytes.
   * @param n - Number of bytes to read.
   * @returns The decoded string.
   */
  readUtf8(t = 1) {
    return Ol(this.readBytes(t));
  }
  /**
   * Read the next `n` bytes, return a string decoded with `encoding` and move pointer
   * forward by `n` bytes.
   * If no encoding is passed, the function is equivalent to @see {@link IOBuffer#readUtf8}
   * @param n - Number of bytes to read.
   * @param encoding - The encoding to use. Default is 'utf8'.
   * @returns The decoded string.
   */
  decodeText(t = 1, e = "utf8") {
    return Ol(this.readBytes(t), e);
  }
  /**
   * Write 0xff if the passed value is truthy, 0x00 otherwise and move pointer
   * forward by 1 byte.
   * @param value - The value to write.
   * @returns This.
   */
  writeBoolean(t) {
    return this.writeUint8(t ? 255 : 0), this;
  }
  /**
   * Write `value` as an 8-bit signed integer and move pointer forward by 1 byte.
   * @param value - The value to write.
   * @returns This.
   */
  writeInt8(t) {
    return this.ensureAvailable(1), this._data.setInt8(this.offset++, t), this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as an 8-bit unsigned integer and move pointer forward by 1
   * byte.
   * @param value - The value to write.
   * @returns This.
   */
  writeUint8(t) {
    return this.ensureAvailable(1), this._data.setUint8(this.offset++, t), this._updateLastWrittenByte(), this;
  }
  /**
   * An alias for {@link IOBuffer#writeUint8}.
   * @param value - The value to write.
   * @returns This.
   */
  writeByte(t) {
    return this.writeUint8(t);
  }
  /**
   * Write all elements of `bytes` as uint8 values and move pointer forward by
   * `bytes.length` bytes.
   * @param bytes - The array of bytes to write.
   * @returns This.
   */
  writeBytes(t) {
    this.ensureAvailable(t.length);
    for (let e = 0; e < t.length; e++)
      this._data.setUint8(this.offset++, t[e]);
    return this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 16-bit signed integer and move pointer forward by 2
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeInt16(t) {
    return this.ensureAvailable(2), this._data.setInt16(this.offset, t, this.littleEndian), this.offset += 2, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 16-bit unsigned integer and move pointer forward by 2
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeUint16(t) {
    return this.ensureAvailable(2), this._data.setUint16(this.offset, t, this.littleEndian), this.offset += 2, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 32-bit signed integer and move pointer forward by 4
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeInt32(t) {
    return this.ensureAvailable(4), this._data.setInt32(this.offset, t, this.littleEndian), this.offset += 4, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 32-bit unsigned integer and move pointer forward by 4
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeUint32(t) {
    return this.ensureAvailable(4), this._data.setUint32(this.offset, t, this.littleEndian), this.offset += 4, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 32-bit floating number and move pointer forward by 4
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeFloat32(t) {
    return this.ensureAvailable(4), this._data.setFloat32(this.offset, t, this.littleEndian), this.offset += 4, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 64-bit floating number and move pointer forward by 8
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeFloat64(t) {
    return this.ensureAvailable(8), this._data.setFloat64(this.offset, t, this.littleEndian), this.offset += 8, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 64-bit signed bigint and move pointer forward by 8
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeBigInt64(t) {
    return this.ensureAvailable(8), this._data.setBigInt64(this.offset, t, this.littleEndian), this.offset += 8, this._updateLastWrittenByte(), this;
  }
  /**
   * Write `value` as a 64-bit unsigned bigint and move pointer forward by 8
   * bytes.
   * @param value - The value to write.
   * @returns This.
   */
  writeBigUint64(t) {
    return this.ensureAvailable(8), this._data.setBigUint64(this.offset, t, this.littleEndian), this.offset += 8, this._updateLastWrittenByte(), this;
  }
  /**
   * Write the charCode of `str`'s first character as an 8-bit unsigned integer
   * and move pointer forward by 1 byte.
   * @param str - The character to write.
   * @returns This.
   */
  writeChar(t) {
    return this.writeUint8(t.charCodeAt(0));
  }
  /**
   * Write the charCodes of all `str`'s characters as 8-bit unsigned integers
   * and move pointer forward by `str.length` bytes.
   * @param str - The characters to write.
   * @returns This.
   */
  writeChars(t) {
    for (let e = 0; e < t.length; e++)
      this.writeUint8(t.charCodeAt(e));
    return this;
  }
  /**
   * UTF-8 encode and write `str` to the current pointer offset and move pointer
   * forward according to the encoded length.
   * @param str - The string to write.
   * @returns This.
   */
  writeUtf8(t) {
    return this.writeBytes(C2(t));
  }
  /**
   * Export a Uint8Array view of the internal buffer.
   * The view starts at the byte offset and its length
   * is calculated to stop at the last written byte or the original length.
   * @returns A new Uint8Array view.
   */
  toArray() {
    return new Uint8Array(this.buffer, this.byteOffset, this.lastWrittenByte);
  }
  /**
   *  Get the total number of bytes written so far, regardless of the current offset.
   * @returns - Total number of bytes.
   */
  getWrittenByteLength() {
    return this.lastWrittenByte - this.byteOffset;
  }
  /**
   * Update the last written byte offset
   * @private
   */
  _updateLastWrittenByte() {
    this.offset > this.lastWrittenByte && (this.lastWrittenByte = this.offset);
  }
}
function _s(r) {
  let t = r.length;
  for (; --t >= 0; )
    r[t] = 0;
}
const F2 = 3, O2 = 258, Yh = 29, B2 = 256, T2 = B2 + 1 + Yh, Kh = 30, M2 = 512, D2 = new Array((T2 + 2) * 2);
_s(D2);
const j2 = new Array(Kh * 2);
_s(j2);
const q2 = new Array(M2);
_s(q2);
const U2 = new Array(O2 - F2 + 1);
_s(U2);
const z2 = new Array(Yh);
_s(z2);
const H2 = new Array(Kh);
_s(H2);
const V2 = (r, t, e, n) => {
  let i = r & 65535 | 0, s = r >>> 16 & 65535 | 0, c = 0;
  for (; e !== 0; ) {
    c = e > 2e3 ? 2e3 : e, e -= c;
    do
      i = i + t[n++] | 0, s = s + i | 0;
    while (--c);
    i %= 65521, s %= 65521;
  }
  return i | s << 16 | 0;
};
var gu = V2;
const W2 = () => {
  let r, t = [];
  for (var e = 0; e < 256; e++) {
    r = e;
    for (var n = 0; n < 8; n++)
      r = r & 1 ? 3988292384 ^ r >>> 1 : r >>> 1;
    t[e] = r;
  }
  return t;
}, G2 = new Uint32Array(W2()), J2 = (r, t, e, n) => {
  const i = G2, s = n + e;
  r ^= -1;
  for (let c = n; c < s; c++)
    r = r >>> 8 ^ i[(r ^ t[c]) & 255];
  return r ^ -1;
};
var An = J2, mu = {
  2: "need dictionary",
  /* Z_NEED_DICT       2  */
  1: "stream end",
  /* Z_STREAM_END      1  */
  0: "",
  /* Z_OK              0  */
  "-1": "file error",
  /* Z_ERRNO         (-1) */
  "-2": "stream error",
  /* Z_STREAM_ERROR  (-2) */
  "-3": "data error",
  /* Z_DATA_ERROR    (-3) */
  "-4": "insufficient memory",
  /* Z_MEM_ERROR     (-4) */
  "-5": "buffer error",
  /* Z_BUF_ERROR     (-5) */
  "-6": "incompatible version"
  /* Z_VERSION_ERROR (-6) */
}, Xh = {
  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH: 0,
  Z_FINISH: 4,
  Z_BLOCK: 5,
  Z_TREES: 6,
  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK: 0,
  Z_STREAM_END: 1,
  Z_NEED_DICT: 2,
  Z_STREAM_ERROR: -2,
  Z_DATA_ERROR: -3,
  Z_MEM_ERROR: -4,
  Z_BUF_ERROR: -5,
  /* The deflate compression method */
  Z_DEFLATED: 8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};
const Y2 = (r, t) => Object.prototype.hasOwnProperty.call(r, t);
var K2 = function(r) {
  const t = Array.prototype.slice.call(arguments, 1);
  for (; t.length; ) {
    const e = t.shift();
    if (e) {
      if (typeof e != "object")
        throw new TypeError(e + "must be non-object");
      for (const n in e)
        Y2(e, n) && (r[n] = e[n]);
    }
  }
  return r;
}, X2 = (r) => {
  let t = 0;
  for (let n = 0, i = r.length; n < i; n++)
    t += r[n].length;
  const e = new Uint8Array(t);
  for (let n = 0, i = 0, s = r.length; n < s; n++) {
    let c = r[n];
    e.set(c, i), i += c.length;
  }
  return e;
}, $h = {
  assign: K2,
  flattenChunks: X2
};
let Zh = !0;
try {
  String.fromCharCode.apply(null, new Uint8Array(1));
} catch {
  Zh = !1;
}
const oa = new Uint8Array(256);
for (let r = 0; r < 256; r++)
  oa[r] = r >= 252 ? 6 : r >= 248 ? 5 : r >= 240 ? 4 : r >= 224 ? 3 : r >= 192 ? 2 : 1;
oa[254] = oa[254] = 1;
var $2 = (r) => {
  if (typeof TextEncoder == "function" && TextEncoder.prototype.encode)
    return new TextEncoder().encode(r);
  let t, e, n, i, s, c = r.length, o = 0;
  for (i = 0; i < c; i++)
    e = r.charCodeAt(i), (e & 64512) === 55296 && i + 1 < c && (n = r.charCodeAt(i + 1), (n & 64512) === 56320 && (e = 65536 + (e - 55296 << 10) + (n - 56320), i++)), o += e < 128 ? 1 : e < 2048 ? 2 : e < 65536 ? 3 : 4;
  for (t = new Uint8Array(o), s = 0, i = 0; s < o; i++)
    e = r.charCodeAt(i), (e & 64512) === 55296 && i + 1 < c && (n = r.charCodeAt(i + 1), (n & 64512) === 56320 && (e = 65536 + (e - 55296 << 10) + (n - 56320), i++)), e < 128 ? t[s++] = e : e < 2048 ? (t[s++] = 192 | e >>> 6, t[s++] = 128 | e & 63) : e < 65536 ? (t[s++] = 224 | e >>> 12, t[s++] = 128 | e >>> 6 & 63, t[s++] = 128 | e & 63) : (t[s++] = 240 | e >>> 18, t[s++] = 128 | e >>> 12 & 63, t[s++] = 128 | e >>> 6 & 63, t[s++] = 128 | e & 63);
  return t;
};
const Z2 = (r, t) => {
  if (t < 65534 && r.subarray && Zh)
    return String.fromCharCode.apply(null, r.length === t ? r : r.subarray(0, t));
  let e = "";
  for (let n = 0; n < t; n++)
    e += String.fromCharCode(r[n]);
  return e;
};
var Q2 = (r, t) => {
  const e = t || r.length;
  if (typeof TextDecoder == "function" && TextDecoder.prototype.decode)
    return new TextDecoder().decode(r.subarray(0, t));
  let n, i;
  const s = new Array(e * 2);
  for (i = 0, n = 0; n < e; ) {
    let c = r[n++];
    if (c < 128) {
      s[i++] = c;
      continue;
    }
    let o = oa[c];
    if (o > 4) {
      s[i++] = 65533, n += o - 1;
      continue;
    }
    for (c &= o === 2 ? 31 : o === 3 ? 15 : 7; o > 1 && n < e; )
      c = c << 6 | r[n++] & 63, o--;
    if (o > 1) {
      s[i++] = 65533;
      continue;
    }
    c < 65536 ? s[i++] = c : (c -= 65536, s[i++] = 55296 | c >> 10 & 1023, s[i++] = 56320 | c & 1023);
  }
  return Z2(s, i);
}, t0 = (r, t) => {
  t = t || r.length, t > r.length && (t = r.length);
  let e = t - 1;
  for (; e >= 0 && (r[e] & 192) === 128; )
    e--;
  return e < 0 || e === 0 ? t : e + oa[r[e]] > t ? e : t;
}, bu = {
  string2buf: $2,
  buf2string: Q2,
  utf8border: t0
};
function e0() {
  this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
}
var r0 = e0;
const $a = 16209, n0 = 16191;
var i0 = function(t, e) {
  let n, i, s, c, o, l, f, d, b, _, g, y, x, E, N, H, q, F, et, Q, X, V, I, G;
  const A = t.state;
  n = t.next_in, I = t.input, i = n + (t.avail_in - 5), s = t.next_out, G = t.output, c = s - (e - t.avail_out), o = s + (t.avail_out - 257), l = A.dmax, f = A.wsize, d = A.whave, b = A.wnext, _ = A.window, g = A.hold, y = A.bits, x = A.lencode, E = A.distcode, N = (1 << A.lenbits) - 1, H = (1 << A.distbits) - 1;
  t:
    do {
      y < 15 && (g += I[n++] << y, y += 8, g += I[n++] << y, y += 8), q = x[g & N];
      e:
        for (; ; ) {
          if (F = q >>> 24, g >>>= F, y -= F, F = q >>> 16 & 255, F === 0)
            G[s++] = q & 65535;
          else if (F & 16) {
            et = q & 65535, F &= 15, F && (y < F && (g += I[n++] << y, y += 8), et += g & (1 << F) - 1, g >>>= F, y -= F), y < 15 && (g += I[n++] << y, y += 8, g += I[n++] << y, y += 8), q = E[g & H];
            r:
              for (; ; ) {
                if (F = q >>> 24, g >>>= F, y -= F, F = q >>> 16 & 255, F & 16) {
                  if (Q = q & 65535, F &= 15, y < F && (g += I[n++] << y, y += 8, y < F && (g += I[n++] << y, y += 8)), Q += g & (1 << F) - 1, Q > l) {
                    t.msg = "invalid distance too far back", A.mode = $a;
                    break t;
                  }
                  if (g >>>= F, y -= F, F = s - c, Q > F) {
                    if (F = Q - F, F > d && A.sane) {
                      t.msg = "invalid distance too far back", A.mode = $a;
                      break t;
                    }
                    if (X = 0, V = _, b === 0) {
                      if (X += f - F, F < et) {
                        et -= F;
                        do
                          G[s++] = _[X++];
                        while (--F);
                        X = s - Q, V = G;
                      }
                    } else if (b < F) {
                      if (X += f + b - F, F -= b, F < et) {
                        et -= F;
                        do
                          G[s++] = _[X++];
                        while (--F);
                        if (X = 0, b < et) {
                          F = b, et -= F;
                          do
                            G[s++] = _[X++];
                          while (--F);
                          X = s - Q, V = G;
                        }
                      }
                    } else if (X += b - F, F < et) {
                      et -= F;
                      do
                        G[s++] = _[X++];
                      while (--F);
                      X = s - Q, V = G;
                    }
                    for (; et > 2; )
                      G[s++] = V[X++], G[s++] = V[X++], G[s++] = V[X++], et -= 3;
                    et && (G[s++] = V[X++], et > 1 && (G[s++] = V[X++]));
                  } else {
                    X = s - Q;
                    do
                      G[s++] = G[X++], G[s++] = G[X++], G[s++] = G[X++], et -= 3;
                    while (et > 2);
                    et && (G[s++] = G[X++], et > 1 && (G[s++] = G[X++]));
                  }
                } else if ((F & 64) === 0) {
                  q = E[(q & 65535) + (g & (1 << F) - 1)];
                  continue r;
                } else {
                  t.msg = "invalid distance code", A.mode = $a;
                  break t;
                }
                break;
              }
          } else if ((F & 64) === 0) {
            q = x[(q & 65535) + (g & (1 << F) - 1)];
            continue e;
          } else if (F & 32) {
            A.mode = n0;
            break t;
          } else {
            t.msg = "invalid literal/length code", A.mode = $a;
            break t;
          }
          break;
        }
    } while (n < i && s < o);
  et = y >> 3, n -= et, y -= et << 3, g &= (1 << y) - 1, t.next_in = n, t.next_out = s, t.avail_in = n < i ? 5 + (i - n) : 5 - (n - i), t.avail_out = s < o ? 257 + (o - s) : 257 - (s - o), A.hold = g, A.bits = y;
};
const us = 15, Bl = 852, Tl = 592, Ml = 0, bc = 1, Dl = 2, s0 = new Uint16Array([
  /* Length codes 257..285 base */
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  13,
  15,
  17,
  19,
  23,
  27,
  31,
  35,
  43,
  51,
  59,
  67,
  83,
  99,
  115,
  131,
  163,
  195,
  227,
  258,
  0,
  0
]), a0 = new Uint8Array([
  /* Length codes 257..285 extra */
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  16,
  72,
  78
]), o0 = new Uint16Array([
  /* Distance codes 0..29 base */
  1,
  2,
  3,
  4,
  5,
  7,
  9,
  13,
  17,
  25,
  33,
  49,
  65,
  97,
  129,
  193,
  257,
  385,
  513,
  769,
  1025,
  1537,
  2049,
  3073,
  4097,
  6145,
  8193,
  12289,
  16385,
  24577,
  0,
  0
]), c0 = new Uint8Array([
  /* Distance codes 0..29 extra */
  16,
  16,
  16,
  16,
  17,
  17,
  18,
  18,
  19,
  19,
  20,
  20,
  21,
  21,
  22,
  22,
  23,
  23,
  24,
  24,
  25,
  25,
  26,
  26,
  27,
  27,
  28,
  28,
  29,
  29,
  64,
  64
]), u0 = (r, t, e, n, i, s, c, o) => {
  const l = o.bits;
  let f = 0, d = 0, b = 0, _ = 0, g = 0, y = 0, x = 0, E = 0, N = 0, H = 0, q, F, et, Q, X, V = null, I;
  const G = new Uint16Array(us + 1), A = new Uint16Array(us + 1);
  let C = null, M, D, at;
  for (f = 0; f <= us; f++)
    G[f] = 0;
  for (d = 0; d < n; d++)
    G[t[e + d]]++;
  for (g = l, _ = us; _ >= 1 && G[_] === 0; _--)
    ;
  if (g > _ && (g = _), _ === 0)
    return i[s++] = 1 << 24 | 64 << 16 | 0, i[s++] = 1 << 24 | 64 << 16 | 0, o.bits = 1, 0;
  for (b = 1; b < _ && G[b] === 0; b++)
    ;
  for (g < b && (g = b), E = 1, f = 1; f <= us; f++)
    if (E <<= 1, E -= G[f], E < 0)
      return -1;
  if (E > 0 && (r === Ml || _ !== 1))
    return -1;
  for (A[1] = 0, f = 1; f < us; f++)
    A[f + 1] = A[f] + G[f];
  for (d = 0; d < n; d++)
    t[e + d] !== 0 && (c[A[t[e + d]]++] = d);
  if (r === Ml ? (V = C = c, I = 20) : r === bc ? (V = s0, C = a0, I = 257) : (V = o0, C = c0, I = 0), H = 0, d = 0, f = b, X = s, y = g, x = 0, et = -1, N = 1 << g, Q = N - 1, r === bc && N > Bl || r === Dl && N > Tl)
    return 1;
  for (; ; ) {
    M = f - x, c[d] + 1 < I ? (D = 0, at = c[d]) : c[d] >= I ? (D = C[c[d] - I], at = V[c[d] - I]) : (D = 96, at = 0), q = 1 << f - x, F = 1 << y, b = F;
    do
      F -= q, i[X + (H >> x) + F] = M << 24 | D << 16 | at | 0;
    while (F !== 0);
    for (q = 1 << f - 1; H & q; )
      q >>= 1;
    if (q !== 0 ? (H &= q - 1, H += q) : H = 0, d++, --G[f] === 0) {
      if (f === _)
        break;
      f = t[e + c[d]];
    }
    if (f > g && (H & Q) !== et) {
      for (x === 0 && (x = g), X += b, y = f - x, E = 1 << y; y + x < _ && (E -= G[y + x], !(E <= 0)); )
        y++, E <<= 1;
      if (N += 1 << y, r === bc && N > Bl || r === Dl && N > Tl)
        return 1;
      et = H & Q, i[et] = g << 24 | y << 16 | X - s | 0;
    }
  }
  return H !== 0 && (i[X + H] = f - x << 24 | 64 << 16 | 0), o.bits = g, 0;
};
var sa = u0;
const l0 = 0, Qh = 1, t1 = 2, {
  Z_FINISH: jl,
  Z_BLOCK: f0,
  Z_TREES: Za,
  Z_OK: Vi,
  Z_STREAM_END: h0,
  Z_NEED_DICT: d0,
  Z_STREAM_ERROR: en,
  Z_DATA_ERROR: e1,
  Z_MEM_ERROR: r1,
  Z_BUF_ERROR: p0,
  Z_DEFLATED: ql
} = Xh, Po = 16180, Ul = 16181, zl = 16182, Hl = 16183, Vl = 16184, Wl = 16185, Gl = 16186, Jl = 16187, Yl = 16188, Kl = 16189, No = 16190, zn = 16191, wc = 16192, Xl = 16193, vc = 16194, $l = 16195, Zl = 16196, Ql = 16197, tf = 16198, Qa = 16199, to = 16200, ef = 16201, rf = 16202, nf = 16203, sf = 16204, af = 16205, yc = 16206, of = 16207, cf = 16208, Be = 16209, n1 = 16210, i1 = 16211, g0 = 852, m0 = 592, b0 = 15, w0 = b0, uf = (r) => (r >>> 24 & 255) + (r >>> 8 & 65280) + ((r & 65280) << 8) + ((r & 255) << 24);
function v0() {
  this.strm = null, this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Uint16Array(320), this.work = new Uint16Array(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
}
const Gi = (r) => {
  if (!r)
    return 1;
  const t = r.state;
  return !t || t.strm !== r || t.mode < Po || t.mode > i1 ? 1 : 0;
}, s1 = (r) => {
  if (Gi(r))
    return en;
  const t = r.state;
  return r.total_in = r.total_out = t.total = 0, r.msg = "", t.wrap && (r.adler = t.wrap & 1), t.mode = Po, t.last = 0, t.havedict = 0, t.flags = -1, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new Int32Array(g0), t.distcode = t.distdyn = new Int32Array(m0), t.sane = 1, t.back = -1, Vi;
}, a1 = (r) => {
  if (Gi(r))
    return en;
  const t = r.state;
  return t.wsize = 0, t.whave = 0, t.wnext = 0, s1(r);
}, o1 = (r, t) => {
  let e;
  if (Gi(r))
    return en;
  const n = r.state;
  return t < 0 ? (e = 0, t = -t) : (e = (t >> 4) + 5, t < 48 && (t &= 15)), t && (t < 8 || t > 15) ? en : (n.window !== null && n.wbits !== t && (n.window = null), n.wrap = e, n.wbits = t, a1(r));
}, c1 = (r, t) => {
  if (!r)
    return en;
  const e = new v0();
  r.state = e, e.strm = r, e.window = null, e.mode = Po;
  const n = o1(r, t);
  return n !== Vi && (r.state = null), n;
}, y0 = (r) => c1(r, w0);
let lf = !0, _c, Ac;
const _0 = (r) => {
  if (lf) {
    _c = new Int32Array(512), Ac = new Int32Array(32);
    let t = 0;
    for (; t < 144; )
      r.lens[t++] = 8;
    for (; t < 256; )
      r.lens[t++] = 9;
    for (; t < 280; )
      r.lens[t++] = 7;
    for (; t < 288; )
      r.lens[t++] = 8;
    for (sa(Qh, r.lens, 0, 288, _c, 0, r.work, { bits: 9 }), t = 0; t < 32; )
      r.lens[t++] = 5;
    sa(t1, r.lens, 0, 32, Ac, 0, r.work, { bits: 5 }), lf = !1;
  }
  r.lencode = _c, r.lenbits = 9, r.distcode = Ac, r.distbits = 5;
}, u1 = (r, t, e, n) => {
  let i;
  const s = r.state;
  return s.window === null && (s.wsize = 1 << s.wbits, s.wnext = 0, s.whave = 0, s.window = new Uint8Array(s.wsize)), n >= s.wsize ? (s.window.set(t.subarray(e - s.wsize, e), 0), s.wnext = 0, s.whave = s.wsize) : (i = s.wsize - s.wnext, i > n && (i = n), s.window.set(t.subarray(e - n, e - n + i), s.wnext), n -= i, n ? (s.window.set(t.subarray(e - n, e), 0), s.wnext = n, s.whave = s.wsize) : (s.wnext += i, s.wnext === s.wsize && (s.wnext = 0), s.whave < s.wsize && (s.whave += i))), 0;
}, A0 = (r, t) => {
  let e, n, i, s, c, o, l, f, d, b, _, g, y, x, E = 0, N, H, q, F, et, Q, X, V;
  const I = new Uint8Array(4);
  let G, A;
  const C = (
    /* permutation of code lengths */
    new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15])
  );
  if (Gi(r) || !r.output || !r.input && r.avail_in !== 0)
    return en;
  e = r.state, e.mode === zn && (e.mode = wc), c = r.next_out, i = r.output, l = r.avail_out, s = r.next_in, n = r.input, o = r.avail_in, f = e.hold, d = e.bits, b = o, _ = l, V = Vi;
  t:
    for (; ; )
      switch (e.mode) {
        case Po:
          if (e.wrap === 0) {
            e.mode = wc;
            break;
          }
          for (; d < 16; ) {
            if (o === 0)
              break t;
            o--, f += n[s++] << d, d += 8;
          }
          if (e.wrap & 2 && f === 35615) {
            e.wbits === 0 && (e.wbits = 15), e.check = 0, I[0] = f & 255, I[1] = f >>> 8 & 255, e.check = An(e.check, I, 2, 0), f = 0, d = 0, e.mode = Ul;
            break;
          }
          if (e.head && (e.head.done = !1), !(e.wrap & 1) || /* check if zlib header allowed */
          (((f & 255) << 8) + (f >> 8)) % 31) {
            r.msg = "incorrect header check", e.mode = Be;
            break;
          }
          if ((f & 15) !== ql) {
            r.msg = "unknown compression method", e.mode = Be;
            break;
          }
          if (f >>>= 4, d -= 4, X = (f & 15) + 8, e.wbits === 0 && (e.wbits = X), X > 15 || X > e.wbits) {
            r.msg = "invalid window size", e.mode = Be;
            break;
          }
          e.dmax = 1 << e.wbits, e.flags = 0, r.adler = e.check = 1, e.mode = f & 512 ? Kl : zn, f = 0, d = 0;
          break;
        case Ul:
          for (; d < 16; ) {
            if (o === 0)
              break t;
            o--, f += n[s++] << d, d += 8;
          }
          if (e.flags = f, (e.flags & 255) !== ql) {
            r.msg = "unknown compression method", e.mode = Be;
            break;
          }
          if (e.flags & 57344) {
            r.msg = "unknown header flags set", e.mode = Be;
            break;
          }
          e.head && (e.head.text = f >> 8 & 1), e.flags & 512 && e.wrap & 4 && (I[0] = f & 255, I[1] = f >>> 8 & 255, e.check = An(e.check, I, 2, 0)), f = 0, d = 0, e.mode = zl;
        /* falls through */
        case zl:
          for (; d < 32; ) {
            if (o === 0)
              break t;
            o--, f += n[s++] << d, d += 8;
          }
          e.head && (e.head.time = f), e.flags & 512 && e.wrap & 4 && (I[0] = f & 255, I[1] = f >>> 8 & 255, I[2] = f >>> 16 & 255, I[3] = f >>> 24 & 255, e.check = An(e.check, I, 4, 0)), f = 0, d = 0, e.mode = Hl;
        /* falls through */
        case Hl:
          for (; d < 16; ) {
            if (o === 0)
              break t;
            o--, f += n[s++] << d, d += 8;
          }
          e.head && (e.head.xflags = f & 255, e.head.os = f >> 8), e.flags & 512 && e.wrap & 4 && (I[0] = f & 255, I[1] = f >>> 8 & 255, e.check = An(e.check, I, 2, 0)), f = 0, d = 0, e.mode = Vl;
        /* falls through */
        case Vl:
          if (e.flags & 1024) {
            for (; d < 16; ) {
              if (o === 0)
                break t;
              o--, f += n[s++] << d, d += 8;
            }
            e.length = f, e.head && (e.head.extra_len = f), e.flags & 512 && e.wrap & 4 && (I[0] = f & 255, I[1] = f >>> 8 & 255, e.check = An(e.check, I, 2, 0)), f = 0, d = 0;
          } else e.head && (e.head.extra = null);
          e.mode = Wl;
        /* falls through */
        case Wl:
          if (e.flags & 1024 && (g = e.length, g > o && (g = o), g && (e.head && (X = e.head.extra_len - e.length, e.head.extra || (e.head.extra = new Uint8Array(e.head.extra_len)), e.head.extra.set(
            n.subarray(
              s,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              s + g
            ),
            /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
            X
          )), e.flags & 512 && e.wrap & 4 && (e.check = An(e.check, n, g, s)), o -= g, s += g, e.length -= g), e.length))
            break t;
          e.length = 0, e.mode = Gl;
        /* falls through */
        case Gl:
          if (e.flags & 2048) {
            if (o === 0)
              break t;
            g = 0;
            do
              X = n[s + g++], e.head && X && e.length < 65536 && (e.head.name += String.fromCharCode(X));
            while (X && g < o);
            if (e.flags & 512 && e.wrap & 4 && (e.check = An(e.check, n, g, s)), o -= g, s += g, X)
              break t;
          } else e.head && (e.head.name = null);
          e.length = 0, e.mode = Jl;
        /* falls through */
        case Jl:
          if (e.flags & 4096) {
            if (o === 0)
              break t;
            g = 0;
            do
              X = n[s + g++], e.head && X && e.length < 65536 && (e.head.comment += String.fromCharCode(X));
            while (X && g < o);
            if (e.flags & 512 && e.wrap & 4 && (e.check = An(e.check, n, g, s)), o -= g, s += g, X)
              break t;
          } else e.head && (e.head.comment = null);
          e.mode = Yl;
        /* falls through */
        case Yl:
          if (e.flags & 512) {
            for (; d < 16; ) {
              if (o === 0)
                break t;
              o--, f += n[s++] << d, d += 8;
            }
            if (e.wrap & 4 && f !== (e.check & 65535)) {
              r.msg = "header crc mismatch", e.mode = Be;
              break;
            }
            f = 0, d = 0;
          }
          e.head && (e.head.hcrc = e.flags >> 9 & 1, e.head.done = !0), r.adler = e.check = 0, e.mode = zn;
          break;
        case Kl:
          for (; d < 32; ) {
            if (o === 0)
              break t;
            o--, f += n[s++] << d, d += 8;
          }
          r.adler = e.check = uf(f), f = 0, d = 0, e.mode = No;
        /* falls through */
        case No:
          if (e.havedict === 0)
            return r.next_out = c, r.avail_out = l, r.next_in = s, r.avail_in = o, e.hold = f, e.bits = d, d0;
          r.adler = e.check = 1, e.mode = zn;
        /* falls through */
        case zn:
          if (t === f0 || t === Za)
            break t;
        /* falls through */
        case wc:
          if (e.last) {
            f >>>= d & 7, d -= d & 7, e.mode = yc;
            break;
          }
          for (; d < 3; ) {
            if (o === 0)
              break t;
            o--, f += n[s++] << d, d += 8;
          }
          switch (e.last = f & 1, f >>>= 1, d -= 1, f & 3) {
            case 0:
              e.mode = Xl;
              break;
            case 1:
              if (_0(e), e.mode = Qa, t === Za) {
                f >>>= 2, d -= 2;
                break t;
              }
              break;
            case 2:
              e.mode = Zl;
              break;
            case 3:
              r.msg = "invalid block type", e.mode = Be;
          }
          f >>>= 2, d -= 2;
          break;
        case Xl:
          for (f >>>= d & 7, d -= d & 7; d < 32; ) {
            if (o === 0)
              break t;
            o--, f += n[s++] << d, d += 8;
          }
          if ((f & 65535) !== (f >>> 16 ^ 65535)) {
            r.msg = "invalid stored block lengths", e.mode = Be;
            break;
          }
          if (e.length = f & 65535, f = 0, d = 0, e.mode = vc, t === Za)
            break t;
        /* falls through */
        case vc:
          e.mode = $l;
        /* falls through */
        case $l:
          if (g = e.length, g) {
            if (g > o && (g = o), g > l && (g = l), g === 0)
              break t;
            i.set(n.subarray(s, s + g), c), o -= g, s += g, l -= g, c += g, e.length -= g;
            break;
          }
          e.mode = zn;
          break;
        case Zl:
          for (; d < 14; ) {
            if (o === 0)
              break t;
            o--, f += n[s++] << d, d += 8;
          }
          if (e.nlen = (f & 31) + 257, f >>>= 5, d -= 5, e.ndist = (f & 31) + 1, f >>>= 5, d -= 5, e.ncode = (f & 15) + 4, f >>>= 4, d -= 4, e.nlen > 286 || e.ndist > 30) {
            r.msg = "too many length or distance symbols", e.mode = Be;
            break;
          }
          e.have = 0, e.mode = Ql;
        /* falls through */
        case Ql:
          for (; e.have < e.ncode; ) {
            for (; d < 3; ) {
              if (o === 0)
                break t;
              o--, f += n[s++] << d, d += 8;
            }
            e.lens[C[e.have++]] = f & 7, f >>>= 3, d -= 3;
          }
          for (; e.have < 19; )
            e.lens[C[e.have++]] = 0;
          if (e.lencode = e.lendyn, e.lenbits = 7, G = { bits: e.lenbits }, V = sa(l0, e.lens, 0, 19, e.lencode, 0, e.work, G), e.lenbits = G.bits, V) {
            r.msg = "invalid code lengths set", e.mode = Be;
            break;
          }
          e.have = 0, e.mode = tf;
        /* falls through */
        case tf:
          for (; e.have < e.nlen + e.ndist; ) {
            for (; E = e.lencode[f & (1 << e.lenbits) - 1], N = E >>> 24, H = E >>> 16 & 255, q = E & 65535, !(N <= d); ) {
              if (o === 0)
                break t;
              o--, f += n[s++] << d, d += 8;
            }
            if (q < 16)
              f >>>= N, d -= N, e.lens[e.have++] = q;
            else {
              if (q === 16) {
                for (A = N + 2; d < A; ) {
                  if (o === 0)
                    break t;
                  o--, f += n[s++] << d, d += 8;
                }
                if (f >>>= N, d -= N, e.have === 0) {
                  r.msg = "invalid bit length repeat", e.mode = Be;
                  break;
                }
                X = e.lens[e.have - 1], g = 3 + (f & 3), f >>>= 2, d -= 2;
              } else if (q === 17) {
                for (A = N + 3; d < A; ) {
                  if (o === 0)
                    break t;
                  o--, f += n[s++] << d, d += 8;
                }
                f >>>= N, d -= N, X = 0, g = 3 + (f & 7), f >>>= 3, d -= 3;
              } else {
                for (A = N + 7; d < A; ) {
                  if (o === 0)
                    break t;
                  o--, f += n[s++] << d, d += 8;
                }
                f >>>= N, d -= N, X = 0, g = 11 + (f & 127), f >>>= 7, d -= 7;
              }
              if (e.have + g > e.nlen + e.ndist) {
                r.msg = "invalid bit length repeat", e.mode = Be;
                break;
              }
              for (; g--; )
                e.lens[e.have++] = X;
            }
          }
          if (e.mode === Be)
            break;
          if (e.lens[256] === 0) {
            r.msg = "invalid code -- missing end-of-block", e.mode = Be;
            break;
          }
          if (e.lenbits = 9, G = { bits: e.lenbits }, V = sa(Qh, e.lens, 0, e.nlen, e.lencode, 0, e.work, G), e.lenbits = G.bits, V) {
            r.msg = "invalid literal/lengths set", e.mode = Be;
            break;
          }
          if (e.distbits = 6, e.distcode = e.distdyn, G = { bits: e.distbits }, V = sa(t1, e.lens, e.nlen, e.ndist, e.distcode, 0, e.work, G), e.distbits = G.bits, V) {
            r.msg = "invalid distances set", e.mode = Be;
            break;
          }
          if (e.mode = Qa, t === Za)
            break t;
        /* falls through */
        case Qa:
          e.mode = to;
        /* falls through */
        case to:
          if (o >= 6 && l >= 258) {
            r.next_out = c, r.avail_out = l, r.next_in = s, r.avail_in = o, e.hold = f, e.bits = d, i0(r, _), c = r.next_out, i = r.output, l = r.avail_out, s = r.next_in, n = r.input, o = r.avail_in, f = e.hold, d = e.bits, e.mode === zn && (e.back = -1);
            break;
          }
          for (e.back = 0; E = e.lencode[f & (1 << e.lenbits) - 1], N = E >>> 24, H = E >>> 16 & 255, q = E & 65535, !(N <= d); ) {
            if (o === 0)
              break t;
            o--, f += n[s++] << d, d += 8;
          }
          if (H && (H & 240) === 0) {
            for (F = N, et = H, Q = q; E = e.lencode[Q + ((f & (1 << F + et) - 1) >> F)], N = E >>> 24, H = E >>> 16 & 255, q = E & 65535, !(F + N <= d); ) {
              if (o === 0)
                break t;
              o--, f += n[s++] << d, d += 8;
            }
            f >>>= F, d -= F, e.back += F;
          }
          if (f >>>= N, d -= N, e.back += N, e.length = q, H === 0) {
            e.mode = af;
            break;
          }
          if (H & 32) {
            e.back = -1, e.mode = zn;
            break;
          }
          if (H & 64) {
            r.msg = "invalid literal/length code", e.mode = Be;
            break;
          }
          e.extra = H & 15, e.mode = ef;
        /* falls through */
        case ef:
          if (e.extra) {
            for (A = e.extra; d < A; ) {
              if (o === 0)
                break t;
              o--, f += n[s++] << d, d += 8;
            }
            e.length += f & (1 << e.extra) - 1, f >>>= e.extra, d -= e.extra, e.back += e.extra;
          }
          e.was = e.length, e.mode = rf;
        /* falls through */
        case rf:
          for (; E = e.distcode[f & (1 << e.distbits) - 1], N = E >>> 24, H = E >>> 16 & 255, q = E & 65535, !(N <= d); ) {
            if (o === 0)
              break t;
            o--, f += n[s++] << d, d += 8;
          }
          if ((H & 240) === 0) {
            for (F = N, et = H, Q = q; E = e.distcode[Q + ((f & (1 << F + et) - 1) >> F)], N = E >>> 24, H = E >>> 16 & 255, q = E & 65535, !(F + N <= d); ) {
              if (o === 0)
                break t;
              o--, f += n[s++] << d, d += 8;
            }
            f >>>= F, d -= F, e.back += F;
          }
          if (f >>>= N, d -= N, e.back += N, H & 64) {
            r.msg = "invalid distance code", e.mode = Be;
            break;
          }
          e.offset = q, e.extra = H & 15, e.mode = nf;
        /* falls through */
        case nf:
          if (e.extra) {
            for (A = e.extra; d < A; ) {
              if (o === 0)
                break t;
              o--, f += n[s++] << d, d += 8;
            }
            e.offset += f & (1 << e.extra) - 1, f >>>= e.extra, d -= e.extra, e.back += e.extra;
          }
          if (e.offset > e.dmax) {
            r.msg = "invalid distance too far back", e.mode = Be;
            break;
          }
          e.mode = sf;
        /* falls through */
        case sf:
          if (l === 0)
            break t;
          if (g = _ - l, e.offset > g) {
            if (g = e.offset - g, g > e.whave && e.sane) {
              r.msg = "invalid distance too far back", e.mode = Be;
              break;
            }
            g > e.wnext ? (g -= e.wnext, y = e.wsize - g) : y = e.wnext - g, g > e.length && (g = e.length), x = e.window;
          } else
            x = i, y = c - e.offset, g = e.length;
          g > l && (g = l), l -= g, e.length -= g;
          do
            i[c++] = x[y++];
          while (--g);
          e.length === 0 && (e.mode = to);
          break;
        case af:
          if (l === 0)
            break t;
          i[c++] = e.length, l--, e.mode = to;
          break;
        case yc:
          if (e.wrap) {
            for (; d < 32; ) {
              if (o === 0)
                break t;
              o--, f |= n[s++] << d, d += 8;
            }
            if (_ -= l, r.total_out += _, e.total += _, e.wrap & 4 && _ && (r.adler = e.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/
            e.flags ? An(e.check, i, _, c - _) : gu(e.check, i, _, c - _)), _ = l, e.wrap & 4 && (e.flags ? f : uf(f)) !== e.check) {
              r.msg = "incorrect data check", e.mode = Be;
              break;
            }
            f = 0, d = 0;
          }
          e.mode = of;
        /* falls through */
        case of:
          if (e.wrap && e.flags) {
            for (; d < 32; ) {
              if (o === 0)
                break t;
              o--, f += n[s++] << d, d += 8;
            }
            if (e.wrap & 4 && f !== (e.total & 4294967295)) {
              r.msg = "incorrect length check", e.mode = Be;
              break;
            }
            f = 0, d = 0;
          }
          e.mode = cf;
        /* falls through */
        case cf:
          V = h0;
          break t;
        case Be:
          V = e1;
          break t;
        case n1:
          return r1;
        case i1:
        /* falls through */
        default:
          return en;
      }
  return r.next_out = c, r.avail_out = l, r.next_in = s, r.avail_in = o, e.hold = f, e.bits = d, (e.wsize || _ !== r.avail_out && e.mode < Be && (e.mode < yc || t !== jl)) && u1(r, r.output, r.next_out, _ - r.avail_out), b -= r.avail_in, _ -= r.avail_out, r.total_in += b, r.total_out += _, e.total += _, e.wrap & 4 && _ && (r.adler = e.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/
  e.flags ? An(e.check, i, _, r.next_out - _) : gu(e.check, i, _, r.next_out - _)), r.data_type = e.bits + (e.last ? 64 : 0) + (e.mode === zn ? 128 : 0) + (e.mode === Qa || e.mode === vc ? 256 : 0), (b === 0 && _ === 0 || t === jl) && V === Vi && (V = p0), V;
}, x0 = (r) => {
  if (Gi(r))
    return en;
  let t = r.state;
  return t.window && (t.window = null), r.state = null, Vi;
}, N0 = (r, t) => {
  if (Gi(r))
    return en;
  const e = r.state;
  return (e.wrap & 2) === 0 ? en : (e.head = t, t.done = !1, Vi);
}, L0 = (r, t) => {
  const e = t.length;
  let n, i, s;
  return Gi(r) || (n = r.state, n.wrap !== 0 && n.mode !== No) ? en : n.mode === No && (i = 1, i = gu(i, t, e, 0), i !== n.check) ? e1 : (s = u1(r, t, e, e), s ? (n.mode = n1, r1) : (n.havedict = 1, Vi));
};
var S0 = a1, k0 = o1, E0 = s1, P0 = y0, C0 = c1, R0 = A0, I0 = x0, F0 = N0, O0 = L0, B0 = "pako inflate (from Nodeca project)", Hn = {
  inflateReset: S0,
  inflateReset2: k0,
  inflateResetKeep: E0,
  inflateInit: P0,
  inflateInit2: C0,
  inflate: R0,
  inflateEnd: I0,
  inflateGetHeader: F0,
  inflateSetDictionary: O0,
  inflateInfo: B0
};
function T0() {
  this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
}
var M0 = T0;
const l1 = Object.prototype.toString, {
  Z_NO_FLUSH: D0,
  Z_FINISH: j0,
  Z_OK: ca,
  Z_STREAM_END: xc,
  Z_NEED_DICT: Nc,
  Z_STREAM_ERROR: q0,
  Z_DATA_ERROR: ff,
  Z_MEM_ERROR: U0
} = Xh;
function la(r) {
  this.options = $h.assign({
    chunkSize: 1024 * 64,
    windowBits: 15,
    to: ""
  }, r || {});
  const t = this.options;
  t.raw && t.windowBits >= 0 && t.windowBits < 16 && (t.windowBits = -t.windowBits, t.windowBits === 0 && (t.windowBits = -15)), t.windowBits >= 0 && t.windowBits < 16 && !(r && r.windowBits) && (t.windowBits += 32), t.windowBits > 15 && t.windowBits < 48 && (t.windowBits & 15) === 0 && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new r0(), this.strm.avail_out = 0;
  let e = Hn.inflateInit2(
    this.strm,
    t.windowBits
  );
  if (e !== ca)
    throw new Error(mu[e]);
  if (this.header = new M0(), Hn.inflateGetHeader(this.strm, this.header), t.dictionary && (typeof t.dictionary == "string" ? t.dictionary = bu.string2buf(t.dictionary) : l1.call(t.dictionary) === "[object ArrayBuffer]" && (t.dictionary = new Uint8Array(t.dictionary)), t.raw && (e = Hn.inflateSetDictionary(this.strm, t.dictionary), e !== ca)))
    throw new Error(mu[e]);
}
la.prototype.push = function(r, t) {
  const e = this.strm, n = this.options.chunkSize, i = this.options.dictionary;
  let s, c, o;
  if (this.ended) return !1;
  for (t === ~~t ? c = t : c = t === !0 ? j0 : D0, l1.call(r) === "[object ArrayBuffer]" ? e.input = new Uint8Array(r) : e.input = r, e.next_in = 0, e.avail_in = e.input.length; ; ) {
    for (e.avail_out === 0 && (e.output = new Uint8Array(n), e.next_out = 0, e.avail_out = n), s = Hn.inflate(e, c), s === Nc && i && (s = Hn.inflateSetDictionary(e, i), s === ca ? s = Hn.inflate(e, c) : s === ff && (s = Nc)); e.avail_in > 0 && s === xc && e.state.wrap > 0 && r[e.next_in] !== 0; )
      Hn.inflateReset(e), s = Hn.inflate(e, c);
    switch (s) {
      case q0:
      case ff:
      case Nc:
      case U0:
        return this.onEnd(s), this.ended = !0, !1;
    }
    if (o = e.avail_out, e.next_out && (e.avail_out === 0 || s === xc))
      if (this.options.to === "string") {
        let l = bu.utf8border(e.output, e.next_out), f = e.next_out - l, d = bu.buf2string(e.output, l);
        e.next_out = f, e.avail_out = n - f, f && e.output.set(e.output.subarray(l, l + f), 0), this.onData(d);
      } else
        this.onData(e.output.length === e.next_out ? e.output : e.output.subarray(0, e.next_out));
    if (!(s === ca && o === 0)) {
      if (s === xc)
        return s = Hn.inflateEnd(this.strm), this.onEnd(s), this.ended = !0, !0;
      if (e.avail_in === 0) break;
    }
  }
  return !0;
};
la.prototype.onData = function(r) {
  this.chunks.push(r);
};
la.prototype.onEnd = function(r) {
  r === ca && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = $h.flattenChunks(this.chunks)), this.chunks = [], this.err = r, this.msg = this.strm.msg;
};
function z0(r, t) {
  const e = new la(t);
  if (e.push(r), e.err) throw e.msg || mu[e.err];
  return e.result;
}
var H0 = la, V0 = z0, W0 = {
  Inflate: H0,
  inflate: V0
};
const { Inflate: G0, inflate: J0 } = W0;
var hf = G0, Y0 = J0;
const f1 = [];
for (let r = 0; r < 256; r++) {
  let t = r;
  for (let e = 0; e < 8; e++)
    t & 1 ? t = 3988292384 ^ t >>> 1 : t = t >>> 1;
  f1[r] = t;
}
const df = 4294967295;
function K0(r, t, e) {
  let n = r;
  for (let i = 0; i < e; i++)
    n = f1[(n ^ t[i]) & 255] ^ n >>> 8;
  return n;
}
function X0(r, t) {
  return (K0(df, r, t) ^ df) >>> 0;
}
function pf(r, t, e) {
  const n = r.readUint32(), i = X0(new Uint8Array(r.buffer, r.byteOffset + r.offset - t - 4, t), t);
  if (i !== n)
    throw new Error(`CRC mismatch for chunk ${e}. Expected ${n}, found ${i}`);
}
function h1(r, t, e) {
  for (let n = 0; n < e; n++)
    t[n] = r[n];
}
function d1(r, t, e, n) {
  let i = 0;
  for (; i < n; i++)
    t[i] = r[i];
  for (; i < e; i++)
    t[i] = r[i] + t[i - n] & 255;
}
function p1(r, t, e, n) {
  let i = 0;
  if (e.length === 0)
    for (; i < n; i++)
      t[i] = r[i];
  else
    for (; i < n; i++)
      t[i] = r[i] + e[i] & 255;
}
function g1(r, t, e, n, i) {
  let s = 0;
  if (e.length === 0) {
    for (; s < i; s++)
      t[s] = r[s];
    for (; s < n; s++)
      t[s] = r[s] + (t[s - i] >> 1) & 255;
  } else {
    for (; s < i; s++)
      t[s] = r[s] + (e[s] >> 1) & 255;
    for (; s < n; s++)
      t[s] = r[s] + (t[s - i] + e[s] >> 1) & 255;
  }
}
function m1(r, t, e, n, i) {
  let s = 0;
  if (e.length === 0) {
    for (; s < i; s++)
      t[s] = r[s];
    for (; s < n; s++)
      t[s] = r[s] + t[s - i] & 255;
  } else {
    for (; s < i; s++)
      t[s] = r[s] + e[s] & 255;
    for (; s < n; s++)
      t[s] = r[s] + $0(t[s - i], e[s], e[s - i]) & 255;
  }
}
function $0(r, t, e) {
  const n = r + t - e, i = Math.abs(n - r), s = Math.abs(n - t), c = Math.abs(n - e);
  return i <= s && i <= c ? r : s <= c ? t : e;
}
function Z0(r, t, e, n, i, s) {
  switch (r) {
    case 0:
      h1(t, e, i);
      break;
    case 1:
      d1(t, e, i, s);
      break;
    case 2:
      p1(t, e, n, i);
      break;
    case 3:
      g1(t, e, n, i, s);
      break;
    case 4:
      m1(t, e, n, i, s);
      break;
    default:
      throw new Error(`Unsupported filter: ${r}`);
  }
}
const Q0 = new Uint16Array([255]), t5 = new Uint8Array(Q0.buffer), e5 = t5[0] === 255;
function r5(r) {
  const { data: t, width: e, height: n, channels: i, depth: s } = r, c = [
    { x: 0, y: 0, xStep: 8, yStep: 8 },
    // Pass 1
    { x: 4, y: 0, xStep: 8, yStep: 8 },
    // Pass 2
    { x: 0, y: 4, xStep: 4, yStep: 8 },
    // Pass 3
    { x: 2, y: 0, xStep: 4, yStep: 4 },
    // Pass 4
    { x: 0, y: 2, xStep: 2, yStep: 4 },
    // Pass 5
    { x: 1, y: 0, xStep: 2, yStep: 2 },
    // Pass 6
    { x: 0, y: 1, xStep: 1, yStep: 2 }
    // Pass 7
  ], o = Math.ceil(s / 8) * i, l = new Uint8Array(n * e * o);
  let f = 0;
  for (let d = 0; d < 7; d++) {
    const b = c[d], _ = Math.ceil((e - b.x) / b.xStep), g = Math.ceil((n - b.y) / b.yStep);
    if (_ <= 0 || g <= 0)
      continue;
    const y = _ * o, x = new Uint8Array(y);
    for (let E = 0; E < g; E++) {
      const N = t[f++], H = t.subarray(f, f + y);
      f += y;
      const q = new Uint8Array(y);
      Z0(N, H, q, x, y, o), x.set(q);
      for (let F = 0; F < _; F++) {
        const et = b.x + F * b.xStep, Q = b.y + E * b.yStep;
        if (!(et >= e || Q >= n))
          for (let X = 0; X < o; X++)
            l[(Q * e + et) * o + X] = q[F * o + X];
      }
    }
  }
  if (s === 16) {
    const d = new Uint16Array(l.buffer);
    if (e5)
      for (let b = 0; b < d.length; b++)
        d[b] = n5(d[b]);
    return d;
  } else
    return l;
}
function n5(r) {
  return (r & 255) << 8 | r >> 8 & 255;
}
const i5 = new Uint16Array([255]), s5 = new Uint8Array(i5.buffer), a5 = s5[0] === 255, o5 = new Uint8Array(0);
function gf(r) {
  const { data: t, width: e, height: n, channels: i, depth: s } = r, c = Math.ceil(s / 8) * i, o = Math.ceil(s / 8 * i * e), l = new Uint8Array(n * o);
  let f = o5, d = 0, b, _;
  for (let g = 0; g < n; g++) {
    switch (b = t.subarray(d + 1, d + 1 + o), _ = l.subarray(g * o, (g + 1) * o), t[d]) {
      case 0:
        h1(b, _, o);
        break;
      case 1:
        d1(b, _, o, c);
        break;
      case 2:
        p1(b, _, f, o);
        break;
      case 3:
        g1(b, _, f, o, c);
        break;
      case 4:
        m1(b, _, f, o, c);
        break;
      default:
        throw new Error(`Unsupported filter: ${t[d]}`);
    }
    f = _, d += o + 1;
  }
  if (s === 16) {
    const g = new Uint16Array(l.buffer);
    if (a5)
      for (let y = 0; y < g.length; y++)
        g[y] = c5(g[y]);
    return g;
  } else
    return l;
}
function c5(r) {
  return (r & 255) << 8 | r >> 8 & 255;
}
const lo = Uint8Array.of(137, 80, 78, 71, 13, 10, 26, 10);
function mf(r) {
  if (!u5(r.readBytes(lo.length)))
    throw new Error("wrong PNG signature");
}
function u5(r) {
  if (r.length < lo.length)
    return !1;
  for (let t = 0; t < lo.length; t++)
    if (r[t] !== lo[t])
      return !1;
  return !0;
}
const l5 = "tEXt", f5 = 0, b1 = new TextDecoder("latin1");
function h5(r) {
  if (p5(r), r.length === 0 || r.length > 79)
    throw new Error("keyword length must be between 1 and 79");
}
const d5 = /^[\u0000-\u00FF]*$/;
function p5(r) {
  if (!d5.test(r))
    throw new Error("invalid latin1 text");
}
function g5(r, t, e) {
  const n = w1(t);
  r[n] = m5(t, e - n.length - 1);
}
function w1(r) {
  for (r.mark(); r.readByte() !== f5; )
    ;
  const t = r.offset;
  r.reset();
  const e = b1.decode(r.readBytes(t - r.offset - 1));
  return r.skip(1), h5(e), e;
}
function m5(r, t) {
  return b1.decode(r.readBytes(t));
}
const Hr = {
  UNKNOWN: -1,
  GREYSCALE: 0,
  TRUECOLOUR: 2,
  INDEXED_COLOUR: 3,
  GREYSCALE_ALPHA: 4,
  TRUECOLOUR_ALPHA: 6
}, Lc = {
  UNKNOWN: -1,
  DEFLATE: 0
}, bf = {
  UNKNOWN: -1,
  ADAPTIVE: 0
}, Sc = {
  UNKNOWN: -1,
  NO_INTERLACE: 0,
  ADAM7: 1
}, eo = {
  NONE: 0,
  BACKGROUND: 1,
  PREVIOUS: 2
}, kc = {
  SOURCE: 0,
  OVER: 1
};
class b5 extends Ou {
  _checkCrc;
  _inflator;
  _png;
  _apng;
  _end;
  _hasPalette;
  _palette;
  _hasTransparency;
  _transparency;
  _compressionMethod;
  _filterMethod;
  _interlaceMethod;
  _colorType;
  _isAnimated;
  _numberOfFrames;
  _numberOfPlays;
  _frames;
  _writingDataChunks;
  constructor(t, e = {}) {
    super(t);
    const { checkCrc: n = !1 } = e;
    this._checkCrc = n, this._inflator = new hf(), this._png = {
      width: -1,
      height: -1,
      channels: -1,
      data: new Uint8Array(0),
      depth: 1,
      text: {}
    }, this._apng = {
      width: -1,
      height: -1,
      channels: -1,
      depth: 1,
      numberOfFrames: 1,
      numberOfPlays: 0,
      text: {},
      frames: []
    }, this._end = !1, this._hasPalette = !1, this._palette = [], this._hasTransparency = !1, this._transparency = new Uint16Array(0), this._compressionMethod = Lc.UNKNOWN, this._filterMethod = bf.UNKNOWN, this._interlaceMethod = Sc.UNKNOWN, this._colorType = Hr.UNKNOWN, this._isAnimated = !1, this._numberOfFrames = 1, this._numberOfPlays = 0, this._frames = [], this._writingDataChunks = !1, this.setBigEndian();
  }
  decode() {
    for (mf(this); !this._end; ) {
      const t = this.readUint32(), e = this.readChars(4);
      this.decodeChunk(t, e);
    }
    return this.decodeImage(), this._png;
  }
  decodeApng() {
    for (mf(this); !this._end; ) {
      const t = this.readUint32(), e = this.readChars(4);
      this.decodeApngChunk(t, e);
    }
    return this.decodeApngImage(), this._apng;
  }
  // https://www.w3.org/TR/PNG/#5Chunk-layout
  decodeChunk(t, e) {
    const n = this.offset;
    switch (e) {
      // 11.2 Critical chunks
      case "IHDR":
        this.decodeIHDR();
        break;
      case "PLTE":
        this.decodePLTE(t);
        break;
      case "IDAT":
        this.decodeIDAT(t);
        break;
      case "IEND":
        this._end = !0;
        break;
      // 11.3 Ancillary chunks
      case "tRNS":
        this.decodetRNS(t);
        break;
      case "iCCP":
        this.decodeiCCP(t);
        break;
      case l5:
        g5(this._png.text, this, t);
        break;
      case "pHYs":
        this.decodepHYs();
        break;
      default:
        this.skip(t);
        break;
    }
    if (this.offset - n !== t)
      throw new Error(`Length mismatch while decoding chunk ${e}`);
    this._checkCrc ? pf(this, t + 4, e) : this.skip(4);
  }
  decodeApngChunk(t, e) {
    const n = this.offset;
    switch (e !== "fdAT" && e !== "IDAT" && this._writingDataChunks && this.pushDataToFrame(), e) {
      case "acTL":
        this.decodeACTL();
        break;
      case "fcTL":
        this.decodeFCTL();
        break;
      case "fdAT":
        this.decodeFDAT(t);
        break;
      default:
        this.decodeChunk(t, e), this.offset = n + t;
        break;
    }
    if (this.offset - n !== t)
      throw new Error(`Length mismatch while decoding chunk ${e}`);
    this._checkCrc ? pf(this, t + 4, e) : this.skip(4);
  }
  // https://www.w3.org/TR/PNG/#11IHDR
  decodeIHDR() {
    const t = this._png;
    t.width = this.readUint32(), t.height = this.readUint32(), t.depth = w5(this.readUint8());
    const e = this.readUint8();
    this._colorType = e;
    let n;
    switch (e) {
      case Hr.GREYSCALE:
        n = 1;
        break;
      case Hr.TRUECOLOUR:
        n = 3;
        break;
      case Hr.INDEXED_COLOUR:
        n = 1;
        break;
      case Hr.GREYSCALE_ALPHA:
        n = 2;
        break;
      case Hr.TRUECOLOUR_ALPHA:
        n = 4;
        break;
      // Kept for exhaustiveness.
      // eslint-disable-next-line unicorn/no-useless-switch-case
      case Hr.UNKNOWN:
      default:
        throw new Error(`Unknown color type: ${e}`);
    }
    if (this._png.channels = n, this._compressionMethod = this.readUint8(), this._compressionMethod !== Lc.DEFLATE)
      throw new Error(`Unsupported compression method: ${this._compressionMethod}`);
    this._filterMethod = this.readUint8(), this._interlaceMethod = this.readUint8();
  }
  decodeACTL() {
    this._numberOfFrames = this.readUint32(), this._numberOfPlays = this.readUint32(), this._isAnimated = !0;
  }
  decodeFCTL() {
    const t = {
      sequenceNumber: this.readUint32(),
      width: this.readUint32(),
      height: this.readUint32(),
      xOffset: this.readUint32(),
      yOffset: this.readUint32(),
      delayNumber: this.readUint16(),
      delayDenominator: this.readUint16(),
      disposeOp: this.readUint8(),
      blendOp: this.readUint8(),
      data: new Uint8Array(0)
    };
    this._frames.push(t);
  }
  // https://www.w3.org/TR/PNG/#11PLTE
  decodePLTE(t) {
    if (t % 3 !== 0)
      throw new RangeError(`PLTE field length must be a multiple of 3. Got ${t}`);
    const e = t / 3;
    this._hasPalette = !0;
    const n = [];
    this._palette = n;
    for (let i = 0; i < e; i++)
      n.push([this.readUint8(), this.readUint8(), this.readUint8()]);
  }
  // https://www.w3.org/TR/PNG/#11IDAT
  decodeIDAT(t) {
    this._writingDataChunks = !0;
    const e = t, n = this.offset + this.byteOffset;
    if (this._inflator.push(new Uint8Array(this.buffer, n, e)), this._inflator.err)
      throw new Error(`Error while decompressing the data: ${this._inflator.err}`);
    this.skip(t);
  }
  decodeFDAT(t) {
    this._writingDataChunks = !0;
    let e = t, n = this.offset + this.byteOffset;
    if (n += 4, e -= 4, this._inflator.push(new Uint8Array(this.buffer, n, e)), this._inflator.err)
      throw new Error(`Error while decompressing the data: ${this._inflator.err}`);
    this.skip(t);
  }
  // https://www.w3.org/TR/PNG/#11tRNS
  decodetRNS(t) {
    switch (this._colorType) {
      case Hr.GREYSCALE:
      case Hr.TRUECOLOUR: {
        if (t % 2 !== 0)
          throw new RangeError(`tRNS chunk length must be a multiple of 2. Got ${t}`);
        if (t / 2 > this._png.width * this._png.height)
          throw new Error(`tRNS chunk contains more alpha values than there are pixels (${t / 2} vs ${this._png.width * this._png.height})`);
        this._hasTransparency = !0, this._transparency = new Uint16Array(t / 2);
        for (let e = 0; e < t / 2; e++)
          this._transparency[e] = this.readUint16();
        break;
      }
      case Hr.INDEXED_COLOUR: {
        if (t > this._palette.length)
          throw new Error(`tRNS chunk contains more alpha values than there are palette colors (${t} vs ${this._palette.length})`);
        let e = 0;
        for (; e < t; e++) {
          const n = this.readByte();
          this._palette[e].push(n);
        }
        for (; e < this._palette.length; e++)
          this._palette[e].push(255);
        break;
      }
      // Kept for exhaustiveness.
      /* eslint-disable unicorn/no-useless-switch-case */
      case Hr.UNKNOWN:
      case Hr.GREYSCALE_ALPHA:
      case Hr.TRUECOLOUR_ALPHA:
      default:
        throw new Error(`tRNS chunk is not supported for color type ${this._colorType}`);
    }
  }
  // https://www.w3.org/TR/PNG/#11iCCP
  decodeiCCP(t) {
    const e = w1(this), n = this.readUint8();
    if (n !== Lc.DEFLATE)
      throw new Error(`Unsupported iCCP compression method: ${n}`);
    const i = this.readBytes(t - e.length - 2);
    this._png.iccEmbeddedProfile = {
      name: e,
      profile: Y0(i)
    };
  }
  // https://www.w3.org/TR/PNG/#11pHYs
  decodepHYs() {
    const t = this.readUint32(), e = this.readUint32(), n = this.readByte();
    this._png.resolution = { x: t, y: e, unit: n };
  }
  decodeApngImage() {
    this._apng.width = this._png.width, this._apng.height = this._png.height, this._apng.channels = this._png.channels, this._apng.depth = this._png.depth, this._apng.numberOfFrames = this._numberOfFrames, this._apng.numberOfPlays = this._numberOfPlays, this._apng.text = this._png.text, this._apng.resolution = this._png.resolution;
    for (let t = 0; t < this._numberOfFrames; t++) {
      const e = {
        sequenceNumber: this._frames[t].sequenceNumber,
        delayNumber: this._frames[t].delayNumber,
        delayDenominator: this._frames[t].delayDenominator,
        data: this._apng.depth === 8 ? new Uint8Array(this._apng.width * this._apng.height * this._apng.channels) : new Uint16Array(this._apng.width * this._apng.height * this._apng.channels)
      }, n = this._frames.at(t);
      if (n) {
        if (n.data = gf({
          data: n.data,
          width: n.width,
          height: n.height,
          channels: this._apng.channels,
          depth: this._apng.depth
        }), this._hasPalette && (this._apng.palette = this._palette), this._hasTransparency && (this._apng.transparency = this._transparency), t === 0 || n.xOffset === 0 && n.yOffset === 0 && n.width === this._png.width && n.height === this._png.height)
          e.data = n.data;
        else {
          const i = this._apng.frames.at(t - 1);
          this.disposeFrame(n, i, e), this.addFrameDataToCanvas(e, n);
        }
        this._apng.frames.push(e);
      }
    }
    return this._apng;
  }
  disposeFrame(t, e, n) {
    switch (t.disposeOp) {
      case eo.NONE:
        break;
      case eo.BACKGROUND:
        for (let i = 0; i < this._png.height; i++)
          for (let s = 0; s < this._png.width; s++) {
            const c = (i * t.width + s) * this._png.channels;
            for (let o = 0; o < this._png.channels; o++)
              n.data[c + o] = 0;
          }
        break;
      case eo.PREVIOUS:
        n.data.set(e.data);
        break;
      default:
        throw new Error("Unknown disposeOp");
    }
  }
  addFrameDataToCanvas(t, e) {
    const n = 1 << this._png.depth, i = (s, c) => {
      const o = ((s + e.yOffset) * this._png.width + e.xOffset + c) * this._png.channels, l = (s * e.width + c) * this._png.channels;
      return { index: o, frameIndex: l };
    };
    switch (e.blendOp) {
      case kc.SOURCE:
        for (let s = 0; s < e.height; s++)
          for (let c = 0; c < e.width; c++) {
            const { index: o, frameIndex: l } = i(s, c);
            for (let f = 0; f < this._png.channels; f++)
              t.data[o + f] = e.data[l + f];
          }
        break;
      // https://www.w3.org/TR/png-3/#13Alpha-channel-processing
      case kc.OVER:
        for (let s = 0; s < e.height; s++)
          for (let c = 0; c < e.width; c++) {
            const { index: o, frameIndex: l } = i(s, c);
            for (let f = 0; f < this._png.channels; f++) {
              const d = e.data[l + this._png.channels - 1] / n, b = f % (this._png.channels - 1) === 0 ? 1 : e.data[l + f], _ = Math.floor(d * b + (1 - d) * t.data[o + f]);
              t.data[o + f] += _;
            }
          }
        break;
      default:
        throw new Error("Unknown blendOp");
    }
  }
  decodeImage() {
    if (this._inflator.err)
      throw new Error(`Error while decompressing the data: ${this._inflator.err}`);
    const t = this._isAnimated ? (this._frames?.at(0)).data : this._inflator.result;
    if (this._filterMethod !== bf.ADAPTIVE)
      throw new Error(`Filter method ${this._filterMethod} not supported`);
    if (this._interlaceMethod === Sc.NO_INTERLACE)
      this._png.data = gf({
        data: t,
        width: this._png.width,
        height: this._png.height,
        channels: this._png.channels,
        depth: this._png.depth
      });
    else if (this._interlaceMethod === Sc.ADAM7)
      this._png.data = r5({
        data: t,
        width: this._png.width,
        height: this._png.height,
        channels: this._png.channels,
        depth: this._png.depth
      });
    else
      throw new Error(`Interlace method ${this._interlaceMethod} not supported`);
    this._hasPalette && (this._png.palette = this._palette), this._hasTransparency && (this._png.transparency = this._transparency);
  }
  pushDataToFrame() {
    const t = this._inflator.result, e = this._frames.at(-1);
    e ? e.data = t : this._frames.push({
      sequenceNumber: 0,
      width: this._png.width,
      height: this._png.height,
      xOffset: 0,
      yOffset: 0,
      delayNumber: 0,
      delayDenominator: 0,
      disposeOp: eo.NONE,
      blendOp: kc.SOURCE,
      data: t
    }), this._inflator = new hf(), this._writingDataChunks = !1;
  }
}
function w5(r) {
  if (r !== 1 && r !== 2 && r !== 4 && r !== 8 && r !== 16)
    throw new Error(`invalid bit depth: ${r}`);
  return r;
}
var wf;
(function(r) {
  r[r.UNKNOWN = 0] = "UNKNOWN", r[r.METRE = 1] = "METRE";
})(wf || (wf = {}));
function v5(r, t) {
  return new b5(r, t).decode();
}
var Kt = /* @__PURE__ */ (function() {
  return typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : this;
})();
function Ec() {
  Kt.console && typeof Kt.console.log == "function" && Kt.console.log.apply(Kt.console, arguments);
}
var Pe = { log: Ec, warn: function(r) {
  Kt.console && (typeof Kt.console.warn == "function" ? Kt.console.warn.apply(Kt.console, arguments) : Ec.call(null, arguments));
}, error: function(r) {
  Kt.console && (typeof Kt.console.error == "function" ? Kt.console.error.apply(Kt.console, arguments) : Ec(r));
} };
function Pc(r, t, e) {
  var n = new XMLHttpRequest();
  n.open("GET", r), n.responseType = "blob", n.onload = function() {
    Di(n.response, t, e);
  }, n.onerror = function() {
    Pe.error("could not download file");
  }, n.send();
}
function vf(r) {
  var t = new XMLHttpRequest();
  t.open("HEAD", r, !1);
  try {
    t.send();
  } catch {
  }
  return t.status >= 200 && t.status <= 299;
}
function ro(r) {
  try {
    r.dispatchEvent(new MouseEvent("click"));
  } catch {
    var t = document.createEvent("MouseEvents");
    t.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), r.dispatchEvent(t);
  }
}
var Di = Kt.saveAs || ((typeof window > "u" ? "undefined" : xe(window)) !== "object" || window !== Kt ? function() {
} : typeof HTMLAnchorElement < "u" && "download" in HTMLAnchorElement.prototype ? function(r, t, e) {
  var n = Kt.URL || Kt.webkitURL, i = document.createElement("a");
  t = t || r.name || "download", i.download = t, i.rel = "noopener", typeof r == "string" ? (i.href = r, i.origin !== location.origin ? vf(i.href) ? Pc(r, t, e) : ro(i, i.target = "_blank") : ro(i)) : (i.href = n.createObjectURL(r), setTimeout(function() {
    n.revokeObjectURL(i.href);
  }, 4e4), setTimeout(function() {
    ro(i);
  }, 0));
} : "msSaveOrOpenBlob" in navigator ? function(r, t, e) {
  if (t = t || r.name || "download", typeof r == "string") if (vf(r)) Pc(r, t, e);
  else {
    var n = document.createElement("a");
    n.href = r, n.target = "_blank", setTimeout(function() {
      ro(n);
    });
  }
  else navigator.msSaveOrOpenBlob((function(i, s) {
    return s === void 0 ? s = { autoBom: !1 } : xe(s) !== "object" && (Pe.warn("Deprecated: Expected third argument to be a object"), s = { autoBom: !s }), s.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(i.type) ? new Blob(["\uFEFF", i], { type: i.type }) : i;
  })(r, e), t);
} : function(r, t, e, n) {
  if ((n = n || open("", "_blank")) && (n.document.title = n.document.body.innerText = "downloading..."), typeof r == "string") return Pc(r, t, e);
  var i = r.type === "application/octet-stream", s = /constructor/i.test(Kt.HTMLElement) || Kt.safari, c = /CriOS\/[\d]+/.test(navigator.userAgent);
  if ((c || i && s) && (typeof FileReader > "u" ? "undefined" : xe(FileReader)) === "object") {
    var o = new FileReader();
    o.onloadend = function() {
      var d = o.result;
      d = c ? d : d.replace(/^data:[^;]*;/, "data:attachment/file;"), n ? n.location.href = d : location = d, n = null;
    }, o.readAsDataURL(r);
  } else {
    var l = Kt.URL || Kt.webkitURL, f = l.createObjectURL(r);
    n ? n.location = f : location.href = f, n = null, setTimeout(function() {
      l.revokeObjectURL(f);
    }, 4e4);
  }
});
function v1(r) {
  var t;
  r = r || "", this.ok = !1, r.charAt(0) == "#" && (r = r.substr(1, 6)), r = { aliceblue: "f0f8ff", antiquewhite: "faebd7", aqua: "00ffff", aquamarine: "7fffd4", azure: "f0ffff", beige: "f5f5dc", bisque: "ffe4c4", black: "000000", blanchedalmond: "ffebcd", blue: "0000ff", blueviolet: "8a2be2", brown: "a52a2a", burlywood: "deb887", cadetblue: "5f9ea0", chartreuse: "7fff00", chocolate: "d2691e", coral: "ff7f50", cornflowerblue: "6495ed", cornsilk: "fff8dc", crimson: "dc143c", cyan: "00ffff", darkblue: "00008b", darkcyan: "008b8b", darkgoldenrod: "b8860b", darkgray: "a9a9a9", darkgreen: "006400", darkkhaki: "bdb76b", darkmagenta: "8b008b", darkolivegreen: "556b2f", darkorange: "ff8c00", darkorchid: "9932cc", darkred: "8b0000", darksalmon: "e9967a", darkseagreen: "8fbc8f", darkslateblue: "483d8b", darkslategray: "2f4f4f", darkturquoise: "00ced1", darkviolet: "9400d3", deeppink: "ff1493", deepskyblue: "00bfff", dimgray: "696969", dodgerblue: "1e90ff", feldspar: "d19275", firebrick: "b22222", floralwhite: "fffaf0", forestgreen: "228b22", fuchsia: "ff00ff", gainsboro: "dcdcdc", ghostwhite: "f8f8ff", gold: "ffd700", goldenrod: "daa520", gray: "808080", green: "008000", greenyellow: "adff2f", honeydew: "f0fff0", hotpink: "ff69b4", indianred: "cd5c5c", indigo: "4b0082", ivory: "fffff0", khaki: "f0e68c", lavender: "e6e6fa", lavenderblush: "fff0f5", lawngreen: "7cfc00", lemonchiffon: "fffacd", lightblue: "add8e6", lightcoral: "f08080", lightcyan: "e0ffff", lightgoldenrodyellow: "fafad2", lightgrey: "d3d3d3", lightgreen: "90ee90", lightpink: "ffb6c1", lightsalmon: "ffa07a", lightseagreen: "20b2aa", lightskyblue: "87cefa", lightslateblue: "8470ff", lightslategray: "778899", lightsteelblue: "b0c4de", lightyellow: "ffffe0", lime: "00ff00", limegreen: "32cd32", linen: "faf0e6", magenta: "ff00ff", maroon: "800000", mediumaquamarine: "66cdaa", mediumblue: "0000cd", mediumorchid: "ba55d3", mediumpurple: "9370d8", mediumseagreen: "3cb371", mediumslateblue: "7b68ee", mediumspringgreen: "00fa9a", mediumturquoise: "48d1cc", mediumvioletred: "c71585", midnightblue: "191970", mintcream: "f5fffa", mistyrose: "ffe4e1", moccasin: "ffe4b5", navajowhite: "ffdead", navy: "000080", oldlace: "fdf5e6", olive: "808000", olivedrab: "6b8e23", orange: "ffa500", orangered: "ff4500", orchid: "da70d6", palegoldenrod: "eee8aa", palegreen: "98fb98", paleturquoise: "afeeee", palevioletred: "d87093", papayawhip: "ffefd5", peachpuff: "ffdab9", peru: "cd853f", pink: "ffc0cb", plum: "dda0dd", powderblue: "b0e0e6", purple: "800080", red: "ff0000", rosybrown: "bc8f8f", royalblue: "4169e1", saddlebrown: "8b4513", salmon: "fa8072", sandybrown: "f4a460", seagreen: "2e8b57", seashell: "fff5ee", sienna: "a0522d", silver: "c0c0c0", skyblue: "87ceeb", slateblue: "6a5acd", slategray: "708090", snow: "fffafa", springgreen: "00ff7f", steelblue: "4682b4", tan: "d2b48c", teal: "008080", thistle: "d8bfd8", tomato: "ff6347", turquoise: "40e0d0", violet: "ee82ee", violetred: "d02090", wheat: "f5deb3", white: "ffffff", whitesmoke: "f5f5f5", yellow: "ffff00", yellowgreen: "9acd32" }[r = (r = r.replace(/ /g, "")).toLowerCase()] || r;
  for (var e = [{ re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/, example: ["rgb(123, 234, 45)", "rgb(255,234,245)"], process: function(o) {
    return [parseInt(o[1]), parseInt(o[2]), parseInt(o[3])];
  } }, { re: /^(\w{2})(\w{2})(\w{2})$/, example: ["#00ff00", "336699"], process: function(o) {
    return [parseInt(o[1], 16), parseInt(o[2], 16), parseInt(o[3], 16)];
  } }, { re: /^(\w{1})(\w{1})(\w{1})$/, example: ["#fb0", "f0f"], process: function(o) {
    return [parseInt(o[1] + o[1], 16), parseInt(o[2] + o[2], 16), parseInt(o[3] + o[3], 16)];
  } }], n = 0; n < e.length; n++) {
    var i = e[n].re, s = e[n].process, c = i.exec(r);
    c && (t = s(c), this.r = t[0], this.g = t[1], this.b = t[2], this.ok = !0);
  }
  this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.toRGB = function() {
    return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
  }, this.toHex = function() {
    var o = this.r.toString(16), l = this.g.toString(16), f = this.b.toString(16);
    return o.length == 1 && (o = "0" + o), l.length == 1 && (l = "0" + l), f.length == 1 && (f = "0" + f), "#" + o + l + f;
  };
}
var fo = Kt.atob.bind(Kt), yf = Kt.btoa.bind(Kt);
function Cc(r, t) {
  var e = r[0], n = r[1], i = r[2], s = r[3];
  e = wr(e, n, i, s, t[0], 7, -680876936), s = wr(s, e, n, i, t[1], 12, -389564586), i = wr(i, s, e, n, t[2], 17, 606105819), n = wr(n, i, s, e, t[3], 22, -1044525330), e = wr(e, n, i, s, t[4], 7, -176418897), s = wr(s, e, n, i, t[5], 12, 1200080426), i = wr(i, s, e, n, t[6], 17, -1473231341), n = wr(n, i, s, e, t[7], 22, -45705983), e = wr(e, n, i, s, t[8], 7, 1770035416), s = wr(s, e, n, i, t[9], 12, -1958414417), i = wr(i, s, e, n, t[10], 17, -42063), n = wr(n, i, s, e, t[11], 22, -1990404162), e = wr(e, n, i, s, t[12], 7, 1804603682), s = wr(s, e, n, i, t[13], 12, -40341101), i = wr(i, s, e, n, t[14], 17, -1502002290), e = vr(e, n = wr(n, i, s, e, t[15], 22, 1236535329), i, s, t[1], 5, -165796510), s = vr(s, e, n, i, t[6], 9, -1069501632), i = vr(i, s, e, n, t[11], 14, 643717713), n = vr(n, i, s, e, t[0], 20, -373897302), e = vr(e, n, i, s, t[5], 5, -701558691), s = vr(s, e, n, i, t[10], 9, 38016083), i = vr(i, s, e, n, t[15], 14, -660478335), n = vr(n, i, s, e, t[4], 20, -405537848), e = vr(e, n, i, s, t[9], 5, 568446438), s = vr(s, e, n, i, t[14], 9, -1019803690), i = vr(i, s, e, n, t[3], 14, -187363961), n = vr(n, i, s, e, t[8], 20, 1163531501), e = vr(e, n, i, s, t[13], 5, -1444681467), s = vr(s, e, n, i, t[2], 9, -51403784), i = vr(i, s, e, n, t[7], 14, 1735328473), e = yr(e, n = vr(n, i, s, e, t[12], 20, -1926607734), i, s, t[5], 4, -378558), s = yr(s, e, n, i, t[8], 11, -2022574463), i = yr(i, s, e, n, t[11], 16, 1839030562), n = yr(n, i, s, e, t[14], 23, -35309556), e = yr(e, n, i, s, t[1], 4, -1530992060), s = yr(s, e, n, i, t[4], 11, 1272893353), i = yr(i, s, e, n, t[7], 16, -155497632), n = yr(n, i, s, e, t[10], 23, -1094730640), e = yr(e, n, i, s, t[13], 4, 681279174), s = yr(s, e, n, i, t[0], 11, -358537222), i = yr(i, s, e, n, t[3], 16, -722521979), n = yr(n, i, s, e, t[6], 23, 76029189), e = yr(e, n, i, s, t[9], 4, -640364487), s = yr(s, e, n, i, t[12], 11, -421815835), i = yr(i, s, e, n, t[15], 16, 530742520), e = _r(e, n = yr(n, i, s, e, t[2], 23, -995338651), i, s, t[0], 6, -198630844), s = _r(s, e, n, i, t[7], 10, 1126891415), i = _r(i, s, e, n, t[14], 15, -1416354905), n = _r(n, i, s, e, t[5], 21, -57434055), e = _r(e, n, i, s, t[12], 6, 1700485571), s = _r(s, e, n, i, t[3], 10, -1894986606), i = _r(i, s, e, n, t[10], 15, -1051523), n = _r(n, i, s, e, t[1], 21, -2054922799), e = _r(e, n, i, s, t[8], 6, 1873313359), s = _r(s, e, n, i, t[15], 10, -30611744), i = _r(i, s, e, n, t[6], 15, -1560198380), n = _r(n, i, s, e, t[13], 21, 1309151649), e = _r(e, n, i, s, t[4], 6, -145523070), s = _r(s, e, n, i, t[11], 10, -1120210379), i = _r(i, s, e, n, t[2], 15, 718787259), n = _r(n, i, s, e, t[9], 21, -343485551), r[0] = hi(e, r[0]), r[1] = hi(n, r[1]), r[2] = hi(i, r[2]), r[3] = hi(s, r[3]);
}
function Co(r, t, e, n, i, s) {
  return t = hi(hi(t, r), hi(n, s)), hi(t << i | t >>> 32 - i, e);
}
function wr(r, t, e, n, i, s, c) {
  return Co(t & e | ~t & n, r, t, i, s, c);
}
function vr(r, t, e, n, i, s, c) {
  return Co(t & n | e & ~n, r, t, i, s, c);
}
function yr(r, t, e, n, i, s, c) {
  return Co(t ^ e ^ n, r, t, i, s, c);
}
function _r(r, t, e, n, i, s, c) {
  return Co(e ^ (t | ~n), r, t, i, s, c);
}
function y1(r) {
  var t, e = r.length, n = [1732584193, -271733879, -1732584194, 271733878];
  for (t = 64; t <= r.length; t += 64) Cc(n, y5(r.substring(t - 64, t)));
  r = r.substring(t - 64);
  var i = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  for (t = 0; t < r.length; t++) i[t >> 2] |= r.charCodeAt(t) << (t % 4 << 3);
  if (i[t >> 2] |= 128 << (t % 4 << 3), t > 55) for (Cc(n, i), t = 0; t < 16; t++) i[t] = 0;
  return i[14] = 8 * e, Cc(n, i), n;
}
function y5(r) {
  var t, e = [];
  for (t = 0; t < 64; t += 4) e[t >> 2] = r.charCodeAt(t) + (r.charCodeAt(t + 1) << 8) + (r.charCodeAt(t + 2) << 16) + (r.charCodeAt(t + 3) << 24);
  return e;
}
var _f = "0123456789abcdef".split("");
function _5(r) {
  for (var t = "", e = 0; e < 4; e++) t += _f[r >> 8 * e + 4 & 15] + _f[r >> 8 * e & 15];
  return t;
}
function A5(r) {
  return String.fromCharCode(255 & r, (65280 & r) >> 8, (16711680 & r) >> 16, (4278190080 & r) >> 24);
}
function wu(r) {
  return y1(r).map(A5).join("");
}
var x5 = (function(r) {
  for (var t = 0; t < r.length; t++) r[t] = _5(r[t]);
  return r.join("");
})(y1("hello")) != "5d41402abc4b2a76b9719d911017c592";
function hi(r, t) {
  if (x5) {
    var e = (65535 & r) + (65535 & t);
    return (r >> 16) + (t >> 16) + (e >> 16) << 16 | 65535 & e;
  }
  return r + t & 4294967295;
}
function vu(r, t) {
  var e, n, i, s;
  if (r !== e) {
    for (var c = (i = r, s = 1 + (256 / r.length | 0), new Array(s + 1).join(i)), o = [], l = 0; l < 256; l++) o[l] = l;
    var f = 0;
    for (l = 0; l < 256; l++) {
      var d = o[l];
      f = (f + d + c.charCodeAt(l)) % 256, o[l] = o[f], o[f] = d;
    }
    e = r, n = o;
  } else o = n;
  var b = t.length, _ = 0, g = 0, y = "";
  for (l = 0; l < b; l++) g = (g + (d = o[_ = (_ + 1) % 256])) % 256, o[_] = o[g], o[g] = d, c = o[(o[_] + o[g]) % 256], y += String.fromCharCode(t.charCodeAt(l) ^ c);
  return y;
}
var Af = { print: 4, modify: 8, copy: 16, "annot-forms": 32 };
function ds(r, t, e, n) {
  this.v = 1, this.r = 2;
  var i = 192;
  r.forEach(function(o) {
    if (Af.perm !== void 0) throw new Error("Invalid permission: " + o);
    i += Af[o];
  }), this.padding = "(¿N^NuAd\0NVÿú\b..\0¶Ðh>/\f©þdSiz";
  var s = (t + this.padding).substr(0, 32), c = (e + this.padding).substr(0, 32);
  this.O = this.processOwnerPassword(s, c), this.P = -(1 + (255 ^ i)), this.encryptionKey = wu(s + this.O + this.lsbFirstWord(this.P) + this.hexToBytes(n)).substr(0, 5), this.U = vu(this.encryptionKey, this.padding);
}
function ps(r) {
  if (/[^\u0000-\u00ff]/.test(r)) throw new Error("Invalid PDF Name Object: " + r + ", Only accept ASCII characters.");
  for (var t = "", e = r.length, n = 0; n < e; n++) {
    var i = r.charCodeAt(n);
    t += i < 33 || i === 35 || i === 37 || i === 40 || i === 41 || i === 47 || i === 60 || i === 62 || i === 91 || i === 93 || i === 123 || i === 125 || i > 126 ? "#" + ("0" + i.toString(16)).slice(-2) : r[n];
  }
  return t;
}
function xf(r) {
  if (xe(r) !== "object") throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");
  var t = {};
  this.subscribe = function(e, n, i) {
    if (i = i || !1, typeof e != "string" || typeof n != "function" || typeof i != "boolean") throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");
    t.hasOwnProperty(e) || (t[e] = {});
    var s = Math.random().toString(35);
    return t[e][s] = [n, !!i], s;
  }, this.unsubscribe = function(e) {
    for (var n in t) if (t[n][e]) return delete t[n][e], Object.keys(t[n]).length === 0 && delete t[n], !0;
    return !1;
  }, this.publish = function(e) {
    if (t.hasOwnProperty(e)) {
      var n = Array.prototype.slice.call(arguments, 1), i = [];
      for (var s in t[e]) {
        var c = t[e][s];
        try {
          c[0].apply(r, n);
        } catch (o) {
          Kt.console && Pe.error("jsPDF PubSub Error", o.message, o);
        }
        c[1] && i.push(s);
      }
      i.length && i.forEach(this.unsubscribe);
    }
  }, this.getTopics = function() {
    return t;
  };
}
function Lo(r) {
  if (!(this instanceof Lo)) return new Lo(r);
  var t = "opacity,stroke-opacity".split(",");
  for (var e in r) r.hasOwnProperty(e) && t.indexOf(e) >= 0 && (this[e] = r[e]);
  this.id = "", this.objectNumber = -1;
}
function _1(r, t) {
  this.gState = r, this.matrix = t, this.id = "", this.objectNumber = -1;
}
function ji(r, t, e, n, i) {
  if (!(this instanceof ji)) return new ji(r, t, e, n, i);
  this.type = r === "axial" ? 2 : 3, this.coords = t, this.colors = e, _1.call(this, n, i);
}
function gs(r, t, e, n, i) {
  if (!(this instanceof gs)) return new gs(r, t, e, n, i);
  this.boundingBox = r, this.xStep = t, this.yStep = e, this.stream = "", this.cloneIndex = 0, _1.call(this, n, i);
}
function Dt(r) {
  var t, e = typeof arguments[0] == "string" ? arguments[0] : "p", n = arguments[1], i = arguments[2], s = arguments[3], c = [], o = 1, l = 16, f = "S", d = null;
  xe(r = r || {}) === "object" && (e = r.orientation, n = r.unit || n, i = r.format || i, s = r.compress || r.compressPdf || s, (d = r.encryption || null) !== null && (d.userPassword = d.userPassword || "", d.ownerPassword = d.ownerPassword || "", d.userPermissions = d.userPermissions || []), o = typeof r.userUnit == "number" ? Math.abs(r.userUnit) : 1, r.precision !== void 0 && (t = r.precision), r.floatPrecision !== void 0 && (l = r.floatPrecision), f = r.defaultPathOperation || "S"), c = r.filters || (s === !0 ? ["FlateEncode"] : c), n = n || "mm", e = ("" + (e || "P")).toLowerCase();
  var b = r.putOnlyUsedFonts || !1, _ = {}, g = { internal: {}, __private__: {} };
  g.__private__.PubSub = xf;
  var y = "1.3", x = g.__private__.getPdfVersion = function() {
    return y;
  };
  g.__private__.setPdfVersion = function(h) {
    y = h;
  };
  var E = { a0: [2383.94, 3370.39], a1: [1683.78, 2383.94], a2: [1190.55, 1683.78], a3: [841.89, 1190.55], a4: [595.28, 841.89], a5: [419.53, 595.28], a6: [297.64, 419.53], a7: [209.76, 297.64], a8: [147.4, 209.76], a9: [104.88, 147.4], a10: [73.7, 104.88], b0: [2834.65, 4008.19], b1: [2004.09, 2834.65], b2: [1417.32, 2004.09], b3: [1000.63, 1417.32], b4: [708.66, 1000.63], b5: [498.9, 708.66], b6: [354.33, 498.9], b7: [249.45, 354.33], b8: [175.75, 249.45], b9: [124.72, 175.75], b10: [87.87, 124.72], c0: [2599.37, 3676.54], c1: [1836.85, 2599.37], c2: [1298.27, 1836.85], c3: [918.43, 1298.27], c4: [649.13, 918.43], c5: [459.21, 649.13], c6: [323.15, 459.21], c7: [229.61, 323.15], c8: [161.57, 229.61], c9: [113.39, 161.57], c10: [79.37, 113.39], dl: [311.81, 623.62], letter: [612, 792], "government-letter": [576, 756], legal: [612, 1008], "junior-legal": [576, 360], ledger: [1224, 792], tabloid: [792, 1224], "credit-card": [153, 243] };
  g.__private__.getPageFormats = function() {
    return E;
  };
  var N = g.__private__.getPageFormat = function(h) {
    return E[h];
  };
  i = i || "a4";
  var H = "compat", q = "advanced", F = H;
  function et() {
    this.saveGraphicsState(), U(new Gt(Yt, 0, 0, -Yt, 0, Si() * Yt).toString() + " cm"), this.setFontSize(this.getFontSize() / Yt), f = "n", F = q;
  }
  function Q() {
    this.restoreGraphicsState(), f = "S", F = H;
  }
  var X = g.__private__.combineFontStyleAndFontWeight = function(h, w) {
    if (h == "bold" && w == "normal" || h == "bold" && w == 400 || h == "normal" && w == "italic" || h == "bold" && w == "italic") throw new Error("Invalid Combination of fontweight and fontstyle");
    return w && (h = w == 400 || w === "normal" ? h === "italic" ? "italic" : "normal" : w != 700 && w !== "bold" || h !== "normal" ? (w == 700 ? "bold" : w) + "" + h : "bold"), h;
  };
  g.advancedAPI = function(h) {
    var w = F === H;
    return w && et.call(this), typeof h != "function" || (h(this), w && Q.call(this)), this;
  }, g.compatAPI = function(h) {
    var w = F === q;
    return w && Q.call(this), typeof h != "function" || (h(this), w && et.call(this)), this;
  }, g.isAdvancedAPI = function() {
    return F === q;
  };
  var V, I = function(h) {
    if (F !== q) throw new Error(h + " is only available in 'advanced' API mode. You need to call advancedAPI() first.");
  }, G = g.roundToPrecision = g.__private__.roundToPrecision = function(h, w) {
    var T = t || w;
    if (isNaN(h) || isNaN(T)) throw new Error("Invalid argument passed to jsPDF.roundToPrecision");
    return h.toFixed(T).replace(/0+$/, "");
  };
  V = g.hpf = g.__private__.hpf = typeof l == "number" ? function(h) {
    if (isNaN(h)) throw new Error("Invalid argument passed to jsPDF.hpf");
    return G(h, l);
  } : l === "smart" ? function(h) {
    if (isNaN(h)) throw new Error("Invalid argument passed to jsPDF.hpf");
    return G(h, h > -1 && h < 1 ? 16 : 5);
  } : function(h) {
    if (isNaN(h)) throw new Error("Invalid argument passed to jsPDF.hpf");
    return G(h, 16);
  };
  var A = g.f2 = g.__private__.f2 = function(h) {
    if (isNaN(h)) throw new Error("Invalid argument passed to jsPDF.f2");
    return G(h, 2);
  }, C = g.__private__.f3 = function(h) {
    if (isNaN(h)) throw new Error("Invalid argument passed to jsPDF.f3");
    return G(h, 3);
  }, M = g.scale = g.__private__.scale = function(h) {
    if (isNaN(h)) throw new Error("Invalid argument passed to jsPDF.scale");
    return F === H ? h * Yt : F === q ? h : void 0;
  }, D = function(h) {
    return M((function(w) {
      return F === H ? Si() - w : F === q ? w : void 0;
    })(h));
  };
  g.__private__.setPrecision = g.setPrecision = function(h) {
    typeof parseInt(h, 10) == "number" && (t = parseInt(h, 10));
  };
  var at, ot = "00000000000000000000000000000000", ft = g.__private__.getFileId = function() {
    return ot;
  }, rt = g.__private__.setFileId = function(h) {
    return ot = h !== void 0 && /^[a-fA-F0-9]{32}$/.test(h) ? h.toUpperCase() : ot.split("").map(function() {
      return "ABCDEF0123456789".charAt(Math.floor(16 * Math.random()));
    }).join(""), d !== null && (He = new ds(d.userPermissions, d.userPassword, d.ownerPassword, ot)), ot;
  };
  g.setFileId = function(h) {
    return rt(h), this;
  }, g.getFileId = function() {
    return ft();
  };
  var ht = g.__private__.convertDateToPDFDate = function(h) {
    var w = h.getTimezoneOffset(), T = w < 0 ? "+" : "-", W = Math.floor(Math.abs(w / 60)), Z = Math.abs(w % 60), mt = [T, z(W), "'", z(Z), "'"].join("");
    return ["D:", h.getFullYear(), z(h.getMonth() + 1), z(h.getDate()), z(h.getHours()), z(h.getMinutes()), z(h.getSeconds()), mt].join("");
  }, Lt = g.__private__.convertPDFDateToDate = function(h) {
    var w = parseInt(h.substr(2, 4), 10), T = parseInt(h.substr(6, 2), 10) - 1, W = parseInt(h.substr(8, 2), 10), Z = parseInt(h.substr(10, 2), 10), mt = parseInt(h.substr(12, 2), 10), _t = parseInt(h.substr(14, 2), 10);
    return new Date(w, T, W, Z, mt, _t, 0);
  }, vt = g.__private__.setCreationDate = function(h) {
    var w;
    if (h === void 0 && (h = /* @__PURE__ */ new Date()), h instanceof Date) w = ht(h);
    else {
      if (!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|-0[0-9]|-1[0-1])'(0[0-9]|[1-5][0-9])'?$/.test(h)) throw new Error("Invalid argument passed to jsPDF.setCreationDate");
      w = h;
    }
    return at = w;
  }, S = g.__private__.getCreationDate = function(h) {
    var w = at;
    return h === "jsDate" && (w = Lt(at)), w;
  };
  g.setCreationDate = function(h) {
    return vt(h), this;
  }, g.getCreationDate = function(h) {
    return S(h);
  };
  var j, z = g.__private__.padd2 = function(h) {
    return ("0" + parseInt(h)).slice(-2);
  }, J = g.__private__.padd2Hex = function(h) {
    return ("00" + (h = h.toString())).substr(h.length);
  }, $ = 0, nt = [], lt = [], ct = 0, bt = [], xt = [], Et = !1, Pt = lt;
  g.__private__.setCustomOutputDestination = function(h) {
    Et = !0, Pt = h;
  };
  var dt = function(h) {
    Et || (Pt = h);
  };
  g.__private__.resetCustomOutputDestination = function() {
    Et = !1, Pt = lt;
  };
  var U = g.__private__.out = function(h) {
    return h = h.toString(), ct += h.length + 1, Pt.push(h), Pt;
  }, fe = g.__private__.write = function(h) {
    return U(arguments.length === 1 ? h.toString() : Array.prototype.join.call(arguments, " "));
  }, ae = g.__private__.getArrayBuffer = function(h) {
    for (var w = h.length, T = new ArrayBuffer(w), W = new Uint8Array(T); w--; ) W[w] = h.charCodeAt(w);
    return T;
  }, Vt = [["Helvetica", "helvetica", "normal", "WinAnsiEncoding"], ["Helvetica-Bold", "helvetica", "bold", "WinAnsiEncoding"], ["Helvetica-Oblique", "helvetica", "italic", "WinAnsiEncoding"], ["Helvetica-BoldOblique", "helvetica", "bolditalic", "WinAnsiEncoding"], ["Courier", "courier", "normal", "WinAnsiEncoding"], ["Courier-Bold", "courier", "bold", "WinAnsiEncoding"], ["Courier-Oblique", "courier", "italic", "WinAnsiEncoding"], ["Courier-BoldOblique", "courier", "bolditalic", "WinAnsiEncoding"], ["Times-Roman", "times", "normal", "WinAnsiEncoding"], ["Times-Bold", "times", "bold", "WinAnsiEncoding"], ["Times-Italic", "times", "italic", "WinAnsiEncoding"], ["Times-BoldItalic", "times", "bolditalic", "WinAnsiEncoding"], ["ZapfDingbats", "zapfdingbats", "normal", null], ["Symbol", "symbol", "normal", null]];
  g.__private__.getStandardFonts = function() {
    return Vt;
  };
  var Nt = r.fontSize || 16;
  g.__private__.setFontSize = g.setFontSize = function(h) {
    return Nt = F === q ? h / Yt : h, this;
  };
  var jt, kt = g.__private__.getFontSize = g.getFontSize = function() {
    return F === H ? Nt : Nt * Yt;
  }, oe = r.R2L || !1;
  g.__private__.setR2L = g.setR2L = function(h) {
    return oe = h, this;
  }, g.__private__.getR2L = g.getR2L = function() {
    return oe;
  };
  var Ht, me = g.__private__.setZoomMode = function(h) {
    if (/^(?:\d+\.\d*|\d*\.\d+|\d+)%$/.test(h)) jt = h;
    else if (isNaN(h)) {
      if ([void 0, null, "fullwidth", "fullheight", "fullpage", "original"].indexOf(h) === -1) throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "' + h + '" is not recognized.');
      jt = h;
    } else jt = parseInt(h, 10);
  };
  g.__private__.getZoomMode = function() {
    return jt;
  };
  var ee, re = g.__private__.setPageMode = function(h) {
    if ([void 0, null, "UseNone", "UseOutlines", "UseThumbs", "FullScreen"].indexOf(h) == -1) throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "' + h + '" is not recognized.');
    Ht = h;
  };
  g.__private__.getPageMode = function() {
    return Ht;
  };
  var Ne = g.__private__.setLayoutMode = function(h) {
    if ([void 0, null, "continuous", "single", "twoleft", "tworight", "two"].indexOf(h) == -1) throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "' + h + '" is not recognized.');
    ee = h;
  };
  g.__private__.getLayoutMode = function() {
    return ee;
  }, g.__private__.setDisplayMode = g.setDisplayMode = function(h, w, T) {
    return me(h), Ne(w), re(T), this;
  };
  var ce = { title: "", subject: "", author: "", keywords: "", creator: "" };
  g.__private__.getDocumentProperty = function(h) {
    if (Object.keys(ce).indexOf(h) === -1) throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");
    return ce[h];
  }, g.__private__.getDocumentProperties = function() {
    return ce;
  }, g.__private__.setDocumentProperties = g.setProperties = g.setDocumentProperties = function(h) {
    for (var w in ce) ce.hasOwnProperty(w) && h[w] && (ce[w] = h[w]);
    return this;
  }, g.__private__.setDocumentProperty = function(h, w) {
    if (Object.keys(ce).indexOf(h) === -1) throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");
    return ce[h] = w;
  };
  var qt, Yt, Ut, Ce, be, Tt = {}, ne = {}, Le = [], Wt = {}, he = {}, ie = {}, ze = {}, er = null, Se = 0, $t = [], ve = new xf(g), pi = r.hotfixes || [], gr = {}, kn = {}, gn = [], Gt = function h(w, T, W, Z, mt, _t) {
    if (!(this instanceof h)) return new h(w, T, W, Z, mt, _t);
    isNaN(w) && (w = 1), isNaN(T) && (T = 0), isNaN(W) && (W = 0), isNaN(Z) && (Z = 1), isNaN(mt) && (mt = 0), isNaN(_t) && (_t = 0), this._matrix = [w, T, W, Z, mt, _t];
  };
  Object.defineProperty(Gt.prototype, "sx", { get: function() {
    return this._matrix[0];
  }, set: function(h) {
    this._matrix[0] = h;
  } }), Object.defineProperty(Gt.prototype, "shy", { get: function() {
    return this._matrix[1];
  }, set: function(h) {
    this._matrix[1] = h;
  } }), Object.defineProperty(Gt.prototype, "shx", { get: function() {
    return this._matrix[2];
  }, set: function(h) {
    this._matrix[2] = h;
  } }), Object.defineProperty(Gt.prototype, "sy", { get: function() {
    return this._matrix[3];
  }, set: function(h) {
    this._matrix[3] = h;
  } }), Object.defineProperty(Gt.prototype, "tx", { get: function() {
    return this._matrix[4];
  }, set: function(h) {
    this._matrix[4] = h;
  } }), Object.defineProperty(Gt.prototype, "ty", { get: function() {
    return this._matrix[5];
  }, set: function(h) {
    this._matrix[5] = h;
  } }), Object.defineProperty(Gt.prototype, "a", { get: function() {
    return this._matrix[0];
  }, set: function(h) {
    this._matrix[0] = h;
  } }), Object.defineProperty(Gt.prototype, "b", { get: function() {
    return this._matrix[1];
  }, set: function(h) {
    this._matrix[1] = h;
  } }), Object.defineProperty(Gt.prototype, "c", { get: function() {
    return this._matrix[2];
  }, set: function(h) {
    this._matrix[2] = h;
  } }), Object.defineProperty(Gt.prototype, "d", { get: function() {
    return this._matrix[3];
  }, set: function(h) {
    this._matrix[3] = h;
  } }), Object.defineProperty(Gt.prototype, "e", { get: function() {
    return this._matrix[4];
  }, set: function(h) {
    this._matrix[4] = h;
  } }), Object.defineProperty(Gt.prototype, "f", { get: function() {
    return this._matrix[5];
  }, set: function(h) {
    this._matrix[5] = h;
  } }), Object.defineProperty(Gt.prototype, "rotation", { get: function() {
    return Math.atan2(this.shx, this.sx);
  } }), Object.defineProperty(Gt.prototype, "scaleX", { get: function() {
    return this.decompose().scale.sx;
  } }), Object.defineProperty(Gt.prototype, "scaleY", { get: function() {
    return this.decompose().scale.sy;
  } }), Object.defineProperty(Gt.prototype, "isIdentity", { get: function() {
    return this.sx === 1 && this.shy === 0 && this.shx === 0 && this.sy === 1 && this.tx === 0 && this.ty === 0;
  } }), Gt.prototype.join = function(h) {
    return [this.sx, this.shy, this.shx, this.sy, this.tx, this.ty].map(V).join(h);
  }, Gt.prototype.multiply = function(h) {
    var w = h.sx * this.sx + h.shy * this.shx, T = h.sx * this.shy + h.shy * this.sy, W = h.shx * this.sx + h.sy * this.shx, Z = h.shx * this.shy + h.sy * this.sy, mt = h.tx * this.sx + h.ty * this.shx + this.tx, _t = h.tx * this.shy + h.ty * this.sy + this.ty;
    return new Gt(w, T, W, Z, mt, _t);
  }, Gt.prototype.decompose = function() {
    var h = this.sx, w = this.shy, T = this.shx, W = this.sy, Z = this.tx, mt = this.ty, _t = Math.sqrt(h * h + w * w), It = (h /= _t) * T + (w /= _t) * W;
    T -= h * It, W -= w * It;
    var Bt = Math.sqrt(T * T + W * W);
    return It /= Bt, h * (W /= Bt) < w * (T /= Bt) && (h = -h, w = -w, It = -It, _t = -_t), { scale: new Gt(_t, 0, 0, Bt, 0, 0), translate: new Gt(1, 0, 0, 1, Z, mt), rotate: new Gt(h, w, -w, h, 0, 0), skew: new Gt(1, 0, It, 1, 0, 0) };
  }, Gt.prototype.toString = function(h) {
    return this.join(" ");
  }, Gt.prototype.inversed = function() {
    var h = this.sx, w = this.shy, T = this.shx, W = this.sy, Z = this.tx, mt = this.ty, _t = 1 / (h * W - w * T), It = W * _t, Bt = -w * _t, Xt = -T * _t, Qt = h * _t;
    return new Gt(It, Bt, Xt, Qt, -It * Z - Xt * mt, -Bt * Z - Qt * mt);
  }, Gt.prototype.applyToPoint = function(h) {
    var w = h.x * this.sx + h.y * this.shx + this.tx, T = h.x * this.shy + h.y * this.sy + this.ty;
    return new Ni(w, T);
  }, Gt.prototype.applyToRectangle = function(h) {
    var w = this.applyToPoint(h), T = this.applyToPoint(new Ni(h.x + h.w, h.y + h.h));
    return new Fs(w.x, w.y, T.x - w.x, T.y - w.y);
  }, Gt.prototype.clone = function() {
    var h = this.sx, w = this.shy, T = this.shx, W = this.sy, Z = this.tx, mt = this.ty;
    return new Gt(h, w, T, W, Z, mt);
  }, g.Matrix = Gt;
  var En = g.matrixMult = function(h, w) {
    return w.multiply(h);
  }, Pn = new Gt(1, 0, 0, 1, 0, 0);
  g.unitMatrix = g.identityMatrix = Pn;
  var Wr = function(h, w) {
    if (!he[h]) {
      var T = (w instanceof ji ? "Sh" : "P") + (Object.keys(Wt).length + 1).toString(10);
      w.id = T, he[h] = T, Wt[T] = w, ve.publish("addPattern", w);
    }
  };
  g.ShadingPattern = ji, g.TilingPattern = gs, g.addShadingPattern = function(h, w) {
    return I("addShadingPattern()"), Wr(h, w), this;
  }, g.beginTilingPattern = function(h) {
    I("beginTilingPattern()"), Os(h.boundingBox[0], h.boundingBox[1], h.boundingBox[2] - h.boundingBox[0], h.boundingBox[3] - h.boundingBox[1], h.matrix);
  }, g.endTilingPattern = function(h, w) {
    I("endTilingPattern()"), w.stream = xt[j].join(`
`), Wr(h, w), ve.publish("endTilingPattern", w), gn.pop().restore();
  };
  var Gr, Me = g.__private__.newObject = function() {
    var h = or();
    return lr(h, !0), h;
  }, or = g.__private__.newObjectDeferred = function() {
    return $++, nt[$] = function() {
      return ct;
    }, $;
  }, lr = function(h, w) {
    return w = typeof w == "boolean" && w, nt[h] = ct, w && U(h + " 0 obj"), h;
  }, gi = g.__private__.newAdditionalObject = function() {
    var h = { objId: or(), content: "" };
    return bt.push(h), h;
  }, Gn = or(), rn = or(), mn = g.__private__.decodeColorString = function(h) {
    var w = h.split(" ");
    if (w.length !== 2 || w[1] !== "g" && w[1] !== "G") w.length !== 5 || w[4] !== "k" && w[4] !== "K" || (w = [(1 - w[0]) * (1 - w[3]), (1 - w[1]) * (1 - w[3]), (1 - w[2]) * (1 - w[3]), "r"]);
    else {
      var T = parseFloat(w[0]);
      w = [T, T, T, "r"];
    }
    for (var W = "#", Z = 0; Z < 3; Z++) W += ("0" + Math.floor(255 * parseFloat(w[Z])).toString(16)).slice(-2);
    return W;
  }, nn = g.__private__.encodeColorString = function(h) {
    var w;
    typeof h == "string" && (h = { ch1: h });
    var T = h.ch1, W = h.ch2, Z = h.ch3, mt = h.ch4, _t = h.pdfColorType === "draw" ? ["G", "RG", "K"] : ["g", "rg", "k"];
    if (typeof T == "string" && T.charAt(0) !== "#") {
      var It = new v1(T);
      if (It.ok) T = It.toHex();
      else if (!/^\d*\.?\d*$/.test(T)) throw new Error('Invalid color "' + T + '" passed to jsPDF.encodeColorString.');
    }
    if (typeof T == "string" && /^#[0-9A-Fa-f]{3}$/.test(T) && (T = "#" + T[1] + T[1] + T[2] + T[2] + T[3] + T[3]), typeof T == "string" && /^#[0-9A-Fa-f]{6}$/.test(T)) {
      var Bt = parseInt(T.substr(1), 16);
      T = Bt >> 16 & 255, W = Bt >> 8 & 255, Z = 255 & Bt;
    }
    if (W === void 0 || mt === void 0 && T === W && W === Z) w = typeof T == "string" ? T + " " + _t[0] : h.precision === 2 ? A(T / 255) + " " + _t[0] : C(T / 255) + " " + _t[0];
    else if (mt === void 0 || xe(mt) === "object") {
      if (mt && !isNaN(mt.a) && mt.a === 0) return ["1.", "1.", "1.", _t[1]].join(" ");
      w = typeof T == "string" ? [T, W, Z, _t[1]].join(" ") : h.precision === 2 ? [A(T / 255), A(W / 255), A(Z / 255), _t[1]].join(" ") : [C(T / 255), C(W / 255), C(Z / 255), _t[1]].join(" ");
    } else w = typeof T == "string" ? [T, W, Z, mt, _t[2]].join(" ") : h.precision === 2 ? [A(T), A(W), A(Z), A(mt), _t[2]].join(" ") : [C(T), C(W), C(Z), C(mt), _t[2]].join(" ");
    return w;
  }, sn = g.__private__.getFilters = function() {
    return c;
  }, Jr = g.__private__.putStream = function(h) {
    var w = (h = h || {}).data || "", T = h.filters || sn(), W = h.alreadyAppliedFilters || [], Z = h.addLength1 || !1, mt = w.length, _t = h.objectId, It = function(rr) {
      return rr;
    };
    if (d !== null && _t === void 0) throw new Error("ObjectId must be passed to putStream for file encryption");
    d !== null && (It = He.encryptor(_t, 0));
    var Bt = {};
    T === !0 && (T = ["FlateEncode"]);
    var Xt = h.additionalKeyValues || [], Qt = (Bt = Dt.API.processDataByFilters !== void 0 ? Dt.API.processDataByFilters(w, T) : { data: w, reverseChain: [] }).reverseChain + (Array.isArray(W) ? W.join(" ") : W.toString());
    if (Bt.data.length !== 0 && (Xt.push({ key: "Length", value: Bt.data.length }), Z === !0 && Xt.push({ key: "Length1", value: mt })), Qt.length != 0) if (Qt.split("/").length - 1 == 1) Xt.push({ key: "Filter", value: Qt });
    else {
      Xt.push({ key: "Filter", value: "[" + Qt + "]" });
      for (var we = 0; we < Xt.length; we += 1) if (Xt[we].key === "DecodeParms") {
        for (var Te = [], Qe = 0; Qe < Bt.reverseChain.split("/").length - 1; Qe += 1) Te.push("null");
        Te.push(Xt[we].value), Xt[we].value = "[" + Te.join(" ") + "]";
      }
    }
    U("<<");
    for (var Re = 0; Re < Xt.length; Re++) U("/" + Xt[Re].key + " " + Xt[Re].value);
    U(">>"), Bt.data.length !== 0 && (U("stream"), U(It(Bt.data)), U("endstream"));
  }, mi = g.__private__.putPage = function(h) {
    var w = h.number, T = h.data, W = h.objId, Z = h.contentsObjId;
    lr(W, !0), U("<</Type /Page"), U("/Parent " + h.rootDictionaryObjId + " 0 R"), U("/Resources " + h.resourceDictionaryObjId + " 0 R"), U("/MediaBox [" + parseFloat(V(h.mediaBox.bottomLeftX)) + " " + parseFloat(V(h.mediaBox.bottomLeftY)) + " " + V(h.mediaBox.topRightX) + " " + V(h.mediaBox.topRightY) + "]"), h.cropBox !== null && U("/CropBox [" + V(h.cropBox.bottomLeftX) + " " + V(h.cropBox.bottomLeftY) + " " + V(h.cropBox.topRightX) + " " + V(h.cropBox.topRightY) + "]"), h.bleedBox !== null && U("/BleedBox [" + V(h.bleedBox.bottomLeftX) + " " + V(h.bleedBox.bottomLeftY) + " " + V(h.bleedBox.topRightX) + " " + V(h.bleedBox.topRightY) + "]"), h.trimBox !== null && U("/TrimBox [" + V(h.trimBox.bottomLeftX) + " " + V(h.trimBox.bottomLeftY) + " " + V(h.trimBox.topRightX) + " " + V(h.trimBox.topRightY) + "]"), h.artBox !== null && U("/ArtBox [" + V(h.artBox.bottomLeftX) + " " + V(h.artBox.bottomLeftY) + " " + V(h.artBox.topRightX) + " " + V(h.artBox.topRightY) + "]"), typeof h.userUnit == "number" && h.userUnit !== 1 && U("/UserUnit " + h.userUnit), ve.publish("putPage", { objId: W, pageContext: $t[w], pageNumber: w, page: T }), U("/Contents " + Z + " 0 R"), U(">>"), U("endobj");
    var mt = T.join(`
`);
    return F === q && (mt += `
Q`), lr(Z, !0), Jr({ data: mt, filters: sn(), objectId: Z }), U("endobj"), W;
  }, bn = g.__private__.putPages = function() {
    var h, w, T = [];
    for (h = 1; h <= Se; h++) $t[h].objId = or(), $t[h].contentsObjId = or();
    for (h = 1; h <= Se; h++) T.push(mi({ number: h, data: xt[h], objId: $t[h].objId, contentsObjId: $t[h].contentsObjId, mediaBox: $t[h].mediaBox, cropBox: $t[h].cropBox, bleedBox: $t[h].bleedBox, trimBox: $t[h].trimBox, artBox: $t[h].artBox, userUnit: $t[h].userUnit, rootDictionaryObjId: Gn, resourceDictionaryObjId: rn }));
    lr(Gn, !0), U("<</Type /Pages");
    var W = "/Kids [";
    for (w = 0; w < Se; w++) W += T[w] + " 0 R ";
    U(W + "]"), U("/Count " + Se), U(">>"), U("endobj"), ve.publish("postPutPages");
  }, bi = function(h) {
    ve.publish("putFont", { font: h, out: U, newObject: Me, putStream: Jr }), h.isAlreadyPutted !== !0 && (h.objectNumber = Me(), U("<<"), U("/Type /Font"), U("/BaseFont /" + ps(h.postScriptName)), U("/Subtype /Type1"), typeof h.encoding == "string" && U("/Encoding /" + h.encoding), U("/FirstChar 32"), U("/LastChar 255"), U(">>"), U("endobj"));
  }, Xi = function(h) {
    h.objectNumber = Me();
    var w = [];
    w.push({ key: "Type", value: "/XObject" }), w.push({ key: "Subtype", value: "/Form" }), w.push({ key: "BBox", value: "[" + [V(h.x), V(h.y), V(h.x + h.width), V(h.y + h.height)].join(" ") + "]" }), w.push({ key: "Matrix", value: "[" + h.matrix.toString() + "]" });
    var T = h.pages[1].join(`
`);
    Jr({ data: T, additionalKeyValues: w, objectId: h.objectNumber }), U("endobj");
  }, $i = function(h, w) {
    w || (w = 21);
    var T = Me(), W = (function(_t, It) {
      var Bt, Xt = [], Qt = 1 / (It - 1);
      for (Bt = 0; Bt < 1; Bt += Qt) Xt.push(Bt);
      if (Xt.push(1), _t[0].offset != 0) {
        var we = { offset: 0, color: _t[0].color };
        _t.unshift(we);
      }
      if (_t[_t.length - 1].offset != 1) {
        var Te = { offset: 1, color: _t[_t.length - 1].color };
        _t.push(Te);
      }
      for (var Qe = "", Re = 0, rr = 0; rr < Xt.length; rr++) {
        for (Bt = Xt[rr]; Bt > _t[Re + 1].offset; ) Re++;
        var tr = _t[Re].offset, fr = (Bt - tr) / (_t[Re + 1].offset - tr), Kr = _t[Re].color, Er = _t[Re + 1].color;
        Qe += J(Math.round((1 - fr) * Kr[0] + fr * Er[0]).toString(16)) + J(Math.round((1 - fr) * Kr[1] + fr * Er[1]).toString(16)) + J(Math.round((1 - fr) * Kr[2] + fr * Er[2]).toString(16));
      }
      return Qe.trim();
    })(h.colors, w), Z = [];
    Z.push({ key: "FunctionType", value: "0" }), Z.push({ key: "Domain", value: "[0.0 1.0]" }), Z.push({ key: "Size", value: "[" + w + "]" }), Z.push({ key: "BitsPerSample", value: "8" }), Z.push({ key: "Range", value: "[0.0 1.0 0.0 1.0 0.0 1.0]" }), Z.push({ key: "Decode", value: "[0.0 1.0 0.0 1.0 0.0 1.0]" }), Jr({ data: W, additionalKeyValues: Z, alreadyAppliedFilters: ["/ASCIIHexDecode"], objectId: T }), U("endobj"), h.objectNumber = Me(), U("<< /ShadingType " + h.type), U("/ColorSpace /DeviceRGB");
    var mt = "/Coords [" + V(parseFloat(h.coords[0])) + " " + V(parseFloat(h.coords[1])) + " ";
    h.type === 2 ? mt += V(parseFloat(h.coords[2])) + " " + V(parseFloat(h.coords[3])) : mt += V(parseFloat(h.coords[2])) + " " + V(parseFloat(h.coords[3])) + " " + V(parseFloat(h.coords[4])) + " " + V(parseFloat(h.coords[5])), U(mt += "]"), h.matrix && U("/Matrix [" + h.matrix.toString() + "]"), U("/Function " + T + " 0 R"), U("/Extend [true true]"), U(">>"), U("endobj");
  }, Zi = function(h, w) {
    var T = or(), W = Me();
    w.push({ resourcesOid: T, objectOid: W }), h.objectNumber = W;
    var Z = [];
    Z.push({ key: "Type", value: "/Pattern" }), Z.push({ key: "PatternType", value: "1" }), Z.push({ key: "PaintType", value: "1" }), Z.push({ key: "TilingType", value: "1" }), Z.push({ key: "BBox", value: "[" + h.boundingBox.map(V).join(" ") + "]" }), Z.push({ key: "XStep", value: V(h.xStep) }), Z.push({ key: "YStep", value: V(h.yStep) }), Z.push({ key: "Resources", value: T + " 0 R" }), h.matrix && Z.push({ key: "Matrix", value: "[" + h.matrix.toString() + "]" }), Jr({ data: h.stream, additionalKeyValues: Z, objectId: h.objectNumber }), U("endobj");
  }, To = function(h) {
    for (var w in h.objectNumber = Me(), U("<<"), h) switch (w) {
      case "opacity":
        U("/ca " + A(h[w]));
        break;
      case "stroke-opacity":
        U("/CA " + A(h[w]));
    }
    U(">>"), U("endobj");
  }, xs = function(h) {
    lr(h.resourcesOid, !0), U("<<"), U("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"), (function() {
      for (var w in U("/Font <<"), Tt) Tt.hasOwnProperty(w) && (b === !1 || b === !0 && _.hasOwnProperty(w)) && U("/" + w + " " + Tt[w].objectNumber + " 0 R");
      U(">>");
    })(), (function() {
      if (Object.keys(Wt).length > 0) {
        for (var w in U("/Shading <<"), Wt) Wt.hasOwnProperty(w) && Wt[w] instanceof ji && Wt[w].objectNumber >= 0 && U("/" + w + " " + Wt[w].objectNumber + " 0 R");
        ve.publish("putShadingPatternDict"), U(">>");
      }
    })(), (function(w) {
      if (Object.keys(Wt).length > 0) {
        for (var T in U("/Pattern <<"), Wt) Wt.hasOwnProperty(T) && Wt[T] instanceof g.TilingPattern && Wt[T].objectNumber >= 0 && Wt[T].objectNumber < w && U("/" + T + " " + Wt[T].objectNumber + " 0 R");
        ve.publish("putTilingPatternDict"), U(">>");
      }
    })(h.objectOid), (function() {
      if (Object.keys(ie).length > 0) {
        var w;
        for (w in U("/ExtGState <<"), ie) ie.hasOwnProperty(w) && ie[w].objectNumber >= 0 && U("/" + w + " " + ie[w].objectNumber + " 0 R");
        ve.publish("putGStateDict"), U(">>");
      }
    })(), (function() {
      for (var w in U("/XObject <<"), gr) gr.hasOwnProperty(w) && gr[w].objectNumber >= 0 && U("/" + w + " " + gr[w].objectNumber + " 0 R");
      ve.publish("putXobjectDict"), U(">>");
    })(), U(">>"), U("endobj");
  }, ma = function(h) {
    ne[h.fontName] = ne[h.fontName] || {}, ne[h.fontName][h.fontStyle] = h.id;
  }, ba = function(h, w, T, W, Z) {
    var mt = { id: "F" + (Object.keys(Tt).length + 1).toString(10), postScriptName: h, fontName: w, fontStyle: T, encoding: W, isStandardFont: Z || !1, metadata: {} };
    return ve.publish("addFont", { font: mt, instance: this }), Tt[mt.id] = mt, ma(mt), mt.id;
  }, Yr = g.__private__.pdfEscape = g.pdfEscape = function(h, w) {
    return (function(T, W) {
      var Z, mt, _t, It, Bt, Xt, Qt, we, Te;
      if (_t = (W = W || {}).sourceEncoding || "Unicode", Bt = W.outputEncoding, (W.autoencode || Bt) && Tt[qt].metadata && Tt[qt].metadata[_t] && Tt[qt].metadata[_t].encoding && (It = Tt[qt].metadata[_t].encoding, !Bt && Tt[qt].encoding && (Bt = Tt[qt].encoding), !Bt && It.codePages && (Bt = It.codePages[0]), typeof Bt == "string" && (Bt = It[Bt]), Bt)) {
        for (Qt = !1, Xt = [], Z = 0, mt = T.length; Z < mt; Z++) (we = Bt[T.charCodeAt(Z)]) ? Xt.push(String.fromCharCode(we)) : Xt.push(T[Z]), Xt[Z].charCodeAt(0) >> 8 && (Qt = !0);
        T = Xt.join("");
      }
      for (Z = T.length; Qt === void 0 && Z !== 0; ) T.charCodeAt(Z - 1) >> 8 && (Qt = !0), Z--;
      if (!Qt) return T;
      for (Xt = W.noBOM ? [] : [254, 255], Z = 0, mt = T.length; Z < mt; Z++) {
        if ((Te = (we = T.charCodeAt(Z)) >> 8) >> 8) throw new Error("Character at position " + Z + " of string '" + T + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");
        Xt.push(Te), Xt.push(we - (Te << 8));
      }
      return String.fromCharCode.apply(void 0, Xt);
    })(h, w).replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
  }, Ns = g.__private__.beginPage = function(h) {
    xt[++Se] = [], $t[Se] = { objId: 0, contentsObjId: 0, userUnit: Number(o), artBox: null, bleedBox: null, cropBox: null, trimBox: null, mediaBox: { bottomLeftX: 0, bottomLeftY: 0, topRightX: Number(h[0]), topRightY: Number(h[1]) } }, va(Se), dt(xt[j]);
  }, wa = function(h, w) {
    var T, W, Z;
    switch (e = w || e, typeof h == "string" && (T = N(h.toLowerCase()), Array.isArray(T) && (W = T[0], Z = T[1])), Array.isArray(h) && (W = h[0] * Yt, Z = h[1] * Yt), isNaN(W) && (W = i[0], Z = i[1]), (W > 14400 || Z > 14400) && (Pe.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"), W = Math.min(14400, W), Z = Math.min(14400, Z)), i = [W, Z], e.substr(0, 1)) {
      case "l":
        Z > W && (i = [Z, W]);
        break;
      case "p":
        W > Z && (i = [Z, W]);
    }
    Ns(i), Wo(Ps), U(ts), Rs !== 0 && U(Rs + " J"), Is !== 0 && U(Is + " j"), ve.publish("addPage", { pageNumber: Se });
  }, Ls = function(h) {
    h > 0 && h <= Se && (xt.splice(h, 1), $t.splice(h, 1), Se--, j > Se && (j = Se), this.setPage(j));
  }, va = function(h) {
    h > 0 && h <= Se && (j = h);
  }, ya = g.__private__.getNumberOfPages = g.getNumberOfPages = function() {
    return xt.length - 1;
  }, _a = function(h, w, T) {
    var W, Z = void 0;
    return T = T || {}, h = h !== void 0 ? h : Tt[qt].fontName, w = w !== void 0 ? w : Tt[qt].fontStyle, W = h.toLowerCase(), ne[W] !== void 0 && ne[W][w] !== void 0 ? Z = ne[W][w] : ne[h] !== void 0 && ne[h][w] !== void 0 ? Z = ne[h][w] : T.disableWarning === !1 && Pe.warn("Unable to look up font label for font '" + h + "', '" + w + "'. Refer to getFontList() for available fonts."), Z || T.noFallback || (Z = ne.times[w]) == null && (Z = ne.times.normal), Z;
  }, Qi = g.__private__.putInfo = function() {
    var h = Me(), w = function(W) {
      return W;
    };
    for (var T in d !== null && (w = He.encryptor(h, 0)), U("<<"), U("/Producer (" + Yr(w("jsPDF " + Dt.version)) + ")"), ce) ce.hasOwnProperty(T) && ce[T] && U("/" + T.substr(0, 1).toUpperCase() + T.substr(1) + " (" + Yr(w(ce[T])) + ")");
    U("/CreationDate (" + Yr(w(at)) + ")"), U(">>"), U("endobj");
  }, Mo = g.__private__.putCatalog = function(h) {
    var w = (h = h || {}).rootDictionaryObjId || Gn;
    switch (Me(), U("<<"), U("/Type /Catalog"), U("/Pages " + w + " 0 R"), jt || (jt = "fullwidth"), jt) {
      case "fullwidth":
        U("/OpenAction [3 0 R /FitH null]");
        break;
      case "fullheight":
        U("/OpenAction [3 0 R /FitV null]");
        break;
      case "fullpage":
        U("/OpenAction [3 0 R /Fit]");
        break;
      case "original":
        U("/OpenAction [3 0 R /XYZ null null 1]");
        break;
      default:
        var T = "" + jt;
        T.substr(T.length - 1) === "%" && (jt = parseInt(jt) / 100), typeof jt == "number" && U("/OpenAction [3 0 R /XYZ null null " + A(jt) + "]");
    }
    switch (ee || (ee = "continuous"), ee) {
      case "continuous":
        U("/PageLayout /OneColumn");
        break;
      case "single":
        U("/PageLayout /SinglePage");
        break;
      case "two":
      case "twoleft":
        U("/PageLayout /TwoColumnLeft");
        break;
      case "tworight":
        U("/PageLayout /TwoColumnRight");
    }
    Ht && U("/PageMode /" + Ht), ve.publish("putCatalog"), U(">>"), U("endobj");
  }, Ze = g.__private__.putTrailer = function() {
    U("trailer"), U("<<"), U("/Size " + ($ + 1)), U("/Root " + $ + " 0 R"), U("/Info " + ($ - 1) + " 0 R"), d !== null && U("/Encrypt " + He.oid + " 0 R"), U("/ID [ <" + ot + "> <" + ot + "> ]"), U(">>");
  }, Aa = g.__private__.putHeader = function() {
    U("%PDF-" + y), U("%ºß¬à");
  }, xa = g.__private__.putXRef = function() {
    var h = "0000000000";
    U("xref"), U("0 " + ($ + 1)), U("0000000000 65535 f ");
    for (var w = 1; w <= $; w++) typeof nt[w] == "function" ? U((h + nt[w]()).slice(-10) + " 00000 n ") : nt[w] !== void 0 ? U((h + nt[w]).slice(-10) + " 00000 n ") : U("0000000000 00000 n ");
  }, Cn = g.__private__.buildDocument = function() {
    var h;
    $ = 0, ct = 0, lt = [], nt = [], bt = [], Gn = or(), rn = or(), dt(lt), ve.publish("buildDocument"), Aa(), bn(), (function() {
      ve.publish("putAdditionalObjects");
      for (var T = 0; T < bt.length; T++) {
        var W = bt[T];
        lr(W.objId, !0), U(W.content), U("endobj");
      }
      ve.publish("postPutAdditionalObjects");
    })(), h = [], (function() {
      for (var T in Tt) Tt.hasOwnProperty(T) && (b === !1 || b === !0 && _.hasOwnProperty(T)) && bi(Tt[T]);
    })(), (function() {
      var T;
      for (T in ie) ie.hasOwnProperty(T) && To(ie[T]);
    })(), (function() {
      for (var T in gr) gr.hasOwnProperty(T) && Xi(gr[T]);
    })(), (function(T) {
      var W;
      for (W in Wt) Wt.hasOwnProperty(W) && (Wt[W] instanceof ji ? $i(Wt[W]) : Wt[W] instanceof gs && Zi(Wt[W], T));
    })(h), ve.publish("putResources"), h.forEach(xs), xs({ resourcesOid: rn, objectOid: Number.MAX_SAFE_INTEGER }), ve.publish("postPutResources"), d !== null && (He.oid = Me(), U("<<"), U("/Filter /Standard"), U("/V " + He.v), U("/R " + He.r), U("/U <" + He.toHexString(He.U) + ">"), U("/O <" + He.toHexString(He.O) + ">"), U("/P " + He.P), U(">>"), U("endobj")), Qi(), Mo();
    var w = ct;
    return xa(), Ze(), U("startxref"), U("" + w), U("%%EOF"), dt(xt[j]), lt.join(`
`);
  }, wi = g.__private__.getBlob = function(h) {
    return new Blob([ae(h)], { type: "application/pdf" });
  }, an = g.output = g.__private__.output = (Gr = function(h, w) {
    switch (typeof (w = w || {}) == "string" ? w = { filename: w } : w.filename = w.filename || "generated.pdf", h) {
      case void 0:
        return Cn();
      case "save":
        g.save(w.filename);
        break;
      case "arraybuffer":
        return ae(Cn());
      case "blob":
        return wi(Cn());
      case "bloburi":
      case "bloburl":
        if (Kt.URL !== void 0 && typeof Kt.URL.createObjectURL == "function") return Kt.URL && Kt.URL.createObjectURL(wi(Cn())) || void 0;
        Pe.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");
        break;
      case "datauristring":
      case "dataurlstring":
        var T = "", W = Cn();
        try {
          T = yf(W);
        } catch {
          T = yf(unescape(encodeURIComponent(W)));
        }
        return "data:application/pdf;filename=" + w.filename + ";base64," + T;
      case "pdfobjectnewwindow":
        if (Object.prototype.toString.call(Kt) === "[object Window]") {
          var Z = "https://cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.min.js", mt = ' integrity="sha512-4ze/a9/4jqu+tX9dfOqJYSvyYd5M6qum/3HpCLr+/Jqf0whc37VUbkpNGHR7/8pSnCFw47T1fmIpwBV7UySh3g==" crossorigin="anonymous"';
          w.pdfObjectUrl && (Z = w.pdfObjectUrl, mt = "");
          var _t = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><script src="' + Z + '"' + mt + '><\/script><script >PDFObject.embed("' + this.output("dataurlstring") + '", ' + JSON.stringify(w) + ");<\/script></body></html>", It = Kt.open();
          return It !== null && It.document.write(_t), It;
        }
        throw new Error("The option pdfobjectnewwindow just works in a browser-environment.");
      case "pdfjsnewwindow":
        if (Object.prototype.toString.call(Kt) === "[object Window]") {
          var Bt = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe id="pdfViewer" src="' + (w.pdfJsUrl || "examples/PDF.js/web/viewer.html") + "?file=&downloadName=" + w.filename + '" width="500px" height="400px" /></body></html>', Xt = Kt.open();
          if (Xt !== null) {
            Xt.document.write(Bt);
            var Qt = this;
            Xt.document.documentElement.querySelector("#pdfViewer").onload = function() {
              Xt.document.title = w.filename, Xt.document.documentElement.querySelector("#pdfViewer").contentWindow.PDFViewerApplication.open(Qt.output("bloburl"));
            };
          }
          return Xt;
        }
        throw new Error("The option pdfjsnewwindow just works in a browser-environment.");
      case "dataurlnewwindow":
        if (Object.prototype.toString.call(Kt) !== "[object Window]") throw new Error("The option dataurlnewwindow just works in a browser-environment.");
        var we = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="' + this.output("datauristring", w) + '"></iframe></body></html>', Te = Kt.open();
        if (Te !== null && (Te.document.write(we), Te.document.title = w.filename), Te || typeof safari > "u") return Te;
        break;
      case "datauri":
      case "dataurl":
        return Kt.document.location.href = this.output("datauristring", w);
      default:
        return null;
    }
  }, Gr.foo = function() {
    try {
      return Gr.apply(this, arguments);
    } catch (T) {
      var h = T.stack || "";
      ~h.indexOf(" at ") && (h = h.split(" at ")[1]);
      var w = "Error in function " + h.split(`
`)[0].split("<")[0] + ": " + T.message;
      if (!Kt.console) throw new Error(w);
      Kt.console.error(w, T), Kt.alert && alert(w);
    }
  }, Gr.foo.bar = Gr, Gr.foo), vi = function(h) {
    return Array.isArray(pi) === !0 && pi.indexOf(h) > -1;
  };
  switch (n) {
    case "pt":
      Yt = 1;
      break;
    case "mm":
      Yt = 72 / 25.4;
      break;
    case "cm":
      Yt = 72 / 2.54;
      break;
    case "in":
      Yt = 72;
      break;
    case "px":
      Yt = vi("px_scaling") == 1 ? 0.75 : 96 / 72;
      break;
    case "pc":
    case "em":
      Yt = 12;
      break;
    case "ex":
      Yt = 6;
      break;
    default:
      if (typeof n != "number") throw new Error("Invalid unit: " + n);
      Yt = n;
  }
  var He = null;
  vt(), rt();
  var Ss = g.__private__.getPageInfo = g.getPageInfo = function(h) {
    if (isNaN(h) || h % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfo");
    return { objId: $t[h].objId, pageNumber: h, pageContext: $t[h] };
  }, Do = g.__private__.getPageInfoByObjId = function(h) {
    if (isNaN(h) || h % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");
    for (var w in $t) if ($t[w].objId === h) break;
    return Ss(w);
  }, jo = g.__private__.getCurrentPageInfo = g.getCurrentPageInfo = function() {
    return { objId: $t[j].objId, pageNumber: j, pageContext: $t[j] };
  };
  g.addPage = function() {
    return wa.apply(this, arguments), this;
  }, g.setPage = function() {
    return va.apply(this, arguments), dt.call(this, xt[j]), this;
  }, g.insertPage = function(h) {
    return this.addPage(), this.movePage(j, h), this;
  }, g.movePage = function(h, w) {
    var T, W;
    if (h > w) {
      T = xt[h], W = $t[h];
      for (var Z = h; Z > w; Z--) xt[Z] = xt[Z - 1], $t[Z] = $t[Z - 1];
      xt[w] = T, $t[w] = W, this.setPage(w);
    } else if (h < w) {
      T = xt[h], W = $t[h];
      for (var mt = h; mt < w; mt++) xt[mt] = xt[mt + 1], $t[mt] = $t[mt + 1];
      xt[w] = T, $t[w] = W, this.setPage(w);
    }
    return this;
  }, g.deletePage = function() {
    return Ls.apply(this, arguments), this;
  }, g.__private__.text = g.text = function(h, w, T, W, Z) {
    var mt, _t, It, Bt, Xt, Qt, we, Te, Qe, Re = (W = W || {}).scope || this;
    if (typeof h == "number" && typeof w == "number" && (typeof T == "string" || Array.isArray(T))) {
      var rr = T;
      T = w, w = h, h = rr;
    }
    if (arguments[3] instanceof Gt == 0 ? (It = arguments[4], Bt = arguments[5], xe(we = arguments[3]) === "object" && we !== null || (typeof It == "string" && (Bt = It, It = null), typeof we == "string" && (Bt = we, we = null), typeof we == "number" && (It = we, we = null), W = { flags: we, angle: It, align: Bt })) : (I("The transform parameter of text() with a Matrix value"), Qe = Z), isNaN(w) || isNaN(T) || h == null) throw new Error("Invalid arguments passed to jsPDF.text");
    if (h.length === 0) return Re;
    var tr, fr = "", Kr = typeof W.lineHeightFactor == "number" ? W.lineHeightFactor : _i, Er = Re.internal.scaleFactor;
    function Ra(ye) {
      return ye = ye.split("	").join(Array(W.TabLen || 9).join(" ")), Yr(ye, we);
    }
    function is(ye) {
      for (var ke, We = ye.concat(), nr = [], Mn = We.length; Mn--; ) typeof (ke = We.shift()) == "string" ? nr.push(ke) : Array.isArray(ye) && (ke.length === 1 || ke[1] === void 0 && ke[2] === void 0) ? nr.push(ke[0]) : nr.push([ke[0], ke[1], ke[2]]);
      return nr;
    }
    function ki(ye, ke) {
      var We;
      if (typeof ye == "string") We = ke(ye)[0];
      else if (Array.isArray(ye)) {
        for (var nr, Mn, Vs = ye.concat(), os = [], Oa = Vs.length; Oa--; ) typeof (nr = Vs.shift()) == "string" ? os.push(ke(nr)[0]) : Array.isArray(nr) && typeof nr[0] == "string" && (Mn = ke(nr[0], nr[1], nr[2]), os.push([Mn[0], Mn[1], Mn[2]]));
        We = os;
      }
      return We;
    }
    var Kn = !1, Ei = !0;
    if (typeof h == "string") Kn = !0;
    else if (Array.isArray(h)) {
      var Pi = h.concat();
      _t = [];
      for (var Ci, mr = Pi.length; mr--; ) (typeof (Ci = Pi.shift()) != "string" || Array.isArray(Ci) && typeof Ci[0] != "string") && (Ei = !1);
      Kn = Ei;
    }
    if (Kn === !1) throw new Error('Type of text must be string or Array. "' + h + '" is not recognized.');
    typeof h == "string" && (h = h.match(/[\r?\n]/) ? h.split(/\r\n|\r|\n/g) : [h]);
    var Ri = Nt / Re.internal.scaleFactor, Ii = Ri * (Kr - 1);
    switch (W.baseline) {
      case "bottom":
        T -= Ii;
        break;
      case "top":
        T += Ri - Ii;
        break;
      case "hanging":
        T += Ri - 2 * Ii;
        break;
      case "middle":
        T += Ri / 2 - Ii;
    }
    if ((Qt = W.maxWidth || 0) > 0 && (typeof h == "string" ? h = Re.splitTextToSize(h, Qt) : Object.prototype.toString.call(h) === "[object Array]" && (h = h.reduce(function(ye, ke) {
      return ye.concat(Re.splitTextToSize(ke, Qt));
    }, []))), mt = { text: h, x: w, y: T, options: W, mutex: { pdfEscape: Yr, activeFontKey: qt, fonts: Tt, activeFontSize: Nt } }, ve.publish("preProcessText", mt), h = mt.text, It = (W = mt.options).angle, Qe instanceof Gt == 0 && It && typeof It == "number") {
      It *= Math.PI / 180, W.rotationDirection === 0 && (It = -It), F === q && (It = -It);
      var Bs = Math.cos(It), Ts = Math.sin(It);
      Qe = new Gt(Bs, Ts, -Ts, Bs, 0, 0);
    } else It && It instanceof Gt && (Qe = It);
    F !== q || Qe || (Qe = Pn), (Xt = W.charSpace || rs) !== void 0 && (fr += V(M(Xt)) + ` Tc
`, this.setCharSpace(this.getCharSpace() || 0)), (Te = W.horizontalScale) !== void 0 && (fr += V(100 * Te) + ` Tz
`), W.lang;
    var De = -1, Bn = W.renderingMode !== void 0 ? W.renderingMode : W.stroke, ss = Re.internal.getCurrentPageInfo().pageContext;
    switch (Bn) {
      case 0:
      case !1:
      case "fill":
        De = 0;
        break;
      case 1:
      case !0:
      case "stroke":
        De = 1;
        break;
      case 2:
      case "fillThenStroke":
        De = 2;
        break;
      case 3:
      case "invisible":
        De = 3;
        break;
      case 4:
      case "fillAndAddForClipping":
        De = 4;
        break;
      case 5:
      case "strokeAndAddPathForClipping":
        De = 5;
        break;
      case 6:
      case "fillThenStrokeAndAddToPathForClipping":
        De = 6;
        break;
      case 7:
      case "addToPathForClipping":
        De = 7;
    }
    var Ia = ss.usedRenderingMode !== void 0 ? ss.usedRenderingMode : -1;
    De !== -1 ? fr += De + ` Tr
` : Ia !== -1 && (fr += `0 Tr
`), De !== -1 && (ss.usedRenderingMode = De), Bt = W.align || "left";
    var Xr, Fi = Nt * Kr, Ms = Re.internal.pageSize.getWidth(), Ds = Tt[qt];
    Xt = W.charSpace || rs, Qt = W.maxWidth || 0, we = Object.assign({ autoencode: !0, noBOM: !0 }, W.flags);
    var Xn = [], Oi = function(ye) {
      return Re.getStringUnitWidth(ye, { font: Ds, charSpace: Xt, fontSize: Nt, doKerning: !1 }) * Nt / Er;
    };
    if (Object.prototype.toString.call(h) === "[object Array]") {
      var Br;
      _t = is(h), Bt !== "left" && (Xr = _t.map(Oi));
      var Tr, $n = 0;
      if (Bt === "right") {
        w -= Xr[0], h = [], mr = _t.length;
        for (var Tn = 0; Tn < mr; Tn++) Tn === 0 ? (Tr = Rn(w), Br = In(T)) : (Tr = M($n - Xr[Tn]), Br = -Fi), h.push([_t[Tn], Tr, Br]), $n = Xr[Tn];
      } else if (Bt === "center") {
        w -= Xr[0] / 2, h = [], mr = _t.length;
        for (var Zn = 0; Zn < mr; Zn++) Zn === 0 ? (Tr = Rn(w), Br = In(T)) : (Tr = M(($n - Xr[Zn]) / 2), Br = -Fi), h.push([_t[Zn], Tr, Br]), $n = Xr[Zn];
      } else if (Bt === "left") {
        h = [], mr = _t.length;
        for (var js = 0; js < mr; js++) h.push(_t[js]);
      } else if (Bt === "justify" && Ds.encoding === "Identity-H") {
        h = [], mr = _t.length, Qt = Qt !== 0 ? Qt : Ms;
        for (var as = 0, Ve = 0; Ve < mr; Ve++) if (Br = Ve === 0 ? In(T) : -Fi, Tr = Ve === 0 ? Rn(w) : as, Ve < mr - 1) {
          var Fa = M((Qt - Xr[Ve]) / (_t[Ve].split(" ").length - 1)), vn = _t[Ve].split(" ");
          h.push([vn[0] + " ", Tr, Br]), as = 0;
          for (var yn = 1; yn < vn.length; yn++) {
            var qs = (Oi(vn[yn - 1] + " " + vn[yn]) - Oi(vn[yn])) * Er + Fa;
            yn == vn.length - 1 ? h.push([vn[yn], qs, 0]) : h.push([vn[yn] + " ", qs, 0]), as -= qs;
          }
        } else h.push([_t[Ve], Tr, Br]);
        h.push(["", as, 0]);
      } else {
        if (Bt !== "justify") throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');
        for (h = [], mr = _t.length, Qt = Qt !== 0 ? Qt : Ms, Ve = 0; Ve < mr; Ve++) {
          Br = Ve === 0 ? In(T) : -Fi, Tr = Ve === 0 ? Rn(w) : 0;
          var Us = _t[Ve].split(" ").length - 1, zs = Us > 0 ? (Qt - Xr[Ve]) / Us : 0;
          Ve < mr - 1 ? Xn.push(V(M(zs))) : Xn.push(0), h.push([_t[Ve], Tr, Br]);
        }
      }
    }
    (typeof W.R2L == "boolean" ? W.R2L : oe) === !0 && (h = ki(h, function(ye, ke, We) {
      return [ye.split("").reverse().join(""), ke, We];
    })), mt = { text: h, x: w, y: T, options: W, mutex: { pdfEscape: Yr, activeFontKey: qt, fonts: Tt, activeFontSize: Nt } }, ve.publish("postProcessText", mt), h = mt.text, tr = mt.mutex.isHex || !1;
    var Hs = Tt[qt].encoding;
    Hs !== "WinAnsiEncoding" && Hs !== "StandardEncoding" || (h = ki(h, function(ye, ke, We) {
      return [Ra(ye), ke, We];
    })), _t = is(h), h = [];
    for (var Qn, ti, ei, Bi = Array.isArray(_t[0]) ? 1 : 0, ri = "", Ti = function(ye, ke, We) {
      var nr = "";
      return We instanceof Gt ? (We = typeof W.angle == "number" ? En(We, new Gt(1, 0, 0, 1, ye, ke)) : En(new Gt(1, 0, 0, 1, ye, ke), We), F === q && (We = En(new Gt(1, 0, 0, -1, 0, 0), We)), nr = We.join(" ") + ` Tm
`) : nr = V(ye) + " " + V(ke) + ` Td
`, nr;
    }, $r = 0; $r < _t.length; $r++) {
      switch (ri = "", Bi) {
        case 1:
          ei = (tr ? "<" : "(") + _t[$r][0] + (tr ? ">" : ")"), Qn = parseFloat(_t[$r][1]), ti = parseFloat(_t[$r][2]);
          break;
        case 0:
          ei = (tr ? "<" : "(") + _t[$r] + (tr ? ">" : ")"), Qn = Rn(w), ti = In(T);
      }
      Xn !== void 0 && Xn[$r] !== void 0 && (ri = Xn[$r] + ` Tw
`), $r === 0 ? h.push(ri + Ti(Qn, ti, Qe) + ei) : Bi === 0 ? h.push(ri + ei) : Bi === 1 && h.push(ri + Ti(Qn, ti, Qe) + ei);
    }
    h = Bi === 0 ? h.join(` Tj
T* `) : h.join(` Tj
`), h += ` Tj
`;
    var _n = `BT
/`;
    return _n += qt + " " + Nt + ` Tf
`, _n += V(Nt * Kr) + ` TL
`, _n += Ai + `
`, _n += fr, _n += h, U(_n += "ET"), _[qt] = !0, Re;
  };
  var qo = g.__private__.clip = g.clip = function(h) {
    return U(h === "evenodd" ? "W*" : "W"), this;
  };
  g.clipEvenOdd = function() {
    return qo("evenodd");
  }, g.__private__.discardPath = g.discardPath = function() {
    return U("n"), this;
  };
  var wn = g.__private__.isValidStyle = function(h) {
    var w = !1;
    return [void 0, null, "S", "D", "F", "DF", "FD", "f", "f*", "B", "B*", "n"].indexOf(h) !== -1 && (w = !0), w;
  };
  g.__private__.setDefaultPathOperation = g.setDefaultPathOperation = function(h) {
    return wn(h) && (f = h), this;
  };
  var Na = g.__private__.getStyle = g.getStyle = function(h) {
    var w = f;
    switch (h) {
      case "D":
      case "S":
        w = "S";
        break;
      case "F":
        w = "f";
        break;
      case "FD":
      case "DF":
        w = "B";
        break;
      case "f":
      case "f*":
      case "B":
      case "B*":
        w = h;
    }
    return w;
  }, La = g.close = function() {
    return U("h"), this;
  };
  g.stroke = function() {
    return U("S"), this;
  }, g.fill = function(h) {
    return Jn("f", h), this;
  }, g.fillEvenOdd = function(h) {
    return Jn("f*", h), this;
  }, g.fillStroke = function(h) {
    return Jn("B", h), this;
  }, g.fillStrokeEvenOdd = function(h) {
    return Jn("B*", h), this;
  };
  var Jn = function(h, w) {
    xe(w) === "object" ? zo(w, h) : U(h);
  }, ks = function(h) {
    h === null || F === q && h === void 0 || (h = Na(h), U(h));
  };
  function Uo(h, w, T, W, Z) {
    var mt = new gs(w || this.boundingBox, T || this.xStep, W || this.yStep, this.gState, Z || this.matrix);
    mt.stream = this.stream;
    var _t = h + "$$" + this.cloneIndex++ + "$$";
    return Wr(_t, mt), mt;
  }
  var zo = function(h, w) {
    var T = he[h.key], W = Wt[T];
    if (W instanceof ji) U("q"), U(Ho(w)), W.gState && g.setGState(W.gState), U(h.matrix.toString() + " cm"), U("/" + T + " sh"), U("Q");
    else if (W instanceof gs) {
      var Z = new Gt(1, 0, 0, -1, 0, Si());
      h.matrix && (Z = Z.multiply(h.matrix || Pn), T = Uo.call(W, h.key, h.boundingBox, h.xStep, h.yStep, Z).id), U("q"), U("/Pattern cs"), U("/" + T + " scn"), W.gState && g.setGState(W.gState), U(w), U("Q");
    }
  }, Ho = function(h) {
    switch (h) {
      case "f":
      case "F":
      case "n":
        return "W n";
      case "f*":
        return "W* n";
      case "B":
      case "S":
        return "W S";
      case "B*":
        return "W* S";
    }
  }, Es = g.moveTo = function(h, w) {
    return U(V(M(h)) + " " + V(D(w)) + " m"), this;
  }, yi = g.lineTo = function(h, w) {
    return U(V(M(h)) + " " + V(D(w)) + " l"), this;
  }, Yn = g.curveTo = function(h, w, T, W, Z, mt) {
    return U([V(M(h)), V(D(w)), V(M(T)), V(D(W)), V(M(Z)), V(D(mt)), "c"].join(" ")), this;
  };
  g.__private__.line = g.line = function(h, w, T, W, Z) {
    if (isNaN(h) || isNaN(w) || isNaN(T) || isNaN(W) || !wn(Z)) throw new Error("Invalid arguments passed to jsPDF.line");
    return F === H ? this.lines([[T - h, W - w]], h, w, [1, 1], Z || "S") : this.lines([[T - h, W - w]], h, w, [1, 1]).stroke();
  }, g.__private__.lines = g.lines = function(h, w, T, W, Z, mt) {
    var _t, It, Bt, Xt, Qt, we, Te, Qe, Re, rr, tr, fr;
    if (typeof h == "number" && (fr = T, T = w, w = h, h = fr), W = W || [1, 1], mt = mt || !1, isNaN(w) || isNaN(T) || !Array.isArray(h) || !Array.isArray(W) || !wn(Z) || typeof mt != "boolean") throw new Error("Invalid arguments passed to jsPDF.lines");
    for (Es(w, T), _t = W[0], It = W[1], Xt = h.length, rr = w, tr = T, Bt = 0; Bt < Xt; Bt++) (Qt = h[Bt]).length === 2 ? (rr = Qt[0] * _t + rr, tr = Qt[1] * It + tr, yi(rr, tr)) : (we = Qt[0] * _t + rr, Te = Qt[1] * It + tr, Qe = Qt[2] * _t + rr, Re = Qt[3] * It + tr, rr = Qt[4] * _t + rr, tr = Qt[5] * It + tr, Yn(we, Te, Qe, Re, rr, tr));
    return mt && La(), ks(Z), this;
  }, g.path = function(h) {
    for (var w = 0; w < h.length; w++) {
      var T = h[w], W = T.c;
      switch (T.op) {
        case "m":
          Es(W[0], W[1]);
          break;
        case "l":
          yi(W[0], W[1]);
          break;
        case "c":
          Yn.apply(this, W);
          break;
        case "h":
          La();
      }
    }
    return this;
  }, g.__private__.rect = g.rect = function(h, w, T, W, Z) {
    if (isNaN(h) || isNaN(w) || isNaN(T) || isNaN(W) || !wn(Z)) throw new Error("Invalid arguments passed to jsPDF.rect");
    return F === H && (W = -W), U([V(M(h)), V(D(w)), V(M(T)), V(M(W)), "re"].join(" ")), ks(Z), this;
  }, g.__private__.triangle = g.triangle = function(h, w, T, W, Z, mt, _t) {
    if (isNaN(h) || isNaN(w) || isNaN(T) || isNaN(W) || isNaN(Z) || isNaN(mt) || !wn(_t)) throw new Error("Invalid arguments passed to jsPDF.triangle");
    return this.lines([[T - h, W - w], [Z - T, mt - W], [h - Z, w - mt]], h, w, [1, 1], _t, !0), this;
  }, g.__private__.roundedRect = g.roundedRect = function(h, w, T, W, Z, mt, _t) {
    if (isNaN(h) || isNaN(w) || isNaN(T) || isNaN(W) || isNaN(Z) || isNaN(mt) || !wn(_t)) throw new Error("Invalid arguments passed to jsPDF.roundedRect");
    var It = 4 / 3 * (Math.SQRT2 - 1);
    return Z = Math.min(Z, 0.5 * T), mt = Math.min(mt, 0.5 * W), this.lines([[T - 2 * Z, 0], [Z * It, 0, Z, mt - mt * It, Z, mt], [0, W - 2 * mt], [0, mt * It, -Z * It, mt, -Z, mt], [2 * Z - T, 0], [-Z * It, 0, -Z, -mt * It, -Z, -mt], [0, 2 * mt - W], [0, -mt * It, Z * It, -mt, Z, -mt]], h + Z, w, [1, 1], _t, !0), this;
  }, g.__private__.ellipse = g.ellipse = function(h, w, T, W, Z) {
    if (isNaN(h) || isNaN(w) || isNaN(T) || isNaN(W) || !wn(Z)) throw new Error("Invalid arguments passed to jsPDF.ellipse");
    var mt = 4 / 3 * (Math.SQRT2 - 1) * T, _t = 4 / 3 * (Math.SQRT2 - 1) * W;
    return Es(h + T, w), Yn(h + T, w - _t, h + mt, w - W, h, w - W), Yn(h - mt, w - W, h - T, w - _t, h - T, w), Yn(h - T, w + _t, h - mt, w + W, h, w + W), Yn(h + mt, w + W, h + T, w + _t, h + T, w), ks(Z), this;
  }, g.__private__.circle = g.circle = function(h, w, T, W) {
    if (isNaN(h) || isNaN(w) || isNaN(T) || !wn(W)) throw new Error("Invalid arguments passed to jsPDF.circle");
    return this.ellipse(h, w, T, T, W);
  }, g.setFont = function(h, w, T) {
    return T && (w = X(w, T)), qt = _a(h, w, { disableWarning: !1 }), this;
  };
  var Vo = g.__private__.getFont = g.getFont = function() {
    return Tt[_a.apply(g, arguments)];
  };
  g.__private__.getFontList = g.getFontList = function() {
    var h, w, T = {};
    for (h in ne) if (ne.hasOwnProperty(h)) for (w in T[h] = [], ne[h]) ne[h].hasOwnProperty(w) && T[h].push(w);
    return T;
  }, g.addFont = function(h, w, T, W, Z) {
    var mt = ["StandardEncoding", "MacRomanEncoding", "Identity-H", "WinAnsiEncoding"];
    return arguments[3] && mt.indexOf(arguments[3]) !== -1 ? Z = arguments[3] : arguments[3] && mt.indexOf(arguments[3]) == -1 && (T = X(T, W)), ba.call(this, h, w, T, Z = Z || "Identity-H");
  };
  var _i, Ps = r.lineWidth || 0.200025, Zt = g.__private__.getLineWidth = g.getLineWidth = function() {
    return Ps;
  }, Wo = g.__private__.setLineWidth = g.setLineWidth = function(h) {
    return Ps = h, U(V(M(h)) + " w"), this;
  };
  g.__private__.setLineDash = Dt.API.setLineDash = Dt.API.setLineDashPattern = function(h, w) {
    if (h = h || [], w = w || 0, isNaN(w) || !Array.isArray(h)) throw new Error("Invalid arguments passed to jsPDF.setLineDash");
    return h = h.map(function(T) {
      return V(M(T));
    }).join(" "), w = V(M(w)), U("[" + h + "] " + w + " d"), this;
  };
  var Go = g.__private__.getLineHeight = g.getLineHeight = function() {
    return Nt * _i;
  };
  g.__private__.getLineHeight = g.getLineHeight = function() {
    return Nt * _i;
  };
  var Jo = g.__private__.setLineHeightFactor = g.setLineHeightFactor = function(h) {
    return typeof (h = h || 1.15) == "number" && (_i = h), this;
  }, Yo = g.__private__.getLineHeightFactor = g.getLineHeightFactor = function() {
    return _i;
  };
  Jo(r.lineHeight);
  var Rn = g.__private__.getHorizontalCoordinate = function(h) {
    return M(h);
  }, In = g.__private__.getVerticalCoordinate = function(h) {
    return F === q ? h : $t[j].mediaBox.topRightY - $t[j].mediaBox.bottomLeftY - M(h);
  }, Ko = g.__private__.getHorizontalCoordinateString = g.getHorizontalCoordinateString = function(h) {
    return V(Rn(h));
  }, Xo = g.__private__.getVerticalCoordinateString = g.getVerticalCoordinateString = function(h) {
    return V(In(h));
  }, ts = r.strokeColor || "0 G";
  g.__private__.getStrokeColor = g.getDrawColor = function() {
    return mn(ts);
  }, g.__private__.setStrokeColor = g.setDrawColor = function(h, w, T, W) {
    return ts = nn({ ch1: h, ch2: w, ch3: T, ch4: W, pdfColorType: "draw", precision: 2 }), U(ts), this;
  };
  var Cs = r.fillColor || "0 g";
  g.__private__.getFillColor = g.getFillColor = function() {
    return mn(Cs);
  }, g.__private__.setFillColor = g.setFillColor = function(h, w, T, W) {
    return Cs = nn({ ch1: h, ch2: w, ch3: T, ch4: W, pdfColorType: "fill", precision: 2 }), U(Cs), this;
  };
  var Ai = r.textColor || "0 g", es = g.__private__.getTextColor = g.getTextColor = function() {
    return mn(Ai);
  };
  g.__private__.setTextColor = g.setTextColor = function(h, w, T, W) {
    return Ai = nn({ ch1: h, ch2: w, ch3: T, ch4: W, pdfColorType: "text", precision: 3 }), this;
  };
  var rs = r.charSpace, $o = g.__private__.getCharSpace = g.getCharSpace = function() {
    return parseFloat(rs || 0);
  };
  g.__private__.setCharSpace = g.setCharSpace = function(h) {
    if (isNaN(h)) throw new Error("Invalid argument passed to jsPDF.setCharSpace");
    return rs = h, this;
  };
  var Rs = 0;
  g.CapJoinStyles = { 0: 0, butt: 0, but: 0, miter: 0, 1: 1, round: 1, rounded: 1, circle: 1, 2: 2, projecting: 2, project: 2, square: 2, bevel: 2 }, g.__private__.setLineCap = g.setLineCap = function(h) {
    var w = g.CapJoinStyles[h];
    if (w === void 0) throw new Error("Line cap style of '" + h + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
    return Rs = w, U(w + " J"), this;
  };
  var Is = 0;
  g.__private__.setLineJoin = g.setLineJoin = function(h) {
    var w = g.CapJoinStyles[h];
    if (w === void 0) throw new Error("Line join style of '" + h + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
    return Is = w, U(w + " j"), this;
  }, g.__private__.setLineMiterLimit = g.__private__.setMiterLimit = g.setLineMiterLimit = g.setMiterLimit = function(h) {
    if (h = h || 0, isNaN(h)) throw new Error("Invalid argument passed to jsPDF.setLineMiterLimit");
    return U(V(M(h)) + " M"), this;
  }, g.GState = Lo, g.setGState = function(h) {
    (h = typeof h == "string" ? ie[ze[h]] : xi(null, h)).equals(er) || (U("/" + h.id + " gs"), er = h);
  };
  var xi = function(h, w) {
    if (!h || !ze[h]) {
      var T = !1;
      for (var W in ie) if (ie.hasOwnProperty(W) && ie[W].equals(w)) {
        T = !0;
        break;
      }
      if (T) w = ie[W];
      else {
        var Z = "GS" + (Object.keys(ie).length + 1).toString(10);
        ie[Z] = w, w.id = Z;
      }
      return h && (ze[h] = w.id), ve.publish("addGState", w), w;
    }
  };
  g.addGState = function(h, w) {
    return xi(h, w), this;
  }, g.saveGraphicsState = function() {
    return U("q"), Le.push({ key: qt, size: Nt, color: Ai }), this;
  }, g.restoreGraphicsState = function() {
    U("Q");
    var h = Le.pop();
    return qt = h.key, Nt = h.size, Ai = h.color, er = null, this;
  }, g.setCurrentTransformationMatrix = function(h) {
    return U(h.toString() + " cm"), this;
  }, g.comment = function(h) {
    return U("#" + h), this;
  };
  var Ni = function(h, w) {
    var T = h || 0;
    Object.defineProperty(this, "x", { enumerable: !0, get: function() {
      return T;
    }, set: function(mt) {
      isNaN(mt) || (T = parseFloat(mt));
    } });
    var W = w || 0;
    Object.defineProperty(this, "y", { enumerable: !0, get: function() {
      return W;
    }, set: function(mt) {
      isNaN(mt) || (W = parseFloat(mt));
    } });
    var Z = "pt";
    return Object.defineProperty(this, "type", { enumerable: !0, get: function() {
      return Z;
    }, set: function(mt) {
      Z = mt.toString();
    } }), this;
  }, Fs = function(h, w, T, W) {
    Ni.call(this, h, w), this.type = "rect";
    var Z = T || 0;
    Object.defineProperty(this, "w", { enumerable: !0, get: function() {
      return Z;
    }, set: function(_t) {
      isNaN(_t) || (Z = parseFloat(_t));
    } });
    var mt = W || 0;
    return Object.defineProperty(this, "h", { enumerable: !0, get: function() {
      return mt;
    }, set: function(_t) {
      isNaN(_t) || (mt = parseFloat(_t));
    } }), this;
  }, ns = function() {
    this.page = Se, this.currentPage = j, this.pages = xt.slice(0), this.pagesContext = $t.slice(0), this.x = Ut, this.y = Ce, this.matrix = be, this.width = Sa(j), this.height = Fn(j), this.outputDestination = Pt, this.id = "", this.objectNumber = -1;
  };
  ns.prototype.restore = function() {
    Se = this.page, j = this.currentPage, $t = this.pagesContext, xt = this.pages, Ut = this.x, Ce = this.y, be = this.matrix, ka(j, this.width), On(j, this.height), Pt = this.outputDestination;
  };
  var Os = function(h, w, T, W, Z) {
    gn.push(new ns()), Se = j = 0, xt = [], Ut = h, Ce = w, be = Z, Ns([T, W]);
  };
  for (var Li in g.beginFormObject = function(h, w, T, W, Z) {
    return Os(h, w, T, W, Z), this;
  }, g.endFormObject = function(h) {
    return (function(w) {
      if (kn[w]) gn.pop().restore();
      else {
        var T = new ns(), W = "Xo" + (Object.keys(gr).length + 1).toString(10);
        T.id = W, kn[w] = W, gr[W] = T, ve.publish("addFormObject", T), gn.pop().restore();
      }
    })(h), this;
  }, g.doFormObject = function(h, w) {
    var T = gr[kn[h]];
    return U("q"), U(w.toString() + " cm"), U("/" + T.id + " Do"), U("Q"), this;
  }, g.getFormObject = function(h) {
    var w = gr[kn[h]];
    return { x: w.x, y: w.y, width: w.width, height: w.height, matrix: w.matrix };
  }, g.save = function(h, w) {
    return h = h || "generated.pdf", (w = w || {}).returnPromise = w.returnPromise || !1, w.returnPromise === !1 ? (Di(wi(Cn()), h), typeof Di.unload == "function" && Kt.setTimeout && setTimeout(Di.unload, 911), this) : new Promise(function(T, W) {
      try {
        var Z = Di(wi(Cn()), h);
        typeof Di.unload == "function" && Kt.setTimeout && setTimeout(Di.unload, 911), T(Z);
      } catch (mt) {
        W(mt.message);
      }
    });
  }, Dt.API) Dt.API.hasOwnProperty(Li) && (Li === "events" && Dt.API.events.length ? (function(h, w) {
    var T, W, Z;
    for (Z = w.length - 1; Z !== -1; Z--) T = w[Z][0], W = w[Z][1], h.subscribe.apply(h, [T].concat(typeof W == "function" ? [W] : W));
  })(ve, Dt.API.events) : g[Li] = Dt.API[Li]);
  function Sa(h) {
    return $t[h].mediaBox.topRightX - $t[h].mediaBox.bottomLeftX;
  }
  function ka(h, w) {
    $t[h].mediaBox.topRightX = w + $t[h].mediaBox.bottomLeftX;
  }
  function Fn(h) {
    return $t[h].mediaBox.topRightY - $t[h].mediaBox.bottomLeftY;
  }
  function On(h, w) {
    $t[h].mediaBox.topRightY = w + $t[h].mediaBox.bottomLeftY;
  }
  var Ea = g.getPageWidth = function(h) {
    return Sa(h = h || j) / Yt;
  }, Pa = g.setPageWidth = function(h, w) {
    ka(h, w * Yt);
  }, Si = g.getPageHeight = function(h) {
    return Fn(h = h || j) / Yt;
  }, Ca = g.setPageHeight = function(h, w) {
    On(h, w * Yt);
  };
  return g.internal = { pdfEscape: Yr, getStyle: Na, getFont: Vo, getFontSize: kt, getCharSpace: $o, getTextColor: es, getLineHeight: Go, getLineHeightFactor: Yo, getLineWidth: Zt, write: fe, getHorizontalCoordinate: Rn, getVerticalCoordinate: In, getCoordinateString: Ko, getVerticalCoordinateString: Xo, collections: {}, newObject: Me, newAdditionalObject: gi, newObjectDeferred: or, newObjectDeferredBegin: lr, getFilters: sn, putStream: Jr, events: ve, scaleFactor: Yt, pageSize: { getWidth: function() {
    return Ea(j);
  }, setWidth: function(h) {
    Pa(j, h);
  }, getHeight: function() {
    return Si(j);
  }, setHeight: function(h) {
    Ca(j, h);
  } }, encryptionOptions: d, encryption: He, getEncryptor: function(h) {
    return d !== null ? He.encryptor(h, 0) : function(w) {
      return w;
    };
  }, output: an, getNumberOfPages: ya, pages: xt, out: U, f2: A, f3: C, getPageInfo: Ss, getPageInfoByObjId: Do, getCurrentPageInfo: jo, getPDFVersion: x, Point: Ni, Rectangle: Fs, Matrix: Gt, hasHotfix: vi }, Object.defineProperty(g.internal.pageSize, "width", { get: function() {
    return Ea(j);
  }, set: function(h) {
    Pa(j, h);
  }, enumerable: !0, configurable: !0 }), Object.defineProperty(g.internal.pageSize, "height", { get: function() {
    return Si(j);
  }, set: function(h) {
    Ca(j, h);
  }, enumerable: !0, configurable: !0 }), (function(h) {
    for (var w = 0, T = Vt.length; w < T; w++) {
      var W = ba.call(this, h[w][0], h[w][1], h[w][2], Vt[w][3], !0);
      b === !1 && (_[W] = !0);
      var Z = h[w][0].split("-");
      ma({ id: W, fontName: Z[0], fontStyle: Z[1] || "" });
    }
    ve.publish("addFonts", { fonts: Tt, dictionary: ne });
  }).call(g, Vt), qt = "F1", wa(i, e), ve.publish("initialized"), g;
}
ds.prototype.lsbFirstWord = function(r) {
  return String.fromCharCode(255 & r, r >> 8 & 255, r >> 16 & 255, r >> 24 & 255);
}, ds.prototype.toHexString = function(r) {
  return r.split("").map(function(t) {
    return ("0" + (255 & t.charCodeAt(0)).toString(16)).slice(-2);
  }).join("");
}, ds.prototype.hexToBytes = function(r) {
  for (var t = [], e = 0; e < r.length; e += 2) t.push(String.fromCharCode(parseInt(r.substr(e, 2), 16)));
  return t.join("");
}, ds.prototype.processOwnerPassword = function(r, t) {
  return vu(wu(t).substr(0, 5), r);
}, ds.prototype.encryptor = function(r, t) {
  var e = wu(this.encryptionKey + String.fromCharCode(255 & r, r >> 8 & 255, r >> 16 & 255, 255 & t, t >> 8 & 255)).substr(0, 10);
  return function(n) {
    return vu(e, n);
  };
}, Lo.prototype.equals = function(r) {
  var t, e = "id,objectNumber,equals";
  if (!r || xe(r) !== xe(this)) return !1;
  var n = 0;
  for (t in this) if (!(e.indexOf(t) >= 0)) {
    if (this.hasOwnProperty(t) && !r.hasOwnProperty(t) || this[t] !== r[t]) return !1;
    n++;
  }
  for (t in r) r.hasOwnProperty(t) && e.indexOf(t) < 0 && n--;
  return n === 0;
}, Dt.API = { events: [] }, Dt.version = "3.0.3";
var Ue = Dt.API, Bu = 1, Ji = function(r) {
  return r.replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
}, ls = function(r) {
  return r.replace(/\\\\/g, "\\").replace(/\\\(/g, "(").replace(/\\\)/g, ")");
}, te = function(r) {
  return r.toFixed(2);
}, li = function(r) {
  return r.toFixed(5);
};
Ue.__acroform__ = {};
var Or = function(r, t) {
  r.prototype = Object.create(t.prototype), r.prototype.constructor = r;
}, Nf = function(r) {
  return r * Bu;
}, Nn = function(r) {
  var t = new x1(), e = Rt.internal.getHeight(r) || 0, n = Rt.internal.getWidth(r) || 0;
  return t.BBox = [0, 0, Number(te(n)), Number(te(e))], t;
}, N5 = Ue.__acroform__.setBit = function(r, t) {
  if (r = r || 0, t = t || 0, isNaN(r) || isNaN(t)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");
  return r | 1 << t;
}, L5 = Ue.__acroform__.clearBit = function(r, t) {
  if (r = r || 0, t = t || 0, isNaN(r) || isNaN(t)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");
  return r & ~(1 << t);
}, S5 = Ue.__acroform__.getBit = function(r, t) {
  if (isNaN(r) || isNaN(t)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");
  return r & 1 << t ? 1 : 0;
}, Ye = Ue.__acroform__.getBitForPdf = function(r, t) {
  if (isNaN(r) || isNaN(t)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");
  return S5(r, t - 1);
}, Ke = Ue.__acroform__.setBitForPdf = function(r, t) {
  if (isNaN(r) || isNaN(t)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");
  return N5(r, t - 1);
}, Xe = Ue.__acroform__.clearBitForPdf = function(r, t) {
  if (isNaN(r) || isNaN(t)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");
  return L5(r, t - 1);
}, k5 = Ue.__acroform__.calculateCoordinates = function(r, t) {
  var e = t.internal.getHorizontalCoordinate, n = t.internal.getVerticalCoordinate, i = r[0], s = r[1], c = r[2], o = r[3], l = {};
  return l.lowerLeft_X = e(i) || 0, l.lowerLeft_Y = n(s + o) || 0, l.upperRight_X = e(i + c) || 0, l.upperRight_Y = n(s) || 0, [Number(te(l.lowerLeft_X)), Number(te(l.lowerLeft_Y)), Number(te(l.upperRight_X)), Number(te(l.upperRight_Y))];
}, E5 = function(r) {
  if (r.appearanceStreamContent) return r.appearanceStreamContent;
  if (r.V || r.DV) {
    var t = [], e = r._V || r.DV, n = yu(r, e), i = r.scope.internal.getFont(r.fontName, r.fontStyle).id;
    t.push("/Tx BMC"), t.push("q"), t.push("BT"), t.push(r.scope.__private__.encodeColorString(r.color)), t.push("/" + i + " " + te(n.fontSize) + " Tf"), t.push("1 0 0 1 0 0 Tm"), t.push(n.text), t.push("ET"), t.push("Q"), t.push("EMC");
    var s = Nn(r);
    return s.scope = r.scope, s.stream = t.join(`
`), s;
  }
}, yu = function(r, t) {
  var e = r.fontSize === 0 ? r.maxFontSize : r.fontSize, n = { text: "", fontSize: "" }, i = (t = (t = t.substr(0, 1) == "(" ? t.substr(1) : t).substr(t.length - 1) == ")" ? t.substr(0, t.length - 1) : t).split(" ");
  i = r.multiline ? i.map(function(A) {
    return A.split(`
`);
  }) : i.map(function(A) {
    return [A];
  });
  var s = e, c = Rt.internal.getHeight(r) || 0;
  c = c < 0 ? -c : c;
  var o = Rt.internal.getWidth(r) || 0;
  o = o < 0 ? -o : o;
  var l = function(A, C, M) {
    if (A + 1 < i.length) {
      var D = C + " " + i[A + 1][0];
      return no(D, r, M).width <= o - 4;
    }
    return !1;
  };
  s++;
  t: for (; s > 0; ) {
    t = "", s--;
    var f, d, b = no("3", r, s).height, _ = r.multiline ? c - s : (c - b) / 2, g = _ += 2, y = 0, x = 0, E = 0;
    if (s <= 0) {
      t = `(...) Tj
`, t += "% Width of Text: " + no(t, r, s = 12).width + ", FieldWidth:" + o + `
`;
      break;
    }
    for (var N = "", H = 0, q = 0; q < i.length; q++) if (i.hasOwnProperty(q)) {
      var F = !1;
      if (i[q].length !== 1 && E !== i[q].length - 1) {
        if ((b + 2) * (H + 2) + 2 > c) continue t;
        N += i[q][E], F = !0, x = q, q--;
      } else {
        N = (N += i[q][E] + " ").substr(N.length - 1) == " " ? N.substr(0, N.length - 1) : N;
        var et = parseInt(q), Q = l(et, N, s), X = q >= i.length - 1;
        if (Q && !X) {
          N += " ", E = 0;
          continue;
        }
        if (Q || X) {
          if (X) x = et;
          else if (r.multiline && (b + 2) * (H + 2) + 2 > c) continue t;
        } else {
          if (!r.multiline || (b + 2) * (H + 2) + 2 > c) continue t;
          x = et;
        }
      }
      for (var V = "", I = y; I <= x; I++) {
        var G = i[I];
        if (r.multiline) {
          if (I === x) {
            V += G[E] + " ", E = (E + 1) % G.length;
            continue;
          }
          if (I === y) {
            V += G[G.length - 1] + " ";
            continue;
          }
        }
        V += G[0] + " ";
      }
      switch (V = V.substr(V.length - 1) == " " ? V.substr(0, V.length - 1) : V, d = no(V, r, s).width, r.textAlign) {
        case "right":
          f = o - d - 2;
          break;
        case "center":
          f = (o - d) / 2;
          break;
        default:
          f = 2;
      }
      t += te(f) + " " + te(g) + ` Td
`, t += "(" + Ji(V) + `) Tj
`, t += -te(f) + ` 0 Td
`, g = -(s + 2), d = 0, y = F ? x : x + 1, H++, N = "";
    }
    break;
  }
  return n.text = t, n.fontSize = s, n;
}, no = function(r, t, e) {
  var n = t.scope.internal.getFont(t.fontName, t.fontStyle), i = t.scope.getStringUnitWidth(r, { font: n, fontSize: parseFloat(e), charSpace: 0 }) * parseFloat(e);
  return { height: t.scope.getStringUnitWidth("3", { font: n, fontSize: parseFloat(e), charSpace: 0 }) * parseFloat(e) * 1.5, width: i };
}, P5 = { fields: [], xForms: [], acroFormDictionaryRoot: null, printedOut: !1, internal: null, isInitialized: !1 }, C5 = function(r, t) {
  var e = { type: "reference", object: r };
  t.internal.getPageInfo(r.page).pageContext.annotations.find(function(n) {
    return n.type === e.type && n.object === e.object;
  }) === void 0 && t.internal.getPageInfo(r.page).pageContext.annotations.push(e);
}, R5 = function(r, t) {
  if (t.scope = r, r.internal !== void 0 && (r.internal.acroformPlugin === void 0 || r.internal.acroformPlugin.isInitialized === !1)) {
    if (hn.FieldNum = 0, r.internal.acroformPlugin = JSON.parse(JSON.stringify(P5)), r.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("Exception while creating AcroformDictionary");
    Bu = r.internal.scaleFactor, r.internal.acroformPlugin.acroFormDictionaryRoot = new N1(), r.internal.acroformPlugin.acroFormDictionaryRoot.scope = r, r.internal.acroformPlugin.acroFormDictionaryRoot._eventID = r.internal.events.subscribe("postPutResources", function() {
      (function(e) {
        e.internal.events.unsubscribe(e.internal.acroformPlugin.acroFormDictionaryRoot._eventID), delete e.internal.acroformPlugin.acroFormDictionaryRoot._eventID, e.internal.acroformPlugin.printedOut = !0;
      })(r);
    }), r.internal.events.subscribe("buildDocument", function() {
      (function(e) {
        e.internal.acroformPlugin.acroFormDictionaryRoot.objId = void 0;
        var n = e.internal.acroformPlugin.acroFormDictionaryRoot.Fields;
        for (var i in n) if (n.hasOwnProperty(i)) {
          var s = n[i];
          s.objId = void 0, s.hasAnnotation && C5(s, e);
        }
      })(r);
    }), r.internal.events.subscribe("putCatalog", function() {
      (function(e) {
        if (e.internal.acroformPlugin.acroFormDictionaryRoot === void 0) throw new Error("putCatalogCallback: Root missing.");
        e.internal.write("/AcroForm " + e.internal.acroformPlugin.acroFormDictionaryRoot.objId + " 0 R");
      })(r);
    }), r.internal.events.subscribe("postPutPages", function(e) {
      (function(n, i) {
        var s = !n;
        for (var c in n || (i.internal.newObjectDeferredBegin(i.internal.acroformPlugin.acroFormDictionaryRoot.objId, !0), i.internal.acroformPlugin.acroFormDictionaryRoot.putStream()), n = n || i.internal.acroformPlugin.acroFormDictionaryRoot.Kids) if (n.hasOwnProperty(c)) {
          var o = n[c], l = [], f = o.Rect;
          if (o.Rect && (o.Rect = k5(o.Rect, i)), i.internal.newObjectDeferredBegin(o.objId, !0), o.DA = Rt.createDefaultAppearanceStream(o), xe(o) === "object" && typeof o.getKeyValueListForStream == "function" && (l = o.getKeyValueListForStream()), o.Rect = f, o.hasAppearanceStream && !o.appearanceStreamContent) {
            var d = E5(o);
            l.push({ key: "AP", value: "<</N " + d + ">>" }), i.internal.acroformPlugin.xForms.push(d);
          }
          if (o.appearanceStreamContent) {
            var b = "";
            for (var _ in o.appearanceStreamContent) if (o.appearanceStreamContent.hasOwnProperty(_)) {
              var g = o.appearanceStreamContent[_];
              if (b += "/" + _ + " ", b += "<<", Object.keys(g).length >= 1 || Array.isArray(g)) {
                for (var c in g) if (g.hasOwnProperty(c)) {
                  var y = g[c];
                  typeof y == "function" && (y = y.call(i, o)), b += "/" + c + " " + y + " ", i.internal.acroformPlugin.xForms.indexOf(y) >= 0 || i.internal.acroformPlugin.xForms.push(y);
                }
              } else typeof (y = g) == "function" && (y = y.call(i, o)), b += "/" + c + " " + y, i.internal.acroformPlugin.xForms.indexOf(y) >= 0 || i.internal.acroformPlugin.xForms.push(y);
              b += ">>";
            }
            l.push({ key: "AP", value: `<<
` + b + ">>" });
          }
          i.internal.putStream({ additionalKeyValues: l, objectId: o.objId }), i.internal.out("endobj");
        }
        s && (function(x, E) {
          for (var N in x) if (x.hasOwnProperty(N)) {
            var H = N, q = x[N];
            E.internal.newObjectDeferredBegin(q.objId, !0), xe(q) === "object" && typeof q.putStream == "function" && q.putStream(), delete x[H];
          }
        })(i.internal.acroformPlugin.xForms, i);
      })(e, r);
    }), r.internal.acroformPlugin.isInitialized = !0;
  }
}, A1 = Ue.__acroform__.arrayToPdfArray = function(r, t, e) {
  var n = function(c) {
    return c;
  };
  if (Array.isArray(r)) {
    for (var i = "[", s = 0; s < r.length; s++) switch (s !== 0 && (i += " "), xe(r[s])) {
      case "boolean":
      case "number":
      case "object":
        i += r[s].toString();
        break;
      case "string":
        r[s].substr(0, 1) !== "/" ? (t !== void 0 && e && (n = e.internal.getEncryptor(t)), i += "(" + Ji(n(r[s].toString())) + ")") : i += r[s].toString();
    }
    return i + "]";
  }
  throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray");
}, Rc = function(r, t, e) {
  var n = function(i) {
    return i;
  };
  return t !== void 0 && e && (n = e.internal.getEncryptor(t)), (r = r || "").toString(), "(" + Ji(n(r)) + ")";
}, Ln = function() {
  this._objId = void 0, this._scope = void 0, Object.defineProperty(this, "objId", { get: function() {
    if (this._objId === void 0) {
      if (this.scope === void 0) return;
      this._objId = this.scope.internal.newObjectDeferred();
    }
    return this._objId;
  }, set: function(r) {
    this._objId = r;
  } }), Object.defineProperty(this, "scope", { value: this._scope, writable: !0 });
};
Ln.prototype.toString = function() {
  return this.objId + " 0 R";
}, Ln.prototype.putStream = function() {
  var r = this.getKeyValueListForStream();
  this.scope.internal.putStream({ data: this.stream, additionalKeyValues: r, objectId: this.objId }), this.scope.internal.out("endobj");
}, Ln.prototype.getKeyValueListForStream = function() {
  var r = [], t = Object.getOwnPropertyNames(this).filter(function(s) {
    return s != "content" && s != "appearanceStreamContent" && s != "scope" && s != "objId" && s.substring(0, 1) != "_";
  });
  for (var e in t) if (Object.getOwnPropertyDescriptor(this, t[e]).configurable === !1) {
    var n = t[e], i = this[n];
    i && (Array.isArray(i) ? r.push({ key: n, value: A1(i, this.objId, this.scope) }) : i instanceof Ln ? (i.scope = this.scope, r.push({ key: n, value: i.objId + " 0 R" })) : typeof i != "function" && r.push({ key: n, value: i }));
  }
  return r;
};
var x1 = function() {
  Ln.call(this), Object.defineProperty(this, "Type", { value: "/XObject", configurable: !1, writable: !0 }), Object.defineProperty(this, "Subtype", { value: "/Form", configurable: !1, writable: !0 }), Object.defineProperty(this, "FormType", { value: 1, configurable: !1, writable: !0 });
  var r, t = [];
  Object.defineProperty(this, "BBox", { configurable: !1, get: function() {
    return t;
  }, set: function(e) {
    t = e;
  } }), Object.defineProperty(this, "Resources", { value: "2 0 R", configurable: !1, writable: !0 }), Object.defineProperty(this, "stream", { enumerable: !1, configurable: !0, set: function(e) {
    r = e.trim();
  }, get: function() {
    return r || null;
  } });
};
Or(x1, Ln);
var N1 = function() {
  Ln.call(this);
  var r, t = [];
  Object.defineProperty(this, "Kids", { enumerable: !1, configurable: !0, get: function() {
    return t.length > 0 ? t : void 0;
  } }), Object.defineProperty(this, "Fields", { enumerable: !1, configurable: !1, get: function() {
    return t;
  } }), Object.defineProperty(this, "DA", { enumerable: !1, configurable: !1, get: function() {
    if (r) {
      var e = function(n) {
        return n;
      };
      return this.scope && (e = this.scope.internal.getEncryptor(this.objId)), "(" + Ji(e(r)) + ")";
    }
  }, set: function(e) {
    r = e;
  } });
};
Or(N1, Ln);
var hn = function r() {
  Ln.call(this);
  var t = 4;
  Object.defineProperty(this, "F", { enumerable: !1, configurable: !1, get: function() {
    return t;
  }, set: function(N) {
    if (isNaN(N)) throw new Error('Invalid value "' + N + '" for attribute F supplied.');
    t = N;
  } }), Object.defineProperty(this, "showWhenPrinted", { enumerable: !0, configurable: !0, get: function() {
    return !!Ye(t, 3);
  }, set: function(N) {
    N ? this.F = Ke(t, 3) : this.F = Xe(t, 3);
  } });
  var e = 0;
  Object.defineProperty(this, "Ff", { enumerable: !1, configurable: !1, get: function() {
    return e;
  }, set: function(N) {
    if (isNaN(N)) throw new Error('Invalid value "' + N + '" for attribute Ff supplied.');
    e = N;
  } });
  var n = [];
  Object.defineProperty(this, "Rect", { enumerable: !1, configurable: !1, get: function() {
    if (n.length !== 0) return n;
  }, set: function(N) {
    n = N !== void 0 ? N : [];
  } }), Object.defineProperty(this, "x", { enumerable: !0, configurable: !0, get: function() {
    return !n || isNaN(n[0]) ? 0 : n[0];
  }, set: function(N) {
    n[0] = N;
  } }), Object.defineProperty(this, "y", { enumerable: !0, configurable: !0, get: function() {
    return !n || isNaN(n[1]) ? 0 : n[1];
  }, set: function(N) {
    n[1] = N;
  } }), Object.defineProperty(this, "width", { enumerable: !0, configurable: !0, get: function() {
    return !n || isNaN(n[2]) ? 0 : n[2];
  }, set: function(N) {
    n[2] = N;
  } }), Object.defineProperty(this, "height", { enumerable: !0, configurable: !0, get: function() {
    return !n || isNaN(n[3]) ? 0 : n[3];
  }, set: function(N) {
    n[3] = N;
  } });
  var i = "";
  Object.defineProperty(this, "FT", { enumerable: !0, configurable: !1, get: function() {
    return i;
  }, set: function(N) {
    switch (N) {
      case "/Btn":
      case "/Tx":
      case "/Ch":
      case "/Sig":
        i = N;
        break;
      default:
        throw new Error('Invalid value "' + N + '" for attribute FT supplied.');
    }
  } });
  var s = null;
  Object.defineProperty(this, "T", { enumerable: !0, configurable: !1, get: function() {
    if (!s || s.length < 1) {
      if (this instanceof So) return;
      s = "FieldObject" + r.FieldNum++;
    }
    var N = function(H) {
      return H;
    };
    return this.scope && (N = this.scope.internal.getEncryptor(this.objId)), "(" + Ji(N(s)) + ")";
  }, set: function(N) {
    s = N.toString();
  } }), Object.defineProperty(this, "fieldName", { configurable: !0, enumerable: !0, get: function() {
    return s;
  }, set: function(N) {
    s = N;
  } });
  var c = "helvetica";
  Object.defineProperty(this, "fontName", { enumerable: !0, configurable: !0, get: function() {
    return c;
  }, set: function(N) {
    c = N;
  } });
  var o = "normal";
  Object.defineProperty(this, "fontStyle", { enumerable: !0, configurable: !0, get: function() {
    return o;
  }, set: function(N) {
    o = N;
  } });
  var l = 0;
  Object.defineProperty(this, "fontSize", { enumerable: !0, configurable: !0, get: function() {
    return l;
  }, set: function(N) {
    l = N;
  } });
  var f = void 0;
  Object.defineProperty(this, "maxFontSize", { enumerable: !0, configurable: !0, get: function() {
    return f === void 0 ? 50 / Bu : f;
  }, set: function(N) {
    f = N;
  } });
  var d = "black";
  Object.defineProperty(this, "color", { enumerable: !0, configurable: !0, get: function() {
    return d;
  }, set: function(N) {
    d = N;
  } });
  var b = "/F1 0 Tf 0 g";
  Object.defineProperty(this, "DA", { enumerable: !0, configurable: !1, get: function() {
    if (!(!b || this instanceof So || this instanceof Ui)) return Rc(b, this.objId, this.scope);
  }, set: function(N) {
    N = N.toString(), b = N;
  } });
  var _ = null;
  Object.defineProperty(this, "DV", { enumerable: !1, configurable: !1, get: function() {
    if (_) return this instanceof ur == 0 ? Rc(_, this.objId, this.scope) : _;
  }, set: function(N) {
    N = N.toString(), _ = this instanceof ur == 0 ? N.substr(0, 1) === "(" ? ls(N.substr(1, N.length - 2)) : ls(N) : N;
  } }), Object.defineProperty(this, "defaultValue", { enumerable: !0, configurable: !0, get: function() {
    return this instanceof ur == 1 ? ls(_.substr(1, _.length - 1)) : _;
  }, set: function(N) {
    N = N.toString(), _ = this instanceof ur == 1 ? "/" + N : N;
  } });
  var g = null;
  Object.defineProperty(this, "_V", { enumerable: !1, configurable: !1, get: function() {
    if (g) return g;
  }, set: function(N) {
    this.V = N;
  } }), Object.defineProperty(this, "V", { enumerable: !1, configurable: !1, get: function() {
    if (g) return this instanceof ur == 0 ? Rc(g, this.objId, this.scope) : g;
  }, set: function(N) {
    N = N.toString(), g = this instanceof ur == 0 ? N.substr(0, 1) === "(" ? ls(N.substr(1, N.length - 2)) : ls(N) : N;
  } }), Object.defineProperty(this, "value", { enumerable: !0, configurable: !0, get: function() {
    return this instanceof ur == 1 ? ls(g.substr(1, g.length - 1)) : g;
  }, set: function(N) {
    N = N.toString(), g = this instanceof ur == 1 ? "/" + N : N;
  } }), Object.defineProperty(this, "hasAnnotation", { enumerable: !0, configurable: !0, get: function() {
    return this.Rect;
  } }), Object.defineProperty(this, "Type", { enumerable: !0, configurable: !1, get: function() {
    return this.hasAnnotation ? "/Annot" : null;
  } }), Object.defineProperty(this, "Subtype", { enumerable: !0, configurable: !1, get: function() {
    return this.hasAnnotation ? "/Widget" : null;
  } });
  var y, x = !1;
  Object.defineProperty(this, "hasAppearanceStream", { enumerable: !0, configurable: !0, get: function() {
    return x;
  }, set: function(N) {
    N = !!N, x = N;
  } }), Object.defineProperty(this, "page", { enumerable: !0, configurable: !0, get: function() {
    if (y) return y;
  }, set: function(N) {
    y = N;
  } }), Object.defineProperty(this, "readOnly", { enumerable: !0, configurable: !0, get: function() {
    return !!Ye(this.Ff, 1);
  }, set: function(N) {
    N ? this.Ff = Ke(this.Ff, 1) : this.Ff = Xe(this.Ff, 1);
  } }), Object.defineProperty(this, "required", { enumerable: !0, configurable: !0, get: function() {
    return !!Ye(this.Ff, 2);
  }, set: function(N) {
    N ? this.Ff = Ke(this.Ff, 2) : this.Ff = Xe(this.Ff, 2);
  } }), Object.defineProperty(this, "noExport", { enumerable: !0, configurable: !0, get: function() {
    return !!Ye(this.Ff, 3);
  }, set: function(N) {
    N ? this.Ff = Ke(this.Ff, 3) : this.Ff = Xe(this.Ff, 3);
  } });
  var E = null;
  Object.defineProperty(this, "Q", { enumerable: !0, configurable: !1, get: function() {
    if (E !== null) return E;
  }, set: function(N) {
    if ([0, 1, 2].indexOf(N) === -1) throw new Error('Invalid value "' + N + '" for attribute Q supplied.');
    E = N;
  } }), Object.defineProperty(this, "textAlign", { get: function() {
    var N;
    switch (E) {
      case 0:
      default:
        N = "left";
        break;
      case 1:
        N = "center";
        break;
      case 2:
        N = "right";
    }
    return N;
  }, configurable: !0, enumerable: !0, set: function(N) {
    switch (N) {
      case "right":
      case 2:
        E = 2;
        break;
      case "center":
      case 1:
        E = 1;
        break;
      default:
        E = 0;
    }
  } });
};
Or(hn, Ln);
var ms = function() {
  hn.call(this), this.FT = "/Ch", this.V = "()", this.fontName = "zapfdingbats";
  var r = 0;
  Object.defineProperty(this, "TI", { enumerable: !0, configurable: !1, get: function() {
    return r;
  }, set: function(e) {
    r = e;
  } }), Object.defineProperty(this, "topIndex", { enumerable: !0, configurable: !0, get: function() {
    return r;
  }, set: function(e) {
    r = e;
  } });
  var t = [];
  Object.defineProperty(this, "Opt", { enumerable: !0, configurable: !1, get: function() {
    return A1(t, this.objId, this.scope);
  }, set: function(e) {
    var n, i;
    i = [], typeof (n = e) == "string" && (i = (function(s, c, o) {
      o || (o = 1);
      for (var l, f = []; l = c.exec(s); ) f.push(l[o]);
      return f;
    })(n, /\((.*?)\)/g)), t = i;
  } }), this.getOptions = function() {
    return t;
  }, this.setOptions = function(e) {
    t = e, this.sort && t.sort();
  }, this.addOption = function(e) {
    e = (e = e || "").toString(), t.push(e), this.sort && t.sort();
  }, this.removeOption = function(e, n) {
    for (n = n || !1, e = (e = e || "").toString(); t.indexOf(e) !== -1 && (t.splice(t.indexOf(e), 1), n !== !1); ) ;
  }, Object.defineProperty(this, "combo", { enumerable: !0, configurable: !0, get: function() {
    return !!Ye(this.Ff, 18);
  }, set: function(e) {
    e ? this.Ff = Ke(this.Ff, 18) : this.Ff = Xe(this.Ff, 18);
  } }), Object.defineProperty(this, "edit", { enumerable: !0, configurable: !0, get: function() {
    return !!Ye(this.Ff, 19);
  }, set: function(e) {
    this.combo === !0 && (e ? this.Ff = Ke(this.Ff, 19) : this.Ff = Xe(this.Ff, 19));
  } }), Object.defineProperty(this, "sort", { enumerable: !0, configurable: !0, get: function() {
    return !!Ye(this.Ff, 20);
  }, set: function(e) {
    e ? (this.Ff = Ke(this.Ff, 20), t.sort()) : this.Ff = Xe(this.Ff, 20);
  } }), Object.defineProperty(this, "multiSelect", { enumerable: !0, configurable: !0, get: function() {
    return !!Ye(this.Ff, 22);
  }, set: function(e) {
    e ? this.Ff = Ke(this.Ff, 22) : this.Ff = Xe(this.Ff, 22);
  } }), Object.defineProperty(this, "doNotSpellCheck", { enumerable: !0, configurable: !0, get: function() {
    return !!Ye(this.Ff, 23);
  }, set: function(e) {
    e ? this.Ff = Ke(this.Ff, 23) : this.Ff = Xe(this.Ff, 23);
  } }), Object.defineProperty(this, "commitOnSelChange", { enumerable: !0, configurable: !0, get: function() {
    return !!Ye(this.Ff, 27);
  }, set: function(e) {
    e ? this.Ff = Ke(this.Ff, 27) : this.Ff = Xe(this.Ff, 27);
  } }), this.hasAppearanceStream = !1;
};
Or(ms, hn);
var bs = function() {
  ms.call(this), this.fontName = "helvetica", this.combo = !1;
};
Or(bs, ms);
var ws = function() {
  bs.call(this), this.combo = !0;
};
Or(ws, bs);
var ho = function() {
  ws.call(this), this.edit = !0;
};
Or(ho, ws);
var ur = function() {
  hn.call(this), this.FT = "/Btn", Object.defineProperty(this, "noToggleToOff", { enumerable: !0, configurable: !0, get: function() {
    return !!Ye(this.Ff, 15);
  }, set: function(e) {
    e ? this.Ff = Ke(this.Ff, 15) : this.Ff = Xe(this.Ff, 15);
  } }), Object.defineProperty(this, "radio", { enumerable: !0, configurable: !0, get: function() {
    return !!Ye(this.Ff, 16);
  }, set: function(e) {
    e ? this.Ff = Ke(this.Ff, 16) : this.Ff = Xe(this.Ff, 16);
  } }), Object.defineProperty(this, "pushButton", { enumerable: !0, configurable: !0, get: function() {
    return !!Ye(this.Ff, 17);
  }, set: function(e) {
    e ? this.Ff = Ke(this.Ff, 17) : this.Ff = Xe(this.Ff, 17);
  } }), Object.defineProperty(this, "radioIsUnison", { enumerable: !0, configurable: !0, get: function() {
    return !!Ye(this.Ff, 26);
  }, set: function(e) {
    e ? this.Ff = Ke(this.Ff, 26) : this.Ff = Xe(this.Ff, 26);
  } });
  var r, t = {};
  Object.defineProperty(this, "MK", { enumerable: !1, configurable: !1, get: function() {
    var e = function(s) {
      return s;
    };
    if (this.scope && (e = this.scope.internal.getEncryptor(this.objId)), Object.keys(t).length !== 0) {
      var n, i = [];
      for (n in i.push("<<"), t) i.push("/" + n + " (" + Ji(e(t[n])) + ")");
      return i.push(">>"), i.join(`
`);
    }
  }, set: function(e) {
    xe(e) === "object" && (t = e);
  } }), Object.defineProperty(this, "caption", { enumerable: !0, configurable: !0, get: function() {
    return t.CA || "";
  }, set: function(e) {
    typeof e == "string" && (t.CA = e);
  } }), Object.defineProperty(this, "AS", { enumerable: !1, configurable: !1, get: function() {
    return r;
  }, set: function(e) {
    r = e;
  } }), Object.defineProperty(this, "appearanceState", { enumerable: !0, configurable: !0, get: function() {
    return r.substr(1, r.length - 1);
  }, set: function(e) {
    r = "/" + e;
  } });
};
Or(ur, hn);
var po = function() {
  ur.call(this), this.pushButton = !0;
};
Or(po, ur);
var vs = function() {
  ur.call(this), this.radio = !0, this.pushButton = !1;
  var r = [];
  Object.defineProperty(this, "Kids", { enumerable: !0, configurable: !1, get: function() {
    return r;
  }, set: function(t) {
    r = t !== void 0 ? t : [];
  } });
};
Or(vs, ur);
var So = function() {
  var r, t;
  hn.call(this), Object.defineProperty(this, "Parent", { enumerable: !1, configurable: !1, get: function() {
    return r;
  }, set: function(i) {
    r = i;
  } }), Object.defineProperty(this, "optionName", { enumerable: !1, configurable: !0, get: function() {
    return t;
  }, set: function(i) {
    t = i;
  } });
  var e, n = {};
  Object.defineProperty(this, "MK", { enumerable: !1, configurable: !1, get: function() {
    var i = function(o) {
      return o;
    };
    this.scope && (i = this.scope.internal.getEncryptor(this.objId));
    var s, c = [];
    for (s in c.push("<<"), n) c.push("/" + s + " (" + Ji(i(n[s])) + ")");
    return c.push(">>"), c.join(`
`);
  }, set: function(i) {
    xe(i) === "object" && (n = i);
  } }), Object.defineProperty(this, "caption", { enumerable: !0, configurable: !0, get: function() {
    return n.CA || "";
  }, set: function(i) {
    typeof i == "string" && (n.CA = i);
  } }), Object.defineProperty(this, "AS", { enumerable: !1, configurable: !1, get: function() {
    return e;
  }, set: function(i) {
    e = i;
  } }), Object.defineProperty(this, "appearanceState", { enumerable: !0, configurable: !0, get: function() {
    return e.substr(1, e.length - 1);
  }, set: function(i) {
    e = "/" + i;
  } }), this.caption = "l", this.appearanceState = "Off", this._AppearanceType = Rt.RadioButton.Circle, this.appearanceStreamContent = this._AppearanceType.createAppearanceStream(this.optionName);
};
Or(So, hn), vs.prototype.setAppearance = function(r) {
  if (!("createAppearanceStream" in r) || !("getCA" in r)) throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");
  for (var t in this.Kids) if (this.Kids.hasOwnProperty(t)) {
    var e = this.Kids[t];
    e.appearanceStreamContent = r.createAppearanceStream(e.optionName), e.caption = r.getCA();
  }
}, vs.prototype.createOption = function(r) {
  var t = new So();
  return t.Parent = this, t.optionName = r, this.Kids.push(t), I5.call(this.scope, t), t;
};
var go = function() {
  ur.call(this), this.fontName = "zapfdingbats", this.caption = "3", this.appearanceState = "On", this.value = "On", this.textAlign = "center", this.appearanceStreamContent = Rt.CheckBox.createAppearanceStream();
};
Or(go, ur);
var Ui = function() {
  hn.call(this), this.FT = "/Tx", Object.defineProperty(this, "multiline", { enumerable: !0, configurable: !0, get: function() {
    return !!Ye(this.Ff, 13);
  }, set: function(t) {
    t ? this.Ff = Ke(this.Ff, 13) : this.Ff = Xe(this.Ff, 13);
  } }), Object.defineProperty(this, "fileSelect", { enumerable: !0, configurable: !0, get: function() {
    return !!Ye(this.Ff, 21);
  }, set: function(t) {
    t ? this.Ff = Ke(this.Ff, 21) : this.Ff = Xe(this.Ff, 21);
  } }), Object.defineProperty(this, "doNotSpellCheck", { enumerable: !0, configurable: !0, get: function() {
    return !!Ye(this.Ff, 23);
  }, set: function(t) {
    t ? this.Ff = Ke(this.Ff, 23) : this.Ff = Xe(this.Ff, 23);
  } }), Object.defineProperty(this, "doNotScroll", { enumerable: !0, configurable: !0, get: function() {
    return !!Ye(this.Ff, 24);
  }, set: function(t) {
    t ? this.Ff = Ke(this.Ff, 24) : this.Ff = Xe(this.Ff, 24);
  } }), Object.defineProperty(this, "comb", { enumerable: !0, configurable: !0, get: function() {
    return !!Ye(this.Ff, 25);
  }, set: function(t) {
    t ? this.Ff = Ke(this.Ff, 25) : this.Ff = Xe(this.Ff, 25);
  } }), Object.defineProperty(this, "richText", { enumerable: !0, configurable: !0, get: function() {
    return !!Ye(this.Ff, 26);
  }, set: function(t) {
    t ? this.Ff = Ke(this.Ff, 26) : this.Ff = Xe(this.Ff, 26);
  } });
  var r = null;
  Object.defineProperty(this, "MaxLen", { enumerable: !0, configurable: !1, get: function() {
    return r;
  }, set: function(t) {
    r = t;
  } }), Object.defineProperty(this, "maxLength", { enumerable: !0, configurable: !0, get: function() {
    return r;
  }, set: function(t) {
    Number.isInteger(t) && (r = t);
  } }), Object.defineProperty(this, "hasAppearanceStream", { enumerable: !0, configurable: !0, get: function() {
    return this.V || this.DV;
  } });
};
Or(Ui, hn);
var mo = function() {
  Ui.call(this), Object.defineProperty(this, "password", { enumerable: !0, configurable: !0, get: function() {
    return !!Ye(this.Ff, 14);
  }, set: function(r) {
    r ? this.Ff = Ke(this.Ff, 14) : this.Ff = Xe(this.Ff, 14);
  } }), this.password = !0;
};
Or(mo, Ui);
var Rt = { CheckBox: { createAppearanceStream: function() {
  return { N: { On: Rt.CheckBox.YesNormal }, D: { On: Rt.CheckBox.YesPushDown, Off: Rt.CheckBox.OffPushDown } };
}, YesPushDown: function(r) {
  var t = Nn(r);
  t.scope = r.scope;
  var e = [], n = r.scope.internal.getFont(r.fontName, r.fontStyle).id, i = r.scope.__private__.encodeColorString(r.color), s = yu(r, r.caption);
  return e.push("0.749023 g"), e.push("0 0 " + te(Rt.internal.getWidth(r)) + " " + te(Rt.internal.getHeight(r)) + " re"), e.push("f"), e.push("BMC"), e.push("q"), e.push("0 0 1 rg"), e.push("/" + n + " " + te(s.fontSize) + " Tf " + i), e.push("BT"), e.push(s.text), e.push("ET"), e.push("Q"), e.push("EMC"), t.stream = e.join(`
`), t;
}, YesNormal: function(r) {
  var t = Nn(r);
  t.scope = r.scope;
  var e = r.scope.internal.getFont(r.fontName, r.fontStyle).id, n = r.scope.__private__.encodeColorString(r.color), i = [], s = Rt.internal.getHeight(r), c = Rt.internal.getWidth(r), o = yu(r, r.caption);
  return i.push("1 g"), i.push("0 0 " + te(c) + " " + te(s) + " re"), i.push("f"), i.push("q"), i.push("0 0 1 rg"), i.push("0 0 " + te(c - 1) + " " + te(s - 1) + " re"), i.push("W"), i.push("n"), i.push("0 g"), i.push("BT"), i.push("/" + e + " " + te(o.fontSize) + " Tf " + n), i.push(o.text), i.push("ET"), i.push("Q"), t.stream = i.join(`
`), t;
}, OffPushDown: function(r) {
  var t = Nn(r);
  t.scope = r.scope;
  var e = [];
  return e.push("0.749023 g"), e.push("0 0 " + te(Rt.internal.getWidth(r)) + " " + te(Rt.internal.getHeight(r)) + " re"), e.push("f"), t.stream = e.join(`
`), t;
} }, RadioButton: { Circle: { createAppearanceStream: function(r) {
  var t = { D: { Off: Rt.RadioButton.Circle.OffPushDown }, N: {} };
  return t.N[r] = Rt.RadioButton.Circle.YesNormal, t.D[r] = Rt.RadioButton.Circle.YesPushDown, t;
}, getCA: function() {
  return "l";
}, YesNormal: function(r) {
  var t = Nn(r);
  t.scope = r.scope;
  var e = [], n = Rt.internal.getWidth(r) <= Rt.internal.getHeight(r) ? Rt.internal.getWidth(r) / 4 : Rt.internal.getHeight(r) / 4;
  n = Number((0.9 * n).toFixed(5));
  var i = Rt.internal.Bezier_C, s = Number((n * i).toFixed(5));
  return e.push("q"), e.push("1 0 0 1 " + li(Rt.internal.getWidth(r) / 2) + " " + li(Rt.internal.getHeight(r) / 2) + " cm"), e.push(n + " 0 m"), e.push(n + " " + s + " " + s + " " + n + " 0 " + n + " c"), e.push("-" + s + " " + n + " -" + n + " " + s + " -" + n + " 0 c"), e.push("-" + n + " -" + s + " -" + s + " -" + n + " 0 -" + n + " c"), e.push(s + " -" + n + " " + n + " -" + s + " " + n + " 0 c"), e.push("f"), e.push("Q"), t.stream = e.join(`
`), t;
}, YesPushDown: function(r) {
  var t = Nn(r);
  t.scope = r.scope;
  var e = [], n = Rt.internal.getWidth(r) <= Rt.internal.getHeight(r) ? Rt.internal.getWidth(r) / 4 : Rt.internal.getHeight(r) / 4;
  n = Number((0.9 * n).toFixed(5));
  var i = Number((2 * n).toFixed(5)), s = Number((i * Rt.internal.Bezier_C).toFixed(5)), c = Number((n * Rt.internal.Bezier_C).toFixed(5));
  return e.push("0.749023 g"), e.push("q"), e.push("1 0 0 1 " + li(Rt.internal.getWidth(r) / 2) + " " + li(Rt.internal.getHeight(r) / 2) + " cm"), e.push(i + " 0 m"), e.push(i + " " + s + " " + s + " " + i + " 0 " + i + " c"), e.push("-" + s + " " + i + " -" + i + " " + s + " -" + i + " 0 c"), e.push("-" + i + " -" + s + " -" + s + " -" + i + " 0 -" + i + " c"), e.push(s + " -" + i + " " + i + " -" + s + " " + i + " 0 c"), e.push("f"), e.push("Q"), e.push("0 g"), e.push("q"), e.push("1 0 0 1 " + li(Rt.internal.getWidth(r) / 2) + " " + li(Rt.internal.getHeight(r) / 2) + " cm"), e.push(n + " 0 m"), e.push(n + " " + c + " " + c + " " + n + " 0 " + n + " c"), e.push("-" + c + " " + n + " -" + n + " " + c + " -" + n + " 0 c"), e.push("-" + n + " -" + c + " -" + c + " -" + n + " 0 -" + n + " c"), e.push(c + " -" + n + " " + n + " -" + c + " " + n + " 0 c"), e.push("f"), e.push("Q"), t.stream = e.join(`
`), t;
}, OffPushDown: function(r) {
  var t = Nn(r);
  t.scope = r.scope;
  var e = [], n = Rt.internal.getWidth(r) <= Rt.internal.getHeight(r) ? Rt.internal.getWidth(r) / 4 : Rt.internal.getHeight(r) / 4;
  n = Number((0.9 * n).toFixed(5));
  var i = Number((2 * n).toFixed(5)), s = Number((i * Rt.internal.Bezier_C).toFixed(5));
  return e.push("0.749023 g"), e.push("q"), e.push("1 0 0 1 " + li(Rt.internal.getWidth(r) / 2) + " " + li(Rt.internal.getHeight(r) / 2) + " cm"), e.push(i + " 0 m"), e.push(i + " " + s + " " + s + " " + i + " 0 " + i + " c"), e.push("-" + s + " " + i + " -" + i + " " + s + " -" + i + " 0 c"), e.push("-" + i + " -" + s + " -" + s + " -" + i + " 0 -" + i + " c"), e.push(s + " -" + i + " " + i + " -" + s + " " + i + " 0 c"), e.push("f"), e.push("Q"), t.stream = e.join(`
`), t;
} }, Cross: { createAppearanceStream: function(r) {
  var t = { D: { Off: Rt.RadioButton.Cross.OffPushDown }, N: {} };
  return t.N[r] = Rt.RadioButton.Cross.YesNormal, t.D[r] = Rt.RadioButton.Cross.YesPushDown, t;
}, getCA: function() {
  return "8";
}, YesNormal: function(r) {
  var t = Nn(r);
  t.scope = r.scope;
  var e = [], n = Rt.internal.calculateCross(r);
  return e.push("q"), e.push("1 1 " + te(Rt.internal.getWidth(r) - 2) + " " + te(Rt.internal.getHeight(r) - 2) + " re"), e.push("W"), e.push("n"), e.push(te(n.x1.x) + " " + te(n.x1.y) + " m"), e.push(te(n.x2.x) + " " + te(n.x2.y) + " l"), e.push(te(n.x4.x) + " " + te(n.x4.y) + " m"), e.push(te(n.x3.x) + " " + te(n.x3.y) + " l"), e.push("s"), e.push("Q"), t.stream = e.join(`
`), t;
}, YesPushDown: function(r) {
  var t = Nn(r);
  t.scope = r.scope;
  var e = Rt.internal.calculateCross(r), n = [];
  return n.push("0.749023 g"), n.push("0 0 " + te(Rt.internal.getWidth(r)) + " " + te(Rt.internal.getHeight(r)) + " re"), n.push("f"), n.push("q"), n.push("1 1 " + te(Rt.internal.getWidth(r) - 2) + " " + te(Rt.internal.getHeight(r) - 2) + " re"), n.push("W"), n.push("n"), n.push(te(e.x1.x) + " " + te(e.x1.y) + " m"), n.push(te(e.x2.x) + " " + te(e.x2.y) + " l"), n.push(te(e.x4.x) + " " + te(e.x4.y) + " m"), n.push(te(e.x3.x) + " " + te(e.x3.y) + " l"), n.push("s"), n.push("Q"), t.stream = n.join(`
`), t;
}, OffPushDown: function(r) {
  var t = Nn(r);
  t.scope = r.scope;
  var e = [];
  return e.push("0.749023 g"), e.push("0 0 " + te(Rt.internal.getWidth(r)) + " " + te(Rt.internal.getHeight(r)) + " re"), e.push("f"), t.stream = e.join(`
`), t;
} } }, createDefaultAppearanceStream: function(r) {
  var t = r.scope.internal.getFont(r.fontName, r.fontStyle).id, e = r.scope.__private__.encodeColorString(r.color);
  return "/" + t + " " + r.fontSize + " Tf " + e;
} };
Rt.internal = { Bezier_C: 0.551915024494, calculateCross: function(r) {
  var t = Rt.internal.getWidth(r), e = Rt.internal.getHeight(r), n = Math.min(t, e);
  return { x1: { x: (t - n) / 2, y: (e - n) / 2 + n }, x2: { x: (t - n) / 2 + n, y: (e - n) / 2 }, x3: { x: (t - n) / 2, y: (e - n) / 2 }, x4: { x: (t - n) / 2 + n, y: (e - n) / 2 + n } };
} }, Rt.internal.getWidth = function(r) {
  var t = 0;
  return xe(r) === "object" && (t = Nf(r.Rect[2])), t;
}, Rt.internal.getHeight = function(r) {
  var t = 0;
  return xe(r) === "object" && (t = Nf(r.Rect[3])), t;
};
var I5 = Ue.addField = function(r) {
  if (R5(this, r), !(r instanceof hn)) throw new Error("Invalid argument passed to jsPDF.addField.");
  var t;
  return (t = r).scope.internal.acroformPlugin.printedOut && (t.scope.internal.acroformPlugin.printedOut = !1, t.scope.internal.acroformPlugin.acroFormDictionaryRoot = null), t.scope.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(t), r.page = r.scope.internal.getCurrentPageInfo().pageNumber, this;
};
Ue.AcroFormChoiceField = ms, Ue.AcroFormListBox = bs, Ue.AcroFormComboBox = ws, Ue.AcroFormEditBox = ho, Ue.AcroFormButton = ur, Ue.AcroFormPushButton = po, Ue.AcroFormRadioButton = vs, Ue.AcroFormCheckBox = go, Ue.AcroFormTextField = Ui, Ue.AcroFormPasswordField = mo, Ue.AcroFormAppearance = Rt, Ue.AcroForm = { ChoiceField: ms, ListBox: bs, ComboBox: ws, EditBox: ho, Button: ur, PushButton: po, RadioButton: vs, CheckBox: go, TextField: Ui, PasswordField: mo, Appearance: Rt }, Dt.AcroForm = { ChoiceField: ms, ListBox: bs, ComboBox: ws, EditBox: ho, Button: ur, PushButton: po, RadioButton: vs, CheckBox: go, TextField: Ui, PasswordField: mo, Appearance: Rt };
Dt.AcroForm;
function L1(r) {
  return r.reduce(function(t, e, n) {
    return t[e] = n, t;
  }, {});
}
(function(r) {
  var t = "addImage_";
  r.__addimage__ = {};
  var e = "UNKNOWN", n = { PNG: [[137, 80, 78, 71]], TIFF: [[77, 77, 0, 42], [73, 73, 42, 0]], JPEG: [[255, 216, 255, 224, void 0, void 0, 74, 70, 73, 70, 0], [255, 216, 255, 225, void 0, void 0, 69, 120, 105, 102, 0, 0], [255, 216, 255, 219], [255, 216, 255, 238]], JPEG2000: [[0, 0, 0, 12, 106, 80, 32, 32]], GIF87a: [[71, 73, 70, 56, 55, 97]], GIF89a: [[71, 73, 70, 56, 57, 97]], WEBP: [[82, 73, 70, 70, void 0, void 0, void 0, void 0, 87, 69, 66, 80]], BMP: [[66, 77], [66, 65], [67, 73], [67, 80], [73, 67], [80, 84]] }, i = r.__addimage__.getImageFileTypeByImageData = function(A, C) {
    var M, D, at, ot, ft, rt = e;
    if ((C = C || e) === "RGBA" || A.data !== void 0 && A.data instanceof Uint8ClampedArray && "height" in A && "width" in A) return "RGBA";
    if (Q(A)) for (ft in n) for (at = n[ft], M = 0; M < at.length; M += 1) {
      for (ot = !0, D = 0; D < at[M].length; D += 1) if (at[M][D] !== void 0 && at[M][D] !== A[D]) {
        ot = !1;
        break;
      }
      if (ot === !0) {
        rt = ft;
        break;
      }
    }
    else for (ft in n) for (at = n[ft], M = 0; M < at.length; M += 1) {
      for (ot = !0, D = 0; D < at[M].length; D += 1) if (at[M][D] !== void 0 && at[M][D] !== A.charCodeAt(D)) {
        ot = !1;
        break;
      }
      if (ot === !0) {
        rt = ft;
        break;
      }
    }
    return rt === e && C !== e && (rt = C), rt;
  }, s = function A(C) {
    for (var M = this.internal.write, D = this.internal.putStream, at = (0, this.internal.getFilters)(); at.indexOf("FlateEncode") !== -1; ) at.splice(at.indexOf("FlateEncode"), 1);
    C.objectId = this.internal.newObject();
    var ot = [];
    if (ot.push({ key: "Type", value: "/XObject" }), ot.push({ key: "Subtype", value: "/Image" }), ot.push({ key: "Width", value: C.width }), ot.push({ key: "Height", value: C.height }), C.colorSpace === N.INDEXED ? ot.push({ key: "ColorSpace", value: "[/Indexed /DeviceRGB " + (C.palette.length / 3 - 1) + " " + ("sMask" in C && C.sMask !== void 0 ? C.objectId + 2 : C.objectId + 1) + " 0 R]" }) : (ot.push({ key: "ColorSpace", value: "/" + C.colorSpace }), C.colorSpace === N.DEVICE_CMYK && ot.push({ key: "Decode", value: "[1 0 1 0 1 0 1 0]" })), ot.push({ key: "BitsPerComponent", value: C.bitsPerComponent }), "decodeParameters" in C && C.decodeParameters !== void 0 && ot.push({ key: "DecodeParms", value: "<<" + C.decodeParameters + ">>" }), "transparency" in C && Array.isArray(C.transparency) && C.transparency.length > 0) {
      for (var ft = "", rt = 0, ht = C.transparency.length; rt < ht; rt++) ft += C.transparency[rt] + " " + C.transparency[rt] + " ";
      ot.push({ key: "Mask", value: "[" + ft + "]" });
    }
    C.sMask !== void 0 && ot.push({ key: "SMask", value: C.objectId + 1 + " 0 R" });
    var Lt = C.filter !== void 0 ? ["/" + C.filter] : void 0;
    if (D({ data: C.data, additionalKeyValues: ot, alreadyAppliedFilters: Lt, objectId: C.objectId }), M("endobj"), "sMask" in C && C.sMask !== void 0) {
      var vt, S = (vt = C.sMaskBitsPerComponent) !== null && vt !== void 0 ? vt : C.bitsPerComponent, j = { width: C.width, height: C.height, colorSpace: "DeviceGray", bitsPerComponent: S, data: C.sMask };
      "filter" in C && (j.decodeParameters = "/Predictor ".concat(C.predictor, " /Colors 1 /BitsPerComponent ").concat(S, " /Columns ").concat(C.width), j.filter = C.filter), A.call(this, j);
    }
    if (C.colorSpace === N.INDEXED) {
      var z = this.internal.newObject();
      D({ data: V(new Uint8Array(C.palette)), objectId: z }), M("endobj");
    }
  }, c = function() {
    var A = this.internal.collections[t + "images"];
    for (var C in A) s.call(this, A[C]);
  }, o = function() {
    var A, C = this.internal.collections[t + "images"], M = this.internal.write;
    for (var D in C) M("/I" + (A = C[D]).index, A.objectId, "0", "R");
  }, l = function() {
    this.internal.collections[t + "images"] || (this.internal.collections[t + "images"] = {}, this.internal.events.subscribe("putResources", c), this.internal.events.subscribe("putXobjectDict", o));
  }, f = function() {
    var A = this.internal.collections[t + "images"];
    return l.call(this), A;
  }, d = function() {
    return Object.keys(this.internal.collections[t + "images"]).length;
  }, b = function(A) {
    return typeof r["process" + A.toUpperCase()] == "function";
  }, _ = function(A) {
    return xe(A) === "object" && A.nodeType === 1;
  }, g = function(A, C) {
    if (A.nodeName === "IMG" && A.hasAttribute("src")) {
      var M = "" + A.getAttribute("src");
      if (M.indexOf("data:image/") === 0) return fo(unescape(M).split("base64,").pop());
      var D = r.loadFile(M, !0);
      if (D !== void 0) return D;
    }
    if (A.nodeName === "CANVAS") {
      if (A.width === 0 || A.height === 0) throw new Error("Given canvas must have data. Canvas width: " + A.width + ", height: " + A.height);
      var at;
      switch (C) {
        case "PNG":
          at = "image/png";
          break;
        case "WEBP":
          at = "image/webp";
          break;
        default:
          at = "image/jpeg";
      }
      return fo(A.toDataURL(at, 1).split("base64,").pop());
    }
  }, y = function(A) {
    var C = this.internal.collections[t + "images"];
    if (C) {
      for (var M in C) if (A === C[M].alias) return C[M];
    }
  }, x = function(A, C, M) {
    return A || C || (A = -96, C = -96), A < 0 && (A = -1 * M.width * 72 / A / this.internal.scaleFactor), C < 0 && (C = -1 * M.height * 72 / C / this.internal.scaleFactor), A === 0 && (A = C * M.width / M.height), C === 0 && (C = A * M.height / M.width), [A, C];
  }, E = function(A, C, M, D, at, ot) {
    var ft = x.call(this, M, D, at), rt = this.internal.getCoordinateString, ht = this.internal.getVerticalCoordinateString, Lt = f.call(this);
    if (M = ft[0], D = ft[1], Lt[at.index] = at, ot) {
      ot *= Math.PI / 180;
      var vt = Math.cos(ot), S = Math.sin(ot), j = function(J) {
        return J.toFixed(4);
      }, z = [j(vt), j(S), j(-1 * S), j(vt), 0, 0, "cm"];
    }
    this.internal.write("q"), ot ? (this.internal.write([1, "0", "0", 1, rt(A), ht(C + D), "cm"].join(" ")), this.internal.write(z.join(" ")), this.internal.write([rt(M), "0", "0", rt(D), "0", "0", "cm"].join(" "))) : this.internal.write([rt(M), "0", "0", rt(D), rt(A), ht(C + D), "cm"].join(" ")), this.isAdvancedAPI() && this.internal.write([1, 0, 0, -1, 0, 0, "cm"].join(" ")), this.internal.write("/I" + at.index + " Do"), this.internal.write("Q");
  }, N = r.color_spaces = { DEVICE_RGB: "DeviceRGB", DEVICE_GRAY: "DeviceGray", DEVICE_CMYK: "DeviceCMYK", CAL_GREY: "CalGray", CAL_RGB: "CalRGB", LAB: "Lab", ICC_BASED: "ICCBased", INDEXED: "Indexed", PATTERN: "Pattern", SEPARATION: "Separation", DEVICE_N: "DeviceN" };
  r.decode = { DCT_DECODE: "DCTDecode", FLATE_DECODE: "FlateDecode", LZW_DECODE: "LZWDecode", JPX_DECODE: "JPXDecode", JBIG2_DECODE: "JBIG2Decode", ASCII85_DECODE: "ASCII85Decode", ASCII_HEX_DECODE: "ASCIIHexDecode", RUN_LENGTH_DECODE: "RunLengthDecode", CCITT_FAX_DECODE: "CCITTFaxDecode" };
  var H = r.image_compression = { NONE: "NONE", FAST: "FAST", MEDIUM: "MEDIUM", SLOW: "SLOW" }, q = r.__addimage__.sHashCode = function(A) {
    var C, M, D = 0;
    if (typeof A == "string") for (M = A.length, C = 0; C < M; C++) D = (D << 5) - D + A.charCodeAt(C), D |= 0;
    else if (Q(A)) for (M = A.byteLength / 2, C = 0; C < M; C++) D = (D << 5) - D + A[C], D |= 0;
    return D;
  }, F = r.__addimage__.validateStringAsBase64 = function(A) {
    (A = A || "").toString().trim();
    var C = !0;
    return A.length === 0 && (C = !1), A.length % 4 != 0 && (C = !1), /^[A-Za-z0-9+/]+$/.test(A.substr(0, A.length - 2)) === !1 && (C = !1), /^[A-Za-z0-9/][A-Za-z0-9+/]|[A-Za-z0-9+/]=|==$/.test(A.substr(-2)) === !1 && (C = !1), C;
  }, et = r.__addimage__.extractImageFromDataUrl = function(A) {
    if (A == null || !(A = A.trim()).startsWith("data:")) return null;
    var C = A.indexOf(",");
    return C < 0 ? null : A.substring(0, C).trim().endsWith("base64") ? A.substring(C + 1) : null;
  };
  r.__addimage__.isArrayBuffer = function(A) {
    return A instanceof ArrayBuffer;
  };
  var Q = r.__addimage__.isArrayBufferView = function(A) {
    return A instanceof Int8Array || A instanceof Uint8Array || A instanceof Uint8ClampedArray || A instanceof Int16Array || A instanceof Uint16Array || A instanceof Int32Array || A instanceof Uint32Array || A instanceof Float32Array || A instanceof Float64Array;
  }, X = r.__addimage__.binaryStringToUint8Array = function(A) {
    for (var C = A.length, M = new Uint8Array(C), D = 0; D < C; D++) M[D] = A.charCodeAt(D);
    return M;
  }, V = r.__addimage__.arrayBufferToBinaryString = function(A) {
    for (var C = "", M = Q(A) ? A : new Uint8Array(A), D = 0; D < M.length; D += 8192) C += String.fromCharCode.apply(null, M.subarray(D, D + 8192));
    return C;
  };
  r.addImage = function() {
    var A, C, M, D, at, ot, ft, rt, ht;
    if (typeof arguments[1] == "number" ? (C = e, M = arguments[1], D = arguments[2], at = arguments[3], ot = arguments[4], ft = arguments[5], rt = arguments[6], ht = arguments[7]) : (C = arguments[1], M = arguments[2], D = arguments[3], at = arguments[4], ot = arguments[5], ft = arguments[6], rt = arguments[7], ht = arguments[8]), xe(A = arguments[0]) === "object" && !_(A) && "imageData" in A) {
      var Lt = A;
      A = Lt.imageData, C = Lt.format || C || e, M = Lt.x || M || 0, D = Lt.y || D || 0, at = Lt.w || Lt.width || at, ot = Lt.h || Lt.height || ot, ft = Lt.alias || ft, rt = Lt.compression || rt, ht = Lt.rotation || Lt.angle || ht;
    }
    var vt = this.internal.getFilters();
    if (rt === void 0 && vt.indexOf("FlateEncode") !== -1 && (rt = "SLOW"), isNaN(M) || isNaN(D)) throw new Error("Invalid coordinates passed to jsPDF.addImage");
    l.call(this);
    var S = I.call(this, A, C, ft, rt);
    return E.call(this, M, D, at, ot, S, ht), this;
  };
  var I = function(A, C, M, D) {
    var at, ot, ft;
    if (typeof A == "string" && i(A) === e) {
      A = unescape(A);
      var rt = G(A, !1);
      (rt !== "" || (rt = r.loadFile(A, !0)) !== void 0) && (A = rt);
    }
    if (_(A) && (A = g(A, C)), C = i(A, C), !b(C)) throw new Error("addImage does not support files of type '" + C + "', please ensure that a plugin for '" + C + "' support is added.");
    if (((ft = M) == null || ft.length === 0) && (M = (function(ht) {
      return typeof ht == "string" || Q(ht) ? q(ht) : Q(ht.data) ? q(ht.data) : null;
    })(A)), (at = y.call(this, M)) || (A instanceof Uint8Array || C === "RGBA" || (ot = A, A = X(A)), at = this["process" + C.toUpperCase()](A, d.call(this), M, (function(ht) {
      return ht && typeof ht == "string" && (ht = ht.toUpperCase()), ht in r.image_compression ? ht : H.NONE;
    })(D), ot)), !at) throw new Error("An unknown error occurred whilst processing the image.");
    return at;
  }, G = r.__addimage__.convertBase64ToBinaryString = function(A, C) {
    C = typeof C != "boolean" || C;
    var M, D = "";
    if (typeof A == "string") {
      var at;
      M = (at = et(A)) !== null && at !== void 0 ? at : A;
      try {
        D = fo(M);
      } catch (ot) {
        if (C) throw F(M) ? new Error("atob-Error in jsPDF.convertBase64ToBinaryString " + ot.message) : new Error("Supplied Data is not a valid base64-String jsPDF.convertBase64ToBinaryString ");
      }
    }
    return D;
  };
  r.getImageProperties = function(A) {
    var C, M, D = "";
    if (_(A) && (A = g(A)), typeof A == "string" && i(A) === e && ((D = G(A, !1)) === "" && (D = r.loadFile(A) || ""), A = D), M = i(A), !b(M)) throw new Error("addImage does not support files of type '" + M + "', please ensure that a plugin for '" + M + "' support is added.");
    if (A instanceof Uint8Array || (A = X(A)), !(C = this["process" + M.toUpperCase()](A))) throw new Error("An unknown error occurred whilst processing the image");
    return C.fileType = M, C;
  };
})(Dt.API), /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  var t = function(e) {
    if (e !== void 0 && e != "") return !0;
  };
  Dt.API.events.push(["addPage", function(e) {
    this.internal.getPageInfo(e.pageNumber).pageContext.annotations = [];
  }]), r.events.push(["putPage", function(e) {
    for (var n, i, s, c = this.internal.getCoordinateString, o = this.internal.getVerticalCoordinateString, l = this.internal.getPageInfoByObjId(e.objId), f = e.pageContext.annotations, d = !1, b = 0; b < f.length && !d; b++) switch ((n = f[b]).type) {
      case "link":
        (t(n.options.url) || t(n.options.pageNumber)) && (d = !0);
        break;
      case "reference":
      case "text":
      case "freetext":
        d = !0;
    }
    if (d != 0) {
      this.internal.write("/Annots [");
      for (var _ = 0; _ < f.length; _++) {
        n = f[_];
        var g = this.internal.pdfEscape, y = this.internal.getEncryptor(e.objId);
        switch (n.type) {
          case "reference":
            this.internal.write(" " + n.object.objId + " 0 R ");
            break;
          case "text":
            var x = this.internal.newAdditionalObject(), E = this.internal.newAdditionalObject(), N = this.internal.getEncryptor(x.objId), H = n.title || "Note";
            s = "<</Type /Annot /Subtype /Text " + (i = "/Rect [" + c(n.bounds.x) + " " + o(n.bounds.y + n.bounds.h) + " " + c(n.bounds.x + n.bounds.w) + " " + o(n.bounds.y) + "] ") + "/Contents (" + g(N(n.contents)) + ")", s += " /Popup " + E.objId + " 0 R", s += " /P " + l.objId + " 0 R", s += " /T (" + g(N(H)) + ") >>", x.content = s;
            var q = x.objId + " 0 R";
            s = "<</Type /Annot /Subtype /Popup " + (i = "/Rect [" + c(n.bounds.x + 30) + " " + o(n.bounds.y + n.bounds.h) + " " + c(n.bounds.x + n.bounds.w + 30) + " " + o(n.bounds.y) + "] ") + " /Parent " + q, n.open && (s += " /Open true"), s += " >>", E.content = s, this.internal.write(x.objId, "0 R", E.objId, "0 R");
            break;
          case "freetext":
            i = "/Rect [" + c(n.bounds.x) + " " + o(n.bounds.y) + " " + c(n.bounds.x + n.bounds.w) + " " + o(n.bounds.y + n.bounds.h) + "] ";
            var F = n.color || "#000000";
            s = "<</Type /Annot /Subtype /FreeText " + i + "/Contents (" + g(y(n.contents)) + ")", s += " /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#" + F + ")", s += " /Border [0 0 0]", s += " >>", this.internal.write(s);
            break;
          case "link":
            if (n.options.name) {
              var et = this.annotations._nameMap[n.options.name];
              n.options.pageNumber = et.page, n.options.top = et.y;
            } else n.options.top || (n.options.top = 0);
            if (i = "/Rect [" + n.finalBounds.x + " " + n.finalBounds.y + " " + n.finalBounds.w + " " + n.finalBounds.h + "] ", s = "", n.options.url) s = "<</Type /Annot /Subtype /Link " + i + "/Border [0 0 0] /A <</S /URI /URI (" + g(y(n.options.url)) + ") >>";
            else if (n.options.pageNumber) switch (s = "<</Type /Annot /Subtype /Link " + i + "/Border [0 0 0] /Dest [" + this.internal.getPageInfo(n.options.pageNumber).objId + " 0 R", n.options.magFactor = n.options.magFactor || "XYZ", n.options.magFactor) {
              case "Fit":
                s += " /Fit]";
                break;
              case "FitH":
                s += " /FitH " + n.options.top + "]";
                break;
              case "FitV":
                n.options.left = n.options.left || 0, s += " /FitV " + n.options.left + "]";
                break;
              default:
                var Q = o(n.options.top);
                n.options.left = n.options.left || 0, n.options.zoom === void 0 && (n.options.zoom = 0), s += " /XYZ " + n.options.left + " " + Q + " " + n.options.zoom + "]";
            }
            s != "" && (s += " >>", this.internal.write(s));
        }
      }
      this.internal.write("]");
    }
  }]), r.createAnnotation = function(e) {
    var n = this.internal.getCurrentPageInfo();
    switch (e.type) {
      case "link":
        this.link(e.bounds.x, e.bounds.y, e.bounds.w, e.bounds.h, e);
        break;
      case "text":
      case "freetext":
        n.pageContext.annotations.push(e);
    }
  }, r.link = function(e, n, i, s, c) {
    var o = this.internal.getCurrentPageInfo(), l = this.internal.getCoordinateString, f = this.internal.getVerticalCoordinateString;
    o.pageContext.annotations.push({ finalBounds: { x: l(e), y: f(n), w: l(e + i), h: f(n + s) }, options: c, type: "link" });
  }, r.textWithLink = function(e, n, i, s) {
    var c, o, l = this.getTextWidth(e), f = this.internal.getLineHeight() / this.internal.scaleFactor;
    if (s.maxWidth !== void 0) {
      o = s.maxWidth;
      var d = this.splitTextToSize(e, o).length;
      c = Math.ceil(f * d);
    } else o = l, c = f;
    return this.text(e, n, i, s), i += 0.2 * f, s.align === "center" && (n -= l / 2), s.align === "right" && (n -= l), this.link(n, i - f, o, c, s), l;
  }, r.getTextWidth = function(e) {
    var n = this.internal.getFontSize();
    return this.getStringUnitWidth(e) * n / this.internal.scaleFactor;
  };
})(Dt.API), /**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  var t = { 1569: [65152], 1570: [65153, 65154], 1571: [65155, 65156], 1572: [65157, 65158], 1573: [65159, 65160], 1574: [65161, 65162, 65163, 65164], 1575: [65165, 65166], 1576: [65167, 65168, 65169, 65170], 1577: [65171, 65172], 1578: [65173, 65174, 65175, 65176], 1579: [65177, 65178, 65179, 65180], 1580: [65181, 65182, 65183, 65184], 1581: [65185, 65186, 65187, 65188], 1582: [65189, 65190, 65191, 65192], 1583: [65193, 65194], 1584: [65195, 65196], 1585: [65197, 65198], 1586: [65199, 65200], 1587: [65201, 65202, 65203, 65204], 1588: [65205, 65206, 65207, 65208], 1589: [65209, 65210, 65211, 65212], 1590: [65213, 65214, 65215, 65216], 1591: [65217, 65218, 65219, 65220], 1592: [65221, 65222, 65223, 65224], 1593: [65225, 65226, 65227, 65228], 1594: [65229, 65230, 65231, 65232], 1601: [65233, 65234, 65235, 65236], 1602: [65237, 65238, 65239, 65240], 1603: [65241, 65242, 65243, 65244], 1604: [65245, 65246, 65247, 65248], 1605: [65249, 65250, 65251, 65252], 1606: [65253, 65254, 65255, 65256], 1607: [65257, 65258, 65259, 65260], 1608: [65261, 65262], 1609: [65263, 65264, 64488, 64489], 1610: [65265, 65266, 65267, 65268], 1649: [64336, 64337], 1655: [64477], 1657: [64358, 64359, 64360, 64361], 1658: [64350, 64351, 64352, 64353], 1659: [64338, 64339, 64340, 64341], 1662: [64342, 64343, 64344, 64345], 1663: [64354, 64355, 64356, 64357], 1664: [64346, 64347, 64348, 64349], 1667: [64374, 64375, 64376, 64377], 1668: [64370, 64371, 64372, 64373], 1670: [64378, 64379, 64380, 64381], 1671: [64382, 64383, 64384, 64385], 1672: [64392, 64393], 1676: [64388, 64389], 1677: [64386, 64387], 1678: [64390, 64391], 1681: [64396, 64397], 1688: [64394, 64395], 1700: [64362, 64363, 64364, 64365], 1702: [64366, 64367, 64368, 64369], 1705: [64398, 64399, 64400, 64401], 1709: [64467, 64468, 64469, 64470], 1711: [64402, 64403, 64404, 64405], 1713: [64410, 64411, 64412, 64413], 1715: [64406, 64407, 64408, 64409], 1722: [64414, 64415], 1723: [64416, 64417, 64418, 64419], 1726: [64426, 64427, 64428, 64429], 1728: [64420, 64421], 1729: [64422, 64423, 64424, 64425], 1733: [64480, 64481], 1734: [64473, 64474], 1735: [64471, 64472], 1736: [64475, 64476], 1737: [64482, 64483], 1739: [64478, 64479], 1740: [64508, 64509, 64510, 64511], 1744: [64484, 64485, 64486, 64487], 1746: [64430, 64431], 1747: [64432, 64433] }, e = { 65247: { 65154: 65269, 65156: 65271, 65160: 65273, 65166: 65275 }, 65248: { 65154: 65270, 65156: 65272, 65160: 65274, 65166: 65276 }, 65165: { 65247: { 65248: { 65258: 65010 } } }, 1617: { 1612: 64606, 1613: 64607, 1614: 64608, 1615: 64609, 1616: 64610 } }, n = { 1612: 64606, 1613: 64607, 1614: 64608, 1615: 64609, 1616: 64610 }, i = [1570, 1571, 1573, 1575];
  r.__arabicParser__ = {};
  var s = r.__arabicParser__.isInArabicSubstitutionA = function(x) {
    return t[x.charCodeAt(0)] !== void 0;
  }, c = r.__arabicParser__.isArabicLetter = function(x) {
    return typeof x == "string" && /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(x);
  }, o = r.__arabicParser__.isArabicEndLetter = function(x) {
    return c(x) && s(x) && t[x.charCodeAt(0)].length <= 2;
  }, l = r.__arabicParser__.isArabicAlfLetter = function(x) {
    return c(x) && i.indexOf(x.charCodeAt(0)) >= 0;
  };
  r.__arabicParser__.arabicLetterHasIsolatedForm = function(x) {
    return c(x) && s(x) && t[x.charCodeAt(0)].length >= 1;
  };
  var f = r.__arabicParser__.arabicLetterHasFinalForm = function(x) {
    return c(x) && s(x) && t[x.charCodeAt(0)].length >= 2;
  };
  r.__arabicParser__.arabicLetterHasInitialForm = function(x) {
    return c(x) && s(x) && t[x.charCodeAt(0)].length >= 3;
  };
  var d = r.__arabicParser__.arabicLetterHasMedialForm = function(x) {
    return c(x) && s(x) && t[x.charCodeAt(0)].length == 4;
  }, b = r.__arabicParser__.resolveLigatures = function(x) {
    var E = 0, N = e, H = "", q = 0;
    for (E = 0; E < x.length; E += 1) N[x.charCodeAt(E)] !== void 0 ? (q++, typeof (N = N[x.charCodeAt(E)]) == "number" && (H += String.fromCharCode(N), N = e, q = 0), E === x.length - 1 && (N = e, H += x.charAt(E - (q - 1)), E -= q - 1, q = 0)) : (N = e, H += x.charAt(E - q), E -= q, q = 0);
    return H;
  };
  r.__arabicParser__.isArabicDiacritic = function(x) {
    return x !== void 0 && n[x.charCodeAt(0)] !== void 0;
  };
  var _ = r.__arabicParser__.getCorrectForm = function(x, E, N) {
    return c(x) ? s(x) === !1 ? -1 : !f(x) || !c(E) && !c(N) || !c(N) && o(E) || o(x) && !c(E) || o(x) && l(E) || o(x) && o(E) ? 0 : d(x) && c(E) && !o(E) && c(N) && f(N) ? 3 : o(x) || !c(N) ? 1 : 2 : -1;
  }, g = function(x) {
    var E = 0, N = 0, H = 0, q = "", F = "", et = "", Q = (x = x || "").split("\\s+"), X = [];
    for (E = 0; E < Q.length; E += 1) {
      for (X.push(""), N = 0; N < Q[E].length; N += 1) q = Q[E][N], F = Q[E][N - 1], et = Q[E][N + 1], c(q) ? (H = _(q, F, et), X[E] += H !== -1 ? String.fromCharCode(t[q.charCodeAt(0)][H]) : q) : X[E] += q;
      X[E] = b(X[E]);
    }
    return X.join(" ");
  }, y = r.__arabicParser__.processArabic = r.processArabic = function() {
    var x, E = typeof arguments[0] == "string" ? arguments[0] : arguments[0].text, N = [];
    if (Array.isArray(E)) {
      var H = 0;
      for (N = [], H = 0; H < E.length; H += 1) Array.isArray(E[H]) ? N.push([g(E[H][0]), E[H][1], E[H][2]]) : N.push([g(E[H])]);
      x = N;
    } else x = g(E);
    return typeof arguments[0] == "string" ? x : (arguments[0].text = x, arguments[0]);
  };
  r.events.push(["preProcessText", y]);
})(Dt.API), Dt.API.autoPrint = function(r) {
  var t;
  return (r = r || {}).variant = r.variant || "non-conform", r.variant === "javascript" ? this.addJS("print({});") : (this.internal.events.subscribe("postPutResources", function() {
    t = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /Named"), this.internal.out("/Type /Action"), this.internal.out("/N /Print"), this.internal.out(">>"), this.internal.out("endobj");
  }), this.internal.events.subscribe("putCatalog", function() {
    this.internal.out("/OpenAction " + t + " 0 R");
  })), this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  var t = function() {
    var e = void 0;
    Object.defineProperty(this, "pdf", { get: function() {
      return e;
    }, set: function(o) {
      e = o;
    } });
    var n = 150;
    Object.defineProperty(this, "width", { get: function() {
      return n;
    }, set: function(o) {
      n = isNaN(o) || Number.isInteger(o) === !1 || o < 0 ? 150 : o, this.getContext("2d").pageWrapXEnabled && (this.getContext("2d").pageWrapX = n + 1);
    } });
    var i = 300;
    Object.defineProperty(this, "height", { get: function() {
      return i;
    }, set: function(o) {
      i = isNaN(o) || Number.isInteger(o) === !1 || o < 0 ? 300 : o, this.getContext("2d").pageWrapYEnabled && (this.getContext("2d").pageWrapY = i + 1);
    } });
    var s = [];
    Object.defineProperty(this, "childNodes", { get: function() {
      return s;
    }, set: function(o) {
      s = o;
    } });
    var c = {};
    Object.defineProperty(this, "style", { get: function() {
      return c;
    }, set: function(o) {
      c = o;
    } }), Object.defineProperty(this, "parentNode", {});
  };
  t.prototype.getContext = function(e, n) {
    var i;
    if ((e = e || "2d") !== "2d") return null;
    for (i in n) this.pdf.context2d.hasOwnProperty(i) && (this.pdf.context2d[i] = n[i]);
    return this.pdf.context2d._canvas = this, this.pdf.context2d;
  }, t.prototype.toDataURL = function() {
    throw new Error("toDataURL is not implemented.");
  }, r.events.push(["initialized", function() {
    this.canvas = new t(), this.canvas.pdf = this;
  }]);
})(Dt.API), (function(r) {
  var t = { left: 0, top: 0, bottom: 0, right: 0 }, e = !1, n = function() {
    this.internal.__cell__ === void 0 && (this.internal.__cell__ = {}, this.internal.__cell__.padding = 3, this.internal.__cell__.headerFunction = void 0, this.internal.__cell__.margins = Object.assign({}, t), this.internal.__cell__.margins.width = this.getPageWidth(), i.call(this));
  }, i = function() {
    this.internal.__cell__.lastCell = new s(), this.internal.__cell__.pages = 1;
  }, s = function() {
    var l = arguments[0];
    Object.defineProperty(this, "x", { enumerable: !0, get: function() {
      return l;
    }, set: function(x) {
      l = x;
    } });
    var f = arguments[1];
    Object.defineProperty(this, "y", { enumerable: !0, get: function() {
      return f;
    }, set: function(x) {
      f = x;
    } });
    var d = arguments[2];
    Object.defineProperty(this, "width", { enumerable: !0, get: function() {
      return d;
    }, set: function(x) {
      d = x;
    } });
    var b = arguments[3];
    Object.defineProperty(this, "height", { enumerable: !0, get: function() {
      return b;
    }, set: function(x) {
      b = x;
    } });
    var _ = arguments[4];
    Object.defineProperty(this, "text", { enumerable: !0, get: function() {
      return _;
    }, set: function(x) {
      _ = x;
    } });
    var g = arguments[5];
    Object.defineProperty(this, "lineNumber", { enumerable: !0, get: function() {
      return g;
    }, set: function(x) {
      g = x;
    } });
    var y = arguments[6];
    return Object.defineProperty(this, "align", { enumerable: !0, get: function() {
      return y;
    }, set: function(x) {
      y = x;
    } }), this;
  };
  s.prototype.clone = function() {
    return new s(this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align);
  }, s.prototype.toArray = function() {
    return [this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align];
  }, r.setHeaderFunction = function(l) {
    return n.call(this), this.internal.__cell__.headerFunction = typeof l == "function" ? l : void 0, this;
  }, r.getTextDimensions = function(l, f) {
    n.call(this);
    var d = (f = f || {}).fontSize || this.getFontSize(), b = f.font || this.getFont(), _ = f.scaleFactor || this.internal.scaleFactor, g = 0, y = 0, x = 0, E = this;
    if (!Array.isArray(l) && typeof l != "string") {
      if (typeof l != "number") throw new Error("getTextDimensions expects text-parameter to be of type String or type Number or an Array of Strings.");
      l = String(l);
    }
    var N = f.maxWidth;
    N > 0 ? typeof l == "string" ? l = this.splitTextToSize(l, N) : Object.prototype.toString.call(l) === "[object Array]" && (l = l.reduce(function(q, F) {
      return q.concat(E.splitTextToSize(F, N));
    }, [])) : l = Array.isArray(l) ? l : [l];
    for (var H = 0; H < l.length; H++) g < (x = this.getStringUnitWidth(l[H], { font: b }) * d) && (g = x);
    return g !== 0 && (y = l.length), { w: g /= _, h: Math.max((y * d * this.getLineHeightFactor() - d * (this.getLineHeightFactor() - 1)) / _, 0) };
  }, r.cellAddPage = function() {
    n.call(this), this.addPage();
    var l = this.internal.__cell__.margins || t;
    return this.internal.__cell__.lastCell = new s(l.left, l.top, void 0, void 0), this.internal.__cell__.pages += 1, this;
  };
  var c = r.cell = function() {
    var l;
    l = arguments[0] instanceof s ? arguments[0] : new s(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]), n.call(this);
    var f = this.internal.__cell__.lastCell, d = this.internal.__cell__.padding, b = this.internal.__cell__.margins || t, _ = this.internal.__cell__.tableHeaderRow, g = this.internal.__cell__.printHeaders;
    return f.lineNumber !== void 0 && (f.lineNumber === l.lineNumber ? (l.x = (f.x || 0) + (f.width || 0), l.y = f.y || 0) : f.y + f.height + l.height + b.bottom > this.getPageHeight() ? (this.cellAddPage(), l.y = b.top, g && _ && (this.printHeaderRow(l.lineNumber, !0), l.y += _[0].height)) : l.y = f.y + f.height || l.y), l.text[0] !== void 0 && (this.rect(l.x, l.y, l.width, l.height, e === !0 ? "FD" : void 0), l.align === "right" ? this.text(l.text, l.x + l.width - d, l.y + d, { align: "right", baseline: "top" }) : l.align === "center" ? this.text(l.text, l.x + l.width / 2, l.y + d, { align: "center", baseline: "top", maxWidth: l.width - d - d }) : this.text(l.text, l.x + d, l.y + d, { align: "left", baseline: "top", maxWidth: l.width - d - d })), this.internal.__cell__.lastCell = l, this;
  };
  r.table = function(l, f, d, b, _) {
    if (n.call(this), !d) throw new Error("No data for PDF table.");
    var g, y, x, E, N = [], H = [], q = [], F = {}, et = {}, Q = [], X = [], V = (_ = _ || {}).autoSize || !1, I = _.printHeaders !== !1, G = _.css && _.css["font-size"] !== void 0 ? 16 * _.css["font-size"] : _.fontSize || 12, A = _.margins || Object.assign({ width: this.getPageWidth() }, t), C = typeof _.padding == "number" ? _.padding : 3, M = _.headerBackgroundColor || "#c8c8c8", D = _.headerTextColor || "#000";
    if (i.call(this), this.internal.__cell__.printHeaders = I, this.internal.__cell__.margins = A, this.internal.__cell__.table_font_size = G, this.internal.__cell__.padding = C, this.internal.__cell__.headerBackgroundColor = M, this.internal.__cell__.headerTextColor = D, this.setFontSize(G), b == null) H = N = Object.keys(d[0]), q = N.map(function() {
      return "left";
    });
    else if (Array.isArray(b) && xe(b[0]) === "object") for (N = b.map(function(Lt) {
      return Lt.name;
    }), H = b.map(function(Lt) {
      return Lt.prompt || Lt.name || "";
    }), q = b.map(function(Lt) {
      return Lt.align || "left";
    }), g = 0; g < b.length; g += 1) et[b[g].name] = 0.7499990551181103 * b[g].width;
    else Array.isArray(b) && typeof b[0] == "string" && (H = N = b, q = N.map(function() {
      return "left";
    }));
    if (V || Array.isArray(b) && typeof b[0] == "string") for (g = 0; g < N.length; g += 1) {
      for (F[E = N[g]] = d.map(function(Lt) {
        return Lt[E];
      }), this.setFont(void 0, "bold"), Q.push(this.getTextDimensions(H[g], { fontSize: this.internal.__cell__.table_font_size, scaleFactor: this.internal.scaleFactor }).w), y = F[E], this.setFont(void 0, "normal"), x = 0; x < y.length; x += 1) Q.push(this.getTextDimensions(y[x], { fontSize: this.internal.__cell__.table_font_size, scaleFactor: this.internal.scaleFactor }).w);
      et[E] = Math.max.apply(null, Q) + C + C, Q = [];
    }
    if (I) {
      var at = {};
      for (g = 0; g < N.length; g += 1) at[N[g]] = {}, at[N[g]].text = H[g], at[N[g]].align = q[g];
      var ot = o.call(this, at, et);
      X = N.map(function(Lt) {
        return new s(l, f, et[Lt], ot, at[Lt].text, void 0, at[Lt].align);
      }), this.setTableHeaderRow(X), this.printHeaderRow(1, !1);
    }
    var ft = b.reduce(function(Lt, vt) {
      return Lt[vt.name] = vt.align, Lt;
    }, {});
    for (g = 0; g < d.length; g += 1) {
      "rowStart" in _ && _.rowStart instanceof Function && _.rowStart({ row: g, data: d[g] }, this);
      var rt = o.call(this, d[g], et);
      for (x = 0; x < N.length; x += 1) {
        var ht = d[g][N[x]];
        "cellStart" in _ && _.cellStart instanceof Function && _.cellStart({ row: g, col: x, data: ht }, this), c.call(this, new s(l, f, et[N[x]], rt, ht, g + 2, ft[N[x]]));
      }
    }
    return this.internal.__cell__.table_x = l, this.internal.__cell__.table_y = f, this;
  };
  var o = function(l, f) {
    var d = this.internal.__cell__.padding, b = this.internal.__cell__.table_font_size, _ = this.internal.scaleFactor;
    return Object.keys(l).map(function(g) {
      var y = l[g];
      return this.splitTextToSize(y.hasOwnProperty("text") ? y.text : y, f[g] - d - d);
    }, this).map(function(g) {
      return this.getLineHeightFactor() * g.length * b / _ + d + d;
    }, this).reduce(function(g, y) {
      return Math.max(g, y);
    }, 0);
  };
  r.setTableHeaderRow = function(l) {
    n.call(this), this.internal.__cell__.tableHeaderRow = l;
  }, r.printHeaderRow = function(l, f) {
    if (n.call(this), !this.internal.__cell__.tableHeaderRow) throw new Error("Property tableHeaderRow does not exist.");
    var d;
    if (e = !0, typeof this.internal.__cell__.headerFunction == "function") {
      var b = this.internal.__cell__.headerFunction(this, this.internal.__cell__.pages);
      this.internal.__cell__.lastCell = new s(b[0], b[1], b[2], b[3], void 0, -1);
    }
    this.setFont(void 0, "bold");
    for (var _ = [], g = 0; g < this.internal.__cell__.tableHeaderRow.length; g += 1) {
      d = this.internal.__cell__.tableHeaderRow[g].clone(), f && (d.y = this.internal.__cell__.margins.top || 0, _.push(d)), d.lineNumber = l;
      var y = this.getTextColor();
      this.setTextColor(this.internal.__cell__.headerTextColor), this.setFillColor(this.internal.__cell__.headerBackgroundColor), c.call(this, d), this.setTextColor(y);
    }
    _.length > 0 && this.setTableHeaderRow(_), this.setFont(void 0, "normal"), e = !1;
  };
})(Dt.API);
var S1 = { italic: ["italic", "oblique", "normal"], oblique: ["oblique", "italic", "normal"], normal: ["normal", "oblique", "italic"] }, k1 = ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded"], _u = L1(k1), E1 = [100, 200, 300, 400, 500, 600, 700, 800, 900], F5 = L1(E1);
function Ic(r) {
  var t = r.family.replace(/"|'/g, "").toLowerCase(), e = (function(s) {
    return S1[s = s || "normal"] ? s : "normal";
  })(r.style), n = (function(s) {
    return s ? typeof s == "number" ? s >= 100 && s <= 900 && s % 100 == 0 ? s : 400 : /^\d00$/.test(s) ? parseInt(s) : s === "bold" ? 700 : 400 : 400;
  })(r.weight), i = (function(s) {
    return typeof _u[s = s || "normal"] == "number" ? s : "normal";
  })(r.stretch);
  return { family: t, style: e, weight: n, stretch: i, src: r.src || [], ref: r.ref || { name: t, style: [i, e, n].join(" ") } };
}
function Lf(r, t, e, n) {
  var i;
  for (i = e; i >= 0 && i < t.length; i += n) if (r[t[i]]) return r[t[i]];
  for (i = e; i >= 0 && i < t.length; i -= n) if (r[t[i]]) return r[t[i]];
}
var O5 = { "sans-serif": "helvetica", fixed: "courier", monospace: "courier", terminal: "courier", cursive: "times", fantasy: "times", serif: "times" }, Sf = { caption: "times", icon: "times", menu: "times", "message-box": "times", "small-caption": "times", "status-bar": "times" };
function kf(r) {
  return [r.stretch, r.style, r.weight, r.family].join(" ");
}
function Ef(r) {
  return r.trimLeft();
}
function B5(r, t) {
  for (var e = 0; e < r.length; ) {
    if (r.charAt(e) === t) return [r.substring(0, e), r.substring(e + 1)];
    e += 1;
  }
  return null;
}
function T5(r) {
  var t = r.match(/^(-[a-z_]|[a-z_])[a-z0-9_-]*/i);
  return t === null ? null : [t[0], r.substring(t[0].length)];
}
var io, Pf, Cf, fs, so, Rf, If, Ff, Fc = ["times"];
function Of(r, t, e, n, i) {
  var s = 4, c = Tf;
  switch (i) {
    case Dt.API.image_compression.FAST:
      s = 1, c = Bf;
      break;
    case Dt.API.image_compression.MEDIUM:
      s = 6, c = Mf;
      break;
    case Dt.API.image_compression.SLOW:
      s = 9, c = Df;
  }
  r = (function(l, f, d, b) {
    for (var _, g = l.length / f, y = new Uint8Array(l.length + g), x = [M5, Bf, Tf, Mf, Df], E = 0; E < g; E += 1) {
      var N = E * f, H = l.subarray(N, N + f);
      if (b) y.set(b(H, d, _), N + E);
      else {
        for (var q = x.length, F = [], et = 0; et < q; et += 1) F[et] = x[et](H, d, _);
        var Q = j5(F.concat());
        y.set(F[Q], N + E);
      }
      _ = H;
    }
    return y;
  })(r, t, Math.ceil(e * n / 8), c);
  var o = pu(r, { level: s });
  return Dt.API.__addimage__.arrayBufferToBinaryString(o);
}
function M5(r) {
  var t = Array.apply([], r);
  return t.unshift(0), t;
}
function Bf(r, t) {
  var e = r.length, n = [];
  n[0] = 1;
  for (var i = 0; i < e; i += 1) {
    var s = r[i - t] || 0;
    n[i + 1] = r[i] - s + 256 & 255;
  }
  return n;
}
function Tf(r, t, e) {
  var n = r.length, i = [];
  i[0] = 2;
  for (var s = 0; s < n; s += 1) {
    var c = e && e[s] || 0;
    i[s + 1] = r[s] - c + 256 & 255;
  }
  return i;
}
function Mf(r, t, e) {
  var n = r.length, i = [];
  i[0] = 3;
  for (var s = 0; s < n; s += 1) {
    var c = r[s - t] || 0, o = e && e[s] || 0;
    i[s + 1] = r[s] + 256 - (c + o >>> 1) & 255;
  }
  return i;
}
function Df(r, t, e) {
  var n = r.length, i = [];
  i[0] = 4;
  for (var s = 0; s < n; s += 1) {
    var c = D5(r[s - t] || 0, e && e[s] || 0, e && e[s - t] || 0);
    i[s + 1] = r[s] - c + 256 & 255;
  }
  return i;
}
function D5(r, t, e) {
  if (r === t && t === e) return r;
  var n = Math.abs(t - e), i = Math.abs(r - e), s = Math.abs(r + t - e - e);
  return n <= i && n <= s ? r : i <= s ? t : e;
}
function j5(r) {
  var t = r.map(function(e) {
    return e.reduce(function(n, i) {
      return n + Math.abs(i);
    }, 0);
  });
  return t.indexOf(Math.min.apply(null, t));
}
function Oc(r, t, e) {
  var n = t * e, i = Math.floor(n / 8), s = 16 - (n - 8 * i + e), c = (1 << e) - 1;
  return P1(r, i) >> s & c;
}
function jf(r, t, e, n) {
  var i = e * n, s = Math.floor(i / 8), c = 16 - (i - 8 * s + n), o = (1 << n) - 1, l = (t & o) << c;
  (function(f, d, b) {
    if (d + 1 < f.byteLength) f.setUint16(d, b, !1);
    else {
      var _ = b >> 8 & 255;
      f.setUint8(d, _);
    }
  })(r, s, P1(r, s) & ~(o << c) & 65535 | l);
}
function P1(r, t) {
  return t + 1 < r.byteLength ? r.getUint16(t, !1) : r.getUint8(t) << 8;
}
function q5(r) {
  var t = 0;
  if (r[t++] !== 71 || r[t++] !== 73 || r[t++] !== 70 || r[t++] !== 56 || (r[t++] + 1 & 253) != 56 || r[t++] !== 97) throw new Error("Invalid GIF 87a/89a header.");
  var e = r[t++] | r[t++] << 8, n = r[t++] | r[t++] << 8, i = r[t++], s = i >> 7, c = 1 << 1 + (7 & i);
  r[t++], r[t++];
  var o = null, l = null;
  s && (o = t, l = c, t += 3 * c);
  var f = !0, d = [], b = 0, _ = null, g = 0, y = null;
  for (this.width = e, this.height = n; f && t < r.length; ) switch (r[t++]) {
    case 33:
      switch (r[t++]) {
        case 255:
          if (r[t] !== 11 || r[t + 1] == 78 && r[t + 2] == 69 && r[t + 3] == 84 && r[t + 4] == 83 && r[t + 5] == 67 && r[t + 6] == 65 && r[t + 7] == 80 && r[t + 8] == 69 && r[t + 9] == 50 && r[t + 10] == 46 && r[t + 11] == 48 && r[t + 12] == 3 && r[t + 13] == 1 && r[t + 16] == 0) t += 14, y = r[t++] | r[t++] << 8, t++;
          else for (t += 12; ; ) {
            if (!((A = r[t++]) >= 0)) throw Error("Invalid block size");
            if (A === 0) break;
            t += A;
          }
          break;
        case 249:
          if (r[t++] !== 4 || r[t + 4] !== 0) throw new Error("Invalid graphics extension block.");
          var x = r[t++];
          b = r[t++] | r[t++] << 8, _ = r[t++], 1 & x || (_ = null), g = x >> 2 & 7, t++;
          break;
        case 254:
          for (; ; ) {
            if (!((A = r[t++]) >= 0)) throw Error("Invalid block size");
            if (A === 0) break;
            t += A;
          }
          break;
        default:
          throw new Error("Unknown graphic control label: 0x" + r[t - 1].toString(16));
      }
      break;
    case 44:
      var E = r[t++] | r[t++] << 8, N = r[t++] | r[t++] << 8, H = r[t++] | r[t++] << 8, q = r[t++] | r[t++] << 8, F = r[t++], et = F >> 6 & 1, Q = 1 << 1 + (7 & F), X = o, V = l, I = !1;
      F >> 7 && (I = !0, X = t, V = Q, t += 3 * Q);
      var G = t;
      for (t++; ; ) {
        var A;
        if (!((A = r[t++]) >= 0)) throw Error("Invalid block size");
        if (A === 0) break;
        t += A;
      }
      d.push({ x: E, y: N, width: H, height: q, has_local_palette: I, palette_offset: X, palette_size: V, data_offset: G, data_length: t - G, transparent_index: _, interlaced: !!et, delay: b, disposal: g });
      break;
    case 59:
      f = !1;
      break;
    default:
      throw new Error("Unknown gif block: 0x" + r[t - 1].toString(16));
  }
  this.numFrames = function() {
    return d.length;
  }, this.loopCount = function() {
    return y;
  }, this.frameInfo = function(C) {
    if (C < 0 || C >= d.length) throw new Error("Frame index out of range.");
    return d[C];
  }, this.decodeAndBlitFrameBGRA = function(C, M) {
    var D = this.frameInfo(C), at = D.width * D.height, ot = new Uint8Array(at);
    qf(r, D.data_offset, ot, at);
    var ft = D.palette_offset, rt = D.transparent_index;
    rt === null && (rt = 256);
    var ht = D.width, Lt = e - ht, vt = ht, S = 4 * (D.y * e + D.x), j = 4 * ((D.y + D.height) * e + D.x), z = S, J = 4 * Lt;
    D.interlaced === !0 && (J += 4 * e * 7);
    for (var $ = 8, nt = 0, lt = ot.length; nt < lt; ++nt) {
      var ct = ot[nt];
      if (vt === 0 && (vt = ht, (z += J) >= j && (J = 4 * Lt + 4 * e * ($ - 1), z = S + (ht + Lt) * ($ << 1), $ >>= 1)), ct === rt) z += 4;
      else {
        var bt = r[ft + 3 * ct], xt = r[ft + 3 * ct + 1], Et = r[ft + 3 * ct + 2];
        M[z++] = Et, M[z++] = xt, M[z++] = bt, M[z++] = 255;
      }
      --vt;
    }
  }, this.decodeAndBlitFrameRGBA = function(C, M) {
    var D = this.frameInfo(C), at = D.width * D.height, ot = new Uint8Array(at);
    qf(r, D.data_offset, ot, at);
    var ft = D.palette_offset, rt = D.transparent_index;
    rt === null && (rt = 256);
    var ht = D.width, Lt = e - ht, vt = ht, S = 4 * (D.y * e + D.x), j = 4 * ((D.y + D.height) * e + D.x), z = S, J = 4 * Lt;
    D.interlaced === !0 && (J += 4 * e * 7);
    for (var $ = 8, nt = 0, lt = ot.length; nt < lt; ++nt) {
      var ct = ot[nt];
      if (vt === 0 && (vt = ht, (z += J) >= j && (J = 4 * Lt + 4 * e * ($ - 1), z = S + (ht + Lt) * ($ << 1), $ >>= 1)), ct === rt) z += 4;
      else {
        var bt = r[ft + 3 * ct], xt = r[ft + 3 * ct + 1], Et = r[ft + 3 * ct + 2];
        M[z++] = bt, M[z++] = xt, M[z++] = Et, M[z++] = 255;
      }
      --vt;
    }
  };
}
function qf(r, t, e, n) {
  for (var i = r[t++], s = 1 << i, c = s + 1, o = c + 1, l = i + 1, f = (1 << l) - 1, d = 0, b = 0, _ = 0, g = r[t++], y = new Int32Array(4096), x = null; ; ) {
    for (; d < 16 && g !== 0; ) b |= r[t++] << d, d += 8, g === 1 ? g = r[t++] : --g;
    if (d < l) break;
    var E = b & f;
    if (b >>= l, d -= l, E !== s) {
      if (E === c) break;
      for (var N = E < o ? E : x, H = 0, q = N; q > s; ) q = y[q] >> 8, ++H;
      var F = q;
      if (_ + H + (N !== E ? 1 : 0) > n) return void Pe.log("Warning, gif stream longer than expected.");
      e[_++] = F;
      var et = _ += H;
      for (N !== E && (e[_++] = F), q = N; H--; ) q = y[q], e[--et] = 255 & q, q >>= 8;
      x !== null && o < 4096 && (y[o++] = x << 8 | F, o >= f + 1 && l < 12 && (++l, f = f << 1 | 1)), x = E;
    } else o = c + 1, f = (1 << (l = i + 1)) - 1, x = null;
  }
  return _ !== n && Pe.log("Warning, gif stream shorter than expected."), e;
}
function Bc(r) {
  var t, e, n, i, s, c = Math.floor, o = new Array(64), l = new Array(64), f = new Array(64), d = new Array(64), b = new Array(65535), _ = new Array(65535), g = new Array(64), y = new Array(64), x = [], E = 0, N = 7, H = new Array(64), q = new Array(64), F = new Array(64), et = new Array(256), Q = new Array(2048), X = [0, 1, 5, 6, 14, 15, 27, 28, 2, 4, 7, 13, 16, 26, 29, 42, 3, 8, 12, 17, 25, 30, 41, 43, 9, 11, 18, 24, 31, 40, 44, 53, 10, 19, 23, 32, 39, 45, 52, 54, 20, 22, 33, 38, 46, 51, 55, 60, 21, 34, 37, 47, 50, 56, 59, 61, 35, 36, 48, 49, 57, 58, 62, 63], V = [0, 0, 1, 5, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0], I = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], G = [0, 0, 2, 1, 3, 3, 2, 4, 3, 5, 5, 4, 4, 0, 0, 1, 125], A = [1, 2, 3, 0, 4, 17, 5, 18, 33, 49, 65, 6, 19, 81, 97, 7, 34, 113, 20, 50, 129, 145, 161, 8, 35, 66, 177, 193, 21, 82, 209, 240, 36, 51, 98, 114, 130, 9, 10, 22, 23, 24, 25, 26, 37, 38, 39, 40, 41, 42, 52, 53, 54, 55, 56, 57, 58, 67, 68, 69, 70, 71, 72, 73, 74, 83, 84, 85, 86, 87, 88, 89, 90, 99, 100, 101, 102, 103, 104, 105, 106, 115, 116, 117, 118, 119, 120, 121, 122, 131, 132, 133, 134, 135, 136, 137, 138, 146, 147, 148, 149, 150, 151, 152, 153, 154, 162, 163, 164, 165, 166, 167, 168, 169, 170, 178, 179, 180, 181, 182, 183, 184, 185, 186, 194, 195, 196, 197, 198, 199, 200, 201, 202, 210, 211, 212, 213, 214, 215, 216, 217, 218, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250], C = [0, 0, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0], M = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], D = [0, 0, 2, 1, 2, 4, 4, 3, 4, 7, 5, 4, 4, 0, 1, 2, 119], at = [0, 1, 2, 3, 17, 4, 5, 33, 49, 6, 18, 65, 81, 7, 97, 113, 19, 34, 50, 129, 8, 20, 66, 145, 161, 177, 193, 9, 35, 51, 82, 240, 21, 98, 114, 209, 10, 22, 36, 52, 225, 37, 241, 23, 24, 25, 26, 38, 39, 40, 41, 42, 53, 54, 55, 56, 57, 58, 67, 68, 69, 70, 71, 72, 73, 74, 83, 84, 85, 86, 87, 88, 89, 90, 99, 100, 101, 102, 103, 104, 105, 106, 115, 116, 117, 118, 119, 120, 121, 122, 130, 131, 132, 133, 134, 135, 136, 137, 138, 146, 147, 148, 149, 150, 151, 152, 153, 154, 162, 163, 164, 165, 166, 167, 168, 169, 170, 178, 179, 180, 181, 182, 183, 184, 185, 186, 194, 195, 196, 197, 198, 199, 200, 201, 202, 210, 211, 212, 213, 214, 215, 216, 217, 218, 226, 227, 228, 229, 230, 231, 232, 233, 234, 242, 243, 244, 245, 246, 247, 248, 249, 250];
  function ot(S, j) {
    for (var z = 0, J = 0, $ = new Array(), nt = 1; nt <= 16; nt++) {
      for (var lt = 1; lt <= S[nt]; lt++) $[j[J]] = [], $[j[J]][0] = z, $[j[J]][1] = nt, J++, z++;
      z *= 2;
    }
    return $;
  }
  function ft(S) {
    for (var j = S[0], z = S[1] - 1; z >= 0; ) j & 1 << z && (E |= 1 << N), z--, --N < 0 && (E == 255 ? (rt(255), rt(0)) : rt(E), N = 7, E = 0);
  }
  function rt(S) {
    x.push(S);
  }
  function ht(S) {
    rt(S >> 8 & 255), rt(255 & S);
  }
  function Lt(S, j, z, J, $) {
    for (var nt, lt = $[0], ct = $[240], bt = (function(Nt, jt) {
      var kt, oe, Ht, me, ee, re, Ne, ce, qt, Yt, Ut = 0;
      for (qt = 0; qt < 8; ++qt) {
        kt = Nt[Ut], oe = Nt[Ut + 1], Ht = Nt[Ut + 2], me = Nt[Ut + 3], ee = Nt[Ut + 4], re = Nt[Ut + 5], Ne = Nt[Ut + 6];
        var Ce = kt + (ce = Nt[Ut + 7]), be = kt - ce, Tt = oe + Ne, ne = oe - Ne, Le = Ht + re, Wt = Ht - re, he = me + ee, ie = me - ee, ze = Ce + he, er = Ce - he, Se = Tt + Le, $t = Tt - Le;
        Nt[Ut] = ze + Se, Nt[Ut + 4] = ze - Se;
        var ve = 0.707106781 * ($t + er);
        Nt[Ut + 2] = er + ve, Nt[Ut + 6] = er - ve;
        var pi = 0.382683433 * ((ze = ie + Wt) - ($t = ne + be)), gr = 0.5411961 * ze + pi, kn = 1.306562965 * $t + pi, gn = 0.707106781 * (Se = Wt + ne), Gt = be + gn, En = be - gn;
        Nt[Ut + 5] = En + gr, Nt[Ut + 3] = En - gr, Nt[Ut + 1] = Gt + kn, Nt[Ut + 7] = Gt - kn, Ut += 8;
      }
      for (Ut = 0, qt = 0; qt < 8; ++qt) {
        kt = Nt[Ut], oe = Nt[Ut + 8], Ht = Nt[Ut + 16], me = Nt[Ut + 24], ee = Nt[Ut + 32], re = Nt[Ut + 40], Ne = Nt[Ut + 48];
        var Pn = kt + (ce = Nt[Ut + 56]), Wr = kt - ce, Gr = oe + Ne, Me = oe - Ne, or = Ht + re, lr = Ht - re, gi = me + ee, Gn = me - ee, rn = Pn + gi, mn = Pn - gi, nn = Gr + or, sn = Gr - or;
        Nt[Ut] = rn + nn, Nt[Ut + 32] = rn - nn;
        var Jr = 0.707106781 * (sn + mn);
        Nt[Ut + 16] = mn + Jr, Nt[Ut + 48] = mn - Jr;
        var mi = 0.382683433 * ((rn = Gn + lr) - (sn = Me + Wr)), bn = 0.5411961 * rn + mi, bi = 1.306562965 * sn + mi, Xi = 0.707106781 * (nn = lr + Me), $i = Wr + Xi, Zi = Wr - Xi;
        Nt[Ut + 40] = Zi + bn, Nt[Ut + 24] = Zi - bn, Nt[Ut + 8] = $i + bi, Nt[Ut + 56] = $i - bi, Ut++;
      }
      for (qt = 0; qt < 64; ++qt) Yt = Nt[qt] * jt[qt], g[qt] = Yt > 0 ? Yt + 0.5 | 0 : Yt - 0.5 | 0;
      return g;
    })(S, j), xt = 0; xt < 64; ++xt) y[X[xt]] = bt[xt];
    var Et = y[0] - z;
    z = y[0], Et == 0 ? ft(J[0]) : (ft(J[_[nt = 32767 + Et]]), ft(b[nt]));
    for (var Pt = 63; Pt > 0 && y[Pt] == 0; ) Pt--;
    if (Pt == 0) return ft(lt), z;
    for (var dt, U = 1; U <= Pt; ) {
      for (var fe = U; y[U] == 0 && U <= Pt; ) ++U;
      var ae = U - fe;
      if (ae >= 16) {
        dt = ae >> 4;
        for (var Vt = 1; Vt <= dt; ++Vt) ft(ct);
        ae &= 15;
      }
      nt = 32767 + y[U], ft($[(ae << 4) + _[nt]]), ft(b[nt]), U++;
    }
    return Pt != 63 && ft(lt), z;
  }
  function vt(S) {
    S = Math.min(Math.max(S, 1), 100), s != S && ((function(j) {
      for (var z = [16, 11, 10, 16, 24, 40, 51, 61, 12, 12, 14, 19, 26, 58, 60, 55, 14, 13, 16, 24, 40, 57, 69, 56, 14, 17, 22, 29, 51, 87, 80, 62, 18, 22, 37, 56, 68, 109, 103, 77, 24, 35, 55, 64, 81, 104, 113, 92, 49, 64, 78, 87, 103, 121, 120, 101, 72, 92, 95, 98, 112, 100, 103, 99], J = 0; J < 64; J++) {
        var $ = c((z[J] * j + 50) / 100);
        $ = Math.min(Math.max($, 1), 255), o[X[J]] = $;
      }
      for (var nt = [17, 18, 24, 47, 99, 99, 99, 99, 18, 21, 26, 66, 99, 99, 99, 99, 24, 26, 56, 99, 99, 99, 99, 99, 47, 66, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99], lt = 0; lt < 64; lt++) {
        var ct = c((nt[lt] * j + 50) / 100);
        ct = Math.min(Math.max(ct, 1), 255), l[X[lt]] = ct;
      }
      for (var bt = [1, 1.387039845, 1.306562965, 1.175875602, 1, 0.785694958, 0.5411961, 0.275899379], xt = 0, Et = 0; Et < 8; Et++) for (var Pt = 0; Pt < 8; Pt++) f[xt] = 1 / (o[X[xt]] * bt[Et] * bt[Pt] * 8), d[xt] = 1 / (l[X[xt]] * bt[Et] * bt[Pt] * 8), xt++;
    })(S < 50 ? Math.floor(5e3 / S) : Math.floor(200 - 2 * S)), s = S);
  }
  this.encode = function(S, j) {
    j && vt(j), x = new Array(), E = 0, N = 7, ht(65496), ht(65504), ht(16), rt(74), rt(70), rt(73), rt(70), rt(0), rt(1), rt(1), rt(0), ht(1), ht(1), rt(0), rt(0), (function() {
      ht(65499), ht(132), rt(0);
      for (var oe = 0; oe < 64; oe++) rt(o[oe]);
      rt(1);
      for (var Ht = 0; Ht < 64; Ht++) rt(l[Ht]);
    })(), (function(oe, Ht) {
      ht(65472), ht(17), rt(8), ht(Ht), ht(oe), rt(3), rt(1), rt(17), rt(0), rt(2), rt(17), rt(1), rt(3), rt(17), rt(1);
    })(S.width, S.height), (function() {
      ht(65476), ht(418), rt(0);
      for (var oe = 0; oe < 16; oe++) rt(V[oe + 1]);
      for (var Ht = 0; Ht <= 11; Ht++) rt(I[Ht]);
      rt(16);
      for (var me = 0; me < 16; me++) rt(G[me + 1]);
      for (var ee = 0; ee <= 161; ee++) rt(A[ee]);
      rt(1);
      for (var re = 0; re < 16; re++) rt(C[re + 1]);
      for (var Ne = 0; Ne <= 11; Ne++) rt(M[Ne]);
      rt(17);
      for (var ce = 0; ce < 16; ce++) rt(D[ce + 1]);
      for (var qt = 0; qt <= 161; qt++) rt(at[qt]);
    })(), ht(65498), ht(12), rt(3), rt(1), rt(0), rt(2), rt(17), rt(3), rt(17), rt(0), rt(63), rt(0);
    var z = 0, J = 0, $ = 0;
    E = 0, N = 7, this.encode.displayName = "_encode_";
    for (var nt, lt, ct, bt, xt, Et, Pt, dt, U, fe = S.data, ae = S.width, Vt = S.height, Nt = 4 * ae, jt = 0; jt < Vt; ) {
      for (nt = 0; nt < Nt; ) {
        for (xt = Nt * jt + nt, Pt = -1, dt = 0, U = 0; U < 64; U++) Et = xt + (dt = U >> 3) * Nt + (Pt = 4 * (7 & U)), jt + dt >= Vt && (Et -= Nt * (jt + 1 + dt - Vt)), nt + Pt >= Nt && (Et -= nt + Pt - Nt + 4), lt = fe[Et++], ct = fe[Et++], bt = fe[Et++], H[U] = (Q[lt] + Q[ct + 256 | 0] + Q[bt + 512 | 0] >> 16) - 128, q[U] = (Q[lt + 768 | 0] + Q[ct + 1024 | 0] + Q[bt + 1280 | 0] >> 16) - 128, F[U] = (Q[lt + 1280 | 0] + Q[ct + 1536 | 0] + Q[bt + 1792 | 0] >> 16) - 128;
        z = Lt(H, f, z, t, n), J = Lt(q, d, J, e, i), $ = Lt(F, d, $, e, i), nt += 32;
      }
      jt += 8;
    }
    if (N >= 0) {
      var kt = [];
      kt[1] = N + 1, kt[0] = (1 << N + 1) - 1, ft(kt);
    }
    return ht(65497), new Uint8Array(x);
  }, r = r || 50, (function() {
    for (var S = String.fromCharCode, j = 0; j < 256; j++) et[j] = S(j);
  })(), t = ot(V, I), e = ot(C, M), n = ot(G, A), i = ot(D, at), (function() {
    for (var S = 1, j = 2, z = 1; z <= 15; z++) {
      for (var J = S; J < j; J++) _[32767 + J] = z, b[32767 + J] = [], b[32767 + J][1] = z, b[32767 + J][0] = J;
      for (var $ = -(j - 1); $ <= -S; $++) _[32767 + $] = z, b[32767 + $] = [], b[32767 + $][1] = z, b[32767 + $][0] = j - 1 + $;
      S <<= 1, j <<= 1;
    }
  })(), (function() {
    for (var S = 0; S < 256; S++) Q[S] = 19595 * S, Q[S + 256 | 0] = 38470 * S, Q[S + 512 | 0] = 7471 * S + 32768, Q[S + 768 | 0] = -11059 * S, Q[S + 1024 | 0] = -21709 * S, Q[S + 1280 | 0] = 32768 * S + 8421375, Q[S + 1536 | 0] = -27439 * S, Q[S + 1792 | 0] = -5329 * S;
  })(), vt(r);
}
function ln(r, t) {
  if (this.pos = 0, this.buffer = r, this.datav = new DataView(r.buffer), this.is_with_alpha = !!t, this.bottom_up = !0, this.flag = String.fromCharCode(this.buffer[0]) + String.fromCharCode(this.buffer[1]), this.pos += 2, ["BM", "BA", "CI", "CP", "IC", "PT"].indexOf(this.flag) === -1) throw new Error("Invalid BMP File");
  this.parseHeader(), this.parseBGR();
}
function Uf(r) {
  function t(I) {
    if (!I) throw Error("assert :P");
  }
  function e(I, G, A) {
    for (var C = 0; 4 > C; C++) if (I[G + C] != A.charCodeAt(C)) return !0;
    return !1;
  }
  function n(I, G, A, C, M) {
    for (var D = 0; D < M; D++) I[G + D] = A[C + D];
  }
  function i(I, G, A, C) {
    for (var M = 0; M < C; M++) I[G + M] = A;
  }
  function s(I) {
    return new Int32Array(I);
  }
  function c(I, G) {
    for (var A = [], C = 0; C < I; C++) A.push(new G());
    return A;
  }
  function o(I, G) {
    var A = [];
    return (function C(M, D, at) {
      for (var ot = at[D], ft = 0; ft < ot && (M.push(at.length > D + 1 ? [] : new G()), !(at.length < D + 1)); ft++) C(M[ft], D + 1, at);
    })(A, 0, I), A;
  }
  var l = function() {
    var I = this;
    function G(a, u) {
      for (var p = 1 << u - 1 >>> 0; a & p; ) p >>>= 1;
      return p ? (a & p - 1) + p : a;
    }
    function A(a, u, p, m, v) {
      t(!(m % p));
      do
        a[u + (m -= p)] = v;
      while (0 < m);
    }
    function C(a, u, p, m, v) {
      if (t(2328 >= v), 512 >= v) var L = s(512);
      else if ((L = s(v)) == null) return 0;
      return (function(k, P, R, O, Y, st) {
        var B, K, tt = P, pt = 1 << R, it = s(16), gt = s(16);
        for (t(Y != 0), t(O != null), t(k != null), t(0 < R), K = 0; K < Y; ++K) {
          if (15 < O[K]) return 0;
          ++it[O[K]];
        }
        if (it[0] == Y) return 0;
        for (gt[1] = 0, B = 1; 15 > B; ++B) {
          if (it[B] > 1 << B) return 0;
          gt[B + 1] = gt[B] + it[B];
        }
        for (K = 0; K < Y; ++K) B = O[K], 0 < O[K] && (st[gt[B]++] = K);
        if (gt[15] == 1) return (O = new M()).g = 0, O.value = st[0], A(k, tt, 1, pt, O), pt;
        var wt, At = -1, yt = pt - 1, Mt = 0, Ct = 1, ue = 1, Ft = 1 << R;
        for (K = 0, B = 1, Y = 2; B <= R; ++B, Y <<= 1) {
          if (Ct += ue <<= 1, 0 > (ue -= it[B])) return 0;
          for (; 0 < it[B]; --it[B]) (O = new M()).g = B, O.value = st[K++], A(k, tt + Mt, Y, Ft, O), Mt = G(Mt, B);
        }
        for (B = R + 1, Y = 2; 15 >= B; ++B, Y <<= 1) {
          if (Ct += ue <<= 1, 0 > (ue -= it[B])) return 0;
          for (; 0 < it[B]; --it[B]) {
            if (O = new M(), (Mt & yt) != At) {
              for (tt += Ft, wt = 1 << (At = B) - R; 15 > At && !(0 >= (wt -= it[At])); ) ++At, wt <<= 1;
              pt += Ft = 1 << (wt = At - R), k[P + (At = Mt & yt)].g = wt + R, k[P + At].value = tt - P - At;
            }
            O.g = B - R, O.value = st[K++], A(k, tt + (Mt >> R), Y, Ft, O), Mt = G(Mt, B);
          }
        }
        return Ct != 2 * gt[15] - 1 ? 0 : pt;
      })(a, u, p, m, v, L);
    }
    function M() {
      this.value = this.g = 0;
    }
    function D() {
      this.value = this.g = 0;
    }
    function at() {
      this.G = c(5, M), this.H = s(5), this.jc = this.Qb = this.qb = this.nd = 0, this.pd = c(Oi, D);
    }
    function ot(a, u, p, m) {
      t(a != null), t(u != null), t(2147483648 > m), a.Ca = 254, a.I = 0, a.b = -8, a.Ka = 0, a.oa = u, a.pa = p, a.Jd = u, a.Yc = p + m, a.Zc = 4 <= m ? p + m - 4 + 1 : p, lt(a);
    }
    function ft(a, u) {
      for (var p = 0; 0 < u--; ) p |= bt(a, 128) << u;
      return p;
    }
    function rt(a, u) {
      var p = ft(a, u);
      return ct(a) ? -p : p;
    }
    function ht(a, u, p, m) {
      var v, L = 0;
      for (t(a != null), t(u != null), t(4294967288 > m), a.Sb = m, a.Ra = 0, a.u = 0, a.h = 0, 4 < m && (m = 4), v = 0; v < m; ++v) L += u[p + v] << 8 * v;
      a.Ra = L, a.bb = m, a.oa = u, a.pa = p;
    }
    function Lt(a) {
      for (; 8 <= a.u && a.bb < a.Sb; ) a.Ra >>>= 8, a.Ra += a.oa[a.pa + a.bb] << $n - 8 >>> 0, ++a.bb, a.u -= 8;
      J(a) && (a.h = 1, a.u = 0);
    }
    function vt(a, u) {
      if (t(0 <= u), !a.h && u <= Tr) {
        var p = z(a) & Br[u];
        return a.u += u, Lt(a), p;
      }
      return a.h = 1, a.u = 0;
    }
    function S() {
      this.b = this.Ca = this.I = 0, this.oa = [], this.pa = 0, this.Jd = [], this.Yc = 0, this.Zc = [], this.Ka = 0;
    }
    function j() {
      this.Ra = 0, this.oa = [], this.h = this.u = this.bb = this.Sb = this.pa = 0;
    }
    function z(a) {
      return a.Ra >>> (a.u & $n - 1) >>> 0;
    }
    function J(a) {
      return t(a.bb <= a.Sb), a.h || a.bb == a.Sb && a.u > $n;
    }
    function $(a, u) {
      a.u = u, a.h = J(a);
    }
    function nt(a) {
      a.u >= Tn && (t(a.u >= Tn), Lt(a));
    }
    function lt(a) {
      t(a != null && a.oa != null), a.pa < a.Zc ? (a.I = (a.oa[a.pa++] | a.I << 8) >>> 0, a.b += 8) : (t(a != null && a.oa != null), a.pa < a.Yc ? (a.b += 8, a.I = a.oa[a.pa++] | a.I << 8) : a.Ka ? a.b = 0 : (a.I <<= 8, a.b += 8, a.Ka = 1));
    }
    function ct(a) {
      return ft(a, 1);
    }
    function bt(a, u) {
      var p = a.Ca;
      0 > a.b && lt(a);
      var m = a.b, v = p * u >>> 8, L = (a.I >>> m > v) + 0;
      for (L ? (p -= v, a.I -= v + 1 << m >>> 0) : p = v + 1, m = p, v = 0; 256 <= m; ) v += 8, m >>= 8;
      return m = 7 ^ v + Zn[m], a.b -= m, a.Ca = (p << m) - 1, L;
    }
    function xt(a, u, p) {
      a[u + 0] = p >> 24 & 255, a[u + 1] = p >> 16 & 255, a[u + 2] = p >> 8 & 255, a[u + 3] = 255 & p;
    }
    function Et(a, u) {
      return a[u + 0] | a[u + 1] << 8;
    }
    function Pt(a, u) {
      return Et(a, u) | a[u + 2] << 16;
    }
    function dt(a, u) {
      return Et(a, u) | Et(a, u + 2) << 16;
    }
    function U(a, u) {
      var p = 1 << u;
      return t(a != null), t(0 < u), a.X = s(p), a.X == null ? 0 : (a.Mb = 32 - u, a.Xa = u, 1);
    }
    function fe(a, u) {
      t(a != null), t(u != null), t(a.Xa == u.Xa), n(u.X, 0, a.X, 0, 1 << u.Xa);
    }
    function ae() {
      this.X = [], this.Xa = this.Mb = 0;
    }
    function Vt(a, u, p, m) {
      t(p != null), t(m != null);
      var v = p[0], L = m[0];
      return v == 0 && (v = (a * L + u / 2) / u), L == 0 && (L = (u * v + a / 2) / a), 0 >= v || 0 >= L ? 0 : (p[0] = v, m[0] = L, 1);
    }
    function Nt(a, u) {
      return a + (1 << u) - 1 >>> u;
    }
    function jt(a, u) {
      return ((4278255360 & a) + (4278255360 & u) >>> 0 & 4278255360) + ((16711935 & a) + (16711935 & u) >>> 0 & 16711935) >>> 0;
    }
    function kt(a, u) {
      I[u] = function(p, m, v, L, k, P, R) {
        var O;
        for (O = 0; O < k; ++O) {
          var Y = I[a](P[R + O - 1], v, L + O);
          P[R + O] = jt(p[m + O], Y);
        }
      };
    }
    function oe() {
      this.ud = this.hd = this.jd = 0;
    }
    function Ht(a, u) {
      return ((4278124286 & (a ^ u)) >>> 1) + (a & u) >>> 0;
    }
    function me(a) {
      return 0 <= a && 256 > a ? a : 0 > a ? 0 : 255 < a ? 255 : void 0;
    }
    function ee(a, u) {
      return me(a + (a - u + 0.5 >> 1));
    }
    function re(a, u, p) {
      return Math.abs(u - p) - Math.abs(a - p);
    }
    function Ne(a, u, p, m, v, L, k) {
      for (m = L[k - 1], p = 0; p < v; ++p) L[k + p] = m = jt(a[u + p], m);
    }
    function ce(a, u, p, m, v) {
      var L;
      for (L = 0; L < p; ++L) {
        var k = a[u + L], P = k >> 8 & 255, R = 16711935 & (R = (R = 16711935 & k) + ((P << 16) + P));
        m[v + L] = (4278255360 & k) + R >>> 0;
      }
    }
    function qt(a, u) {
      u.jd = 255 & a, u.hd = a >> 8 & 255, u.ud = a >> 16 & 255;
    }
    function Yt(a, u, p, m, v, L) {
      var k;
      for (k = 0; k < m; ++k) {
        var P = u[p + k], R = P >>> 8, O = P, Y = 255 & (Y = (Y = P >>> 16) + ((a.jd << 24 >> 24) * (R << 24 >> 24) >>> 5));
        O = 255 & (O = (O += (a.hd << 24 >> 24) * (R << 24 >> 24) >>> 5) + ((a.ud << 24 >> 24) * (Y << 24 >> 24) >>> 5)), v[L + k] = (4278255360 & P) + (Y << 16) + O;
      }
    }
    function Ut(a, u, p, m, v) {
      I[u] = function(L, k, P, R, O, Y, st, B, K) {
        for (R = st; R < B; ++R) for (st = 0; st < K; ++st) O[Y++] = v(P[m(L[k++])]);
      }, I[a] = function(L, k, P, R, O, Y, st) {
        var B = 8 >> L.b, K = L.Ea, tt = L.K[0], pt = L.w;
        if (8 > B) for (L = (1 << L.b) - 1, pt = (1 << B) - 1; k < P; ++k) {
          var it, gt = 0;
          for (it = 0; it < K; ++it) it & L || (gt = m(R[O++])), Y[st++] = v(tt[gt & pt]), gt >>= B;
        }
        else I["VP8LMapColor" + p](R, O, tt, pt, Y, st, k, P, K);
      };
    }
    function Ce(a, u, p, m, v) {
      for (p = u + p; u < p; ) {
        var L = a[u++];
        m[v++] = L >> 16 & 255, m[v++] = L >> 8 & 255, m[v++] = 255 & L;
      }
    }
    function be(a, u, p, m, v) {
      for (p = u + p; u < p; ) {
        var L = a[u++];
        m[v++] = L >> 16 & 255, m[v++] = L >> 8 & 255, m[v++] = 255 & L, m[v++] = L >> 24 & 255;
      }
    }
    function Tt(a, u, p, m, v) {
      for (p = u + p; u < p; ) {
        var L = (k = a[u++]) >> 16 & 240 | k >> 12 & 15, k = 240 & k | k >> 28 & 15;
        m[v++] = L, m[v++] = k;
      }
    }
    function ne(a, u, p, m, v) {
      for (p = u + p; u < p; ) {
        var L = (k = a[u++]) >> 16 & 248 | k >> 13 & 7, k = k >> 5 & 224 | k >> 3 & 31;
        m[v++] = L, m[v++] = k;
      }
    }
    function Le(a, u, p, m, v) {
      for (p = u + p; u < p; ) {
        var L = a[u++];
        m[v++] = 255 & L, m[v++] = L >> 8 & 255, m[v++] = L >> 16 & 255;
      }
    }
    function Wt(a, u, p, m, v, L) {
      if (L == 0) for (p = u + p; u < p; ) xt(m, ((L = a[u++])[0] >> 24 | L[1] >> 8 & 65280 | L[2] << 8 & 16711680 | L[3] << 24) >>> 0), v += 32;
      else n(m, v, a, u, p);
    }
    function he(a, u) {
      I[u][0] = I[a + "0"], I[u][1] = I[a + "1"], I[u][2] = I[a + "2"], I[u][3] = I[a + "3"], I[u][4] = I[a + "4"], I[u][5] = I[a + "5"], I[u][6] = I[a + "6"], I[u][7] = I[a + "7"], I[u][8] = I[a + "8"], I[u][9] = I[a + "9"], I[u][10] = I[a + "10"], I[u][11] = I[a + "11"], I[u][12] = I[a + "12"], I[u][13] = I[a + "13"], I[u][14] = I[a + "0"], I[u][15] = I[a + "0"];
    }
    function ie(a) {
      return a == tc || a == ec || a == qa || a == rc;
    }
    function ze() {
      this.eb = [], this.size = this.A = this.fb = 0;
    }
    function er() {
      this.y = [], this.f = [], this.ea = [], this.F = [], this.Tc = this.Ed = this.Cd = this.Fd = this.lb = this.Db = this.Ab = this.fa = this.J = this.W = this.N = this.O = 0;
    }
    function Se() {
      this.Rd = this.height = this.width = this.S = 0, this.f = {}, this.f.RGBA = new ze(), this.f.kb = new er(), this.sd = null;
    }
    function $t() {
      this.width = [0], this.height = [0], this.Pd = [0], this.Qd = [0], this.format = [0];
    }
    function ve() {
      this.Id = this.fd = this.Md = this.hb = this.ib = this.da = this.bd = this.cd = this.j = this.v = this.Da = this.Sd = this.ob = 0;
    }
    function pi(a) {
      return alert("todo:WebPSamplerProcessPlane"), a.T;
    }
    function gr(a, u) {
      var p = a.T, m = u.ba.f.RGBA, v = m.eb, L = m.fb + a.ka * m.A, k = Qr[u.ba.S], P = a.y, R = a.O, O = a.f, Y = a.N, st = a.ea, B = a.W, K = u.cc, tt = u.dc, pt = u.Mc, it = u.Nc, gt = a.ka, wt = a.ka + a.T, At = a.U, yt = At + 1 >> 1;
      for (gt == 0 ? k(P, R, null, null, O, Y, st, B, O, Y, st, B, v, L, null, null, At) : (k(u.ec, u.fc, P, R, K, tt, pt, it, O, Y, st, B, v, L - m.A, v, L, At), ++p); gt + 2 < wt; gt += 2) K = O, tt = Y, pt = st, it = B, Y += a.Rc, B += a.Rc, L += 2 * m.A, k(P, (R += 2 * a.fa) - a.fa, P, R, K, tt, pt, it, O, Y, st, B, v, L - m.A, v, L, At);
      return R += a.fa, a.j + wt < a.o ? (n(u.ec, u.fc, P, R, At), n(u.cc, u.dc, O, Y, yt), n(u.Mc, u.Nc, st, B, yt), p--) : 1 & wt || k(P, R, null, null, O, Y, st, B, O, Y, st, B, v, L + m.A, null, null, At), p;
    }
    function kn(a, u, p) {
      var m = a.F, v = [a.J];
      if (m != null) {
        var L = a.U, k = u.ba.S, P = k == ja || k == qa;
        u = u.ba.f.RGBA;
        var R = [0], O = a.ka;
        R[0] = a.T, a.Kb && (O == 0 ? --R[0] : (--O, v[0] -= a.width), a.j + a.ka + a.T == a.o && (R[0] = a.o - a.j - O));
        var Y = u.eb;
        O = u.fb + O * u.A, a = Ku(m, v[0], a.width, L, R, Y, O + (P ? 0 : 3), u.A), t(p == R), a && ie(k) && Ws(Y, O, P, L, R, u.A);
      }
      return 0;
    }
    function gn(a) {
      var u = a.ma, p = u.ba.S, m = 11 > p, v = p == Ma || p == Da || p == ja || p == Qo || p == 12 || ie(p);
      if (u.memory = null, u.Ib = null, u.Jb = null, u.Nd = null, !Ms(u.Oa, a, v ? 11 : 12)) return 0;
      if (v && ie(p) && Ra(), a.da) alert("todo:use_scaling");
      else {
        if (m) {
          if (u.Ib = pi, a.Kb) {
            if (p = a.U + 1 >> 1, u.memory = s(a.U + 2 * p), u.memory == null) return 0;
            u.ec = u.memory, u.fc = 0, u.cc = u.ec, u.dc = u.fc + a.U, u.Mc = u.cc, u.Nc = u.dc + p, u.Ib = gr, Ra();
          }
        } else alert("todo:EmitYUV");
        v && (u.Jb = kn, m && Kr());
      }
      if (m && !fl) {
        for (a = 0; 256 > a; ++a) kd[a] = 89858 * (a - 128) + za >> Ua, Cd[a] = -22014 * (a - 128) + za, Pd[a] = -45773 * (a - 128), Ed[a] = 113618 * (a - 128) + za >> Ua;
        for (a = Js; a < sc; ++a) u = 76283 * (a - 16) + za >> Ua, Rd[a - Js] = De(u, 255), Id[a - Js] = De(u + 8 >> 4, 15);
        fl = 1;
      }
      return 1;
    }
    function Gt(a) {
      var u = a.ma, p = a.U, m = a.T;
      return t(!(1 & a.ka)), 0 >= p || 0 >= m ? 0 : (p = u.Ib(a, u), u.Jb != null && u.Jb(a, u, p), u.Dc += p, 1);
    }
    function En(a) {
      a.ma.memory = null;
    }
    function Pn(a, u, p, m) {
      return vt(a, 8) != 47 ? 0 : (u[0] = vt(a, 14) + 1, p[0] = vt(a, 14) + 1, m[0] = vt(a, 1), vt(a, 3) != 0 ? 0 : !a.h);
    }
    function Wr(a, u) {
      if (4 > a) return a + 1;
      var p = a - 2 >> 1;
      return (2 + (1 & a) << p) + vt(u, p) + 1;
    }
    function Gr(a, u) {
      return 120 < u ? u - 120 : 1 <= (p = ((p = dd[u - 1]) >> 4) * a + (8 - (15 & p))) ? p : 1;
      var p;
    }
    function Me(a, u, p) {
      var m = z(p), v = a[u += 255 & m].g - 8;
      return 0 < v && ($(p, p.u + 8), m = z(p), u += a[u].value, u += m & (1 << v) - 1), $(p, p.u + a[u].g), a[u].value;
    }
    function or(a, u, p) {
      return p.g += a.g, p.value += a.value << u >>> 0, t(8 >= p.g), a.g;
    }
    function lr(a, u, p) {
      var m = a.xc;
      return t((u = m == 0 ? 0 : a.vc[a.md * (p >> m) + (u >> m)]) < a.Wb), a.Ya[u];
    }
    function gi(a, u, p, m) {
      var v = a.ab, L = a.c * u, k = a.C;
      u = k + u;
      var P = p, R = m;
      for (m = a.Ta, p = a.Ua; 0 < v--; ) {
        var O = a.gc[v], Y = k, st = u, B = P, K = R, tt = (R = m, P = p, O.Ea);
        switch (t(Y < st), t(st <= O.nc), O.hc) {
          case 2:
            Ve(B, K, (st - Y) * tt, R, P);
            break;
          case 0:
            var pt = Y, it = st, gt = R, wt = P, At = (Ft = O).Ea;
            pt == 0 && (js(B, K, null, null, 1, gt, wt), Ne(B, K + 1, 0, 0, At - 1, gt, wt + 1), K += At, wt += At, ++pt);
            for (var yt = 1 << Ft.b, Mt = yt - 1, Ct = Nt(At, Ft.b), ue = Ft.K, Ft = Ft.w + (pt >> Ft.b) * Ct; pt < it; ) {
              var de = ue, ir = Ft, le = 1;
              for (as(B, K, gt, wt - At, 1, gt, wt); le < At; ) {
                var Ot = (le & ~Mt) + yt;
                Ot > At && (Ot = At), (0, Us[de[ir++] >> 8 & 15])(B, K + +le, gt, wt + le - At, Ot - le, gt, wt + le), le = Ot;
              }
              K += At, wt += At, ++pt & Mt || (Ft += Ct);
            }
            st != O.nc && n(R, P - tt, R, P + (st - Y - 1) * tt, tt);
            break;
          case 1:
            for (tt = B, it = K, At = (B = O.Ea) - (wt = B & ~(gt = (K = 1 << O.b) - 1)), pt = Nt(B, O.b), yt = O.K, O = O.w + (Y >> O.b) * pt; Y < st; ) {
              for (Mt = yt, Ct = O, ue = new oe(), Ft = it + wt, de = it + B; it < Ft; ) qt(Mt[Ct++], ue), zs(ue, tt, it, K, R, P), it += K, P += K;
              it < de && (qt(Mt[Ct++], ue), zs(ue, tt, it, At, R, P), it += At, P += At), ++Y & gt || (O += pt);
            }
            break;
          case 3:
            if (B == R && K == P && 0 < O.b) {
              for (it = R, B = tt = P + (st - Y) * tt - (wt = (st - Y) * Nt(O.Ea, O.b)), K = R, gt = P, pt = [], wt = (At = wt) - 1; 0 <= wt; --wt) pt[wt] = K[gt + wt];
              for (wt = At - 1; 0 <= wt; --wt) it[B + wt] = pt[wt];
              Fa(O, Y, st, R, tt, R, P);
            } else Fa(O, Y, st, B, K, R, P);
        }
        P = m, R = p;
      }
      R != p && n(m, p, P, R, L);
    }
    function Gn(a, u) {
      var p = a.V, m = a.Ba + a.c * a.C, v = u - a.C;
      if (t(u <= a.l.o), t(16 >= v), 0 < v) {
        var L = a.l, k = a.Ta, P = a.Ua, R = L.width;
        if (gi(a, v, p, m), v = P = [P], t((p = a.C) < (m = u)), t(L.v < L.va), m > L.o && (m = L.o), p < L.j) {
          var O = L.j - p;
          p = L.j, v[0] += O * R;
        }
        if (p >= m ? p = 0 : (v[0] += 4 * L.v, L.ka = p - L.j, L.U = L.va - L.v, L.T = m - p, p = 1), p) {
          if (P = P[0], 11 > (p = a.ca).S) {
            var Y = p.f.RGBA, st = (m = p.S, v = L.U, L = L.T, O = Y.eb, Y.A), B = L;
            for (Y = Y.fb + a.Ma * Y.A; 0 < B--; ) {
              var K = k, tt = P, pt = v, it = O, gt = Y;
              switch (m) {
                case Ta:
                  Hs(K, tt, pt, it, gt);
                  break;
                case Ma:
                  Qn(K, tt, pt, it, gt);
                  break;
                case tc:
                  Qn(K, tt, pt, it, gt), Ws(it, gt, 0, pt, 1, 0);
                  break;
                case rl:
                  Bi(K, tt, pt, it, gt);
                  break;
                case Da:
                  Wt(K, tt, pt, it, gt, 1);
                  break;
                case ec:
                  Wt(K, tt, pt, it, gt, 1), Ws(it, gt, 0, pt, 1, 0);
                  break;
                case ja:
                  Wt(K, tt, pt, it, gt, 0);
                  break;
                case qa:
                  Wt(K, tt, pt, it, gt, 0), Ws(it, gt, 1, pt, 1, 0);
                  break;
                case Qo:
                  ti(K, tt, pt, it, gt);
                  break;
                case rc:
                  ti(K, tt, pt, it, gt), Yu(it, gt, pt, 1, 0);
                  break;
                case nl:
                  ei(K, tt, pt, it, gt);
                  break;
                default:
                  t(0);
              }
              P += R, Y += st;
            }
            a.Ma += L;
          } else alert("todo:EmitRescaledRowsYUVA");
          t(a.Ma <= p.height);
        }
      }
      a.C = u, t(a.C <= a.i);
    }
    function rn(a) {
      var u;
      if (0 < a.ua) return 0;
      for (u = 0; u < a.Wb; ++u) {
        var p = a.Ya[u].G, m = a.Ya[u].H;
        if (0 < p[1][m[1] + 0].g || 0 < p[2][m[2] + 0].g || 0 < p[3][m[3] + 0].g) return 0;
      }
      return 1;
    }
    function mn(a, u, p, m, v, L) {
      if (a.Z != 0) {
        var k = a.qd, P = a.rd;
        for (t(ii[a.Z] != null); u < p; ++u) ii[a.Z](k, P, m, v, m, v, L), k = m, P = v, v += L;
        a.qd = k, a.rd = P;
      }
    }
    function nn(a, u) {
      var p = a.l.ma, m = p.Z == 0 || p.Z == 1 ? a.l.j : a.C;
      if (m = a.C < m ? m : a.C, t(u <= a.l.o), u > m) {
        var v = a.l.width, L = p.ca, k = p.tb + v * m, P = a.V, R = a.Ba + a.c * m, O = a.gc;
        t(a.ab == 1), t(O[0].hc == 3), yn(O[0], m, u, P, R, L, k), mn(p, m, u, L, k, v);
      }
      a.C = a.Ma = u;
    }
    function sn(a, u, p, m, v, L, k) {
      var P = a.$ / m, R = a.$ % m, O = a.m, Y = a.s, st = p + a.$, B = st;
      v = p + m * v;
      var K = p + m * L, tt = 280 + Y.ua, pt = a.Pb ? P : 16777216, it = 0 < Y.ua ? Y.Wa : null, gt = Y.wc, wt = st < K ? lr(Y, R, P) : null;
      t(a.C < L), t(K <= v);
      var At = !1;
      t: for (; ; ) {
        for (; At || st < K; ) {
          var yt = 0;
          if (P >= pt) {
            var Mt = st - p;
            t((pt = a).Pb), pt.wd = pt.m, pt.xd = Mt, 0 < pt.s.ua && fe(pt.s.Wa, pt.s.vb), pt = P + gd;
          }
          if (R & gt || (wt = lr(Y, R, P)), t(wt != null), wt.Qb && (u[st] = wt.qb, At = !0), !At) if (nt(O), wt.jc) {
            yt = O, Mt = u;
            var Ct = st, ue = wt.pd[z(yt) & Oi - 1];
            t(wt.jc), 256 > ue.g ? ($(yt, yt.u + ue.g), Mt[Ct] = ue.value, yt = 0) : ($(yt, yt.u + ue.g - 256), t(256 <= ue.value), yt = ue.value), yt == 0 && (At = !0);
          } else yt = Me(wt.G[0], wt.H[0], O);
          if (O.h) break;
          if (At || 256 > yt) {
            if (!At) if (wt.nd) u[st] = (wt.qb | yt << 8) >>> 0;
            else {
              if (nt(O), At = Me(wt.G[1], wt.H[1], O), nt(O), Mt = Me(wt.G[2], wt.H[2], O), Ct = Me(wt.G[3], wt.H[3], O), O.h) break;
              u[st] = (Ct << 24 | At << 16 | yt << 8 | Mt) >>> 0;
            }
            if (At = !1, ++st, ++R >= m && (R = 0, ++P, k != null && P <= L && !(P % 16) && k(a, P), it != null)) for (; B < st; ) yt = u[B++], it.X[(506832829 * yt & 4294967295) >>> it.Mb] = yt;
          } else if (280 > yt) {
            if (yt = Wr(yt - 256, O), Mt = Me(wt.G[4], wt.H[4], O), nt(O), Mt = Gr(m, Mt = Wr(Mt, O)), O.h) break;
            if (st - p < Mt || v - st < yt) break t;
            for (Ct = 0; Ct < yt; ++Ct) u[st + Ct] = u[st + Ct - Mt];
            for (st += yt, R += yt; R >= m; ) R -= m, ++P, k != null && P <= L && !(P % 16) && k(a, P);
            if (t(st <= v), R & gt && (wt = lr(Y, R, P)), it != null) for (; B < st; ) yt = u[B++], it.X[(506832829 * yt & 4294967295) >>> it.Mb] = yt;
          } else {
            if (!(yt < tt)) break t;
            for (At = yt - 280, t(it != null); B < st; ) yt = u[B++], it.X[(506832829 * yt & 4294967295) >>> it.Mb] = yt;
            yt = st, t(!(At >>> (Mt = it).Xa)), u[yt] = Mt.X[At], At = !0;
          }
          At || t(O.h == J(O));
        }
        if (a.Pb && O.h && st < v) t(a.m.h), a.a = 5, a.m = a.wd, a.$ = a.xd, 0 < a.s.ua && fe(a.s.vb, a.s.Wa);
        else {
          if (O.h) break t;
          k?.(a, P > L ? L : P), a.a = 0, a.$ = st - p;
        }
        return 1;
      }
      return a.a = 3, 0;
    }
    function Jr(a) {
      t(a != null), a.vc = null, a.yc = null, a.Ya = null;
      var u = a.Wa;
      u != null && (u.X = null), a.vb = null, t(a != null);
    }
    function mi() {
      var a = new Bt();
      return a == null ? null : (a.a = 0, a.xb = al, he("Predictor", "VP8LPredictors"), he("Predictor", "VP8LPredictors_C"), he("PredictorAdd", "VP8LPredictorsAdd"), he("PredictorAdd", "VP8LPredictorsAdd_C"), Ve = ce, zs = Yt, Hs = Ce, Qn = be, ti = Tt, ei = ne, Bi = Le, I.VP8LMapColor32b = vn, I.VP8LMapColor8b = qs, a);
    }
    function bn(a, u, p, m, v) {
      var L = 1, k = [a], P = [u], R = m.m, O = m.s, Y = null, st = 0;
      t: for (; ; ) {
        if (p) for (; L && vt(R, 1); ) {
          var B = k, K = P, tt = m, pt = 1, it = tt.m, gt = tt.gc[tt.ab], wt = vt(it, 2);
          if (tt.Oc & 1 << wt) L = 0;
          else {
            switch (tt.Oc |= 1 << wt, gt.hc = wt, gt.Ea = B[0], gt.nc = K[0], gt.K = [null], ++tt.ab, t(4 >= tt.ab), wt) {
              case 0:
              case 1:
                gt.b = vt(it, 3) + 2, pt = bn(Nt(gt.Ea, gt.b), Nt(gt.nc, gt.b), 0, tt, gt.K), gt.K = gt.K[0];
                break;
              case 3:
                var At, yt = vt(it, 8) + 1, Mt = 16 < yt ? 0 : 4 < yt ? 1 : 2 < yt ? 2 : 3;
                if (B[0] = Nt(gt.Ea, Mt), gt.b = Mt, At = pt = bn(yt, 1, 0, tt, gt.K)) {
                  var Ct, ue = yt, Ft = gt, de = 1 << (8 >> Ft.b), ir = s(de);
                  if (ir == null) At = 0;
                  else {
                    var le = Ft.K[0], Ot = Ft.w;
                    for (ir[0] = Ft.K[0][0], Ct = 1; Ct < 1 * ue; ++Ct) ir[Ct] = jt(le[Ot + Ct], ir[Ct - 1]);
                    for (; Ct < 4 * de; ++Ct) ir[Ct] = 0;
                    Ft.K[0] = null, Ft.K[0] = ir, At = 1;
                  }
                }
                pt = At;
                break;
              case 2:
                break;
              default:
                t(0);
            }
            L = pt;
          }
        }
        if (k = k[0], P = P[0], L && vt(R, 1) && !(L = 1 <= (st = vt(R, 4)) && 11 >= st)) {
          m.a = 3;
          break t;
        }
        var St;
        if (St = L) e: {
          var Ge, se, pe, Fe = m, hr = k, Nr = P, je = st, br = p, Lr = Fe.m, sr = Fe.s, ge = [null], _e = 1, qe = 0, Ae = pd[je];
          r: for (; ; ) {
            if (br && vt(Lr, 1)) {
              var dr = vt(Lr, 3) + 2, cn = Nt(hr, dr), Je = Nt(Nr, dr), Pr = cn * Je;
              if (!bn(cn, Je, 0, Fe, ge)) break r;
              for (ge = ge[0], sr.xc = dr, Ge = 0; Ge < Pr; ++Ge) {
                var Ee = ge[Ge] >> 8 & 65535;
                ge[Ge] = Ee, Ee >= _e && (_e = Ee + 1);
              }
            }
            if (Lr.h) break r;
            for (se = 0; 5 > se; ++se) {
              var ar = il[se];
              !se && 0 < je && (ar += 1 << je), qe < ar && (qe = ar);
            }
            var Dr = c(_e * Ae, M), Sr = _e, jr = c(Sr, at);
            if (jr == null) var qr = null;
            else t(65536 >= Sr), qr = jr;
            var Cr = s(qe);
            if (qr == null || Cr == null || Dr == null) {
              Fe.a = 1;
              break r;
            }
            var Ur = Dr;
            for (Ge = pe = 0; Ge < _e; ++Ge) {
              var Ie = qr[Ge], zr = Ie.G, un = Ie.H, Mi = 0, jn = 1, pr = 0;
              for (se = 0; 5 > se; ++se) {
                ar = il[se], zr[se] = Ur, un[se] = pe, !se && 0 < je && (ar += 1 << je);
                i: {
                  var Va, ac = ar, Wa = Fe, Ys = Cr, Bd = Ur, Td = pe, oc = 0, si = Wa.m, Md = vt(si, 1);
                  if (i(Ys, 0, 0, ac), Md) {
                    var Dd = vt(si, 1) + 1, jd = vt(si, 1), pl = vt(si, jd == 0 ? 1 : 8);
                    Ys[pl] = 1, Dd == 2 && (Ys[pl = vt(si, 8)] = 1);
                    var Ga = 1;
                  } else {
                    var gl = s(19), ml = vt(si, 4) + 4;
                    if (19 < ml) {
                      Wa.a = 3;
                      var Ja = 0;
                      break i;
                    }
                    for (Va = 0; Va < ml; ++Va) gl[hd[Va]] = vt(si, 3);
                    var cc = void 0, Ks = void 0, bl = Wa, qd = gl, Ya = ac, wl = Ys, uc = 0, ai = bl.m, vl = 8, yl = c(128, M);
                    n: for (; C(yl, 0, 7, qd, 19); ) {
                      if (vt(ai, 1)) {
                        var Ud = 2 + 2 * vt(ai, 3);
                        if ((cc = 2 + vt(ai, Ud)) > Ya) break n;
                      } else cc = Ya;
                      for (Ks = 0; Ks < Ya && cc--; ) {
                        nt(ai);
                        var _l = yl[0 + (127 & z(ai))];
                        $(ai, ai.u + _l.g);
                        var cs = _l.value;
                        if (16 > cs) wl[Ks++] = cs, cs != 0 && (vl = cs);
                        else {
                          var zd = cs == 16, Al = cs - 16, Hd = ld[Al], xl = vt(ai, ud[Al]) + Hd;
                          if (Ks + xl > Ya) break n;
                          for (var Vd = zd ? vl : 0; 0 < xl--; ) wl[Ks++] = Vd;
                        }
                      }
                      uc = 1;
                      break n;
                    }
                    uc || (bl.a = 3), Ga = uc;
                  }
                  (Ga = Ga && !si.h) && (oc = C(Bd, Td, 8, Ys, ac)), Ga && oc != 0 ? Ja = oc : (Wa.a = 3, Ja = 0);
                }
                if (Ja == 0) break r;
                if (jn && fd[se] == 1 && (jn = Ur[pe].g == 0), Mi += Ur[pe].g, pe += Ja, 3 >= se) {
                  var Xs, lc = Cr[0];
                  for (Xs = 1; Xs < ar; ++Xs) Cr[Xs] > lc && (lc = Cr[Xs]);
                  pr += lc;
                }
              }
              if (Ie.nd = jn, Ie.Qb = 0, jn && (Ie.qb = (zr[3][un[3] + 0].value << 24 | zr[1][un[1] + 0].value << 16 | zr[2][un[2] + 0].value) >>> 0, Mi == 0 && 256 > zr[0][un[0] + 0].value && (Ie.Qb = 1, Ie.qb += zr[0][un[0] + 0].value << 8)), Ie.jc = !Ie.Qb && 6 > pr, Ie.jc) {
                var Ka, qn = Ie;
                for (Ka = 0; Ka < Oi; ++Ka) {
                  var oi = Ka, ci = qn.pd[oi], Xa = qn.G[0][qn.H[0] + oi];
                  256 <= Xa.value ? (ci.g = Xa.g + 256, ci.value = Xa.value) : (ci.g = 0, ci.value = 0, oi >>= or(Xa, 8, ci), oi >>= or(qn.G[1][qn.H[1] + oi], 16, ci), oi >>= or(qn.G[2][qn.H[2] + oi], 0, ci), or(qn.G[3][qn.H[3] + oi], 24, ci));
                }
              }
            }
            sr.vc = ge, sr.Wb = _e, sr.Ya = qr, sr.yc = Dr, St = 1;
            break e;
          }
          St = 0;
        }
        if (!(L = St)) {
          m.a = 3;
          break t;
        }
        if (0 < st) {
          if (O.ua = 1 << st, !U(O.Wa, st)) {
            m.a = 1, L = 0;
            break t;
          }
        } else O.ua = 0;
        var fc = m, Nl = k, Wd = P, hc = fc.s, dc = hc.xc;
        if (fc.c = Nl, fc.i = Wd, hc.md = Nt(Nl, dc), hc.wc = dc == 0 ? -1 : (1 << dc) - 1, p) {
          m.xb = Ad;
          break t;
        }
        if ((Y = s(k * P)) == null) {
          m.a = 1, L = 0;
          break t;
        }
        L = (L = sn(m, Y, 0, k, P, P, null)) && !R.h;
        break t;
      }
      return L ? (v != null ? v[0] = Y : (t(Y == null), t(p)), m.$ = 0, p || Jr(O)) : Jr(O), L;
    }
    function bi(a, u) {
      var p = a.c * a.i, m = p + u + 16 * u;
      return t(a.c <= u), a.V = s(m), a.V == null ? (a.Ta = null, a.Ua = 0, a.a = 1, 0) : (a.Ta = a.V, a.Ua = a.Ba + p + u, 1);
    }
    function Xi(a, u) {
      var p = a.C, m = u - p, v = a.V, L = a.Ba + a.c * p;
      for (t(u <= a.l.o); 0 < m; ) {
        var k = 16 < m ? 16 : m, P = a.l.ma, R = a.l.width, O = R * k, Y = P.ca, st = P.tb + R * p, B = a.Ta, K = a.Ua;
        gi(a, k, v, L), Xu(B, K, Y, st, O), mn(P, p, p + k, Y, st, R), m -= k, v += k * a.c, p += k;
      }
      t(p == u), a.C = a.Ma = u;
    }
    function $i() {
      this.ub = this.yd = this.td = this.Rb = 0;
    }
    function Zi() {
      this.Kd = this.Ld = this.Ud = this.Td = this.i = this.c = 0;
    }
    function To() {
      this.Fb = this.Bb = this.Cb = 0, this.Zb = s(4), this.Lb = s(4);
    }
    function xs() {
      this.Yb = (function() {
        var a = [];
        return (function u(p, m, v) {
          for (var L = v[m], k = 0; k < L && (p.push(v.length > m + 1 ? [] : 0), !(v.length < m + 1)); k++) u(p[k], m + 1, v);
        })(a, 0, [3, 11]), a;
      })();
    }
    function ma() {
      this.jb = s(3), this.Wc = o([4, 8], xs), this.Xc = o([4, 17], xs);
    }
    function ba() {
      this.Pc = this.wb = this.Tb = this.zd = 0, this.vd = new s(4), this.od = new s(4);
    }
    function Yr() {
      this.ld = this.La = this.dd = this.tc = 0;
    }
    function Ns() {
      this.Na = this.la = 0;
    }
    function wa() {
      this.Sc = [0, 0], this.Eb = [0, 0], this.Qc = [0, 0], this.ia = this.lc = 0;
    }
    function Ls() {
      this.ad = s(384), this.Za = 0, this.Ob = s(16), this.$b = this.Ad = this.ia = this.Gc = this.Hc = this.Dd = 0;
    }
    function va() {
      this.uc = this.M = this.Nb = 0, this.wa = Array(new Yr()), this.Y = 0, this.ya = Array(new Ls()), this.aa = 0, this.l = new Qi();
    }
    function ya() {
      this.y = s(16), this.f = s(8), this.ea = s(8);
    }
    function _a() {
      this.cb = this.a = 0, this.sc = "", this.m = new S(), this.Od = new $i(), this.Kc = new Zi(), this.ed = new ba(), this.Qa = new To(), this.Ic = this.$c = this.Aa = 0, this.D = new va(), this.Xb = this.Va = this.Hb = this.zb = this.yb = this.Ub = this.za = 0, this.Jc = c(8, S), this.ia = 0, this.pb = c(4, wa), this.Pa = new ma(), this.Bd = this.kc = 0, this.Ac = [], this.Bc = 0, this.zc = [0, 0, 0, 0], this.Gd = Array(new ya()), this.Hd = 0, this.rb = Array(new Ns()), this.sb = 0, this.wa = Array(new Yr()), this.Y = 0, this.oc = [], this.pc = 0, this.sa = [], this.ta = 0, this.qa = [], this.ra = 0, this.Ha = [], this.B = this.R = this.Ia = 0, this.Ec = [], this.M = this.ja = this.Vb = this.Fc = 0, this.ya = Array(new Ls()), this.L = this.aa = 0, this.gd = o([4, 2], Yr), this.ga = null, this.Fa = [], this.Cc = this.qc = this.P = 0, this.Gb = [], this.Uc = 0, this.mb = [], this.nb = 0, this.rc = [], this.Ga = this.Vc = 0;
    }
    function Qi() {
      this.T = this.U = this.ka = this.height = this.width = 0, this.y = [], this.f = [], this.ea = [], this.Rc = this.fa = this.W = this.N = this.O = 0, this.ma = "void", this.put = "VP8IoPutHook", this.ac = "VP8IoSetupHook", this.bc = "VP8IoTeardownHook", this.ha = this.Kb = 0, this.data = [], this.hb = this.ib = this.da = this.o = this.j = this.va = this.v = this.Da = this.ob = this.w = 0, this.F = [], this.J = 0;
    }
    function Mo() {
      var a = new _a();
      return a != null && (a.a = 0, a.sc = "OK", a.cb = 0, a.Xb = 0, Gs || (Gs = Cn)), a;
    }
    function Ze(a, u, p) {
      return a.a == 0 && (a.a = u, a.sc = p, a.cb = 0), 0;
    }
    function Aa(a, u, p) {
      return 3 <= p && a[u + 0] == 157 && a[u + 1] == 1 && a[u + 2] == 42;
    }
    function xa(a, u) {
      if (a == null) return 0;
      if (a.a = 0, a.sc = "OK", u == null) return Ze(a, 2, "null VP8Io passed to VP8GetHeaders()");
      var p = u.data, m = u.w, v = u.ha;
      if (4 > v) return Ze(a, 7, "Truncated header.");
      var L = p[m + 0] | p[m + 1] << 8 | p[m + 2] << 16, k = a.Od;
      if (k.Rb = !(1 & L), k.td = L >> 1 & 7, k.yd = L >> 4 & 1, k.ub = L >> 5, 3 < k.td) return Ze(a, 3, "Incorrect keyframe parameters.");
      if (!k.yd) return Ze(a, 4, "Frame not displayable.");
      m += 3, v -= 3;
      var P = a.Kc;
      if (k.Rb) {
        if (7 > v) return Ze(a, 7, "cannot parse picture header");
        if (!Aa(p, m, v)) return Ze(a, 3, "Bad code word");
        P.c = 16383 & (p[m + 4] << 8 | p[m + 3]), P.Td = p[m + 4] >> 6, P.i = 16383 & (p[m + 6] << 8 | p[m + 5]), P.Ud = p[m + 6] >> 6, m += 7, v -= 7, a.za = P.c + 15 >> 4, a.Ub = P.i + 15 >> 4, u.width = P.c, u.height = P.i, u.Da = 0, u.j = 0, u.v = 0, u.va = u.width, u.o = u.height, u.da = 0, u.ib = u.width, u.hb = u.height, u.U = u.width, u.T = u.height, i((L = a.Pa).jb, 0, 255, L.jb.length), t((L = a.Qa) != null), L.Cb = 0, L.Bb = 0, L.Fb = 1, i(L.Zb, 0, 0, L.Zb.length), i(L.Lb, 0, 0, L.Lb);
      }
      if (k.ub > v) return Ze(a, 7, "bad partition length");
      ot(L = a.m, p, m, k.ub), m += k.ub, v -= k.ub, k.Rb && (P.Ld = ct(L), P.Kd = ct(L)), P = a.Qa;
      var R, O = a.Pa;
      if (t(L != null), t(P != null), P.Cb = ct(L), P.Cb) {
        if (P.Bb = ct(L), ct(L)) {
          for (P.Fb = ct(L), R = 0; 4 > R; ++R) P.Zb[R] = ct(L) ? rt(L, 7) : 0;
          for (R = 0; 4 > R; ++R) P.Lb[R] = ct(L) ? rt(L, 6) : 0;
        }
        if (P.Bb) for (R = 0; 3 > R; ++R) O.jb[R] = ct(L) ? ft(L, 8) : 255;
      } else P.Bb = 0;
      if (L.Ka) return Ze(a, 3, "cannot parse segment header");
      if ((P = a.ed).zd = ct(L), P.Tb = ft(L, 6), P.wb = ft(L, 3), P.Pc = ct(L), P.Pc && ct(L)) {
        for (O = 0; 4 > O; ++O) ct(L) && (P.vd[O] = rt(L, 6));
        for (O = 0; 4 > O; ++O) ct(L) && (P.od[O] = rt(L, 6));
      }
      if (a.L = P.Tb == 0 ? 0 : P.zd ? 1 : 2, L.Ka) return Ze(a, 3, "cannot parse filter header");
      var Y = v;
      if (v = R = m, m = R + Y, P = Y, a.Xb = (1 << ft(a.m, 2)) - 1, Y < 3 * (O = a.Xb)) p = 7;
      else {
        for (R += 3 * O, P -= 3 * O, Y = 0; Y < O; ++Y) {
          var st = p[v + 0] | p[v + 1] << 8 | p[v + 2] << 16;
          st > P && (st = P), ot(a.Jc[+Y], p, R, st), R += st, P -= st, v += 3;
        }
        ot(a.Jc[+O], p, R, P), p = R < m ? 0 : 5;
      }
      if (p != 0) return Ze(a, p, "cannot parse partitions");
      for (p = ft(R = a.m, 7), v = ct(R) ? rt(R, 4) : 0, m = ct(R) ? rt(R, 4) : 0, P = ct(R) ? rt(R, 4) : 0, O = ct(R) ? rt(R, 4) : 0, R = ct(R) ? rt(R, 4) : 0, Y = a.Qa, st = 0; 4 > st; ++st) {
        if (Y.Cb) {
          var B = Y.Zb[st];
          Y.Fb || (B += p);
        } else {
          if (0 < st) {
            a.pb[st] = a.pb[0];
            continue;
          }
          B = p;
        }
        var K = a.pb[st];
        K.Sc[0] = nc[De(B + v, 127)], K.Sc[1] = ic[De(B + 0, 127)], K.Eb[0] = 2 * nc[De(B + m, 127)], K.Eb[1] = 101581 * ic[De(B + P, 127)] >> 16, 8 > K.Eb[1] && (K.Eb[1] = 8), K.Qc[0] = nc[De(B + O, 117)], K.Qc[1] = ic[De(B + R, 127)], K.lc = B + R;
      }
      if (!k.Rb) return Ze(a, 4, "Not a key frame.");
      for (ct(L), k = a.Pa, p = 0; 4 > p; ++p) {
        for (v = 0; 8 > v; ++v) for (m = 0; 3 > m; ++m) for (P = 0; 11 > P; ++P) O = bt(L, yd[p][v][m][P]) ? ft(L, 8) : wd[p][v][m][P], k.Wc[p][v].Yb[m][P] = O;
        for (v = 0; 17 > v; ++v) k.Xc[p][v] = k.Wc[p][_d[v]];
      }
      return a.kc = ct(L), a.kc && (a.Bd = ft(L, 8)), a.cb = 1;
    }
    function Cn(a, u, p, m, v, L, k) {
      var P = u[v].Yb[p];
      for (p = 0; 16 > v; ++v) {
        if (!bt(a, P[p + 0])) return v;
        for (; !bt(a, P[p + 1]); ) if (P = u[++v].Yb[0], p = 0, v == 16) return 16;
        var R = u[v + 1].Yb;
        if (bt(a, P[p + 2])) {
          var O = a, Y = 0;
          if (bt(O, (B = P)[(st = p) + 3])) if (bt(O, B[st + 6])) {
            for (P = 0, st = 2 * (Y = bt(O, B[st + 8])) + (B = bt(O, B[st + 9 + Y])), Y = 0, B = md[st]; B[P]; ++P) Y += Y + bt(O, B[P]);
            Y += 3 + (8 << st);
          } else bt(O, B[st + 7]) ? (Y = 7 + 2 * bt(O, 165), Y += bt(O, 145)) : Y = 5 + bt(O, 159);
          else Y = bt(O, B[st + 4]) ? 3 + bt(O, B[st + 5]) : 2;
          P = R[2];
        } else Y = 1, P = R[1];
        R = k + bd[v], 0 > (O = a).b && lt(O);
        var st, B = O.b, K = (st = O.Ca >> 1) - (O.I >> B) >> 31;
        --O.b, O.Ca += K, O.Ca |= 1, O.I -= (st + 1 & K) << B, L[R] = ((Y ^ K) - K) * m[(0 < v) + 0];
      }
      return 16;
    }
    function wi(a) {
      var u = a.rb[a.sb - 1];
      u.la = 0, u.Na = 0, i(a.zc, 0, 0, a.zc.length), a.ja = 0;
    }
    function an(a, u, p, m, v) {
      v = a[u + p + 32 * m] + (v >> 3), a[u + p + 32 * m] = -256 & v ? 0 > v ? 0 : 255 : v;
    }
    function vi(a, u, p, m, v, L) {
      an(a, u, 0, p, m + v), an(a, u, 1, p, m + L), an(a, u, 2, p, m - L), an(a, u, 3, p, m - v);
    }
    function He(a) {
      return (20091 * a >> 16) + a;
    }
    function Ss(a, u, p, m) {
      var v, L = 0, k = s(16);
      for (v = 0; 4 > v; ++v) {
        var P = a[u + 0] + a[u + 8], R = a[u + 0] - a[u + 8], O = (35468 * a[u + 4] >> 16) - He(a[u + 12]), Y = He(a[u + 4]) + (35468 * a[u + 12] >> 16);
        k[L + 0] = P + Y, k[L + 1] = R + O, k[L + 2] = R - O, k[L + 3] = P - Y, L += 4, u++;
      }
      for (v = L = 0; 4 > v; ++v) P = (a = k[L + 0] + 4) + k[L + 8], R = a - k[L + 8], O = (35468 * k[L + 4] >> 16) - He(k[L + 12]), an(p, m, 0, 0, P + (Y = He(k[L + 4]) + (35468 * k[L + 12] >> 16))), an(p, m, 1, 0, R + O), an(p, m, 2, 0, R - O), an(p, m, 3, 0, P - Y), L++, m += 32;
    }
    function Do(a, u, p, m) {
      var v = a[u + 0] + 4, L = 35468 * a[u + 4] >> 16, k = He(a[u + 4]), P = 35468 * a[u + 1] >> 16;
      vi(p, m, 0, v + k, a = He(a[u + 1]), P), vi(p, m, 1, v + L, a, P), vi(p, m, 2, v - L, a, P), vi(p, m, 3, v - k, a, P);
    }
    function jo(a, u, p, m, v) {
      Ss(a, u, p, m), v && Ss(a, u + 16, p, m + 4);
    }
    function qo(a, u, p, m) {
      Ti(a, u + 0, p, m, 1), Ti(a, u + 32, p, m + 128, 1);
    }
    function wn(a, u, p, m) {
      var v;
      for (a = a[u + 0] + 4, v = 0; 4 > v; ++v) for (u = 0; 4 > u; ++u) an(p, m, u, v, a);
    }
    function Na(a, u, p, m) {
      a[u + 0] && ye(a, u + 0, p, m), a[u + 16] && ye(a, u + 16, p, m + 4), a[u + 32] && ye(a, u + 32, p, m + 128), a[u + 48] && ye(a, u + 48, p, m + 128 + 4);
    }
    function La(a, u, p, m) {
      var v, L = s(16);
      for (v = 0; 4 > v; ++v) {
        var k = a[u + 0 + v] + a[u + 12 + v], P = a[u + 4 + v] + a[u + 8 + v], R = a[u + 4 + v] - a[u + 8 + v], O = a[u + 0 + v] - a[u + 12 + v];
        L[0 + v] = k + P, L[8 + v] = k - P, L[4 + v] = O + R, L[12 + v] = O - R;
      }
      for (v = 0; 4 > v; ++v) k = (a = L[0 + 4 * v] + 3) + L[3 + 4 * v], P = L[1 + 4 * v] + L[2 + 4 * v], R = L[1 + 4 * v] - L[2 + 4 * v], O = a - L[3 + 4 * v], p[m + 0] = k + P >> 3, p[m + 16] = O + R >> 3, p[m + 32] = k - P >> 3, p[m + 48] = O - R >> 3, m += 64;
    }
    function Jn(a, u, p) {
      var m, v = u - 32, L = Mr, k = 255 - a[v - 1];
      for (m = 0; m < p; ++m) {
        var P, R = L, O = k + a[u - 1];
        for (P = 0; P < p; ++P) a[u + P] = R[O + a[v + P]];
        u += 32;
      }
    }
    function ks(a, u) {
      Jn(a, u, 4);
    }
    function Uo(a, u) {
      Jn(a, u, 8);
    }
    function zo(a, u) {
      Jn(a, u, 16);
    }
    function Ho(a, u) {
      var p;
      for (p = 0; 16 > p; ++p) n(a, u + 32 * p, a, u - 32, 16);
    }
    function Es(a, u) {
      var p;
      for (p = 16; 0 < p; --p) i(a, u, a[u - 1], 16), u += 32;
    }
    function yi(a, u, p) {
      var m;
      for (m = 0; 16 > m; ++m) i(u, p + 32 * m, a, 16);
    }
    function Yn(a, u) {
      var p, m = 16;
      for (p = 0; 16 > p; ++p) m += a[u - 1 + 32 * p] + a[u + p - 32];
      yi(m >> 5, a, u);
    }
    function Vo(a, u) {
      var p, m = 8;
      for (p = 0; 16 > p; ++p) m += a[u - 1 + 32 * p];
      yi(m >> 4, a, u);
    }
    function _i(a, u) {
      var p, m = 8;
      for (p = 0; 16 > p; ++p) m += a[u + p - 32];
      yi(m >> 4, a, u);
    }
    function Ps(a, u) {
      yi(128, a, u);
    }
    function Zt(a, u, p) {
      return a + 2 * u + p + 2 >> 2;
    }
    function Wo(a, u) {
      var p, m = u - 32;
      for (m = new Uint8Array([Zt(a[m - 1], a[m + 0], a[m + 1]), Zt(a[m + 0], a[m + 1], a[m + 2]), Zt(a[m + 1], a[m + 2], a[m + 3]), Zt(a[m + 2], a[m + 3], a[m + 4])]), p = 0; 4 > p; ++p) n(a, u + 32 * p, m, 0, m.length);
    }
    function Go(a, u) {
      var p = a[u - 1], m = a[u - 1 + 32], v = a[u - 1 + 64], L = a[u - 1 + 96];
      xt(a, u + 0, 16843009 * Zt(a[u - 1 - 32], p, m)), xt(a, u + 32, 16843009 * Zt(p, m, v)), xt(a, u + 64, 16843009 * Zt(m, v, L)), xt(a, u + 96, 16843009 * Zt(v, L, L));
    }
    function Jo(a, u) {
      var p, m = 4;
      for (p = 0; 4 > p; ++p) m += a[u + p - 32] + a[u - 1 + 32 * p];
      for (m >>= 3, p = 0; 4 > p; ++p) i(a, u + 32 * p, m, 4);
    }
    function Yo(a, u) {
      var p = a[u - 1 + 0], m = a[u - 1 + 32], v = a[u - 1 + 64], L = a[u - 1 - 32], k = a[u + 0 - 32], P = a[u + 1 - 32], R = a[u + 2 - 32], O = a[u + 3 - 32];
      a[u + 0 + 96] = Zt(m, v, a[u - 1 + 96]), a[u + 1 + 96] = a[u + 0 + 64] = Zt(p, m, v), a[u + 2 + 96] = a[u + 1 + 64] = a[u + 0 + 32] = Zt(L, p, m), a[u + 3 + 96] = a[u + 2 + 64] = a[u + 1 + 32] = a[u + 0 + 0] = Zt(k, L, p), a[u + 3 + 64] = a[u + 2 + 32] = a[u + 1 + 0] = Zt(P, k, L), a[u + 3 + 32] = a[u + 2 + 0] = Zt(R, P, k), a[u + 3 + 0] = Zt(O, R, P);
    }
    function Rn(a, u) {
      var p = a[u + 1 - 32], m = a[u + 2 - 32], v = a[u + 3 - 32], L = a[u + 4 - 32], k = a[u + 5 - 32], P = a[u + 6 - 32], R = a[u + 7 - 32];
      a[u + 0 + 0] = Zt(a[u + 0 - 32], p, m), a[u + 1 + 0] = a[u + 0 + 32] = Zt(p, m, v), a[u + 2 + 0] = a[u + 1 + 32] = a[u + 0 + 64] = Zt(m, v, L), a[u + 3 + 0] = a[u + 2 + 32] = a[u + 1 + 64] = a[u + 0 + 96] = Zt(v, L, k), a[u + 3 + 32] = a[u + 2 + 64] = a[u + 1 + 96] = Zt(L, k, P), a[u + 3 + 64] = a[u + 2 + 96] = Zt(k, P, R), a[u + 3 + 96] = Zt(P, R, R);
    }
    function In(a, u) {
      var p = a[u - 1 + 0], m = a[u - 1 + 32], v = a[u - 1 + 64], L = a[u - 1 - 32], k = a[u + 0 - 32], P = a[u + 1 - 32], R = a[u + 2 - 32], O = a[u + 3 - 32];
      a[u + 0 + 0] = a[u + 1 + 64] = L + k + 1 >> 1, a[u + 1 + 0] = a[u + 2 + 64] = k + P + 1 >> 1, a[u + 2 + 0] = a[u + 3 + 64] = P + R + 1 >> 1, a[u + 3 + 0] = R + O + 1 >> 1, a[u + 0 + 96] = Zt(v, m, p), a[u + 0 + 64] = Zt(m, p, L), a[u + 0 + 32] = a[u + 1 + 96] = Zt(p, L, k), a[u + 1 + 32] = a[u + 2 + 96] = Zt(L, k, P), a[u + 2 + 32] = a[u + 3 + 96] = Zt(k, P, R), a[u + 3 + 32] = Zt(P, R, O);
    }
    function Ko(a, u) {
      var p = a[u + 0 - 32], m = a[u + 1 - 32], v = a[u + 2 - 32], L = a[u + 3 - 32], k = a[u + 4 - 32], P = a[u + 5 - 32], R = a[u + 6 - 32], O = a[u + 7 - 32];
      a[u + 0 + 0] = p + m + 1 >> 1, a[u + 1 + 0] = a[u + 0 + 64] = m + v + 1 >> 1, a[u + 2 + 0] = a[u + 1 + 64] = v + L + 1 >> 1, a[u + 3 + 0] = a[u + 2 + 64] = L + k + 1 >> 1, a[u + 0 + 32] = Zt(p, m, v), a[u + 1 + 32] = a[u + 0 + 96] = Zt(m, v, L), a[u + 2 + 32] = a[u + 1 + 96] = Zt(v, L, k), a[u + 3 + 32] = a[u + 2 + 96] = Zt(L, k, P), a[u + 3 + 64] = Zt(k, P, R), a[u + 3 + 96] = Zt(P, R, O);
    }
    function Xo(a, u) {
      var p = a[u - 1 + 0], m = a[u - 1 + 32], v = a[u - 1 + 64], L = a[u - 1 + 96];
      a[u + 0 + 0] = p + m + 1 >> 1, a[u + 2 + 0] = a[u + 0 + 32] = m + v + 1 >> 1, a[u + 2 + 32] = a[u + 0 + 64] = v + L + 1 >> 1, a[u + 1 + 0] = Zt(p, m, v), a[u + 3 + 0] = a[u + 1 + 32] = Zt(m, v, L), a[u + 3 + 32] = a[u + 1 + 64] = Zt(v, L, L), a[u + 3 + 64] = a[u + 2 + 64] = a[u + 0 + 96] = a[u + 1 + 96] = a[u + 2 + 96] = a[u + 3 + 96] = L;
    }
    function ts(a, u) {
      var p = a[u - 1 + 0], m = a[u - 1 + 32], v = a[u - 1 + 64], L = a[u - 1 + 96], k = a[u - 1 - 32], P = a[u + 0 - 32], R = a[u + 1 - 32], O = a[u + 2 - 32];
      a[u + 0 + 0] = a[u + 2 + 32] = p + k + 1 >> 1, a[u + 0 + 32] = a[u + 2 + 64] = m + p + 1 >> 1, a[u + 0 + 64] = a[u + 2 + 96] = v + m + 1 >> 1, a[u + 0 + 96] = L + v + 1 >> 1, a[u + 3 + 0] = Zt(P, R, O), a[u + 2 + 0] = Zt(k, P, R), a[u + 1 + 0] = a[u + 3 + 32] = Zt(p, k, P), a[u + 1 + 32] = a[u + 3 + 64] = Zt(m, p, k), a[u + 1 + 64] = a[u + 3 + 96] = Zt(v, m, p), a[u + 1 + 96] = Zt(L, v, m);
    }
    function Cs(a, u) {
      var p;
      for (p = 0; 8 > p; ++p) n(a, u + 32 * p, a, u - 32, 8);
    }
    function Ai(a, u) {
      var p;
      for (p = 0; 8 > p; ++p) i(a, u, a[u - 1], 8), u += 32;
    }
    function es(a, u, p) {
      var m;
      for (m = 0; 8 > m; ++m) i(u, p + 32 * m, a, 8);
    }
    function rs(a, u) {
      var p, m = 8;
      for (p = 0; 8 > p; ++p) m += a[u + p - 32] + a[u - 1 + 32 * p];
      es(m >> 4, a, u);
    }
    function $o(a, u) {
      var p, m = 4;
      for (p = 0; 8 > p; ++p) m += a[u + p - 32];
      es(m >> 3, a, u);
    }
    function Rs(a, u) {
      var p, m = 4;
      for (p = 0; 8 > p; ++p) m += a[u - 1 + 32 * p];
      es(m >> 3, a, u);
    }
    function Is(a, u) {
      es(128, a, u);
    }
    function xi(a, u, p) {
      var m = a[u - p], v = a[u + 0], L = 3 * (v - m) + Zo[1020 + a[u - 2 * p] - a[u + p]], k = Ba[112 + (L + 4 >> 3)];
      a[u - p] = Mr[255 + m + Ba[112 + (L + 3 >> 3)]], a[u + 0] = Mr[255 + v - k];
    }
    function Ni(a, u, p, m) {
      var v = a[u + 0], L = a[u + p];
      return Zr[255 + a[u - 2 * p] - a[u - p]] > m || Zr[255 + L - v] > m;
    }
    function Fs(a, u, p, m) {
      return 4 * Zr[255 + a[u - p] - a[u + 0]] + Zr[255 + a[u - 2 * p] - a[u + p]] <= m;
    }
    function ns(a, u, p, m, v) {
      var L = a[u - 3 * p], k = a[u - 2 * p], P = a[u - p], R = a[u + 0], O = a[u + p], Y = a[u + 2 * p], st = a[u + 3 * p];
      return 4 * Zr[255 + P - R] + Zr[255 + k - O] > m ? 0 : Zr[255 + a[u - 4 * p] - L] <= v && Zr[255 + L - k] <= v && Zr[255 + k - P] <= v && Zr[255 + st - Y] <= v && Zr[255 + Y - O] <= v && Zr[255 + O - R] <= v;
    }
    function Os(a, u, p, m) {
      var v = 2 * m + 1;
      for (m = 0; 16 > m; ++m) Fs(a, u + m, p, v) && xi(a, u + m, p);
    }
    function Li(a, u, p, m) {
      var v = 2 * m + 1;
      for (m = 0; 16 > m; ++m) Fs(a, u + m * p, 1, v) && xi(a, u + m * p, 1);
    }
    function Sa(a, u, p, m) {
      var v;
      for (v = 3; 0 < v; --v) Os(a, u += 4 * p, p, m);
    }
    function ka(a, u, p, m) {
      var v;
      for (v = 3; 0 < v; --v) Li(a, u += 4, p, m);
    }
    function Fn(a, u, p, m, v, L, k, P) {
      for (L = 2 * L + 1; 0 < v--; ) {
        if (ns(a, u, p, L, k)) if (Ni(a, u, p, P)) xi(a, u, p);
        else {
          var R = a, O = u, Y = p, st = R[O - 2 * Y], B = R[O - Y], K = R[O + 0], tt = R[O + Y], pt = R[O + 2 * Y], it = 27 * (wt = Zo[1020 + 3 * (K - B) + Zo[1020 + st - tt]]) + 63 >> 7, gt = 18 * wt + 63 >> 7, wt = 9 * wt + 63 >> 7;
          R[O - 3 * Y] = Mr[255 + R[O - 3 * Y] + wt], R[O - 2 * Y] = Mr[255 + st + gt], R[O - Y] = Mr[255 + B + it], R[O + 0] = Mr[255 + K - it], R[O + Y] = Mr[255 + tt - gt], R[O + 2 * Y] = Mr[255 + pt - wt];
        }
        u += m;
      }
    }
    function On(a, u, p, m, v, L, k, P) {
      for (L = 2 * L + 1; 0 < v--; ) {
        if (ns(a, u, p, L, k)) if (Ni(a, u, p, P)) xi(a, u, p);
        else {
          var R = a, O = u, Y = p, st = R[O - Y], B = R[O + 0], K = R[O + Y], tt = Ba[112 + (4 + (pt = 3 * (B - st)) >> 3)], pt = Ba[112 + (pt + 3 >> 3)], it = tt + 1 >> 1;
          R[O - 2 * Y] = Mr[255 + R[O - 2 * Y] + it], R[O - Y] = Mr[255 + st + pt], R[O + 0] = Mr[255 + B - tt], R[O + Y] = Mr[255 + K - it];
        }
        u += m;
      }
    }
    function Ea(a, u, p, m, v, L) {
      Fn(a, u, p, 1, 16, m, v, L);
    }
    function Pa(a, u, p, m, v, L) {
      Fn(a, u, 1, p, 16, m, v, L);
    }
    function Si(a, u, p, m, v, L) {
      var k;
      for (k = 3; 0 < k; --k) On(a, u += 4 * p, p, 1, 16, m, v, L);
    }
    function Ca(a, u, p, m, v, L) {
      var k;
      for (k = 3; 0 < k; --k) On(a, u += 4, 1, p, 16, m, v, L);
    }
    function h(a, u, p, m, v, L, k, P) {
      Fn(a, u, v, 1, 8, L, k, P), Fn(p, m, v, 1, 8, L, k, P);
    }
    function w(a, u, p, m, v, L, k, P) {
      Fn(a, u, 1, v, 8, L, k, P), Fn(p, m, 1, v, 8, L, k, P);
    }
    function T(a, u, p, m, v, L, k, P) {
      On(a, u + 4 * v, v, 1, 8, L, k, P), On(p, m + 4 * v, v, 1, 8, L, k, P);
    }
    function W(a, u, p, m, v, L, k, P) {
      On(a, u + 4, 1, v, 8, L, k, P), On(p, m + 4, 1, v, 8, L, k, P);
    }
    function Z() {
      this.ba = new Se(), this.ec = [], this.cc = [], this.Mc = [], this.Dc = this.Nc = this.dc = this.fc = 0, this.Oa = new ve(), this.memory = 0, this.Ib = "OutputFunc", this.Jb = "OutputAlphaFunc", this.Nd = "OutputRowFunc";
    }
    function mt() {
      this.data = [], this.offset = this.kd = this.ha = this.w = 0, this.na = [], this.xa = this.gb = this.Ja = this.Sa = this.P = 0;
    }
    function _t() {
      this.nc = this.Ea = this.b = this.hc = 0, this.K = [], this.w = 0;
    }
    function It() {
      this.ua = 0, this.Wa = new ae(), this.vb = new ae(), this.md = this.xc = this.wc = 0, this.vc = [], this.Wb = 0, this.Ya = new at(), this.yc = new M();
    }
    function Bt() {
      this.xb = this.a = 0, this.l = new Qi(), this.ca = new Se(), this.V = [], this.Ba = 0, this.Ta = [], this.Ua = 0, this.m = new j(), this.Pb = 0, this.wd = new j(), this.Ma = this.$ = this.C = this.i = this.c = this.xd = 0, this.s = new It(), this.ab = 0, this.gc = c(4, _t), this.Oc = 0;
    }
    function Xt() {
      this.Lc = this.Z = this.$a = this.i = this.c = 0, this.l = new Qi(), this.ic = 0, this.ca = [], this.tb = 0, this.qd = null, this.rd = 0;
    }
    function Qt(a, u, p, m, v, L, k) {
      for (a = a == null ? 0 : a[u + 0], u = 0; u < k; ++u) v[L + u] = a + p[m + u] & 255, a = v[L + u];
    }
    function we(a, u, p, m, v, L, k) {
      var P;
      if (a == null) Qt(null, null, p, m, v, L, k);
      else for (P = 0; P < k; ++P) v[L + P] = a[u + P] + p[m + P] & 255;
    }
    function Te(a, u, p, m, v, L, k) {
      if (a == null) Qt(null, null, p, m, v, L, k);
      else {
        var P, R = a[u + 0], O = R, Y = R;
        for (P = 0; P < k; ++P) O = Y + (R = a[u + P]) - O, Y = p[m + P] + (-256 & O ? 0 > O ? 0 : 255 : O) & 255, O = R, v[L + P] = Y;
      }
    }
    function Qe(a, u, p, m) {
      var v = u.width, L = u.o;
      if (t(a != null && u != null), 0 > p || 0 >= m || p + m > L) return null;
      if (!a.Cc) {
        if (a.ga == null) {
          var k;
          if (a.ga = new Xt(), (k = a.ga == null) || (k = u.width * u.o, t(a.Gb.length == 0), a.Gb = s(k), a.Uc = 0, a.Gb == null ? k = 0 : (a.mb = a.Gb, a.nb = a.Uc, a.rc = null, k = 1), k = !k), !k) {
            k = a.ga;
            var P = a.Fa, R = a.P, O = a.qc, Y = a.mb, st = a.nb, B = R + 1, K = O - 1, tt = k.l;
            if (t(P != null && Y != null && u != null), ii[0] = null, ii[1] = Qt, ii[2] = we, ii[3] = Te, k.ca = Y, k.tb = st, k.c = u.width, k.i = u.height, t(0 < k.c && 0 < k.i), 1 >= O) u = 0;
            else if (k.$a = 3 & P[R + 0], k.Z = P[R + 0] >> 2 & 3, k.Lc = P[R + 0] >> 4 & 3, R = P[R + 0] >> 6 & 3, 0 > k.$a || 1 < k.$a || 4 <= k.Z || 1 < k.Lc || R) u = 0;
            else if (tt.put = Gt, tt.ac = gn, tt.bc = En, tt.ma = k, tt.width = u.width, tt.height = u.height, tt.Da = u.Da, tt.v = u.v, tt.va = u.va, tt.j = u.j, tt.o = u.o, k.$a) t: {
              t(k.$a == 1), u = mi();
              e: for (; ; ) {
                if (u == null) {
                  u = 0;
                  break t;
                }
                if (t(k != null), k.mc = u, u.c = k.c, u.i = k.i, u.l = k.l, u.l.ma = k, u.l.width = k.c, u.l.height = k.i, u.a = 0, ht(u.m, P, B, K), !bn(k.c, k.i, 1, u, null) || (u.ab == 1 && u.gc[0].hc == 3 && rn(u.s) ? (k.ic = 1, P = u.c * u.i, u.Ta = null, u.Ua = 0, u.V = s(P), u.Ba = 0, u.V == null ? (u.a = 1, u = 0) : u = 1) : (k.ic = 0, u = bi(u, k.c)), !u)) break e;
                u = 1;
                break t;
              }
              k.mc = null, u = 0;
            }
            else u = K >= k.c * k.i;
            k = !u;
          }
          if (k) return null;
          a.ga.Lc != 1 ? a.Ga = 0 : m = L - p;
        }
        t(a.ga != null), t(p + m <= L);
        t: {
          if (u = (P = a.ga).c, L = P.l.o, P.$a == 0) {
            if (B = a.rc, K = a.Vc, tt = a.Fa, R = a.P + 1 + p * u, O = a.mb, Y = a.nb + p * u, t(R <= a.P + a.qc), P.Z != 0) for (t(ii[P.Z] != null), k = 0; k < m; ++k) ii[P.Z](B, K, tt, R, O, Y, u), B = O, K = Y, Y += u, R += u;
            else for (k = 0; k < m; ++k) n(O, Y, tt, R, u), B = O, K = Y, Y += u, R += u;
            a.rc = B, a.Vc = K;
          } else {
            if (t(P.mc != null), u = p + m, t((k = P.mc) != null), t(u <= k.i), k.C >= u) u = 1;
            else if (P.ic || Kr(), P.ic) {
              P = k.V, B = k.Ba, K = k.c;
              var pt = k.i, it = (tt = 1, R = k.$ / K, O = k.$ % K, Y = k.m, st = k.s, k.$), gt = K * pt, wt = K * u, At = st.wc, yt = it < wt ? lr(st, O, R) : null;
              t(it <= gt), t(u <= pt), t(rn(st));
              e: for (; ; ) {
                for (; !Y.h && it < wt; ) {
                  if (O & At || (yt = lr(st, O, R)), t(yt != null), nt(Y), 256 > (pt = Me(yt.G[0], yt.H[0], Y))) P[B + it] = pt, ++it, ++O >= K && (O = 0, ++R <= u && !(R % 16) && nn(k, R));
                  else {
                    if (!(280 > pt)) {
                      tt = 0;
                      break e;
                    }
                    pt = Wr(pt - 256, Y);
                    var Mt, Ct = Me(yt.G[4], yt.H[4], Y);
                    if (nt(Y), !(it >= (Ct = Gr(K, Ct = Wr(Ct, Y))) && gt - it >= pt)) {
                      tt = 0;
                      break e;
                    }
                    for (Mt = 0; Mt < pt; ++Mt) P[B + it + Mt] = P[B + it + Mt - Ct];
                    for (it += pt, O += pt; O >= K; ) O -= K, ++R <= u && !(R % 16) && nn(k, R);
                    it < wt && O & At && (yt = lr(st, O, R));
                  }
                  t(Y.h == J(Y));
                }
                nn(k, R > u ? u : R);
                break e;
              }
              !tt || Y.h && it < gt ? (tt = 0, k.a = Y.h ? 5 : 3) : k.$ = it, u = tt;
            } else u = sn(k, k.V, k.Ba, k.c, k.i, u, Xi);
            if (!u) {
              m = 0;
              break t;
            }
          }
          p + m >= L && (a.Cc = 1), m = 1;
        }
        if (!m) return null;
        if (a.Cc && ((m = a.ga) != null && (m.mc = null), a.ga = null, 0 < a.Ga)) return alert("todo:WebPDequantizeLevels"), null;
      }
      return a.nb + p * v;
    }
    function Re(a, u, p, m, v, L) {
      for (; 0 < v--; ) {
        var k, P = a, R = u + (p ? 1 : 0), O = a, Y = u + (p ? 0 : 3);
        for (k = 0; k < m; ++k) {
          var st = O[Y + 4 * k];
          st != 255 && (st *= 32897, P[R + 4 * k + 0] = P[R + 4 * k + 0] * st >> 23, P[R + 4 * k + 1] = P[R + 4 * k + 1] * st >> 23, P[R + 4 * k + 2] = P[R + 4 * k + 2] * st >> 23);
        }
        u += L;
      }
    }
    function rr(a, u, p, m, v) {
      for (; 0 < m--; ) {
        var L;
        for (L = 0; L < p; ++L) {
          var k = a[u + 2 * L + 0], P = 15 & (O = a[u + 2 * L + 1]), R = 4369 * P, O = (240 & O | O >> 4) * R >> 16;
          a[u + 2 * L + 0] = (240 & k | k >> 4) * R >> 16 & 240 | (15 & k | k << 4) * R >> 16 >> 4 & 15, a[u + 2 * L + 1] = 240 & O | P;
        }
        u += v;
      }
    }
    function tr(a, u, p, m, v, L, k, P) {
      var R, O, Y = 255;
      for (O = 0; O < v; ++O) {
        for (R = 0; R < m; ++R) {
          var st = a[u + R];
          L[k + 4 * R] = st, Y &= st;
        }
        u += p, k += P;
      }
      return Y != 255;
    }
    function fr(a, u, p, m, v) {
      var L;
      for (L = 0; L < v; ++L) p[m + L] = a[u + L] >> 8;
    }
    function Kr() {
      Ws = Re, Yu = rr, Ku = tr, Xu = fr;
    }
    function Er(a, u, p) {
      I[a] = function(m, v, L, k, P, R, O, Y, st, B, K, tt, pt, it, gt, wt, At) {
        var yt, Mt = At - 1 >> 1, Ct = P[R + 0] | O[Y + 0] << 16, ue = st[B + 0] | K[tt + 0] << 16;
        t(m != null);
        var Ft = 3 * Ct + ue + 131074 >> 2;
        for (u(m[v + 0], 255 & Ft, Ft >> 16, pt, it), L != null && (Ft = 3 * ue + Ct + 131074 >> 2, u(L[k + 0], 255 & Ft, Ft >> 16, gt, wt)), yt = 1; yt <= Mt; ++yt) {
          var de = P[R + yt] | O[Y + yt] << 16, ir = st[B + yt] | K[tt + yt] << 16, le = Ct + de + ue + ir + 524296, Ot = le + 2 * (de + ue) >> 3;
          Ft = Ot + Ct >> 1, Ct = (le = le + 2 * (Ct + ir) >> 3) + de >> 1, u(m[v + 2 * yt - 1], 255 & Ft, Ft >> 16, pt, it + (2 * yt - 1) * p), u(m[v + 2 * yt - 0], 255 & Ct, Ct >> 16, pt, it + (2 * yt - 0) * p), L != null && (Ft = le + ue >> 1, Ct = Ot + ir >> 1, u(L[k + 2 * yt - 1], 255 & Ft, Ft >> 16, gt, wt + (2 * yt - 1) * p), u(L[k + 2 * yt + 0], 255 & Ct, Ct >> 16, gt, wt + (2 * yt + 0) * p)), Ct = de, ue = ir;
        }
        1 & At || (Ft = 3 * Ct + ue + 131074 >> 2, u(m[v + At - 1], 255 & Ft, Ft >> 16, pt, it + (At - 1) * p), L != null && (Ft = 3 * ue + Ct + 131074 >> 2, u(L[k + At - 1], 255 & Ft, Ft >> 16, gt, wt + (At - 1) * p)));
      };
    }
    function Ra() {
      Qr[Ta] = xd, Qr[Ma] = ol, Qr[rl] = Nd, Qr[Da] = cl, Qr[ja] = ul, Qr[Qo] = ll, Qr[nl] = Ld, Qr[tc] = ol, Qr[ec] = cl, Qr[qa] = ul, Qr[rc] = ll;
    }
    function is(a) {
      return a & -16384 ? 0 > a ? 0 : 255 : a >> Sd;
    }
    function ki(a, u) {
      return is((19077 * a >> 8) + (26149 * u >> 8) - 14234);
    }
    function Kn(a, u, p) {
      return is((19077 * a >> 8) - (6419 * u >> 8) - (13320 * p >> 8) + 8708);
    }
    function Ei(a, u) {
      return is((19077 * a >> 8) + (33050 * u >> 8) - 17685);
    }
    function Pi(a, u, p, m, v) {
      m[v + 0] = ki(a, p), m[v + 1] = Kn(a, u, p), m[v + 2] = Ei(a, u);
    }
    function Ci(a, u, p, m, v) {
      m[v + 0] = Ei(a, u), m[v + 1] = Kn(a, u, p), m[v + 2] = ki(a, p);
    }
    function mr(a, u, p, m, v) {
      var L = Kn(a, u, p);
      u = L << 3 & 224 | Ei(a, u) >> 3, m[v + 0] = 248 & ki(a, p) | L >> 5, m[v + 1] = u;
    }
    function Ri(a, u, p, m, v) {
      var L = 240 & Ei(a, u) | 15;
      m[v + 0] = 240 & ki(a, p) | Kn(a, u, p) >> 4, m[v + 1] = L;
    }
    function Ii(a, u, p, m, v) {
      m[v + 0] = 255, Pi(a, u, p, m, v + 1);
    }
    function Bs(a, u, p, m, v) {
      Ci(a, u, p, m, v), m[v + 3] = 255;
    }
    function Ts(a, u, p, m, v) {
      Pi(a, u, p, m, v), m[v + 3] = 255;
    }
    function De(a, u) {
      return 0 > a ? 0 : a > u ? u : a;
    }
    function Bn(a, u, p) {
      I[a] = function(m, v, L, k, P, R, O, Y, st) {
        for (var B = Y + (-2 & st) * p; Y != B; ) u(m[v + 0], L[k + 0], P[R + 0], O, Y), u(m[v + 1], L[k + 0], P[R + 0], O, Y + p), v += 2, ++k, ++R, Y += 2 * p;
        1 & st && u(m[v + 0], L[k + 0], P[R + 0], O, Y);
      };
    }
    function ss(a, u, p) {
      return p == 0 ? a == 0 ? u == 0 ? 6 : 5 : u == 0 ? 4 : 0 : p;
    }
    function Ia(a, u, p, m, v) {
      switch (a >>> 30) {
        case 3:
          Ti(u, p, m, v, 0);
          break;
        case 2:
          $r(u, p, m, v);
          break;
        case 1:
          ye(u, p, m, v);
      }
    }
    function Xr(a, u) {
      var p, m, v = u.M, L = u.Nb, k = a.oc, P = a.pc + 40, R = a.oc, O = a.pc + 584, Y = a.oc, st = a.pc + 600;
      for (p = 0; 16 > p; ++p) k[P + 32 * p - 1] = 129;
      for (p = 0; 8 > p; ++p) R[O + 32 * p - 1] = 129, Y[st + 32 * p - 1] = 129;
      for (0 < v ? k[P - 1 - 32] = R[O - 1 - 32] = Y[st - 1 - 32] = 129 : (i(k, P - 32 - 1, 127, 21), i(R, O - 32 - 1, 127, 9), i(Y, st - 32 - 1, 127, 9)), m = 0; m < a.za; ++m) {
        var B = u.ya[u.aa + m];
        if (0 < m) {
          for (p = -1; 16 > p; ++p) n(k, P + 32 * p - 4, k, P + 32 * p + 12, 4);
          for (p = -1; 8 > p; ++p) n(R, O + 32 * p - 4, R, O + 32 * p + 4, 4), n(Y, st + 32 * p - 4, Y, st + 32 * p + 4, 4);
        }
        var K = a.Gd, tt = a.Hd + m, pt = B.ad, it = B.Hc;
        if (0 < v && (n(k, P - 32, K[tt].y, 0, 16), n(R, O - 32, K[tt].f, 0, 8), n(Y, st - 32, K[tt].ea, 0, 8)), B.Za) {
          var gt = k, wt = P - 32 + 16;
          for (0 < v && (m >= a.za - 1 ? i(gt, wt, K[tt].y[15], 4) : n(gt, wt, K[tt + 1].y, 0, 4)), p = 0; 4 > p; p++) gt[wt + 128 + p] = gt[wt + 256 + p] = gt[wt + 384 + p] = gt[wt + 0 + p];
          for (p = 0; 16 > p; ++p, it <<= 2) gt = k, wt = P + hl[p], on[B.Ob[p]](gt, wt), Ia(it, pt, 16 * +p, gt, wt);
        } else if (gt = ss(m, v, B.Ob[0]), ni[gt](k, P), it != 0) for (p = 0; 16 > p; ++p, it <<= 2) Ia(it, pt, 16 * +p, k, P + hl[p]);
        for (p = B.Gc, gt = ss(m, v, B.Dd), Dn[gt](R, O), Dn[gt](Y, st), it = pt, gt = R, wt = O, 255 & (B = 0 | p) && (170 & B ? _n(it, 256, gt, wt) : ke(it, 256, gt, wt)), B = Y, it = st, 255 & (p >>= 8) && (170 & p ? _n(pt, 320, B, it) : ke(pt, 320, B, it)), v < a.Ub - 1 && (n(K[tt].y, 0, k, P + 480, 16), n(K[tt].f, 0, R, O + 224, 8), n(K[tt].ea, 0, Y, st + 224, 8)), p = 8 * L * a.B, K = a.sa, tt = a.ta + 16 * m + 16 * L * a.R, pt = a.qa, B = a.ra + 8 * m + p, it = a.Ha, gt = a.Ia + 8 * m + p, p = 0; 16 > p; ++p) n(K, tt + p * a.R, k, P + 32 * p, 16);
        for (p = 0; 8 > p; ++p) n(pt, B + p * a.B, R, O + 32 * p, 8), n(it, gt + p * a.B, Y, st + 32 * p, 8);
      }
    }
    function Fi(a, u, p, m, v, L, k, P, R) {
      var O = [0], Y = [0], st = 0, B = R != null ? R.kd : 0, K = R ?? new mt();
      if (a == null || 12 > p) return 7;
      K.data = a, K.w = u, K.ha = p, u = [u], p = [p], K.gb = [K.gb];
      t: {
        var tt = u, pt = p, it = K.gb;
        if (t(a != null), t(pt != null), t(it != null), it[0] = 0, 12 <= pt[0] && !e(a, tt[0], "RIFF")) {
          if (e(a, tt[0] + 8, "WEBP")) {
            it = 3;
            break t;
          }
          var gt = dt(a, tt[0] + 4);
          if (12 > gt || 4294967286 < gt) {
            it = 3;
            break t;
          }
          if (B && gt > pt[0] - 8) {
            it = 7;
            break t;
          }
          it[0] = gt, tt[0] += 12, pt[0] -= 12;
        }
        it = 0;
      }
      if (it != 0) return it;
      for (gt = 0 < K.gb[0], p = p[0]; ; ) {
        t: {
          var wt = a;
          pt = u, it = p;
          var At = O, yt = Y, Mt = tt = [0];
          if ((Ft = st = [st])[0] = 0, 8 > it[0]) it = 7;
          else {
            if (!e(wt, pt[0], "VP8X")) {
              if (dt(wt, pt[0] + 4) != 10) {
                it = 3;
                break t;
              }
              if (18 > it[0]) {
                it = 7;
                break t;
              }
              var Ct = dt(wt, pt[0] + 8), ue = 1 + Pt(wt, pt[0] + 12);
              if (2147483648 <= ue * (wt = 1 + Pt(wt, pt[0] + 15))) {
                it = 3;
                break t;
              }
              Mt != null && (Mt[0] = Ct), At != null && (At[0] = ue), yt != null && (yt[0] = wt), pt[0] += 18, it[0] -= 18, Ft[0] = 1;
            }
            it = 0;
          }
        }
        if (st = st[0], tt = tt[0], it != 0) return it;
        if (pt = !!(2 & tt), !gt && st) return 3;
        if (L != null && (L[0] = !!(16 & tt)), k != null && (k[0] = pt), P != null && (P[0] = 0), k = O[0], tt = Y[0], st && pt && R == null) {
          it = 0;
          break;
        }
        if (4 > p) {
          it = 7;
          break;
        }
        if (gt && st || !gt && !st && !e(a, u[0], "ALPH")) {
          p = [p], K.na = [K.na], K.P = [K.P], K.Sa = [K.Sa];
          t: {
            Ct = a, it = u, gt = p;
            var Ft = K.gb;
            At = K.na, yt = K.P, Mt = K.Sa, ue = 22, t(Ct != null), t(gt != null), wt = it[0];
            var de = gt[0];
            for (t(At != null), t(Mt != null), At[0] = null, yt[0] = null, Mt[0] = 0; ; ) {
              if (it[0] = wt, gt[0] = de, 8 > de) {
                it = 7;
                break t;
              }
              var ir = dt(Ct, wt + 4);
              if (4294967286 < ir) {
                it = 3;
                break t;
              }
              var le = 8 + ir + 1 & -2;
              if (ue += le, 0 < Ft && ue > Ft) {
                it = 3;
                break t;
              }
              if (!e(Ct, wt, "VP8 ") || !e(Ct, wt, "VP8L")) {
                it = 0;
                break t;
              }
              if (de[0] < le) {
                it = 7;
                break t;
              }
              e(Ct, wt, "ALPH") || (At[0] = Ct, yt[0] = wt + 8, Mt[0] = ir), wt += le, de -= le;
            }
          }
          if (p = p[0], K.na = K.na[0], K.P = K.P[0], K.Sa = K.Sa[0], it != 0) break;
        }
        p = [p], K.Ja = [K.Ja], K.xa = [K.xa];
        t: if (Ft = a, it = u, gt = p, At = K.gb[0], yt = K.Ja, Mt = K.xa, Ct = it[0], wt = !e(Ft, Ct, "VP8 "), ue = !e(Ft, Ct, "VP8L"), t(Ft != null), t(gt != null), t(yt != null), t(Mt != null), 8 > gt[0]) it = 7;
        else {
          if (wt || ue) {
            if (Ft = dt(Ft, Ct + 4), 12 <= At && Ft > At - 12) {
              it = 3;
              break t;
            }
            if (B && Ft > gt[0] - 8) {
              it = 7;
              break t;
            }
            yt[0] = Ft, it[0] += 8, gt[0] -= 8, Mt[0] = ue;
          } else Mt[0] = 5 <= gt[0] && Ft[Ct + 0] == 47 && !(Ft[Ct + 4] >> 5), yt[0] = gt[0];
          it = 0;
        }
        if (p = p[0], K.Ja = K.Ja[0], K.xa = K.xa[0], u = u[0], it != 0) break;
        if (4294967286 < K.Ja) return 3;
        if (P == null || pt || (P[0] = K.xa ? 2 : 1), k = [k], tt = [tt], K.xa) {
          if (5 > p) {
            it = 7;
            break;
          }
          P = k, B = tt, pt = L, a == null || 5 > p ? a = 0 : 5 <= p && a[u + 0] == 47 && !(a[u + 4] >> 5) ? (gt = [0], Ft = [0], At = [0], ht(yt = new j(), a, u, p), Pn(yt, gt, Ft, At) ? (P != null && (P[0] = gt[0]), B != null && (B[0] = Ft[0]), pt != null && (pt[0] = At[0]), a = 1) : a = 0) : a = 0;
        } else {
          if (10 > p) {
            it = 7;
            break;
          }
          P = tt, a == null || 10 > p || !Aa(a, u + 3, p - 3) ? a = 0 : (B = a[u + 0] | a[u + 1] << 8 | a[u + 2] << 16, pt = 16383 & (a[u + 7] << 8 | a[u + 6]), a = 16383 & (a[u + 9] << 8 | a[u + 8]), 1 & B || 3 < (B >> 1 & 7) || !(B >> 4 & 1) || B >> 5 >= K.Ja || !pt || !a ? a = 0 : (k && (k[0] = pt), P && (P[0] = a), a = 1));
        }
        if (!a || (k = k[0], tt = tt[0], st && (O[0] != k || Y[0] != tt))) return 3;
        R != null && (R[0] = K, R.offset = u - R.w, t(4294967286 > u - R.w), t(R.offset == R.ha - p));
        break;
      }
      return it == 0 || it == 7 && st && R == null ? (L != null && (L[0] |= K.na != null && 0 < K.na.length), m != null && (m[0] = k), v != null && (v[0] = tt), 0) : it;
    }
    function Ms(a, u, p) {
      var m = u.width, v = u.height, L = 0, k = 0, P = m, R = v;
      if (u.Da = a != null && 0 < a.Da, u.Da && (P = a.cd, R = a.bd, L = a.v, k = a.j, 11 > p || (L &= -2, k &= -2), 0 > L || 0 > k || 0 >= P || 0 >= R || L + P > m || k + R > v)) return 0;
      if (u.v = L, u.j = k, u.va = L + P, u.o = k + R, u.U = P, u.T = R, u.da = a != null && 0 < a.da, u.da) {
        if (!Vt(P, R, p = [a.ib], L = [a.hb])) return 0;
        u.ib = p[0], u.hb = L[0];
      }
      return u.ob = a != null && a.ob, u.Kb = a == null || !a.Sd, u.da && (u.ob = u.ib < 3 * m / 4 && u.hb < 3 * v / 4, u.Kb = 0), 1;
    }
    function Ds(a) {
      if (a == null) return 2;
      if (11 > a.S) {
        var u = a.f.RGBA;
        u.fb += (a.height - 1) * u.A, u.A = -u.A;
      } else u = a.f.kb, a = a.height, u.O += (a - 1) * u.fa, u.fa = -u.fa, u.N += (a - 1 >> 1) * u.Ab, u.Ab = -u.Ab, u.W += (a - 1 >> 1) * u.Db, u.Db = -u.Db, u.F != null && (u.J += (a - 1) * u.lb, u.lb = -u.lb);
      return 0;
    }
    function Xn(a, u, p, m) {
      if (m == null || 0 >= a || 0 >= u) return 2;
      if (p != null) {
        if (p.Da) {
          var v = p.cd, L = p.bd, k = -2 & p.v, P = -2 & p.j;
          if (0 > k || 0 > P || 0 >= v || 0 >= L || k + v > a || P + L > u) return 2;
          a = v, u = L;
        }
        if (p.da) {
          if (!Vt(a, u, v = [p.ib], L = [p.hb])) return 2;
          a = v[0], u = L[0];
        }
      }
      m.width = a, m.height = u;
      t: {
        var R = m.width, O = m.height;
        if (a = m.S, 0 >= R || 0 >= O || !(a >= Ta && 13 > a)) a = 2;
        else {
          if (0 >= m.Rd && m.sd == null) {
            k = L = v = u = 0;
            var Y = (P = R * dl[a]) * O;
            if (11 > a || (L = (O + 1) / 2 * (u = (R + 1) / 2), a == 12 && (k = (v = R) * O)), (O = s(Y + 2 * L + k)) == null) {
              a = 1;
              break t;
            }
            m.sd = O, 11 > a ? ((R = m.f.RGBA).eb = O, R.fb = 0, R.A = P, R.size = Y) : ((R = m.f.kb).y = O, R.O = 0, R.fa = P, R.Fd = Y, R.f = O, R.N = 0 + Y, R.Ab = u, R.Cd = L, R.ea = O, R.W = 0 + Y + L, R.Db = u, R.Ed = L, a == 12 && (R.F = O, R.J = 0 + Y + 2 * L), R.Tc = k, R.lb = v);
          }
          if (u = 1, v = m.S, L = m.width, k = m.height, v >= Ta && 13 > v) if (11 > v) a = m.f.RGBA, u &= (P = Math.abs(a.A)) * (k - 1) + L <= a.size, u &= P >= L * dl[v], u &= a.eb != null;
          else {
            a = m.f.kb, P = (L + 1) / 2, Y = (k + 1) / 2, R = Math.abs(a.fa), O = Math.abs(a.Ab);
            var st = Math.abs(a.Db), B = Math.abs(a.lb), K = B * (k - 1) + L;
            u &= R * (k - 1) + L <= a.Fd, u &= O * (Y - 1) + P <= a.Cd, u = (u &= st * (Y - 1) + P <= a.Ed) & R >= L & O >= P & st >= P, u &= a.y != null, u &= a.f != null, u &= a.ea != null, v == 12 && (u &= B >= L, u &= K <= a.Tc, u &= a.F != null);
          }
          else u = 0;
          a = u ? 0 : 2;
        }
      }
      return a != 0 || p != null && p.fd && (a = Ds(m)), a;
    }
    var Oi = 64, Br = [0, 1, 3, 7, 15, 31, 63, 127, 255, 511, 1023, 2047, 4095, 8191, 16383, 32767, 65535, 131071, 262143, 524287, 1048575, 2097151, 4194303, 8388607, 16777215], Tr = 24, $n = 32, Tn = 8, Zn = [0, 0, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7];
    kt("Predictor0", "PredictorAdd0"), I.Predictor0 = function() {
      return 4278190080;
    }, I.Predictor1 = function(a) {
      return a;
    }, I.Predictor2 = function(a, u, p) {
      return u[p + 0];
    }, I.Predictor3 = function(a, u, p) {
      return u[p + 1];
    }, I.Predictor4 = function(a, u, p) {
      return u[p - 1];
    }, I.Predictor5 = function(a, u, p) {
      return Ht(Ht(a, u[p + 1]), u[p + 0]);
    }, I.Predictor6 = function(a, u, p) {
      return Ht(a, u[p - 1]);
    }, I.Predictor7 = function(a, u, p) {
      return Ht(a, u[p + 0]);
    }, I.Predictor8 = function(a, u, p) {
      return Ht(u[p - 1], u[p + 0]);
    }, I.Predictor9 = function(a, u, p) {
      return Ht(u[p + 0], u[p + 1]);
    }, I.Predictor10 = function(a, u, p) {
      return Ht(Ht(a, u[p - 1]), Ht(u[p + 0], u[p + 1]));
    }, I.Predictor11 = function(a, u, p) {
      var m = u[p + 0];
      return 0 >= re(m >> 24 & 255, a >> 24 & 255, (u = u[p - 1]) >> 24 & 255) + re(m >> 16 & 255, a >> 16 & 255, u >> 16 & 255) + re(m >> 8 & 255, a >> 8 & 255, u >> 8 & 255) + re(255 & m, 255 & a, 255 & u) ? m : a;
    }, I.Predictor12 = function(a, u, p) {
      var m = u[p + 0];
      return (me((a >> 24 & 255) + (m >> 24 & 255) - ((u = u[p - 1]) >> 24 & 255)) << 24 | me((a >> 16 & 255) + (m >> 16 & 255) - (u >> 16 & 255)) << 16 | me((a >> 8 & 255) + (m >> 8 & 255) - (u >> 8 & 255)) << 8 | me((255 & a) + (255 & m) - (255 & u))) >>> 0;
    }, I.Predictor13 = function(a, u, p) {
      var m = u[p - 1];
      return (ee((a = Ht(a, u[p + 0])) >> 24 & 255, m >> 24 & 255) << 24 | ee(a >> 16 & 255, m >> 16 & 255) << 16 | ee(a >> 8 & 255, m >> 8 & 255) << 8 | ee(255 & a, 255 & m)) >>> 0;
    };
    var js = I.PredictorAdd0;
    I.PredictorAdd1 = Ne, kt("Predictor2", "PredictorAdd2"), kt("Predictor3", "PredictorAdd3"), kt("Predictor4", "PredictorAdd4"), kt("Predictor5", "PredictorAdd5"), kt("Predictor6", "PredictorAdd6"), kt("Predictor7", "PredictorAdd7"), kt("Predictor8", "PredictorAdd8"), kt("Predictor9", "PredictorAdd9"), kt("Predictor10", "PredictorAdd10"), kt("Predictor11", "PredictorAdd11"), kt("Predictor12", "PredictorAdd12"), kt("Predictor13", "PredictorAdd13");
    var as = I.PredictorAdd2;
    Ut("ColorIndexInverseTransform", "MapARGB", "32b", function(a) {
      return a >> 8 & 255;
    }, function(a) {
      return a;
    }), Ut("VP8LColorIndexInverseTransformAlpha", "MapAlpha", "8b", function(a) {
      return a;
    }, function(a) {
      return a >> 8 & 255;
    });
    var Ve, Fa = I.ColorIndexInverseTransform, vn = I.MapARGB, yn = I.VP8LColorIndexInverseTransformAlpha, qs = I.MapAlpha, Us = I.VP8LPredictorsAdd = [];
    Us.length = 16, (I.VP8LPredictors = []).length = 16, (I.VP8LPredictorsAdd_C = []).length = 16, (I.VP8LPredictors_C = []).length = 16;
    var zs, Hs, Qn, ti, ei, Bi, ri, Ti, $r, _n, ye, ke, We, nr, Mn, Vs, os, Oa, zu, Hu, Vu, Wu, Gu, Ju, Ws, Yu, Ku, Xu, $u = s(511), Zu = s(2041), Qu = s(225), tl = s(767), el = 0, Zo = Zu, Ba = Qu, Mr = tl, Zr = $u, Ta = 0, Ma = 1, rl = 2, Da = 3, ja = 4, Qo = 5, nl = 6, tc = 7, ec = 8, qa = 9, rc = 10, ud = [2, 3, 7], ld = [3, 3, 11], il = [280, 256, 256, 256, 40], fd = [0, 1, 1, 1, 0], hd = [17, 18, 0, 1, 2, 3, 4, 5, 16, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], dd = [24, 7, 23, 25, 40, 6, 39, 41, 22, 26, 38, 42, 56, 5, 55, 57, 21, 27, 54, 58, 37, 43, 72, 4, 71, 73, 20, 28, 53, 59, 70, 74, 36, 44, 88, 69, 75, 52, 60, 3, 87, 89, 19, 29, 86, 90, 35, 45, 68, 76, 85, 91, 51, 61, 104, 2, 103, 105, 18, 30, 102, 106, 34, 46, 84, 92, 67, 77, 101, 107, 50, 62, 120, 1, 119, 121, 83, 93, 17, 31, 100, 108, 66, 78, 118, 122, 33, 47, 117, 123, 49, 63, 99, 109, 82, 94, 0, 116, 124, 65, 79, 16, 32, 98, 110, 48, 115, 125, 81, 95, 64, 114, 126, 97, 111, 80, 113, 127, 96, 112], pd = [2954, 2956, 2958, 2962, 2970, 2986, 3018, 3082, 3212, 3468, 3980, 5004], gd = 8, nc = [4, 5, 6, 7, 8, 9, 10, 10, 11, 12, 13, 14, 15, 16, 17, 17, 18, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 25, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 91, 93, 95, 96, 98, 100, 101, 102, 104, 106, 108, 110, 112, 114, 116, 118, 122, 124, 126, 128, 130, 132, 134, 136, 138, 140, 143, 145, 148, 151, 154, 157], ic = [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 60, 62, 64, 66, 68, 70, 72, 74, 76, 78, 80, 82, 84, 86, 88, 90, 92, 94, 96, 98, 100, 102, 104, 106, 108, 110, 112, 114, 116, 119, 122, 125, 128, 131, 134, 137, 140, 143, 146, 149, 152, 155, 158, 161, 164, 167, 170, 173, 177, 181, 185, 189, 193, 197, 201, 205, 209, 213, 217, 221, 225, 229, 234, 239, 245, 249, 254, 259, 264, 269, 274, 279, 284], Gs = null, md = [[173, 148, 140, 0], [176, 155, 140, 135, 0], [180, 157, 141, 134, 130, 0], [254, 254, 243, 230, 196, 177, 153, 140, 133, 130, 129, 0]], bd = [0, 1, 4, 8, 5, 2, 3, 6, 9, 12, 13, 10, 7, 11, 14, 15], sl = [-0, 1, -1, 2, -2, 3, 4, 6, -3, 5, -4, -5, -6, 7, -7, 8, -8, -9], wd = [[[[128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]], [[253, 136, 254, 255, 228, 219, 128, 128, 128, 128, 128], [189, 129, 242, 255, 227, 213, 255, 219, 128, 128, 128], [106, 126, 227, 252, 214, 209, 255, 255, 128, 128, 128]], [[1, 98, 248, 255, 236, 226, 255, 255, 128, 128, 128], [181, 133, 238, 254, 221, 234, 255, 154, 128, 128, 128], [78, 134, 202, 247, 198, 180, 255, 219, 128, 128, 128]], [[1, 185, 249, 255, 243, 255, 128, 128, 128, 128, 128], [184, 150, 247, 255, 236, 224, 128, 128, 128, 128, 128], [77, 110, 216, 255, 236, 230, 128, 128, 128, 128, 128]], [[1, 101, 251, 255, 241, 255, 128, 128, 128, 128, 128], [170, 139, 241, 252, 236, 209, 255, 255, 128, 128, 128], [37, 116, 196, 243, 228, 255, 255, 255, 128, 128, 128]], [[1, 204, 254, 255, 245, 255, 128, 128, 128, 128, 128], [207, 160, 250, 255, 238, 128, 128, 128, 128, 128, 128], [102, 103, 231, 255, 211, 171, 128, 128, 128, 128, 128]], [[1, 152, 252, 255, 240, 255, 128, 128, 128, 128, 128], [177, 135, 243, 255, 234, 225, 128, 128, 128, 128, 128], [80, 129, 211, 255, 194, 224, 128, 128, 128, 128, 128]], [[1, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [246, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [255, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]]], [[[198, 35, 237, 223, 193, 187, 162, 160, 145, 155, 62], [131, 45, 198, 221, 172, 176, 220, 157, 252, 221, 1], [68, 47, 146, 208, 149, 167, 221, 162, 255, 223, 128]], [[1, 149, 241, 255, 221, 224, 255, 255, 128, 128, 128], [184, 141, 234, 253, 222, 220, 255, 199, 128, 128, 128], [81, 99, 181, 242, 176, 190, 249, 202, 255, 255, 128]], [[1, 129, 232, 253, 214, 197, 242, 196, 255, 255, 128], [99, 121, 210, 250, 201, 198, 255, 202, 128, 128, 128], [23, 91, 163, 242, 170, 187, 247, 210, 255, 255, 128]], [[1, 200, 246, 255, 234, 255, 128, 128, 128, 128, 128], [109, 178, 241, 255, 231, 245, 255, 255, 128, 128, 128], [44, 130, 201, 253, 205, 192, 255, 255, 128, 128, 128]], [[1, 132, 239, 251, 219, 209, 255, 165, 128, 128, 128], [94, 136, 225, 251, 218, 190, 255, 255, 128, 128, 128], [22, 100, 174, 245, 186, 161, 255, 199, 128, 128, 128]], [[1, 182, 249, 255, 232, 235, 128, 128, 128, 128, 128], [124, 143, 241, 255, 227, 234, 128, 128, 128, 128, 128], [35, 77, 181, 251, 193, 211, 255, 205, 128, 128, 128]], [[1, 157, 247, 255, 236, 231, 255, 255, 128, 128, 128], [121, 141, 235, 255, 225, 227, 255, 255, 128, 128, 128], [45, 99, 188, 251, 195, 217, 255, 224, 128, 128, 128]], [[1, 1, 251, 255, 213, 255, 128, 128, 128, 128, 128], [203, 1, 248, 255, 255, 128, 128, 128, 128, 128, 128], [137, 1, 177, 255, 224, 255, 128, 128, 128, 128, 128]]], [[[253, 9, 248, 251, 207, 208, 255, 192, 128, 128, 128], [175, 13, 224, 243, 193, 185, 249, 198, 255, 255, 128], [73, 17, 171, 221, 161, 179, 236, 167, 255, 234, 128]], [[1, 95, 247, 253, 212, 183, 255, 255, 128, 128, 128], [239, 90, 244, 250, 211, 209, 255, 255, 128, 128, 128], [155, 77, 195, 248, 188, 195, 255, 255, 128, 128, 128]], [[1, 24, 239, 251, 218, 219, 255, 205, 128, 128, 128], [201, 51, 219, 255, 196, 186, 128, 128, 128, 128, 128], [69, 46, 190, 239, 201, 218, 255, 228, 128, 128, 128]], [[1, 191, 251, 255, 255, 128, 128, 128, 128, 128, 128], [223, 165, 249, 255, 213, 255, 128, 128, 128, 128, 128], [141, 124, 248, 255, 255, 128, 128, 128, 128, 128, 128]], [[1, 16, 248, 255, 255, 128, 128, 128, 128, 128, 128], [190, 36, 230, 255, 236, 255, 128, 128, 128, 128, 128], [149, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[1, 226, 255, 128, 128, 128, 128, 128, 128, 128, 128], [247, 192, 255, 128, 128, 128, 128, 128, 128, 128, 128], [240, 128, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[1, 134, 252, 255, 255, 128, 128, 128, 128, 128, 128], [213, 62, 250, 255, 255, 128, 128, 128, 128, 128, 128], [55, 93, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]]], [[[202, 24, 213, 235, 186, 191, 220, 160, 240, 175, 255], [126, 38, 182, 232, 169, 184, 228, 174, 255, 187, 128], [61, 46, 138, 219, 151, 178, 240, 170, 255, 216, 128]], [[1, 112, 230, 250, 199, 191, 247, 159, 255, 255, 128], [166, 109, 228, 252, 211, 215, 255, 174, 128, 128, 128], [39, 77, 162, 232, 172, 180, 245, 178, 255, 255, 128]], [[1, 52, 220, 246, 198, 199, 249, 220, 255, 255, 128], [124, 74, 191, 243, 183, 193, 250, 221, 255, 255, 128], [24, 71, 130, 219, 154, 170, 243, 182, 255, 255, 128]], [[1, 182, 225, 249, 219, 240, 255, 224, 128, 128, 128], [149, 150, 226, 252, 216, 205, 255, 171, 128, 128, 128], [28, 108, 170, 242, 183, 194, 254, 223, 255, 255, 128]], [[1, 81, 230, 252, 204, 203, 255, 192, 128, 128, 128], [123, 102, 209, 247, 188, 196, 255, 233, 128, 128, 128], [20, 95, 153, 243, 164, 173, 255, 203, 128, 128, 128]], [[1, 222, 248, 255, 216, 213, 128, 128, 128, 128, 128], [168, 175, 246, 252, 235, 205, 255, 255, 128, 128, 128], [47, 116, 215, 255, 211, 212, 255, 255, 128, 128, 128]], [[1, 121, 236, 253, 212, 214, 255, 255, 128, 128, 128], [141, 84, 213, 252, 201, 202, 255, 219, 128, 128, 128], [42, 80, 160, 240, 162, 185, 255, 205, 128, 128, 128]], [[1, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [244, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [238, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128]]]], vd = [[[231, 120, 48, 89, 115, 113, 120, 152, 112], [152, 179, 64, 126, 170, 118, 46, 70, 95], [175, 69, 143, 80, 85, 82, 72, 155, 103], [56, 58, 10, 171, 218, 189, 17, 13, 152], [114, 26, 17, 163, 44, 195, 21, 10, 173], [121, 24, 80, 195, 26, 62, 44, 64, 85], [144, 71, 10, 38, 171, 213, 144, 34, 26], [170, 46, 55, 19, 136, 160, 33, 206, 71], [63, 20, 8, 114, 114, 208, 12, 9, 226], [81, 40, 11, 96, 182, 84, 29, 16, 36]], [[134, 183, 89, 137, 98, 101, 106, 165, 148], [72, 187, 100, 130, 157, 111, 32, 75, 80], [66, 102, 167, 99, 74, 62, 40, 234, 128], [41, 53, 9, 178, 241, 141, 26, 8, 107], [74, 43, 26, 146, 73, 166, 49, 23, 157], [65, 38, 105, 160, 51, 52, 31, 115, 128], [104, 79, 12, 27, 217, 255, 87, 17, 7], [87, 68, 71, 44, 114, 51, 15, 186, 23], [47, 41, 14, 110, 182, 183, 21, 17, 194], [66, 45, 25, 102, 197, 189, 23, 18, 22]], [[88, 88, 147, 150, 42, 46, 45, 196, 205], [43, 97, 183, 117, 85, 38, 35, 179, 61], [39, 53, 200, 87, 26, 21, 43, 232, 171], [56, 34, 51, 104, 114, 102, 29, 93, 77], [39, 28, 85, 171, 58, 165, 90, 98, 64], [34, 22, 116, 206, 23, 34, 43, 166, 73], [107, 54, 32, 26, 51, 1, 81, 43, 31], [68, 25, 106, 22, 64, 171, 36, 225, 114], [34, 19, 21, 102, 132, 188, 16, 76, 124], [62, 18, 78, 95, 85, 57, 50, 48, 51]], [[193, 101, 35, 159, 215, 111, 89, 46, 111], [60, 148, 31, 172, 219, 228, 21, 18, 111], [112, 113, 77, 85, 179, 255, 38, 120, 114], [40, 42, 1, 196, 245, 209, 10, 25, 109], [88, 43, 29, 140, 166, 213, 37, 43, 154], [61, 63, 30, 155, 67, 45, 68, 1, 209], [100, 80, 8, 43, 154, 1, 51, 26, 71], [142, 78, 78, 16, 255, 128, 34, 197, 171], [41, 40, 5, 102, 211, 183, 4, 1, 221], [51, 50, 17, 168, 209, 192, 23, 25, 82]], [[138, 31, 36, 171, 27, 166, 38, 44, 229], [67, 87, 58, 169, 82, 115, 26, 59, 179], [63, 59, 90, 180, 59, 166, 93, 73, 154], [40, 40, 21, 116, 143, 209, 34, 39, 175], [47, 15, 16, 183, 34, 223, 49, 45, 183], [46, 17, 33, 183, 6, 98, 15, 32, 183], [57, 46, 22, 24, 128, 1, 54, 17, 37], [65, 32, 73, 115, 28, 128, 23, 128, 205], [40, 3, 9, 115, 51, 192, 18, 6, 223], [87, 37, 9, 115, 59, 77, 64, 21, 47]], [[104, 55, 44, 218, 9, 54, 53, 130, 226], [64, 90, 70, 205, 40, 41, 23, 26, 57], [54, 57, 112, 184, 5, 41, 38, 166, 213], [30, 34, 26, 133, 152, 116, 10, 32, 134], [39, 19, 53, 221, 26, 114, 32, 73, 255], [31, 9, 65, 234, 2, 15, 1, 118, 73], [75, 32, 12, 51, 192, 255, 160, 43, 51], [88, 31, 35, 67, 102, 85, 55, 186, 85], [56, 21, 23, 111, 59, 205, 45, 37, 192], [55, 38, 70, 124, 73, 102, 1, 34, 98]], [[125, 98, 42, 88, 104, 85, 117, 175, 82], [95, 84, 53, 89, 128, 100, 113, 101, 45], [75, 79, 123, 47, 51, 128, 81, 171, 1], [57, 17, 5, 71, 102, 57, 53, 41, 49], [38, 33, 13, 121, 57, 73, 26, 1, 85], [41, 10, 67, 138, 77, 110, 90, 47, 114], [115, 21, 2, 10, 102, 255, 166, 23, 6], [101, 29, 16, 10, 85, 128, 101, 196, 26], [57, 18, 10, 102, 102, 213, 34, 20, 43], [117, 20, 15, 36, 163, 128, 68, 1, 26]], [[102, 61, 71, 37, 34, 53, 31, 243, 192], [69, 60, 71, 38, 73, 119, 28, 222, 37], [68, 45, 128, 34, 1, 47, 11, 245, 171], [62, 17, 19, 70, 146, 85, 55, 62, 70], [37, 43, 37, 154, 100, 163, 85, 160, 1], [63, 9, 92, 136, 28, 64, 32, 201, 85], [75, 15, 9, 9, 64, 255, 184, 119, 16], [86, 6, 28, 5, 64, 255, 25, 248, 1], [56, 8, 17, 132, 137, 255, 55, 116, 128], [58, 15, 20, 82, 135, 57, 26, 121, 40]], [[164, 50, 31, 137, 154, 133, 25, 35, 218], [51, 103, 44, 131, 131, 123, 31, 6, 158], [86, 40, 64, 135, 148, 224, 45, 183, 128], [22, 26, 17, 131, 240, 154, 14, 1, 209], [45, 16, 21, 91, 64, 222, 7, 1, 197], [56, 21, 39, 155, 60, 138, 23, 102, 213], [83, 12, 13, 54, 192, 255, 68, 47, 28], [85, 26, 85, 85, 128, 128, 32, 146, 171], [18, 11, 7, 63, 144, 171, 4, 4, 246], [35, 27, 10, 146, 174, 171, 12, 26, 128]], [[190, 80, 35, 99, 180, 80, 126, 54, 45], [85, 126, 47, 87, 176, 51, 41, 20, 32], [101, 75, 128, 139, 118, 146, 116, 128, 85], [56, 41, 15, 176, 236, 85, 37, 9, 62], [71, 30, 17, 119, 118, 255, 17, 18, 138], [101, 38, 60, 138, 55, 70, 43, 26, 142], [146, 36, 19, 30, 171, 255, 97, 27, 20], [138, 45, 61, 62, 219, 1, 81, 188, 64], [32, 41, 20, 117, 151, 142, 20, 21, 163], [112, 19, 12, 61, 195, 128, 48, 4, 24]]], yd = [[[[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[176, 246, 255, 255, 255, 255, 255, 255, 255, 255, 255], [223, 241, 252, 255, 255, 255, 255, 255, 255, 255, 255], [249, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 244, 252, 255, 255, 255, 255, 255, 255, 255, 255], [234, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 246, 254, 255, 255, 255, 255, 255, 255, 255, 255], [239, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 248, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 253, 255, 254, 255, 255, 255, 255, 255, 255], [250, 255, 254, 255, 254, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[217, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [225, 252, 241, 253, 255, 255, 254, 255, 255, 255, 255], [234, 250, 241, 250, 253, 255, 253, 254, 255, 255, 255]], [[255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [223, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [238, 253, 254, 254, 255, 255, 255, 255, 255, 255, 255]], [[255, 248, 254, 255, 255, 255, 255, 255, 255, 255, 255], [249, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 255, 255, 255, 255, 255, 255, 255, 255, 255], [247, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [252, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 253, 255, 255, 255, 255, 255, 255, 255, 255], [250, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[186, 251, 250, 255, 255, 255, 255, 255, 255, 255, 255], [234, 251, 244, 254, 255, 255, 255, 255, 255, 255, 255], [251, 251, 243, 253, 254, 255, 254, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [236, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 253, 253, 254, 254, 255, 255, 255, 255, 255, 255]], [[255, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[248, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [250, 254, 252, 254, 255, 255, 255, 255, 255, 255, 255], [248, 254, 249, 253, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255], [246, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255], [252, 254, 251, 254, 254, 255, 255, 255, 255, 255, 255]], [[255, 254, 252, 255, 255, 255, 255, 255, 255, 255, 255], [248, 254, 253, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 254, 254, 255, 255, 255, 255, 255, 255, 255]], [[255, 251, 254, 255, 255, 255, 255, 255, 255, 255, 255], [245, 251, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 251, 253, 255, 255, 255, 255, 255, 255, 255, 255], [252, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 252, 255, 255, 255, 255, 255, 255, 255, 255, 255], [249, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 253, 255, 255, 255, 255, 255, 255, 255, 255], [250, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]]], _d = [0, 1, 2, 3, 6, 4, 5, 6, 6, 6, 6, 6, 6, 6, 6, 7, 0], ni = [], on = [], Dn = [], Ad = 1, al = 2, ii = [], Qr = [];
    Er("UpsampleRgbLinePair", Pi, 3), Er("UpsampleBgrLinePair", Ci, 3), Er("UpsampleRgbaLinePair", Ts, 4), Er("UpsampleBgraLinePair", Bs, 4), Er("UpsampleArgbLinePair", Ii, 4), Er("UpsampleRgba4444LinePair", Ri, 2), Er("UpsampleRgb565LinePair", mr, 2);
    var xd = I.UpsampleRgbLinePair, Nd = I.UpsampleBgrLinePair, ol = I.UpsampleRgbaLinePair, cl = I.UpsampleBgraLinePair, ul = I.UpsampleArgbLinePair, ll = I.UpsampleRgba4444LinePair, Ld = I.UpsampleRgb565LinePair, Ua = 16, za = 1 << Ua - 1, Js = -227, sc = 482, Sd = 6, fl = 0, kd = s(256), Ed = s(256), Pd = s(256), Cd = s(256), Rd = s(sc - Js), Id = s(sc - Js);
    Bn("YuvToRgbRow", Pi, 3), Bn("YuvToBgrRow", Ci, 3), Bn("YuvToRgbaRow", Ts, 4), Bn("YuvToBgraRow", Bs, 4), Bn("YuvToArgbRow", Ii, 4), Bn("YuvToRgba4444Row", Ri, 2), Bn("YuvToRgb565Row", mr, 2);
    var hl = [0, 4, 8, 12, 128, 132, 136, 140, 256, 260, 264, 268, 384, 388, 392, 396], Ha = [0, 2, 8], Fd = [8, 7, 6, 4, 4, 2, 2, 2, 1, 1, 1, 1], Od = 1;
    this.WebPDecodeRGBA = function(a, u, p, m, v) {
      var L = Ma, k = new Z(), P = new Se();
      k.ba = P, P.S = L, P.width = [P.width], P.height = [P.height];
      var R = P.width, O = P.height, Y = new $t();
      if (Y == null || a == null) var st = 2;
      else t(Y != null), st = Fi(a, u, p, Y.width, Y.height, Y.Pd, Y.Qd, Y.format, null);
      if (st != 0 ? R = 0 : (R != null && (R[0] = Y.width[0]), O != null && (O[0] = Y.height[0]), R = 1), R) {
        P.width = P.width[0], P.height = P.height[0], m != null && (m[0] = P.width), v != null && (v[0] = P.height);
        t: {
          if (m = new Qi(), (v = new mt()).data = a, v.w = u, v.ha = p, v.kd = 1, u = [0], t(v != null), ((a = Fi(v.data, v.w, v.ha, null, null, null, u, null, v)) == 0 || a == 7) && u[0] && (a = 4), (u = a) == 0) {
            if (t(k != null), m.data = v.data, m.w = v.w + v.offset, m.ha = v.ha - v.offset, m.put = Gt, m.ac = gn, m.bc = En, m.ma = k, v.xa) {
              if ((a = mi()) == null) {
                k = 1;
                break t;
              }
              if ((function(B, K) {
                var tt = [0], pt = [0], it = [0];
                e: for (; ; ) {
                  if (B == null) return 0;
                  if (K == null) return B.a = 2, 0;
                  if (B.l = K, B.a = 0, ht(B.m, K.data, K.w, K.ha), !Pn(B.m, tt, pt, it)) {
                    B.a = 3;
                    break e;
                  }
                  if (B.xb = al, K.width = tt[0], K.height = pt[0], !bn(tt[0], pt[0], 1, B, null)) break e;
                  return 1;
                }
                return t(B.a != 0), 0;
              })(a, m)) {
                if (m = (u = Xn(m.width, m.height, k.Oa, k.ba)) == 0) {
                  e: {
                    m = a;
                    r: for (; ; ) {
                      if (m == null) {
                        m = 0;
                        break e;
                      }
                      if (t(m.s.yc != null), t(m.s.Ya != null), t(0 < m.s.Wb), t((p = m.l) != null), t((v = p.ma) != null), m.xb != 0) {
                        if (m.ca = v.ba, m.tb = v.tb, t(m.ca != null), !Ms(v.Oa, p, Da)) {
                          m.a = 2;
                          break r;
                        }
                        if (!bi(m, p.width) || p.da) break r;
                        if ((p.da || ie(m.ca.S)) && Kr(), 11 > m.ca.S || (alert("todo:WebPInitConvertARGBToYUV"), m.ca.f.kb.F != null && Kr()), m.Pb && 0 < m.s.ua && m.s.vb.X == null && !U(m.s.vb, m.s.Wa.Xa)) {
                          m.a = 1;
                          break r;
                        }
                        m.xb = 0;
                      }
                      if (!sn(m, m.V, m.Ba, m.c, m.i, p.o, Gn)) break r;
                      v.Dc = m.Ma, m = 1;
                      break e;
                    }
                    t(m.a != 0), m = 0;
                  }
                  m = !m;
                }
                m && (u = a.a);
              } else u = a.a;
            } else {
              if ((a = new Mo()) == null) {
                k = 1;
                break t;
              }
              if (a.Fa = v.na, a.P = v.P, a.qc = v.Sa, xa(a, m)) {
                if ((u = Xn(m.width, m.height, k.Oa, k.ba)) == 0) {
                  if (a.Aa = 0, p = k.Oa, t((v = a) != null), p != null) {
                    if (0 < (R = 0 > (R = p.Md) ? 0 : 100 < R ? 255 : 255 * R / 100)) {
                      for (O = Y = 0; 4 > O; ++O) 12 > (st = v.pb[O]).lc && (st.ia = R * Fd[0 > st.lc ? 0 : st.lc] >> 3), Y |= st.ia;
                      Y && (alert("todo:VP8InitRandom"), v.ia = 1);
                    }
                    v.Ga = p.Id, 100 < v.Ga ? v.Ga = 100 : 0 > v.Ga && (v.Ga = 0);
                  }
                  (function(B, K) {
                    if (B == null) return 0;
                    if (K == null) return Ze(B, 2, "NULL VP8Io parameter in VP8Decode().");
                    if (!B.cb && !xa(B, K)) return 0;
                    if (t(B.cb), K.ac == null || K.ac(K)) {
                      K.ob && (B.L = 0);
                      var tt = Ha[B.L];
                      if (B.L == 2 ? (B.yb = 0, B.zb = 0) : (B.yb = K.v - tt >> 4, B.zb = K.j - tt >> 4, 0 > B.yb && (B.yb = 0), 0 > B.zb && (B.zb = 0)), B.Va = K.o + 15 + tt >> 4, B.Hb = K.va + 15 + tt >> 4, B.Hb > B.za && (B.Hb = B.za), B.Va > B.Ub && (B.Va = B.Ub), 0 < B.L) {
                        var pt = B.ed;
                        for (tt = 0; 4 > tt; ++tt) {
                          var it;
                          if (B.Qa.Cb) {
                            var gt = B.Qa.Lb[tt];
                            B.Qa.Fb || (gt += pt.Tb);
                          } else gt = pt.Tb;
                          for (it = 0; 1 >= it; ++it) {
                            var wt = B.gd[tt][it], At = gt;
                            if (pt.Pc && (At += pt.vd[0], it && (At += pt.od[0])), 0 < (At = 0 > At ? 0 : 63 < At ? 63 : At)) {
                              var yt = At;
                              0 < pt.wb && (yt = 4 < pt.wb ? yt >> 2 : yt >> 1) > 9 - pt.wb && (yt = 9 - pt.wb), 1 > yt && (yt = 1), wt.dd = yt, wt.tc = 2 * At + yt, wt.ld = 40 <= At ? 2 : 15 <= At ? 1 : 0;
                            } else wt.tc = 0;
                            wt.La = it;
                          }
                        }
                      }
                      tt = 0;
                    } else Ze(B, 6, "Frame setup failed"), tt = B.a;
                    if (tt = tt == 0) {
                      if (tt) {
                        B.$c = 0, 0 < B.Aa || (B.Ic = Od);
                        e: {
                          tt = B.Ic, pt = 4 * (yt = B.za);
                          var Mt = 32 * yt, Ct = yt + 1, ue = 0 < B.L ? yt * (0 < B.Aa ? 2 : 1) : 0, Ft = (B.Aa == 2 ? 2 : 1) * yt;
                          if ((wt = pt + 832 + (it = 3 * (16 * tt + Ha[B.L]) / 2 * Mt) + (gt = B.Fa != null && 0 < B.Fa.length ? B.Kc.c * B.Kc.i : 0)) != wt) tt = 0;
                          else {
                            if (wt > B.Vb) {
                              if (B.Vb = 0, B.Ec = s(wt), B.Fc = 0, B.Ec == null) {
                                tt = Ze(B, 1, "no memory during frame initialization.");
                                break e;
                              }
                              B.Vb = wt;
                            }
                            wt = B.Ec, At = B.Fc, B.Ac = wt, B.Bc = At, At += pt, B.Gd = c(Mt, ya), B.Hd = 0, B.rb = c(Ct + 1, Ns), B.sb = 1, B.wa = ue ? c(ue, Yr) : null, B.Y = 0, B.D.Nb = 0, B.D.wa = B.wa, B.D.Y = B.Y, 0 < B.Aa && (B.D.Y += yt), t(!0), B.oc = wt, B.pc = At, At += 832, B.ya = c(Ft, Ls), B.aa = 0, B.D.ya = B.ya, B.D.aa = B.aa, B.Aa == 2 && (B.D.aa += yt), B.R = 16 * yt, B.B = 8 * yt, yt = (Mt = Ha[B.L]) * B.R, Mt = Mt / 2 * B.B, B.sa = wt, B.ta = At + yt, B.qa = B.sa, B.ra = B.ta + 16 * tt * B.R + Mt, B.Ha = B.qa, B.Ia = B.ra + 8 * tt * B.B + Mt, B.$c = 0, At += it, B.mb = gt ? wt : null, B.nb = gt ? At : null, t(At + gt <= B.Fc + B.Vb), wi(B), i(B.Ac, B.Bc, 0, pt), tt = 1;
                          }
                        }
                        if (tt) {
                          if (K.ka = 0, K.y = B.sa, K.O = B.ta, K.f = B.qa, K.N = B.ra, K.ea = B.Ha, K.Vd = B.Ia, K.fa = B.R, K.Rc = B.B, K.F = null, K.J = 0, !el) {
                            for (tt = -255; 255 >= tt; ++tt) $u[255 + tt] = 0 > tt ? -tt : tt;
                            for (tt = -1020; 1020 >= tt; ++tt) Zu[1020 + tt] = -128 > tt ? -128 : 127 < tt ? 127 : tt;
                            for (tt = -112; 112 >= tt; ++tt) Qu[112 + tt] = -16 > tt ? -16 : 15 < tt ? 15 : tt;
                            for (tt = -255; 510 >= tt; ++tt) tl[255 + tt] = 0 > tt ? 0 : 255 < tt ? 255 : tt;
                            el = 1;
                          }
                          ri = La, Ti = jo, _n = qo, ye = wn, ke = Na, $r = Do, We = Ea, nr = Pa, Mn = h, Vs = w, os = Si, Oa = Ca, zu = T, Hu = W, Vu = Os, Wu = Li, Gu = Sa, Ju = ka, on[0] = Jo, on[1] = ks, on[2] = Wo, on[3] = Go, on[4] = Yo, on[5] = In, on[6] = Rn, on[7] = Ko, on[8] = ts, on[9] = Xo, ni[0] = Yn, ni[1] = zo, ni[2] = Ho, ni[3] = Es, ni[4] = Vo, ni[5] = _i, ni[6] = Ps, Dn[0] = rs, Dn[1] = Uo, Dn[2] = Cs, Dn[3] = Ai, Dn[4] = Rs, Dn[5] = $o, Dn[6] = Is, tt = 1;
                        } else tt = 0;
                      }
                      tt && (tt = (function(de, ir) {
                        for (de.M = 0; de.M < de.Va; ++de.M) {
                          var le, Ot = de.Jc[de.M & de.Xb], St = de.m, Ge = de;
                          for (le = 0; le < Ge.za; ++le) {
                            var se = St, pe = Ge, Fe = pe.Ac, hr = pe.Bc + 4 * le, Nr = pe.zc, je = pe.ya[pe.aa + le];
                            if (pe.Qa.Bb ? je.$b = bt(se, pe.Pa.jb[0]) ? 2 + bt(se, pe.Pa.jb[2]) : bt(se, pe.Pa.jb[1]) : je.$b = 0, pe.kc && (je.Ad = bt(se, pe.Bd)), je.Za = !bt(se, 145) + 0, je.Za) {
                              var br = je.Ob, Lr = 0;
                              for (pe = 0; 4 > pe; ++pe) {
                                var sr, ge = Nr[0 + pe];
                                for (sr = 0; 4 > sr; ++sr) {
                                  ge = vd[Fe[hr + sr]][ge];
                                  for (var _e = sl[bt(se, ge[0])]; 0 < _e; ) _e = sl[2 * _e + bt(se, ge[_e])];
                                  ge = -_e, Fe[hr + sr] = ge;
                                }
                                n(br, Lr, Fe, hr, 4), Lr += 4, Nr[0 + pe] = ge;
                              }
                            } else ge = bt(se, 156) ? bt(se, 128) ? 1 : 3 : bt(se, 163) ? 2 : 0, je.Ob[0] = ge, i(Fe, hr, ge, 4), i(Nr, 0, ge, 4);
                            je.Dd = bt(se, 142) ? bt(se, 114) ? bt(se, 183) ? 1 : 3 : 2 : 0;
                          }
                          if (Ge.m.Ka) return Ze(de, 7, "Premature end-of-partition0 encountered.");
                          for (; de.ja < de.za; ++de.ja) {
                            if (Ge = Ot, se = (St = de).rb[St.sb - 1], Fe = St.rb[St.sb + St.ja], le = St.ya[St.aa + St.ja], hr = St.kc ? le.Ad : 0) se.la = Fe.la = 0, le.Za || (se.Na = Fe.Na = 0), le.Hc = 0, le.Gc = 0, le.ia = 0;
                            else {
                              var qe, Ae;
                              if (se = Fe, Fe = Ge, hr = St.Pa.Xc, Nr = St.ya[St.aa + St.ja], je = St.pb[Nr.$b], pe = Nr.ad, br = 0, Lr = St.rb[St.sb - 1], ge = sr = 0, i(pe, br, 0, 384), Nr.Za) var dr = 0, cn = hr[3];
                              else {
                                _e = s(16);
                                var Je = se.Na + Lr.Na;
                                if (Je = Gs(Fe, hr[1], Je, je.Eb, 0, _e, 0), se.Na = Lr.Na = (0 < Je) + 0, 1 < Je) ri(_e, 0, pe, br);
                                else {
                                  var Pr = _e[0] + 3 >> 3;
                                  for (_e = 0; 256 > _e; _e += 16) pe[br + _e] = Pr;
                                }
                                dr = 1, cn = hr[0];
                              }
                              var Ee = 15 & se.la, ar = 15 & Lr.la;
                              for (_e = 0; 4 > _e; ++_e) {
                                var Dr = 1 & ar;
                                for (Pr = Ae = 0; 4 > Pr; ++Pr) Ee = Ee >> 1 | (Dr = (Je = Gs(Fe, cn, Je = Dr + (1 & Ee), je.Sc, dr, pe, br)) > dr) << 7, Ae = Ae << 2 | (3 < Je ? 3 : 1 < Je ? 2 : pe[br + 0] != 0), br += 16;
                                Ee >>= 4, ar = ar >> 1 | Dr << 7, sr = (sr << 8 | Ae) >>> 0;
                              }
                              for (cn = Ee, dr = ar >> 4, qe = 0; 4 > qe; qe += 2) {
                                for (Ae = 0, Ee = se.la >> 4 + qe, ar = Lr.la >> 4 + qe, _e = 0; 2 > _e; ++_e) {
                                  for (Dr = 1 & ar, Pr = 0; 2 > Pr; ++Pr) Je = Dr + (1 & Ee), Ee = Ee >> 1 | (Dr = 0 < (Je = Gs(Fe, hr[2], Je, je.Qc, 0, pe, br))) << 3, Ae = Ae << 2 | (3 < Je ? 3 : 1 < Je ? 2 : pe[br + 0] != 0), br += 16;
                                  Ee >>= 2, ar = ar >> 1 | Dr << 5;
                                }
                                ge |= Ae << 4 * qe, cn |= Ee << 4 << qe, dr |= (240 & ar) << qe;
                              }
                              se.la = cn, Lr.la = dr, Nr.Hc = sr, Nr.Gc = ge, Nr.ia = 43690 & ge ? 0 : je.ia, hr = !(sr | ge);
                            }
                            if (0 < St.L && (St.wa[St.Y + St.ja] = St.gd[le.$b][le.Za], St.wa[St.Y + St.ja].La |= !hr), Ge.Ka) return Ze(de, 7, "Premature end-of-file encountered.");
                          }
                          if (wi(de), St = ir, Ge = 1, le = (Ot = de).D, se = 0 < Ot.L && Ot.M >= Ot.zb && Ot.M <= Ot.Va, Ot.Aa == 0) e: {
                            if (le.M = Ot.M, le.uc = se, Xr(Ot, le), Ge = 1, le = (Ae = Ot.D).Nb, se = (ge = Ha[Ot.L]) * Ot.R, Fe = ge / 2 * Ot.B, _e = 16 * le * Ot.R, Pr = 8 * le * Ot.B, hr = Ot.sa, Nr = Ot.ta - se + _e, je = Ot.qa, pe = Ot.ra - Fe + Pr, br = Ot.Ha, Lr = Ot.Ia - Fe + Pr, ar = (Ee = Ae.M) == 0, sr = Ee >= Ot.Va - 1, Ot.Aa == 2 && Xr(Ot, Ae), Ae.uc) for (Dr = (Je = Ot).D.M, t(Je.D.uc), Ae = Je.yb; Ae < Je.Hb; ++Ae) {
                              dr = Ae, cn = Dr;
                              var Sr = (jr = (pr = Je).D).Nb;
                              qe = pr.R;
                              var jr = jr.wa[jr.Y + dr], qr = pr.sa, Cr = pr.ta + 16 * Sr * qe + 16 * dr, Ur = jr.dd, Ie = jr.tc;
                              if (Ie != 0) if (t(3 <= Ie), pr.L == 1) 0 < dr && Wu(qr, Cr, qe, Ie + 4), jr.La && Ju(qr, Cr, qe, Ie), 0 < cn && Vu(qr, Cr, qe, Ie + 4), jr.La && Gu(qr, Cr, qe, Ie);
                              else {
                                var zr = pr.B, un = pr.qa, Mi = pr.ra + 8 * Sr * zr + 8 * dr, jn = pr.Ha, pr = pr.Ia + 8 * Sr * zr + 8 * dr;
                                Sr = jr.ld, 0 < dr && (nr(qr, Cr, qe, Ie + 4, Ur, Sr), Vs(un, Mi, jn, pr, zr, Ie + 4, Ur, Sr)), jr.La && (Oa(qr, Cr, qe, Ie, Ur, Sr), Hu(un, Mi, jn, pr, zr, Ie, Ur, Sr)), 0 < cn && (We(qr, Cr, qe, Ie + 4, Ur, Sr), Mn(un, Mi, jn, pr, zr, Ie + 4, Ur, Sr)), jr.La && (os(qr, Cr, qe, Ie, Ur, Sr), zu(un, Mi, jn, pr, zr, Ie, Ur, Sr));
                              }
                            }
                            if (Ot.ia && alert("todo:DitherRow"), St.put != null) {
                              if (Ae = 16 * Ee, Ee = 16 * (Ee + 1), ar ? (St.y = Ot.sa, St.O = Ot.ta + _e, St.f = Ot.qa, St.N = Ot.ra + Pr, St.ea = Ot.Ha, St.W = Ot.Ia + Pr) : (Ae -= ge, St.y = hr, St.O = Nr, St.f = je, St.N = pe, St.ea = br, St.W = Lr), sr || (Ee -= ge), Ee > St.o && (Ee = St.o), St.F = null, St.J = null, Ot.Fa != null && 0 < Ot.Fa.length && Ae < Ee && (St.J = Qe(Ot, St, Ae, Ee - Ae), St.F = Ot.mb, St.F == null && St.F.length == 0)) {
                                Ge = Ze(Ot, 3, "Could not decode alpha data.");
                                break e;
                              }
                              Ae < St.j && (ge = St.j - Ae, Ae = St.j, t(!(1 & ge)), St.O += Ot.R * ge, St.N += Ot.B * (ge >> 1), St.W += Ot.B * (ge >> 1), St.F != null && (St.J += St.width * ge)), Ae < Ee && (St.O += St.v, St.N += St.v >> 1, St.W += St.v >> 1, St.F != null && (St.J += St.v), St.ka = Ae - St.j, St.U = St.va - St.v, St.T = Ee - Ae, Ge = St.put(St));
                            }
                            le + 1 != Ot.Ic || sr || (n(Ot.sa, Ot.ta - se, hr, Nr + 16 * Ot.R, se), n(Ot.qa, Ot.ra - Fe, je, pe + 8 * Ot.B, Fe), n(Ot.Ha, Ot.Ia - Fe, br, Lr + 8 * Ot.B, Fe));
                          }
                          if (!Ge) return Ze(de, 6, "Output aborted.");
                        }
                        return 1;
                      })(B, K)), K.bc != null && K.bc(K), tt &= 1;
                    }
                    return tt ? (B.cb = 0, tt) : 0;
                  })(a, m) || (u = a.a);
                }
              } else u = a.a;
            }
            u == 0 && k.Oa != null && k.Oa.fd && (u = Ds(k.ba));
          }
          k = u;
        }
        L = k != 0 ? null : 11 > L ? P.f.RGBA.eb : P.f.kb.y;
      } else L = null;
      return L;
    };
    var dl = [3, 4, 3, 4, 4, 2, 2, 4, 4, 4, 2, 1, 1];
  };
  function f(I, G) {
    for (var A = "", C = 0; C < 4; C++) A += String.fromCharCode(I[G++]);
    return A;
  }
  function d(I, G) {
    return I[G + 0] | I[G + 1] << 8;
  }
  function b(I, G) {
    return (I[G + 0] | I[G + 1] << 8 | I[G + 2] << 16) >>> 0;
  }
  function _(I, G) {
    return (I[G + 0] | I[G + 1] << 8 | I[G + 2] << 16 | I[G + 3] << 24) >>> 0;
  }
  new l();
  var g = [0], y = [0], x = [], E = new l(), N = r, H = (function(I, G) {
    var A = {}, C = 0, M = !1, D = 0, at = 0;
    if (A.frames = [], !/** @license
       * Copyright (c) 2017 Dominik Homberger
      Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
      The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
      THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
      https://webpjs.appspot.com
      WebPRiffParser dominikhlbg@gmail.com
      */
    (function(S, j) {
      for (var z = 0; z < 4; z++) if (S[j + z] != "RIFF".charCodeAt(z)) return !0;
      return !1;
    })(I, G)) {
      for (_(I, G += 4), G += 8; G < I.length; ) {
        var ot = f(I, G), ft = _(I, G += 4);
        G += 4;
        var rt = ft + (1 & ft);
        switch (ot) {
          case "VP8 ":
          case "VP8L":
            A.frames[C] === void 0 && (A.frames[C] = {}), (vt = A.frames[C]).src_off = M ? at : G - 8, vt.src_size = D + ft + 8, C++, M && (M = !1, D = 0, at = 0);
            break;
          case "VP8X":
            (vt = A.header = {}).feature_flags = I[G];
            var ht = G + 4;
            vt.canvas_width = 1 + b(I, ht), ht += 3, vt.canvas_height = 1 + b(I, ht), ht += 3;
            break;
          case "ALPH":
            M = !0, D = rt + 8, at = G - 8;
            break;
          case "ANIM":
            (vt = A.header).bgcolor = _(I, G), ht = G + 4, vt.loop_count = d(I, ht), ht += 2;
            break;
          case "ANMF":
            var Lt, vt;
            (vt = A.frames[C] = {}).offset_x = 2 * b(I, G), G += 3, vt.offset_y = 2 * b(I, G), G += 3, vt.width = 1 + b(I, G), G += 3, vt.height = 1 + b(I, G), G += 3, vt.duration = b(I, G), G += 3, Lt = I[G++], vt.dispose = 1 & Lt, vt.blend = Lt >> 1 & 1;
        }
        ot != "ANMF" && (G += rt);
      }
      return A;
    }
  })(N, 0);
  H.response = N, H.rgbaoutput = !0, H.dataurl = !1;
  var q = H.header ? H.header : null, F = H.frames ? H.frames : null;
  if (q) {
    q.loop_counter = q.loop_count, g = [q.canvas_height], y = [q.canvas_width];
    for (var et = 0; et < F.length && F[et].blend != 0; et++) ;
  }
  var Q = F[0], X = E.WebPDecodeRGBA(N, Q.src_off, Q.src_size, y, g);
  Q.rgba = X, Q.imgwidth = y[0], Q.imgheight = g[0];
  for (var V = 0; V < y[0] * g[0] * 4; V++) x[V] = X[V];
  return this.width = y, this.height = g, this.data = x, this;
}
(function(r) {
  var t, e, n, i, s, c, o, l, f, d = function(S) {
    return S = S || {}, this.isStrokeTransparent = S.isStrokeTransparent || !1, this.strokeOpacity = S.strokeOpacity || 1, this.strokeStyle = S.strokeStyle || "#000000", this.fillStyle = S.fillStyle || "#000000", this.isFillTransparent = S.isFillTransparent || !1, this.fillOpacity = S.fillOpacity || 1, this.font = S.font || "10px sans-serif", this.textBaseline = S.textBaseline || "alphabetic", this.textAlign = S.textAlign || "left", this.lineWidth = S.lineWidth || 1, this.lineJoin = S.lineJoin || "miter", this.lineCap = S.lineCap || "butt", this.path = S.path || [], this.transform = S.transform !== void 0 ? S.transform.clone() : new l(), this.globalCompositeOperation = S.globalCompositeOperation || "normal", this.globalAlpha = S.globalAlpha || 1, this.clip_path = S.clip_path || [], this.currentPoint = S.currentPoint || new c(), this.miterLimit = S.miterLimit || 10, this.lastPoint = S.lastPoint || new c(), this.lineDashOffset = S.lineDashOffset || 0, this.lineDash = S.lineDash || [], this.margin = S.margin || [0, 0, 0, 0], this.prevPageLastElemOffset = S.prevPageLastElemOffset || 0, this.ignoreClearRect = typeof S.ignoreClearRect != "boolean" || S.ignoreClearRect, this;
  };
  r.events.push(["initialized", function() {
    this.context2d = new b(this), t = this.internal.f2, e = this.internal.getCoordinateString, n = this.internal.getVerticalCoordinateString, i = this.internal.getHorizontalCoordinate, s = this.internal.getVerticalCoordinate, c = this.internal.Point, o = this.internal.Rectangle, l = this.internal.Matrix, f = new d();
  }]);
  var b = function(S) {
    Object.defineProperty(this, "canvas", { get: function() {
      return { parentNode: !1, style: !1 };
    } });
    var j = S;
    Object.defineProperty(this, "pdf", { get: function() {
      return j;
    } });
    var z = !1;
    Object.defineProperty(this, "pageWrapXEnabled", { get: function() {
      return z;
    }, set: function(dt) {
      z = !!dt;
    } });
    var J = !1;
    Object.defineProperty(this, "pageWrapYEnabled", { get: function() {
      return J;
    }, set: function(dt) {
      J = !!dt;
    } });
    var $ = 0;
    Object.defineProperty(this, "posX", { get: function() {
      return $;
    }, set: function(dt) {
      isNaN(dt) || ($ = dt);
    } });
    var nt = 0;
    Object.defineProperty(this, "posY", { get: function() {
      return nt;
    }, set: function(dt) {
      isNaN(dt) || (nt = dt);
    } }), Object.defineProperty(this, "margin", { get: function() {
      return f.margin;
    }, set: function(dt) {
      var U;
      typeof dt == "number" ? U = [dt, dt, dt, dt] : ((U = new Array(4))[0] = dt[0], U[1] = dt.length >= 2 ? dt[1] : U[0], U[2] = dt.length >= 3 ? dt[2] : U[0], U[3] = dt.length >= 4 ? dt[3] : U[1]), f.margin = U;
    } });
    var lt = !1;
    Object.defineProperty(this, "autoPaging", { get: function() {
      return lt;
    }, set: function(dt) {
      lt = dt;
    } });
    var ct = 0;
    Object.defineProperty(this, "lastBreak", { get: function() {
      return ct;
    }, set: function(dt) {
      ct = dt;
    } });
    var bt = [];
    Object.defineProperty(this, "pageBreaks", { get: function() {
      return bt;
    }, set: function(dt) {
      bt = dt;
    } }), Object.defineProperty(this, "ctx", { get: function() {
      return f;
    }, set: function(dt) {
      dt instanceof d && (f = dt);
    } }), Object.defineProperty(this, "path", { get: function() {
      return f.path;
    }, set: function(dt) {
      f.path = dt;
    } });
    var xt = [];
    Object.defineProperty(this, "ctxStack", { get: function() {
      return xt;
    }, set: function(dt) {
      xt = dt;
    } }), Object.defineProperty(this, "fillStyle", { get: function() {
      return this.ctx.fillStyle;
    }, set: function(dt) {
      var U;
      U = _(dt), this.ctx.fillStyle = U.style, this.ctx.isFillTransparent = U.a === 0, this.ctx.fillOpacity = U.a, this.pdf.setFillColor(U.r, U.g, U.b, { a: U.a }), this.pdf.setTextColor(U.r, U.g, U.b, { a: U.a });
    } }), Object.defineProperty(this, "strokeStyle", { get: function() {
      return this.ctx.strokeStyle;
    }, set: function(dt) {
      var U = _(dt);
      this.ctx.strokeStyle = U.style, this.ctx.isStrokeTransparent = U.a === 0, this.ctx.strokeOpacity = U.a, U.a === 0 ? this.pdf.setDrawColor(255, 255, 255) : (U.a, this.pdf.setDrawColor(U.r, U.g, U.b));
    } }), Object.defineProperty(this, "lineCap", { get: function() {
      return this.ctx.lineCap;
    }, set: function(dt) {
      ["butt", "round", "square"].indexOf(dt) !== -1 && (this.ctx.lineCap = dt, this.pdf.setLineCap(dt));
    } }), Object.defineProperty(this, "lineWidth", { get: function() {
      return this.ctx.lineWidth;
    }, set: function(dt) {
      isNaN(dt) || (this.ctx.lineWidth = dt, this.pdf.setLineWidth(dt));
    } }), Object.defineProperty(this, "lineJoin", { get: function() {
      return this.ctx.lineJoin;
    }, set: function(dt) {
      ["bevel", "round", "miter"].indexOf(dt) !== -1 && (this.ctx.lineJoin = dt, this.pdf.setLineJoin(dt));
    } }), Object.defineProperty(this, "miterLimit", { get: function() {
      return this.ctx.miterLimit;
    }, set: function(dt) {
      isNaN(dt) || (this.ctx.miterLimit = dt, this.pdf.setMiterLimit(dt));
    } }), Object.defineProperty(this, "textBaseline", { get: function() {
      return this.ctx.textBaseline;
    }, set: function(dt) {
      this.ctx.textBaseline = dt;
    } }), Object.defineProperty(this, "textAlign", { get: function() {
      return this.ctx.textAlign;
    }, set: function(dt) {
      ["right", "end", "center", "left", "start"].indexOf(dt) !== -1 && (this.ctx.textAlign = dt);
    } });
    var Et = null, Pt = null;
    Object.defineProperty(this, "fontFaces", { get: function() {
      return Pt;
    }, set: function(dt) {
      Et = null, Pt = dt;
    } }), Object.defineProperty(this, "font", { get: function() {
      return this.ctx.font;
    }, set: function(dt) {
      var U;
      if (this.ctx.font = dt, (U = /^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z]+?)\s*$/i.exec(dt)) !== null) {
        var fe = U[1];
        U[2];
        var ae = U[3], Vt = U[4];
        U[5];
        var Nt = U[6], jt = /^([.\d]+)((?:%|in|[cem]m|ex|p[ctx]))$/i.exec(Vt)[2];
        Vt = Math.floor(jt === "px" ? parseFloat(Vt) * this.pdf.internal.scaleFactor : jt === "em" ? parseFloat(Vt) * this.pdf.getFontSize() : parseFloat(Vt) * this.pdf.internal.scaleFactor), this.pdf.setFontSize(Vt);
        var kt = (function(Yt) {
          var Ut, Ce, be = [], Tt = Yt.trim();
          if (Tt === "") return Fc;
          if (Tt in Sf) return [Sf[Tt]];
          for (; Tt !== ""; ) {
            switch (Ce = null, Ut = (Tt = Ef(Tt)).charAt(0)) {
              case '"':
              case "'":
                Ce = B5(Tt.substring(1), Ut);
                break;
              default:
                Ce = T5(Tt);
            }
            if (Ce === null || (be.push(Ce[0]), (Tt = Ef(Ce[1])) !== "" && Tt.charAt(0) !== ",")) return Fc;
            Tt = Tt.replace(/^,/, "");
          }
          return be;
        })(Nt);
        if (this.fontFaces) {
          var oe = (function(Yt, Ut) {
            if (Et === null) {
              var Ce = (function(be) {
                var Tt = [];
                return Object.keys(be).forEach(function(ne) {
                  be[ne].forEach(function(Le) {
                    var Wt = null;
                    switch (Le) {
                      case "bold":
                        Wt = { family: ne, weight: "bold" };
                        break;
                      case "italic":
                        Wt = { family: ne, style: "italic" };
                        break;
                      case "bolditalic":
                        Wt = { family: ne, weight: "bold", style: "italic" };
                        break;
                      case "":
                      case "normal":
                        Wt = { family: ne };
                    }
                    Wt !== null && (Wt.ref = { name: ne, style: Le }, Tt.push(Wt));
                  });
                }), Tt;
              })(Yt.getFontList());
              Et = (function(be) {
                for (var Tt = {}, ne = 0; ne < be.length; ++ne) {
                  var Le = Ic(be[ne]), Wt = Le.family, he = Le.stretch, ie = Le.style, ze = Le.weight;
                  Tt[Wt] = Tt[Wt] || {}, Tt[Wt][he] = Tt[Wt][he] || {}, Tt[Wt][he][ie] = Tt[Wt][he][ie] || {}, Tt[Wt][he][ie][ze] = Le;
                }
                return Tt;
              })(Ce.concat(Ut));
            }
            return Et;
          })(this.pdf, this.fontFaces), Ht = kt.map(function(Yt) {
            return { family: Yt, stretch: "normal", weight: ae, style: fe };
          }), me = (function(Yt, Ut, Ce) {
            for (var be = (Ce = Ce || {}).defaultFontFamily || "times", Tt = Object.assign({}, O5, Ce.genericFontFamilies || {}), ne = null, Le = null, Wt = 0; Wt < Ut.length; ++Wt) if (Tt[(ne = Ic(Ut[Wt])).family] && (ne.family = Tt[ne.family]), Yt.hasOwnProperty(ne.family)) {
              Le = Yt[ne.family];
              break;
            }
            if (!(Le = Le || Yt[be])) throw new Error("Could not find a font-family for the rule '" + kf(ne) + "' and default family '" + be + "'.");
            if (Le = (function(he, ie) {
              if (ie[he]) return ie[he];
              var ze = _u[he], er = ze <= _u.normal ? -1 : 1, Se = Lf(ie, k1, ze, er);
              if (!Se) throw new Error("Could not find a matching font-stretch value for " + he);
              return Se;
            })(ne.stretch, Le), Le = (function(he, ie) {
              if (ie[he]) return ie[he];
              for (var ze = S1[he], er = 0; er < ze.length; ++er) if (ie[ze[er]]) return ie[ze[er]];
              throw new Error("Could not find a matching font-style for " + he);
            })(ne.style, Le), !(Le = (function(he, ie) {
              if (ie[he]) return ie[he];
              if (he === 400 && ie[500]) return ie[500];
              if (he === 500 && ie[400]) return ie[400];
              var ze = F5[he], er = Lf(ie, E1, ze, he < 400 ? -1 : 1);
              if (!er) throw new Error("Could not find a matching font-weight for value " + he);
              return er;
            })(ne.weight, Le))) throw new Error("Failed to resolve a font for the rule '" + kf(ne) + "'.");
            return Le;
          })(oe, Ht);
          this.pdf.setFont(me.ref.name, me.ref.style);
        } else {
          var ee = "";
          (ae === "bold" || parseInt(ae, 10) >= 700 || fe === "bold") && (ee = "bold"), fe === "italic" && (ee += "italic"), ee.length === 0 && (ee = "normal");
          for (var re = "", Ne = { arial: "Helvetica", Arial: "Helvetica", verdana: "Helvetica", Verdana: "Helvetica", helvetica: "Helvetica", Helvetica: "Helvetica", "sans-serif": "Helvetica", fixed: "Courier", monospace: "Courier", terminal: "Courier", cursive: "Times", fantasy: "Times", serif: "Times" }, ce = 0; ce < kt.length; ce++) {
            if (this.pdf.internal.getFont(kt[ce], ee, { noFallback: !0, disableWarning: !0 }) !== void 0) {
              re = kt[ce];
              break;
            }
            if (ee === "bolditalic" && this.pdf.internal.getFont(kt[ce], "bold", { noFallback: !0, disableWarning: !0 }) !== void 0) re = kt[ce], ee = "bold";
            else if (this.pdf.internal.getFont(kt[ce], "normal", { noFallback: !0, disableWarning: !0 }) !== void 0) {
              re = kt[ce], ee = "normal";
              break;
            }
          }
          if (re === "") {
            for (var qt = 0; qt < kt.length; qt++) if (Ne[kt[qt]]) {
              re = Ne[kt[qt]];
              break;
            }
          }
          re = re === "" ? "Times" : re, this.pdf.setFont(re, ee);
        }
      }
    } }), Object.defineProperty(this, "globalCompositeOperation", { get: function() {
      return this.ctx.globalCompositeOperation;
    }, set: function(dt) {
      this.ctx.globalCompositeOperation = dt;
    } }), Object.defineProperty(this, "globalAlpha", { get: function() {
      return this.ctx.globalAlpha;
    }, set: function(dt) {
      this.ctx.globalAlpha = dt;
    } }), Object.defineProperty(this, "lineDashOffset", { get: function() {
      return this.ctx.lineDashOffset;
    }, set: function(dt) {
      this.ctx.lineDashOffset = dt, vt.call(this);
    } }), Object.defineProperty(this, "lineDash", { get: function() {
      return this.ctx.lineDash;
    }, set: function(dt) {
      this.ctx.lineDash = dt, vt.call(this);
    } }), Object.defineProperty(this, "ignoreClearRect", { get: function() {
      return this.ctx.ignoreClearRect;
    }, set: function(dt) {
      this.ctx.ignoreClearRect = !!dt;
    } });
  };
  b.prototype.setLineDash = function(S) {
    this.lineDash = S;
  }, b.prototype.getLineDash = function() {
    return this.lineDash.length % 2 ? this.lineDash.concat(this.lineDash) : this.lineDash.slice();
  }, b.prototype.fill = function() {
    F.call(this, "fill", !1);
  }, b.prototype.stroke = function() {
    F.call(this, "stroke", !1);
  }, b.prototype.beginPath = function() {
    this.path = [{ type: "begin" }];
  }, b.prototype.moveTo = function(S, j) {
    if (isNaN(S) || isNaN(j)) throw Pe.error("jsPDF.context2d.moveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.moveTo");
    var z = this.ctx.transform.applyToPoint(new c(S, j));
    this.path.push({ type: "mt", x: z.x, y: z.y }), this.ctx.lastPoint = new c(S, j);
  }, b.prototype.closePath = function() {
    var S = new c(0, 0), j = 0;
    for (j = this.path.length - 1; j !== -1; j--) if (this.path[j].type === "begin" && xe(this.path[j + 1]) === "object" && typeof this.path[j + 1].x == "number") {
      S = new c(this.path[j + 1].x, this.path[j + 1].y);
      break;
    }
    this.path.push({ type: "close" }), this.ctx.lastPoint = new c(S.x, S.y);
  }, b.prototype.lineTo = function(S, j) {
    if (isNaN(S) || isNaN(j)) throw Pe.error("jsPDF.context2d.lineTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.lineTo");
    var z = this.ctx.transform.applyToPoint(new c(S, j));
    this.path.push({ type: "lt", x: z.x, y: z.y }), this.ctx.lastPoint = new c(z.x, z.y);
  }, b.prototype.clip = function() {
    this.ctx.clip_path = JSON.parse(JSON.stringify(this.path)), F.call(this, null, !0);
  }, b.prototype.quadraticCurveTo = function(S, j, z, J) {
    if (isNaN(z) || isNaN(J) || isNaN(S) || isNaN(j)) throw Pe.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");
    var $ = this.ctx.transform.applyToPoint(new c(z, J)), nt = this.ctx.transform.applyToPoint(new c(S, j));
    this.path.push({ type: "qct", x1: nt.x, y1: nt.y, x: $.x, y: $.y }), this.ctx.lastPoint = new c($.x, $.y);
  }, b.prototype.bezierCurveTo = function(S, j, z, J, $, nt) {
    if (isNaN($) || isNaN(nt) || isNaN(S) || isNaN(j) || isNaN(z) || isNaN(J)) throw Pe.error("jsPDF.context2d.bezierCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");
    var lt = this.ctx.transform.applyToPoint(new c($, nt)), ct = this.ctx.transform.applyToPoint(new c(S, j)), bt = this.ctx.transform.applyToPoint(new c(z, J));
    this.path.push({ type: "bct", x1: ct.x, y1: ct.y, x2: bt.x, y2: bt.y, x: lt.x, y: lt.y }), this.ctx.lastPoint = new c(lt.x, lt.y);
  }, b.prototype.arc = function(S, j, z, J, $, nt) {
    if (isNaN(S) || isNaN(j) || isNaN(z) || isNaN(J) || isNaN($)) throw Pe.error("jsPDF.context2d.arc: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.arc");
    if (nt = !!nt, !this.ctx.transform.isIdentity) {
      var lt = this.ctx.transform.applyToPoint(new c(S, j));
      S = lt.x, j = lt.y;
      var ct = this.ctx.transform.applyToPoint(new c(0, z)), bt = this.ctx.transform.applyToPoint(new c(0, 0));
      z = Math.sqrt(Math.pow(ct.x - bt.x, 2) + Math.pow(ct.y - bt.y, 2));
    }
    Math.abs($ - J) >= 2 * Math.PI && (J = 0, $ = 2 * Math.PI), this.path.push({ type: "arc", x: S, y: j, radius: z, startAngle: J, endAngle: $, counterclockwise: nt });
  }, b.prototype.arcTo = function(S, j, z, J, $) {
    throw new Error("arcTo not implemented.");
  }, b.prototype.rect = function(S, j, z, J) {
    if (isNaN(S) || isNaN(j) || isNaN(z) || isNaN(J)) throw Pe.error("jsPDF.context2d.rect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rect");
    this.moveTo(S, j), this.lineTo(S + z, j), this.lineTo(S + z, j + J), this.lineTo(S, j + J), this.lineTo(S, j), this.lineTo(S + z, j), this.lineTo(S, j);
  }, b.prototype.fillRect = function(S, j, z, J) {
    if (isNaN(S) || isNaN(j) || isNaN(z) || isNaN(J)) throw Pe.error("jsPDF.context2d.fillRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillRect");
    if (!g.call(this)) {
      var $ = {};
      this.lineCap !== "butt" && ($.lineCap = this.lineCap, this.lineCap = "butt"), this.lineJoin !== "miter" && ($.lineJoin = this.lineJoin, this.lineJoin = "miter"), this.beginPath(), this.rect(S, j, z, J), this.fill(), $.hasOwnProperty("lineCap") && (this.lineCap = $.lineCap), $.hasOwnProperty("lineJoin") && (this.lineJoin = $.lineJoin);
    }
  }, b.prototype.strokeRect = function(S, j, z, J) {
    if (isNaN(S) || isNaN(j) || isNaN(z) || isNaN(J)) throw Pe.error("jsPDF.context2d.strokeRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");
    y.call(this) || (this.beginPath(), this.rect(S, j, z, J), this.stroke());
  }, b.prototype.clearRect = function(S, j, z, J) {
    if (isNaN(S) || isNaN(j) || isNaN(z) || isNaN(J)) throw Pe.error("jsPDF.context2d.clearRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.clearRect");
    this.ignoreClearRect || (this.fillStyle = "#ffffff", this.fillRect(S, j, z, J));
  }, b.prototype.save = function(S) {
    S = typeof S != "boolean" || S;
    for (var j = this.pdf.internal.getCurrentPageInfo().pageNumber, z = 0; z < this.pdf.internal.getNumberOfPages(); z++) this.pdf.setPage(z + 1), this.pdf.internal.out("q");
    if (this.pdf.setPage(j), S) {
      this.ctx.fontSize = this.pdf.internal.getFontSize();
      var J = new d(this.ctx);
      this.ctxStack.push(this.ctx), this.ctx = J;
    }
  }, b.prototype.restore = function(S) {
    S = typeof S != "boolean" || S;
    for (var j = this.pdf.internal.getCurrentPageInfo().pageNumber, z = 0; z < this.pdf.internal.getNumberOfPages(); z++) this.pdf.setPage(z + 1), this.pdf.internal.out("Q");
    this.pdf.setPage(j), S && this.ctxStack.length !== 0 && (this.ctx = this.ctxStack.pop(), this.fillStyle = this.ctx.fillStyle, this.strokeStyle = this.ctx.strokeStyle, this.font = this.ctx.font, this.lineCap = this.ctx.lineCap, this.lineWidth = this.ctx.lineWidth, this.lineJoin = this.ctx.lineJoin, this.lineDash = this.ctx.lineDash, this.lineDashOffset = this.ctx.lineDashOffset);
  }, b.prototype.toDataURL = function() {
    throw new Error("toDataUrl not implemented.");
  };
  var _ = function(S) {
    var j, z, J, $;
    if (S.isCanvasGradient === !0 && (S = S.getColor()), !S) return { r: 0, g: 0, b: 0, a: 0, style: S };
    if (/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(S)) j = 0, z = 0, J = 0, $ = 0;
    else {
      var nt = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(S);
      if (nt !== null) j = parseInt(nt[1]), z = parseInt(nt[2]), J = parseInt(nt[3]), $ = 1;
      else if ((nt = /rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/.exec(S)) !== null) j = parseInt(nt[1]), z = parseInt(nt[2]), J = parseInt(nt[3]), $ = parseFloat(nt[4]);
      else {
        if ($ = 1, typeof S == "string" && S.charAt(0) !== "#") {
          var lt = new v1(S);
          S = lt.ok ? lt.toHex() : "#000000";
        }
        S.length === 4 ? (j = S.substring(1, 2), j += j, z = S.substring(2, 3), z += z, J = S.substring(3, 4), J += J) : (j = S.substring(1, 3), z = S.substring(3, 5), J = S.substring(5, 7)), j = parseInt(j, 16), z = parseInt(z, 16), J = parseInt(J, 16);
      }
    }
    return { r: j, g: z, b: J, a: $, style: S };
  }, g = function() {
    return this.ctx.isFillTransparent || this.globalAlpha == 0;
  }, y = function() {
    return !!(this.ctx.isStrokeTransparent || this.globalAlpha == 0);
  };
  b.prototype.fillText = function(S, j, z, J) {
    if (isNaN(j) || isNaN(z) || typeof S != "string") throw Pe.error("jsPDF.context2d.fillText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillText");
    if (J = isNaN(J) ? void 0 : J, !g.call(this)) {
      var $ = rt(this.ctx.transform.rotation), nt = this.ctx.transform.scaleX;
      C.call(this, { text: S, x: j, y: z, scale: nt, angle: $, align: this.textAlign, maxWidth: J });
    }
  }, b.prototype.strokeText = function(S, j, z, J) {
    if (isNaN(j) || isNaN(z) || typeof S != "string") throw Pe.error("jsPDF.context2d.strokeText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeText");
    if (!y.call(this)) {
      J = isNaN(J) ? void 0 : J;
      var $ = rt(this.ctx.transform.rotation), nt = this.ctx.transform.scaleX;
      C.call(this, { text: S, x: j, y: z, scale: nt, renderingMode: "stroke", angle: $, align: this.textAlign, maxWidth: J });
    }
  }, b.prototype.measureText = function(S) {
    if (typeof S != "string") throw Pe.error("jsPDF.context2d.measureText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.measureText");
    var j = this.pdf, z = this.pdf.internal.scaleFactor, J = j.internal.getFontSize(), $ = j.getStringUnitWidth(S) * J / j.internal.scaleFactor;
    return new function(nt) {
      var lt = (nt = nt || {}).width || 0;
      return Object.defineProperty(this, "width", { get: function() {
        return lt;
      } }), this;
    }({ width: $ *= Math.round(96 * z / 72 * 1e4) / 1e4 });
  }, b.prototype.scale = function(S, j) {
    if (isNaN(S) || isNaN(j)) throw Pe.error("jsPDF.context2d.scale: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.scale");
    var z = new l(S, 0, 0, j, 0, 0);
    this.ctx.transform = this.ctx.transform.multiply(z);
  }, b.prototype.rotate = function(S) {
    if (isNaN(S)) throw Pe.error("jsPDF.context2d.rotate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rotate");
    var j = new l(Math.cos(S), Math.sin(S), -Math.sin(S), Math.cos(S), 0, 0);
    this.ctx.transform = this.ctx.transform.multiply(j);
  }, b.prototype.translate = function(S, j) {
    if (isNaN(S) || isNaN(j)) throw Pe.error("jsPDF.context2d.translate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.translate");
    var z = new l(1, 0, 0, 1, S, j);
    this.ctx.transform = this.ctx.transform.multiply(z);
  }, b.prototype.transform = function(S, j, z, J, $, nt) {
    if (isNaN(S) || isNaN(j) || isNaN(z) || isNaN(J) || isNaN($) || isNaN(nt)) throw Pe.error("jsPDF.context2d.transform: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.transform");
    var lt = new l(S, j, z, J, $, nt);
    this.ctx.transform = this.ctx.transform.multiply(lt);
  }, b.prototype.setTransform = function(S, j, z, J, $, nt) {
    S = isNaN(S) ? 1 : S, j = isNaN(j) ? 0 : j, z = isNaN(z) ? 0 : z, J = isNaN(J) ? 1 : J, $ = isNaN($) ? 0 : $, nt = isNaN(nt) ? 0 : nt, this.ctx.transform = new l(S, j, z, J, $, nt);
  };
  var x = function() {
    return this.margin[0] > 0 || this.margin[1] > 0 || this.margin[2] > 0 || this.margin[3] > 0;
  };
  b.prototype.drawImage = function(S, j, z, J, $, nt, lt, ct, bt) {
    var xt = this.pdf.getImageProperties(S), Et = 1, Pt = 1, dt = 1, U = 1;
    J !== void 0 && ct !== void 0 && (dt = ct / J, U = bt / $, Et = xt.width / J * ct / J, Pt = xt.height / $ * bt / $), nt === void 0 && (nt = j, lt = z, j = 0, z = 0), J !== void 0 && ct === void 0 && (ct = J, bt = $), J === void 0 && ct === void 0 && (ct = xt.width, bt = xt.height);
    for (var fe, ae = this.ctx.transform.decompose(), Vt = rt(ae.rotate.shx), Nt = new l(), jt = (Nt = (Nt = (Nt = Nt.multiply(ae.translate)).multiply(ae.skew)).multiply(ae.scale)).applyToRectangle(new o(nt - j * dt, lt - z * U, J * Et, $ * Pt)), kt = E.call(this, jt), oe = [], Ht = 0; Ht < kt.length; Ht += 1) oe.indexOf(kt[Ht]) === -1 && oe.push(kt[Ht]);
    if (q(oe), this.autoPaging) for (var me = oe[0], ee = oe[oe.length - 1], re = me; re < ee + 1; re++) {
      this.pdf.setPage(re);
      var Ne = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], ce = re === 1 ? this.posY + this.margin[0] : this.margin[0], qt = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], Yt = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], Ut = re === 1 ? 0 : qt + (re - 2) * Yt;
      if (this.ctx.clip_path.length !== 0) {
        var Ce = this.path;
        fe = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = H(fe, this.posX + this.margin[3], -Ut + ce + this.ctx.prevPageLastElemOffset), et.call(this, "fill", !0), this.path = Ce;
      }
      var be = JSON.parse(JSON.stringify(jt));
      be = H([be], this.posX + this.margin[3], -Ut + ce + this.ctx.prevPageLastElemOffset)[0];
      var Tt = (re > me || re < ee) && x.call(this);
      Tt && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], Ne, Yt, null).clip().discardPath()), this.pdf.addImage(S, "JPEG", be.x, be.y, be.w, be.h, null, null, Vt), Tt && this.pdf.restoreGraphicsState();
    }
    else this.pdf.addImage(S, "JPEG", jt.x, jt.y, jt.w, jt.h, null, null, Vt);
  };
  var E = function(S, j, z) {
    var J = [];
    j = j || this.pdf.internal.pageSize.width, z = z || this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2];
    var $ = this.posY + this.ctx.prevPageLastElemOffset;
    switch (S.type) {
      default:
      case "mt":
      case "lt":
        J.push(Math.floor((S.y + $) / z) + 1);
        break;
      case "arc":
        J.push(Math.floor((S.y + $ - S.radius) / z) + 1), J.push(Math.floor((S.y + $ + S.radius) / z) + 1);
        break;
      case "qct":
        var nt = ht(this.ctx.lastPoint.x, this.ctx.lastPoint.y, S.x1, S.y1, S.x, S.y);
        J.push(Math.floor((nt.y + $) / z) + 1), J.push(Math.floor((nt.y + nt.h + $) / z) + 1);
        break;
      case "bct":
        var lt = Lt(this.ctx.lastPoint.x, this.ctx.lastPoint.y, S.x1, S.y1, S.x2, S.y2, S.x, S.y);
        J.push(Math.floor((lt.y + $) / z) + 1), J.push(Math.floor((lt.y + lt.h + $) / z) + 1);
        break;
      case "rect":
        J.push(Math.floor((S.y + $) / z) + 1), J.push(Math.floor((S.y + S.h + $) / z) + 1);
    }
    for (var ct = 0; ct < J.length; ct += 1) for (; this.pdf.internal.getNumberOfPages() < J[ct]; ) N.call(this);
    return J;
  }, N = function() {
    var S = this.fillStyle, j = this.strokeStyle, z = this.font, J = this.lineCap, $ = this.lineWidth, nt = this.lineJoin;
    this.pdf.addPage(), this.fillStyle = S, this.strokeStyle = j, this.font = z, this.lineCap = J, this.lineWidth = $, this.lineJoin = nt;
  }, H = function(S, j, z) {
    for (var J = 0; J < S.length; J++) switch (S[J].type) {
      case "bct":
        S[J].x2 += j, S[J].y2 += z;
      case "qct":
        S[J].x1 += j, S[J].y1 += z;
      default:
        S[J].x += j, S[J].y += z;
    }
    return S;
  }, q = function(S) {
    return S.sort(function(j, z) {
      return j - z;
    });
  }, F = function(S, j) {
    for (var z, J, $ = this.fillStyle, nt = this.strokeStyle, lt = this.lineCap, ct = this.lineWidth, bt = Math.abs(ct * this.ctx.transform.scaleX), xt = this.lineJoin, Et = JSON.parse(JSON.stringify(this.path)), Pt = JSON.parse(JSON.stringify(this.path)), dt = [], U = 0; U < Pt.length; U++) if (Pt[U].x !== void 0) for (var fe = E.call(this, Pt[U]), ae = 0; ae < fe.length; ae += 1) dt.indexOf(fe[ae]) === -1 && dt.push(fe[ae]);
    for (var Vt = 0; Vt < dt.length; Vt++) for (; this.pdf.internal.getNumberOfPages() < dt[Vt]; ) N.call(this);
    if (q(dt), this.autoPaging) for (var Nt = dt[0], jt = dt[dt.length - 1], kt = Nt; kt < jt + 1; kt++) {
      this.pdf.setPage(kt), this.fillStyle = $, this.strokeStyle = nt, this.lineCap = lt, this.lineWidth = bt, this.lineJoin = xt;
      var oe = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], Ht = kt === 1 ? this.posY + this.margin[0] : this.margin[0], me = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], ee = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], re = kt === 1 ? 0 : me + (kt - 2) * ee;
      if (this.ctx.clip_path.length !== 0) {
        var Ne = this.path;
        z = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = H(z, this.posX + this.margin[3], -re + Ht + this.ctx.prevPageLastElemOffset), et.call(this, S, !0), this.path = Ne;
      }
      if (J = JSON.parse(JSON.stringify(Et)), this.path = H(J, this.posX + this.margin[3], -re + Ht + this.ctx.prevPageLastElemOffset), j === !1 || kt === 0) {
        var ce = (kt > Nt || kt < jt) && x.call(this);
        ce && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], oe, ee, null).clip().discardPath()), et.call(this, S, j), ce && this.pdf.restoreGraphicsState();
      }
      this.lineWidth = ct;
    }
    else this.lineWidth = bt, et.call(this, S, j), this.lineWidth = ct;
    this.path = Et;
  }, et = function(S, j) {
    if ((S !== "stroke" || j || !y.call(this)) && (S === "stroke" || j || !g.call(this))) {
      for (var z, J, $ = [], nt = this.path, lt = 0; lt < nt.length; lt++) {
        var ct = nt[lt];
        switch (ct.type) {
          case "begin":
            $.push({ begin: !0 });
            break;
          case "close":
            $.push({ close: !0 });
            break;
          case "mt":
            $.push({ start: ct, deltas: [], abs: [] });
            break;
          case "lt":
            var bt = $.length;
            if (nt[lt - 1] && !isNaN(nt[lt - 1].x) && (z = [ct.x - nt[lt - 1].x, ct.y - nt[lt - 1].y], bt > 0)) {
              for (; bt >= 0; bt--) if ($[bt - 1].close !== !0 && $[bt - 1].begin !== !0) {
                $[bt - 1].deltas.push(z), $[bt - 1].abs.push(ct);
                break;
              }
            }
            break;
          case "bct":
            z = [ct.x1 - nt[lt - 1].x, ct.y1 - nt[lt - 1].y, ct.x2 - nt[lt - 1].x, ct.y2 - nt[lt - 1].y, ct.x - nt[lt - 1].x, ct.y - nt[lt - 1].y], $[$.length - 1].deltas.push(z);
            break;
          case "qct":
            var xt = nt[lt - 1].x + 2 / 3 * (ct.x1 - nt[lt - 1].x), Et = nt[lt - 1].y + 2 / 3 * (ct.y1 - nt[lt - 1].y), Pt = ct.x + 2 / 3 * (ct.x1 - ct.x), dt = ct.y + 2 / 3 * (ct.y1 - ct.y), U = ct.x, fe = ct.y;
            z = [xt - nt[lt - 1].x, Et - nt[lt - 1].y, Pt - nt[lt - 1].x, dt - nt[lt - 1].y, U - nt[lt - 1].x, fe - nt[lt - 1].y], $[$.length - 1].deltas.push(z);
            break;
          case "arc":
            $.push({ deltas: [], abs: [], arc: !0 }), Array.isArray($[$.length - 1].abs) && $[$.length - 1].abs.push(ct);
        }
      }
      J = j ? null : S === "stroke" ? "stroke" : "fill";
      for (var ae = !1, Vt = 0; Vt < $.length; Vt++) if ($[Vt].arc) for (var Nt = $[Vt].abs, jt = 0; jt < Nt.length; jt++) {
        var kt = Nt[jt];
        kt.type === "arc" ? V.call(this, kt.x, kt.y, kt.radius, kt.startAngle, kt.endAngle, kt.counterclockwise, void 0, j, !ae) : M.call(this, kt.x, kt.y), ae = !0;
      }
      else if ($[Vt].close === !0) this.pdf.internal.out("h"), ae = !1;
      else if ($[Vt].begin !== !0) {
        var oe = $[Vt].start.x, Ht = $[Vt].start.y;
        D.call(this, $[Vt].deltas, oe, Ht), ae = !0;
      }
      J && I.call(this, J), j && G.call(this);
    }
  }, Q = function(S) {
    var j = this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor, z = j * (this.pdf.internal.getLineHeightFactor() - 1);
    switch (this.ctx.textBaseline) {
      case "bottom":
        return S - z;
      case "top":
        return S + j - z;
      case "hanging":
        return S + j - 2 * z;
      case "middle":
        return S + j / 2 - z;
      default:
        return S;
    }
  }, X = function(S) {
    return S + this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor * (this.pdf.internal.getLineHeightFactor() - 1);
  };
  b.prototype.createLinearGradient = function() {
    var S = function() {
    };
    return S.colorStops = [], S.addColorStop = function(j, z) {
      this.colorStops.push([j, z]);
    }, S.getColor = function() {
      return this.colorStops.length === 0 ? "#000000" : this.colorStops[0][1];
    }, S.isCanvasGradient = !0, S;
  }, b.prototype.createPattern = function() {
    return this.createLinearGradient();
  }, b.prototype.createRadialGradient = function() {
    return this.createLinearGradient();
  };
  var V = function(S, j, z, J, $, nt, lt, ct, bt) {
    for (var xt = ot.call(this, z, J, $, nt), Et = 0; Et < xt.length; Et++) {
      var Pt = xt[Et];
      Et === 0 && (bt ? A.call(this, Pt.x1 + S, Pt.y1 + j) : M.call(this, Pt.x1 + S, Pt.y1 + j)), at.call(this, S, j, Pt.x2, Pt.y2, Pt.x3, Pt.y3, Pt.x4, Pt.y4);
    }
    ct ? G.call(this) : I.call(this, lt);
  }, I = function(S) {
    switch (S) {
      case "stroke":
        this.pdf.internal.out("S");
        break;
      case "fill":
        this.pdf.internal.out("f");
    }
  }, G = function() {
    this.pdf.clip(), this.pdf.discardPath();
  }, A = function(S, j) {
    this.pdf.internal.out(e(S) + " " + n(j) + " m");
  }, C = function(S) {
    var j;
    switch (S.align) {
      case "right":
      case "end":
        j = "right";
        break;
      case "center":
        j = "center";
        break;
      default:
        j = "left";
    }
    var z = this.pdf.getTextDimensions(S.text), J = Q.call(this, S.y), $ = X.call(this, J) - z.h, nt = this.ctx.transform.applyToPoint(new c(S.x, J)), lt = this.ctx.transform.decompose(), ct = new l();
    ct = (ct = (ct = ct.multiply(lt.translate)).multiply(lt.skew)).multiply(lt.scale);
    for (var bt, xt, Et, Pt = this.ctx.transform.applyToRectangle(new o(S.x, J, z.w, z.h)), dt = ct.applyToRectangle(new o(S.x, $, z.w, z.h)), U = E.call(this, dt), fe = [], ae = 0; ae < U.length; ae += 1) fe.indexOf(U[ae]) === -1 && fe.push(U[ae]);
    if (q(fe), this.autoPaging) for (var Vt = fe[0], Nt = fe[fe.length - 1], jt = Vt; jt < Nt + 1; jt++) {
      this.pdf.setPage(jt);
      var kt = jt === 1 ? this.posY + this.margin[0] : this.margin[0], oe = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], Ht = this.pdf.internal.pageSize.height - this.margin[2], me = Ht - this.margin[0], ee = this.pdf.internal.pageSize.width - this.margin[1], re = ee - this.margin[3], Ne = jt === 1 ? 0 : oe + (jt - 2) * me;
      if (this.ctx.clip_path.length !== 0) {
        var ce = this.path;
        bt = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = H(bt, this.posX + this.margin[3], -1 * Ne + kt), et.call(this, "fill", !0), this.path = ce;
      }
      var qt = H([JSON.parse(JSON.stringify(dt))], this.posX + this.margin[3], -Ne + kt + this.ctx.prevPageLastElemOffset)[0];
      S.scale >= 0.01 && (xt = this.pdf.internal.getFontSize(), this.pdf.setFontSize(xt * S.scale), Et = this.lineWidth, this.lineWidth = Et * S.scale);
      var Yt = this.autoPaging !== "text";
      if (Yt || qt.y + qt.h <= Ht) {
        if (Yt || qt.y >= kt && qt.x <= ee) {
          var Ut = Yt ? S.text : this.pdf.splitTextToSize(S.text, S.maxWidth || ee - qt.x)[0], Ce = H([JSON.parse(JSON.stringify(Pt))], this.posX + this.margin[3], -Ne + kt + this.ctx.prevPageLastElemOffset)[0], be = Yt && (jt > Vt || jt < Nt) && x.call(this);
          be && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], re, me, null).clip().discardPath()), this.pdf.text(Ut, Ce.x, Ce.y, { angle: S.angle, align: j, renderingMode: S.renderingMode }), be && this.pdf.restoreGraphicsState();
        }
      } else qt.y < Ht && (this.ctx.prevPageLastElemOffset += Ht - qt.y);
      S.scale >= 0.01 && (this.pdf.setFontSize(xt), this.lineWidth = Et);
    }
    else S.scale >= 0.01 && (xt = this.pdf.internal.getFontSize(), this.pdf.setFontSize(xt * S.scale), Et = this.lineWidth, this.lineWidth = Et * S.scale), this.pdf.text(S.text, nt.x + this.posX, nt.y + this.posY, { angle: S.angle, align: j, renderingMode: S.renderingMode, maxWidth: S.maxWidth }), S.scale >= 0.01 && (this.pdf.setFontSize(xt), this.lineWidth = Et);
  }, M = function(S, j, z, J) {
    z = z || 0, J = J || 0, this.pdf.internal.out(e(S + z) + " " + n(j + J) + " l");
  }, D = function(S, j, z) {
    return this.pdf.lines(S, j, z, null, null);
  }, at = function(S, j, z, J, $, nt, lt, ct) {
    this.pdf.internal.out([t(i(z + S)), t(s(J + j)), t(i($ + S)), t(s(nt + j)), t(i(lt + S)), t(s(ct + j)), "c"].join(" "));
  }, ot = function(S, j, z, J) {
    for (var $ = 2 * Math.PI, nt = Math.PI / 2; j > z; ) j -= $;
    var lt = Math.abs(z - j);
    lt < $ && J && (lt = $ - lt);
    for (var ct = [], bt = J ? -1 : 1, xt = j; lt > 1e-5; ) {
      var Et = xt + bt * Math.min(lt, nt);
      ct.push(ft.call(this, S, xt, Et)), lt -= Math.abs(Et - xt), xt = Et;
    }
    return ct;
  }, ft = function(S, j, z) {
    var J = (z - j) / 2, $ = S * Math.cos(J), nt = S * Math.sin(J), lt = $, ct = -nt, bt = lt * lt + ct * ct, xt = bt + lt * $ + ct * nt, Et = 4 / 3 * (Math.sqrt(2 * bt * xt) - xt) / (lt * nt - ct * $), Pt = lt - Et * ct, dt = ct + Et * lt, U = Pt, fe = -dt, ae = J + j, Vt = Math.cos(ae), Nt = Math.sin(ae);
    return { x1: S * Math.cos(j), y1: S * Math.sin(j), x2: Pt * Vt - dt * Nt, y2: Pt * Nt + dt * Vt, x3: U * Vt - fe * Nt, y3: U * Nt + fe * Vt, x4: S * Math.cos(z), y4: S * Math.sin(z) };
  }, rt = function(S) {
    return 180 * S / Math.PI;
  }, ht = function(S, j, z, J, $, nt) {
    var lt = S + 0.5 * (z - S), ct = j + 0.5 * (J - j), bt = $ + 0.5 * (z - $), xt = nt + 0.5 * (J - nt), Et = Math.min(S, $, lt, bt), Pt = Math.max(S, $, lt, bt), dt = Math.min(j, nt, ct, xt), U = Math.max(j, nt, ct, xt);
    return new o(Et, dt, Pt - Et, U - dt);
  }, Lt = function(S, j, z, J, $, nt, lt, ct) {
    var bt, xt, Et, Pt, dt, U, fe, ae, Vt, Nt, jt, kt, oe, Ht, me = z - S, ee = J - j, re = $ - z, Ne = nt - J, ce = lt - $, qt = ct - nt;
    for (xt = 0; xt < 41; xt++) Vt = (fe = (Et = S + (bt = xt / 40) * me) + bt * ((dt = z + bt * re) - Et)) + bt * (dt + bt * ($ + bt * ce - dt) - fe), Nt = (ae = (Pt = j + bt * ee) + bt * ((U = J + bt * Ne) - Pt)) + bt * (U + bt * (nt + bt * qt - U) - ae), xt == 0 ? (jt = Vt, kt = Nt, oe = Vt, Ht = Nt) : (jt = Math.min(jt, Vt), kt = Math.min(kt, Nt), oe = Math.max(oe, Vt), Ht = Math.max(Ht, Nt));
    return new o(Math.round(jt), Math.round(kt), Math.round(oe - jt), Math.round(Ht - kt));
  }, vt = function() {
    if (this.prevLineDash || this.ctx.lineDash.length || this.ctx.lineDashOffset) {
      var S, j, z = (S = this.ctx.lineDash, j = this.ctx.lineDashOffset, JSON.stringify({ lineDash: S, lineDashOffset: j }));
      this.prevLineDash !== z && (this.pdf.setLineDash(this.ctx.lineDash, this.ctx.lineDashOffset), this.prevLineDash = z);
    }
  };
})(Dt.API), /**
 * @license
 * jsPDF filters PlugIn
 * Copyright (c) 2014 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  var t = function(c) {
    var o, l, f, d, b, _, g, y, x, E;
    for (l = [], f = 0, d = (c += o = "\0\0\0\0".slice(c.length % 4 || 4)).length; d > f; f += 4) (b = (c.charCodeAt(f) << 24) + (c.charCodeAt(f + 1) << 16) + (c.charCodeAt(f + 2) << 8) + c.charCodeAt(f + 3)) !== 0 ? (_ = (b = ((b = ((b = ((b = (b - (E = b % 85)) / 85) - (x = b % 85)) / 85) - (y = b % 85)) / 85) - (g = b % 85)) / 85) % 85, l.push(_ + 33, g + 33, y + 33, x + 33, E + 33)) : l.push(122);
    return (function(N, H) {
      for (var q = H; q > 0; q--) N.pop();
    })(l, o.length), String.fromCharCode.apply(String, l) + "~>";
  }, e = function(c) {
    var o, l, f, d, b, _ = String, g = "length", y = 255, x = "charCodeAt", E = "slice", N = "replace";
    for (c[E](-2), c = c[E](0, -2)[N](/\s/g, "")[N]("z", "!!!!!"), f = [], d = 0, b = (c += o = "uuuuu"[E](c[g] % 5 || 5))[g]; b > d; d += 5) l = 52200625 * (c[x](d) - 33) + 614125 * (c[x](d + 1) - 33) + 7225 * (c[x](d + 2) - 33) + 85 * (c[x](d + 3) - 33) + (c[x](d + 4) - 33), f.push(y & l >> 24, y & l >> 16, y & l >> 8, y & l);
    return (function(H, q) {
      for (var F = q; F > 0; F--) H.pop();
    })(f, o[g]), _.fromCharCode.apply(_, f);
  }, n = function(c) {
    return c.split("").map(function(o) {
      return ("0" + o.charCodeAt().toString(16)).slice(-2);
    }).join("") + ">";
  }, i = function(c) {
    var o = new RegExp(/^([0-9A-Fa-f]{2})+$/);
    if ((c = c.replace(/\s/g, "")).indexOf(">") !== -1 && (c = c.substr(0, c.indexOf(">"))), c.length % 2 && (c += "0"), o.test(c) === !1) return "";
    for (var l = "", f = 0; f < c.length; f += 2) l += String.fromCharCode("0x" + (c[f] + c[f + 1]));
    return l;
  }, s = function(c) {
    for (var o = new Uint8Array(c.length), l = c.length; l--; ) o[l] = c.charCodeAt(l);
    return (o = pu(o)).reduce(function(f, d) {
      return f + String.fromCharCode(d);
    }, "");
  };
  r.processDataByFilters = function(c, o) {
    var l = 0, f = c || "", d = [];
    for (typeof (o = o || []) == "string" && (o = [o]), l = 0; l < o.length; l += 1) switch (o[l]) {
      case "ASCII85Decode":
      case "/ASCII85Decode":
        f = e(f), d.push("/ASCII85Encode");
        break;
      case "ASCII85Encode":
      case "/ASCII85Encode":
        f = t(f), d.push("/ASCII85Decode");
        break;
      case "ASCIIHexDecode":
      case "/ASCIIHexDecode":
        f = i(f), d.push("/ASCIIHexEncode");
        break;
      case "ASCIIHexEncode":
      case "/ASCIIHexEncode":
        f = n(f), d.push("/ASCIIHexDecode");
        break;
      case "FlateEncode":
      case "/FlateEncode":
        f = s(f), d.push("/FlateDecode");
        break;
      default:
        throw new Error('The filter: "' + o[l] + '" is not implemented');
    }
    return { data: f, reverseChain: d.reverse().join(" ") };
  };
})(Dt.API), /**
 * @license
 * jsPDF fileloading PlugIn
 * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  r.loadFile = function(t, e, n) {
    return (function(i, s, c) {
      s = s !== !1, c = typeof c == "function" ? c : function() {
      };
      var o = void 0;
      try {
        o = (function(l, f, d) {
          var b = new XMLHttpRequest(), _ = 0, g = function(y) {
            var x = y.length, E = [], N = String.fromCharCode;
            for (_ = 0; _ < x; _ += 1) E.push(N(255 & y.charCodeAt(_)));
            return E.join("");
          };
          if (b.open("GET", l, !f), b.overrideMimeType("text/plain; charset=x-user-defined"), f === !1 && (b.onload = function() {
            b.status === 200 ? d(g(this.responseText)) : d(void 0);
          }), b.send(null), f && b.status === 200) return g(b.responseText);
        })(i, s, c);
      } catch {
      }
      return o;
    })(t, e, n);
  }, r.loadImageFile = r.loadFile;
})(Dt.API), (function(r) {
  function t() {
    return (Kt.html2canvas ? Promise.resolve(Kt.html2canvas) : import("./html2canvas.esm-BWVIUcAF.mjs")).catch(function(o) {
      return Promise.reject(new Error("Could not load html2canvas: " + o));
    }).then(function(o) {
      return o.default ? o.default : o;
    });
  }
  function e() {
    return (Kt.DOMPurify ? Promise.resolve(Kt.DOMPurify) : import("./purify.es-B-PIlM9I.mjs")).catch(function(o) {
      return Promise.reject(new Error("Could not load dompurify: " + o));
    }).then(function(o) {
      return o.default ? o.default : o;
    });
  }
  var n = function(o) {
    var l = xe(o);
    return l === "undefined" ? "undefined" : l === "string" || o instanceof String ? "string" : l === "number" || o instanceof Number ? "number" : l === "function" || o instanceof Function ? "function" : o && o.constructor === Array ? "array" : o && o.nodeType === 1 ? "element" : l === "object" ? "object" : "unknown";
  }, i = function(o, l) {
    var f = document.createElement(o);
    for (var d in l.className && (f.className = l.className), l.innerHTML && l.dompurify && (f.innerHTML = l.dompurify.sanitize(l.innerHTML)), l.style) f.style[d] = l.style[d];
    return f;
  }, s = function o(l, f) {
    for (var d = l.nodeType === 3 ? document.createTextNode(l.nodeValue) : l.cloneNode(!1), b = l.firstChild; b; b = b.nextSibling) f !== !0 && b.nodeType === 1 && b.nodeName === "SCRIPT" || d.appendChild(o(b, f));
    return l.nodeType === 1 && (l.nodeName === "CANVAS" ? (d.width = l.width, d.height = l.height, d.getContext("2d").drawImage(l, 0, 0)) : l.nodeName !== "TEXTAREA" && l.nodeName !== "SELECT" || (d.value = l.value), d.addEventListener("load", function() {
      d.scrollTop = l.scrollTop, d.scrollLeft = l.scrollLeft;
    }, !0)), d;
  }, c = function o(l) {
    var f = Object.assign(o.convert(Promise.resolve()), JSON.parse(JSON.stringify(o.template))), d = o.convert(Promise.resolve(), f);
    return (d = d.setProgress(1, o, 1, [o])).set(l);
  };
  (c.prototype = Object.create(Promise.prototype)).constructor = c, c.convert = function(o, l) {
    return o.__proto__ = l || c.prototype, o;
  }, c.template = { prop: { src: null, container: null, overlay: null, canvas: null, img: null, pdf: null, pageSize: null, callback: function() {
  } }, progress: { val: 0, state: null, n: 0, stack: [] }, opt: { filename: "file.pdf", margin: [0, 0, 0, 0], enableLinks: !0, x: 0, y: 0, html2canvas: {}, jsPDF: {}, backgroundColor: "transparent" } }, c.prototype.from = function(o, l) {
    return this.then(function() {
      switch (l = l || (function(f) {
        switch (n(f)) {
          case "string":
            return "string";
          case "element":
            return f.nodeName.toLowerCase() === "canvas" ? "canvas" : "element";
          default:
            return "unknown";
        }
      })(o), l) {
        case "string":
          return this.then(e).then(function(f) {
            return this.set({ src: i("div", { innerHTML: o, dompurify: f }) });
          });
        case "element":
          return this.set({ src: o });
        case "canvas":
          return this.set({ canvas: o });
        case "img":
          return this.set({ img: o });
        default:
          return this.error("Unknown source type.");
      }
    });
  }, c.prototype.to = function(o) {
    switch (o) {
      case "container":
        return this.toContainer();
      case "canvas":
        return this.toCanvas();
      case "img":
        return this.toImg();
      case "pdf":
        return this.toPdf();
      default:
        return this.error("Invalid target.");
    }
  }, c.prototype.toContainer = function() {
    return this.thenList([function() {
      return this.prop.src || this.error("Cannot duplicate - no source HTML.");
    }, function() {
      return this.prop.pageSize || this.setPageSize();
    }]).then(function() {
      var o = { position: "relative", display: "inline-block", width: (typeof this.opt.width != "number" || isNaN(this.opt.width) || typeof this.opt.windowWidth != "number" || isNaN(this.opt.windowWidth) ? Math.max(this.prop.src.clientWidth, this.prop.src.scrollWidth, this.prop.src.offsetWidth) : this.opt.windowWidth) + "px", left: 0, right: 0, top: 0, margin: "auto", backgroundColor: this.opt.backgroundColor }, l = s(this.prop.src, this.opt.html2canvas.javascriptEnabled);
      l.tagName === "BODY" && (o.height = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) + "px"), this.prop.overlay = i("div", { className: "html2pdf__overlay", style: { position: "fixed", overflow: "hidden", zIndex: 1e3, left: "-100000px", right: 0, bottom: 0, top: 0 } }), this.prop.container = i("div", { className: "html2pdf__container", style: o }), this.prop.container.appendChild(l), this.prop.container.firstChild.appendChild(i("div", { style: { clear: "both", border: "0 none transparent", margin: 0, padding: 0, height: 0 } })), this.prop.container.style.float = "none", this.prop.overlay.appendChild(this.prop.container), document.body.appendChild(this.prop.overlay), this.prop.container.firstChild.style.position = "relative", this.prop.container.height = Math.max(this.prop.container.firstChild.clientHeight, this.prop.container.firstChild.scrollHeight, this.prop.container.firstChild.offsetHeight) + "px";
    });
  }, c.prototype.toCanvas = function() {
    var o = [function() {
      return document.body.contains(this.prop.container) || this.toContainer();
    }];
    return this.thenList(o).then(t).then(function(l) {
      var f = Object.assign({}, this.opt.html2canvas);
      return delete f.onrendered, l(this.prop.container, f);
    }).then(function(l) {
      (this.opt.html2canvas.onrendered || function() {
      })(l), this.prop.canvas = l, document.body.removeChild(this.prop.overlay);
    });
  }, c.prototype.toContext2d = function() {
    var o = [function() {
      return document.body.contains(this.prop.container) || this.toContainer();
    }];
    return this.thenList(o).then(t).then(function(l) {
      var f = this.opt.jsPDF, d = this.opt.fontFaces, b = typeof this.opt.width != "number" || isNaN(this.opt.width) || typeof this.opt.windowWidth != "number" || isNaN(this.opt.windowWidth) ? 1 : this.opt.width / this.opt.windowWidth, _ = Object.assign({ async: !0, allowTaint: !0, scale: b, scrollX: this.opt.scrollX || 0, scrollY: this.opt.scrollY || 0, backgroundColor: "#ffffff", imageTimeout: 15e3, logging: !0, proxy: null, removeContainer: !0, foreignObjectRendering: !1, useCORS: !1 }, this.opt.html2canvas);
      if (delete _.onrendered, f.context2d.autoPaging = this.opt.autoPaging === void 0 || this.opt.autoPaging, f.context2d.posX = this.opt.x, f.context2d.posY = this.opt.y, f.context2d.margin = this.opt.margin, f.context2d.fontFaces = d, d) for (var g = 0; g < d.length; ++g) {
        var y = d[g], x = y.src.find(function(E) {
          return E.format === "truetype";
        });
        x && f.addFont(x.url, y.ref.name, y.ref.style);
      }
      return _.windowHeight = _.windowHeight || 0, _.windowHeight = _.windowHeight == 0 ? Math.max(this.prop.container.clientHeight, this.prop.container.scrollHeight, this.prop.container.offsetHeight) : _.windowHeight, f.context2d.save(!0), l(this.prop.container, _);
    }).then(function(l) {
      this.opt.jsPDF.context2d.restore(!0), (this.opt.html2canvas.onrendered || function() {
      })(l), this.prop.canvas = l, document.body.removeChild(this.prop.overlay);
    });
  }, c.prototype.toImg = function() {
    return this.thenList([function() {
      return this.prop.canvas || this.toCanvas();
    }]).then(function() {
      var o = this.prop.canvas.toDataURL("image/" + this.opt.image.type, this.opt.image.quality);
      this.prop.img = document.createElement("img"), this.prop.img.src = o;
    });
  }, c.prototype.toPdf = function() {
    return this.thenList([function() {
      return this.toContext2d();
    }]).then(function() {
      this.prop.pdf = this.prop.pdf || this.opt.jsPDF;
    });
  }, c.prototype.output = function(o, l, f) {
    return (f = f || "pdf").toLowerCase() === "img" || f.toLowerCase() === "image" ? this.outputImg(o, l) : this.outputPdf(o, l);
  }, c.prototype.outputPdf = function(o, l) {
    return this.thenList([function() {
      return this.prop.pdf || this.toPdf();
    }]).then(function() {
      return this.prop.pdf.output(o, l);
    });
  }, c.prototype.outputImg = function(o) {
    return this.thenList([function() {
      return this.prop.img || this.toImg();
    }]).then(function() {
      switch (o) {
        case void 0:
        case "img":
          return this.prop.img;
        case "datauristring":
        case "dataurlstring":
          return this.prop.img.src;
        case "datauri":
        case "dataurl":
          return document.location.href = this.prop.img.src;
        default:
          throw 'Image output type "' + o + '" is not supported.';
      }
    });
  }, c.prototype.save = function(o) {
    return this.thenList([function() {
      return this.prop.pdf || this.toPdf();
    }]).set(o ? { filename: o } : null).then(function() {
      this.prop.pdf.save(this.opt.filename);
    });
  }, c.prototype.doCallback = function() {
    return this.thenList([function() {
      return this.prop.pdf || this.toPdf();
    }]).then(function() {
      this.prop.callback(this.prop.pdf);
    });
  }, c.prototype.set = function(o) {
    if (n(o) !== "object") return this;
    var l = Object.keys(o || {}).map(function(f) {
      if (f in c.template.prop) return function() {
        this.prop[f] = o[f];
      };
      switch (f) {
        case "margin":
          return this.setMargin.bind(this, o.margin);
        case "jsPDF":
          return function() {
            return this.opt.jsPDF = o.jsPDF, this.setPageSize();
          };
        case "pageSize":
          return this.setPageSize.bind(this, o.pageSize);
        default:
          return function() {
            this.opt[f] = o[f];
          };
      }
    }, this);
    return this.then(function() {
      return this.thenList(l);
    });
  }, c.prototype.get = function(o, l) {
    return this.then(function() {
      var f = o in c.template.prop ? this.prop[o] : this.opt[o];
      return l ? l(f) : f;
    });
  }, c.prototype.setMargin = function(o) {
    return this.then(function() {
      switch (n(o)) {
        case "number":
          o = [o, o, o, o];
        case "array":
          if (o.length === 2 && (o = [o[0], o[1], o[0], o[1]]), o.length === 4) break;
        default:
          return this.error("Invalid margin array.");
      }
      this.opt.margin = o;
    }).then(this.setPageSize);
  }, c.prototype.setPageSize = function(o) {
    function l(f, d) {
      return Math.floor(f * d / 72 * 96);
    }
    return this.then(function() {
      (o = o || Dt.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner") || (o.inner = { width: o.width - this.opt.margin[1] - this.opt.margin[3], height: o.height - this.opt.margin[0] - this.opt.margin[2] }, o.inner.px = { width: l(o.inner.width, o.k), height: l(o.inner.height, o.k) }, o.inner.ratio = o.inner.height / o.inner.width), this.prop.pageSize = o;
    });
  }, c.prototype.setProgress = function(o, l, f, d) {
    return o != null && (this.progress.val = o), l != null && (this.progress.state = l), f != null && (this.progress.n = f), d != null && (this.progress.stack = d), this.progress.ratio = this.progress.val / this.progress.state, this;
  }, c.prototype.updateProgress = function(o, l, f, d) {
    return this.setProgress(o ? this.progress.val + o : null, l || null, f ? this.progress.n + f : null, d ? this.progress.stack.concat(d) : null);
  }, c.prototype.then = function(o, l) {
    var f = this;
    return this.thenCore(o, l, function(d, b) {
      return f.updateProgress(null, null, 1, [d]), Promise.prototype.then.call(this, function(_) {
        return f.updateProgress(null, d), _;
      }).then(d, b).then(function(_) {
        return f.updateProgress(1), _;
      });
    });
  }, c.prototype.thenCore = function(o, l, f) {
    f = f || Promise.prototype.then;
    var d = this;
    o && (o = o.bind(d)), l && (l = l.bind(d));
    var b = Promise.toString().indexOf("[native code]") !== -1 && Promise.name === "Promise" ? d : c.convert(Object.assign({}, d), Promise.prototype), _ = f.call(b, o, l);
    return c.convert(_, d.__proto__);
  }, c.prototype.thenExternal = function(o, l) {
    return Promise.prototype.then.call(this, o, l);
  }, c.prototype.thenList = function(o) {
    var l = this;
    return o.forEach(function(f) {
      l = l.thenCore(f);
    }), l;
  }, c.prototype.catch = function(o) {
    o && (o = o.bind(this));
    var l = Promise.prototype.catch.call(this, o);
    return c.convert(l, this);
  }, c.prototype.catchExternal = function(o) {
    return Promise.prototype.catch.call(this, o);
  }, c.prototype.error = function(o) {
    return this.then(function() {
      throw new Error(o);
    });
  }, c.prototype.using = c.prototype.set, c.prototype.saveAs = c.prototype.save, c.prototype.export = c.prototype.output, c.prototype.run = c.prototype.then, Dt.getPageSize = function(o, l, f) {
    if (xe(o) === "object") {
      var d = o;
      o = d.orientation, l = d.unit || l, f = d.format || f;
    }
    l = l || "mm", f = f || "a4", o = ("" + (o || "P")).toLowerCase();
    var b, _ = ("" + f).toLowerCase(), g = { a0: [2383.94, 3370.39], a1: [1683.78, 2383.94], a2: [1190.55, 1683.78], a3: [841.89, 1190.55], a4: [595.28, 841.89], a5: [419.53, 595.28], a6: [297.64, 419.53], a7: [209.76, 297.64], a8: [147.4, 209.76], a9: [104.88, 147.4], a10: [73.7, 104.88], b0: [2834.65, 4008.19], b1: [2004.09, 2834.65], b2: [1417.32, 2004.09], b3: [1000.63, 1417.32], b4: [708.66, 1000.63], b5: [498.9, 708.66], b6: [354.33, 498.9], b7: [249.45, 354.33], b8: [175.75, 249.45], b9: [124.72, 175.75], b10: [87.87, 124.72], c0: [2599.37, 3676.54], c1: [1836.85, 2599.37], c2: [1298.27, 1836.85], c3: [918.43, 1298.27], c4: [649.13, 918.43], c5: [459.21, 649.13], c6: [323.15, 459.21], c7: [229.61, 323.15], c8: [161.57, 229.61], c9: [113.39, 161.57], c10: [79.37, 113.39], dl: [311.81, 623.62], letter: [612, 792], "government-letter": [576, 756], legal: [612, 1008], "junior-legal": [576, 360], ledger: [1224, 792], tabloid: [792, 1224], "credit-card": [153, 243] };
    switch (l) {
      case "pt":
        b = 1;
        break;
      case "mm":
        b = 72 / 25.4;
        break;
      case "cm":
        b = 72 / 2.54;
        break;
      case "in":
        b = 72;
        break;
      case "px":
        b = 0.75;
        break;
      case "pc":
      case "em":
        b = 12;
        break;
      case "ex":
        b = 6;
        break;
      default:
        throw "Invalid unit: " + l;
    }
    var y, x = 0, E = 0;
    if (g.hasOwnProperty(_)) x = g[_][1] / b, E = g[_][0] / b;
    else try {
      x = f[1], E = f[0];
    } catch {
      throw new Error("Invalid format: " + f);
    }
    if (o === "p" || o === "portrait") o = "p", E > x && (y = E, E = x, x = y);
    else {
      if (o !== "l" && o !== "landscape") throw "Invalid orientation: " + o;
      o = "l", x > E && (y = E, E = x, x = y);
    }
    return { width: E, height: x, unit: l, k: b, orientation: o };
  }, r.html = function(o, l) {
    (l = l || {}).callback = l.callback || function() {
    }, l.html2canvas = l.html2canvas || {}, l.html2canvas.canvas = l.html2canvas.canvas || this.canvas, l.jsPDF = l.jsPDF || this, l.fontFaces = l.fontFaces ? l.fontFaces.map(Ic) : null;
    var f = new c(l);
    return l.worker ? f : f.from(o).doCallback();
  };
})(Dt.API), Dt.API.addJS = function(r) {
  return Cf = r, this.internal.events.subscribe("postPutResources", function() {
    io = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/Names [(EmbeddedJS) " + (io + 1) + " 0 R]"), this.internal.out(">>"), this.internal.out("endobj"), Pf = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /JavaScript"), this.internal.out("/JS (" + Cf + ")"), this.internal.out(">>"), this.internal.out("endobj");
  }), this.internal.events.subscribe("putCatalog", function() {
    io !== void 0 && Pf !== void 0 && this.internal.out("/Names <</JavaScript " + io + " 0 R>>");
  }), this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  var t;
  r.events.push(["postPutResources", function() {
    var e = this, n = /^(\d+) 0 obj$/;
    if (this.outline.root.children.length > 0) for (var i = e.outline.render().split(/\r\n/), s = 0; s < i.length; s++) {
      var c = i[s], o = n.exec(c);
      if (o != null) {
        var l = o[1];
        e.internal.newObjectDeferredBegin(l, !1);
      }
      e.internal.write(c);
    }
    if (this.outline.createNamedDestinations) {
      var f = this.internal.pages.length, d = [];
      for (s = 0; s < f; s++) {
        var b = e.internal.newObject();
        d.push(b);
        var _ = e.internal.getPageInfo(s + 1);
        e.internal.write("<< /D[" + _.objId + " 0 R /XYZ null null null]>> endobj");
      }
      var g = e.internal.newObject();
      for (e.internal.write("<< /Names [ "), s = 0; s < d.length; s++) e.internal.write("(page_" + (s + 1) + ")" + d[s] + " 0 R");
      e.internal.write(" ] >>", "endobj"), t = e.internal.newObject(), e.internal.write("<< /Dests " + g + " 0 R"), e.internal.write(">>", "endobj");
    }
  }]), r.events.push(["putCatalog", function() {
    var e = this;
    e.outline.root.children.length > 0 && (e.internal.write("/Outlines", this.outline.makeRef(this.outline.root)), this.outline.createNamedDestinations && e.internal.write("/Names " + t + " 0 R"));
  }]), r.events.push(["initialized", function() {
    var e = this;
    e.outline = { createNamedDestinations: !1, root: { children: [] } }, e.outline.add = function(n, i, s) {
      var c = { title: i, options: s, children: [] };
      return n == null && (n = this.root), n.children.push(c), c;
    }, e.outline.render = function() {
      return this.ctx = {}, this.ctx.val = "", this.ctx.pdf = e, this.genIds_r(this.root), this.renderRoot(this.root), this.renderItems(this.root), this.ctx.val;
    }, e.outline.genIds_r = function(n) {
      n.id = e.internal.newObjectDeferred();
      for (var i = 0; i < n.children.length; i++) this.genIds_r(n.children[i]);
    }, e.outline.renderRoot = function(n) {
      this.objStart(n), this.line("/Type /Outlines"), n.children.length > 0 && (this.line("/First " + this.makeRef(n.children[0])), this.line("/Last " + this.makeRef(n.children[n.children.length - 1]))), this.line("/Count " + this.count_r({ count: 0 }, n)), this.objEnd();
    }, e.outline.renderItems = function(n) {
      for (var i = this.ctx.pdf.internal.getVerticalCoordinateString, s = 0; s < n.children.length; s++) {
        var c = n.children[s];
        this.objStart(c), this.line("/Title " + this.makeString(c.title)), this.line("/Parent " + this.makeRef(n)), s > 0 && this.line("/Prev " + this.makeRef(n.children[s - 1])), s < n.children.length - 1 && this.line("/Next " + this.makeRef(n.children[s + 1])), c.children.length > 0 && (this.line("/First " + this.makeRef(c.children[0])), this.line("/Last " + this.makeRef(c.children[c.children.length - 1])));
        var o = this.count = this.count_r({ count: 0 }, c);
        if (o > 0 && this.line("/Count " + o), c.options && c.options.pageNumber) {
          var l = e.internal.getPageInfo(c.options.pageNumber);
          this.line("/Dest [" + l.objId + " 0 R /XYZ 0 " + i(0) + " 0]");
        }
        this.objEnd();
      }
      for (var f = 0; f < n.children.length; f++) this.renderItems(n.children[f]);
    }, e.outline.line = function(n) {
      this.ctx.val += n + `\r
`;
    }, e.outline.makeRef = function(n) {
      return n.id + " 0 R";
    }, e.outline.makeString = function(n) {
      return "(" + e.internal.pdfEscape(n) + ")";
    }, e.outline.objStart = function(n) {
      this.ctx.val += `\r
` + n.id + ` 0 obj\r
<<\r
`;
    }, e.outline.objEnd = function() {
      this.ctx.val += `>> \r
endobj\r
`;
    }, e.outline.count_r = function(n, i) {
      for (var s = 0; s < i.children.length; s++) n.count++, this.count_r(n, i.children[s]);
      return n.count;
    };
  }]);
})(Dt.API), /**
 * @license
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  var t = [192, 193, 194, 195, 196, 197, 198, 199];
  r.processJPEG = function(e, n, i, s, c, o) {
    var l, f = this.decode.DCT_DECODE, d = null;
    if (typeof e == "string" || this.__addimage__.isArrayBuffer(e) || this.__addimage__.isArrayBufferView(e)) {
      switch (e = c || e, e = this.__addimage__.isArrayBuffer(e) ? new Uint8Array(e) : e, l = (function(b) {
        for (var _, g = 256 * b.charCodeAt(4) + b.charCodeAt(5), y = b.length, x = { width: 0, height: 0, numcomponents: 1 }, E = 4; E < y; E += 2) {
          if (E += g, t.indexOf(b.charCodeAt(E + 1)) !== -1) {
            _ = 256 * b.charCodeAt(E + 5) + b.charCodeAt(E + 6), x = { width: 256 * b.charCodeAt(E + 7) + b.charCodeAt(E + 8), height: _, numcomponents: b.charCodeAt(E + 9) };
            break;
          }
          g = 256 * b.charCodeAt(E + 2) + b.charCodeAt(E + 3);
        }
        return x;
      })(e = this.__addimage__.isArrayBufferView(e) ? this.__addimage__.arrayBufferToBinaryString(e) : e), l.numcomponents) {
        case 1:
          o = this.color_spaces.DEVICE_GRAY;
          break;
        case 4:
          o = this.color_spaces.DEVICE_CMYK;
          break;
        case 3:
          o = this.color_spaces.DEVICE_RGB;
      }
      d = { data: e, width: l.width, height: l.height, colorSpace: o, bitsPerComponent: 8, filter: f, index: n, alias: i };
    }
    return d;
  };
})(Dt.API), Dt.API.processPNG = function(r, t, e, n) {
  if (this.__addimage__.isArrayBuffer(r) && (r = new Uint8Array(r)), this.__addimage__.isArrayBufferView(r)) {
    var i, s = v5(r, { checkCrc: !0 }), c = s.width, o = s.height, l = s.channels, f = s.palette, d = s.depth;
    i = f && l === 1 ? (function(V) {
      for (var I = V.width, G = V.height, A = V.data, C = V.palette, M = V.depth, D = !1, at = [], ot = [], ft = void 0, rt = !1, ht = 0, Lt = 0; Lt < C.length; Lt++) {
        var vt = Fl(C[Lt], 4), S = vt[0], j = vt[1], z = vt[2], J = vt[3];
        at.push(S, j, z), J != null && (J === 0 ? (ht++, ot.length < 1 && ot.push(Lt)) : J < 255 && (rt = !0));
      }
      if (rt || ht > 1) {
        D = !0, ot = void 0;
        var $ = I * G;
        ft = new Uint8Array($);
        for (var nt = new DataView(A.buffer), lt = 0; lt < $; lt++) {
          var ct = Oc(nt, lt, M), bt = Fl(C[ct], 4)[3];
          ft[lt] = bt;
        }
      } else ht === 0 && (ot = void 0);
      return { colorSpace: "Indexed", colorsPerPixel: 1, sMaskBitsPerComponent: D ? 8 : void 0, colorBytes: A, alphaBytes: ft, needSMask: D, palette: at, mask: ot };
    })(s) : l === 2 || l === 4 ? (function(V) {
      for (var I = V.data, G = V.width, A = V.height, C = V.channels, M = V.depth, D = C === 2 ? "DeviceGray" : "DeviceRGB", at = C - 1, ot = G * A, ft = at, rt = ot * ft, ht = 1 * ot, Lt = Math.ceil(rt * M / 8), vt = Math.ceil(ht * M / 8), S = new Uint8Array(Lt), j = new Uint8Array(vt), z = new DataView(I.buffer), J = new DataView(S.buffer), $ = new DataView(j.buffer), nt = !1, lt = 0; lt < ot; lt++) {
        for (var ct = lt * C, bt = 0; bt < ft; bt++) jf(J, Oc(z, ct + bt, M), lt * ft + bt, M);
        var xt = Oc(z, ct + ft, M);
        xt < (1 << M) - 1 && (nt = !0), jf($, xt, 1 * lt, M);
      }
      return { colorSpace: D, colorsPerPixel: at, sMaskBitsPerComponent: nt ? M : void 0, colorBytes: S, alphaBytes: j, needSMask: nt };
    })(s) : (function(V) {
      var I = V.data, G = V.channels === 1 ? "DeviceGray" : "DeviceRGB";
      return { colorSpace: G, colorsPerPixel: G === "DeviceGray" ? 1 : 3, colorBytes: I instanceof Uint16Array ? (function(A) {
        for (var C = A.length, M = new Uint8Array(2 * C), D = new DataView(M.buffer, M.byteOffset, M.byteLength), at = 0; at < C; at++) D.setUint16(2 * at, A[at], !1);
        return M;
      })(I) : I, needSMask: !1 };
    })(s);
    var b, _, g, y = i, x = y.colorSpace, E = y.colorsPerPixel, N = y.sMaskBitsPerComponent, H = y.colorBytes, q = y.alphaBytes, F = y.needSMask, et = y.palette, Q = y.mask, X = null;
    return n !== Dt.API.image_compression.NONE && typeof pu == "function" ? (X = (function(V) {
      var I;
      switch (V) {
        case Dt.API.image_compression.FAST:
          I = 11;
          break;
        case Dt.API.image_compression.MEDIUM:
          I = 13;
          break;
        case Dt.API.image_compression.SLOW:
          I = 14;
          break;
        default:
          I = 12;
      }
      return I;
    })(n), b = this.decode.FLATE_DECODE, _ = "/Predictor ".concat(X, " /Colors ").concat(E, " /BitsPerComponent ").concat(d, " /Columns ").concat(c), r = Of(H, Math.ceil(c * E * d / 8), E, d, n), F && (g = Of(q, Math.ceil(c * N / 8), 1, N, n))) : (b = void 0, _ = void 0, r = H, F && (g = q)), (this.__addimage__.isArrayBuffer(r) || this.__addimage__.isArrayBufferView(r)) && (r = this.__addimage__.arrayBufferToBinaryString(r)), (g && this.__addimage__.isArrayBuffer(g) || this.__addimage__.isArrayBufferView(g)) && (g = this.__addimage__.arrayBufferToBinaryString(g)), { alias: e, data: r, index: t, filter: b, decodeParameters: _, transparency: Q, palette: et, sMask: g, predictor: X, width: c, height: o, bitsPerComponent: d, sMaskBitsPerComponent: N, colorSpace: x };
  }
}, (function(r) {
  r.processGIF89A = function(t, e, n, i) {
    var s = new q5(t), c = s.width, o = s.height, l = [];
    s.decodeAndBlitFrameRGBA(0, l);
    var f = { data: l, width: c, height: o }, d = new Bc(100).encode(f, 100);
    return r.processJPEG.call(this, d, e, n, i);
  }, r.processGIF87A = r.processGIF89A;
})(Dt.API), ln.prototype.parseHeader = function() {
  if (this.fileSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.reserved = this.datav.getUint32(this.pos, !0), this.pos += 4, this.offset = this.datav.getUint32(this.pos, !0), this.pos += 4, this.headerSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.width = this.datav.getUint32(this.pos, !0), this.pos += 4, this.height = this.datav.getInt32(this.pos, !0), this.pos += 4, this.planes = this.datav.getUint16(this.pos, !0), this.pos += 2, this.bitPP = this.datav.getUint16(this.pos, !0), this.pos += 2, this.compress = this.datav.getUint32(this.pos, !0), this.pos += 4, this.rawSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.hr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.vr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.colors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.importantColors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.bitPP === 16 && this.is_with_alpha && (this.bitPP = 15), this.bitPP < 15) {
    var r = this.colors === 0 ? 1 << this.bitPP : this.colors;
    this.palette = new Array(r);
    for (var t = 0; t < r; t++) {
      var e = this.datav.getUint8(this.pos++, !0), n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), s = this.datav.getUint8(this.pos++, !0);
      this.palette[t] = { red: i, green: n, blue: e, quad: s };
    }
  }
  this.height < 0 && (this.height *= -1, this.bottom_up = !1);
}, ln.prototype.parseBGR = function() {
  this.pos = this.offset;
  try {
    var r = "bit" + this.bitPP, t = this.width * this.height * 4;
    this.data = new Uint8Array(t), this[r]();
  } catch (e) {
    Pe.log("bit decode error:" + e);
  }
}, ln.prototype.bit1 = function() {
  var r, t = Math.ceil(this.width / 8), e = t % 4;
  for (r = this.height - 1; r >= 0; r--) {
    for (var n = this.bottom_up ? r : this.height - 1 - r, i = 0; i < t; i++) for (var s = this.datav.getUint8(this.pos++, !0), c = n * this.width * 4 + 8 * i * 4, o = 0; o < 8 && 8 * i + o < this.width; o++) {
      var l = this.palette[s >> 7 - o & 1];
      this.data[c + 4 * o] = l.blue, this.data[c + 4 * o + 1] = l.green, this.data[c + 4 * o + 2] = l.red, this.data[c + 4 * o + 3] = 255;
    }
    e !== 0 && (this.pos += 4 - e);
  }
}, ln.prototype.bit4 = function() {
  for (var r = Math.ceil(this.width / 2), t = r % 4, e = this.height - 1; e >= 0; e--) {
    for (var n = this.bottom_up ? e : this.height - 1 - e, i = 0; i < r; i++) {
      var s = this.datav.getUint8(this.pos++, !0), c = n * this.width * 4 + 2 * i * 4, o = s >> 4, l = 15 & s, f = this.palette[o];
      if (this.data[c] = f.blue, this.data[c + 1] = f.green, this.data[c + 2] = f.red, this.data[c + 3] = 255, 2 * i + 1 >= this.width) break;
      f = this.palette[l], this.data[c + 4] = f.blue, this.data[c + 4 + 1] = f.green, this.data[c + 4 + 2] = f.red, this.data[c + 4 + 3] = 255;
    }
    t !== 0 && (this.pos += 4 - t);
  }
}, ln.prototype.bit8 = function() {
  for (var r = this.width % 4, t = this.height - 1; t >= 0; t--) {
    for (var e = this.bottom_up ? t : this.height - 1 - t, n = 0; n < this.width; n++) {
      var i = this.datav.getUint8(this.pos++, !0), s = e * this.width * 4 + 4 * n;
      if (i < this.palette.length) {
        var c = this.palette[i];
        this.data[s] = c.red, this.data[s + 1] = c.green, this.data[s + 2] = c.blue, this.data[s + 3] = 255;
      } else this.data[s] = 255, this.data[s + 1] = 255, this.data[s + 2] = 255, this.data[s + 3] = 255;
    }
    r !== 0 && (this.pos += 4 - r);
  }
}, ln.prototype.bit15 = function() {
  for (var r = this.width % 3, t = parseInt("11111", 2), e = this.height - 1; e >= 0; e--) {
    for (var n = this.bottom_up ? e : this.height - 1 - e, i = 0; i < this.width; i++) {
      var s = this.datav.getUint16(this.pos, !0);
      this.pos += 2;
      var c = (s & t) / t * 255 | 0, o = (s >> 5 & t) / t * 255 | 0, l = (s >> 10 & t) / t * 255 | 0, f = s >> 15 ? 255 : 0, d = n * this.width * 4 + 4 * i;
      this.data[d] = l, this.data[d + 1] = o, this.data[d + 2] = c, this.data[d + 3] = f;
    }
    this.pos += r;
  }
}, ln.prototype.bit16 = function() {
  for (var r = this.width % 3, t = parseInt("11111", 2), e = parseInt("111111", 2), n = this.height - 1; n >= 0; n--) {
    for (var i = this.bottom_up ? n : this.height - 1 - n, s = 0; s < this.width; s++) {
      var c = this.datav.getUint16(this.pos, !0);
      this.pos += 2;
      var o = (c & t) / t * 255 | 0, l = (c >> 5 & e) / e * 255 | 0, f = (c >> 11) / t * 255 | 0, d = i * this.width * 4 + 4 * s;
      this.data[d] = f, this.data[d + 1] = l, this.data[d + 2] = o, this.data[d + 3] = 255;
    }
    this.pos += r;
  }
}, ln.prototype.bit24 = function() {
  for (var r = this.height - 1; r >= 0; r--) {
    for (var t = this.bottom_up ? r : this.height - 1 - r, e = 0; e < this.width; e++) {
      var n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), s = this.datav.getUint8(this.pos++, !0), c = t * this.width * 4 + 4 * e;
      this.data[c] = s, this.data[c + 1] = i, this.data[c + 2] = n, this.data[c + 3] = 255;
    }
    this.pos += this.width % 4;
  }
}, ln.prototype.bit32 = function() {
  for (var r = this.height - 1; r >= 0; r--) for (var t = this.bottom_up ? r : this.height - 1 - r, e = 0; e < this.width; e++) {
    var n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), s = this.datav.getUint8(this.pos++, !0), c = this.datav.getUint8(this.pos++, !0), o = t * this.width * 4 + 4 * e;
    this.data[o] = s, this.data[o + 1] = i, this.data[o + 2] = n, this.data[o + 3] = c;
  }
}, ln.prototype.getData = function() {
  return this.data;
}, /**
 * @license
 * Copyright (c) 2018 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  r.processBMP = function(t, e, n, i) {
    var s = new ln(t, !1), c = s.width, o = s.height, l = { data: s.getData(), width: c, height: o }, f = new Bc(100).encode(l, 100);
    return r.processJPEG.call(this, f, e, n, i);
  };
})(Dt.API), Uf.prototype.getData = function() {
  return this.data;
}, /**
 * @license
 * Copyright (c) 2019 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  r.processWEBP = function(t, e, n, i) {
    var s = new Uf(t), c = s.width, o = s.height, l = { data: s.getData(), width: c, height: o }, f = new Bc(100).encode(l, 100);
    return r.processJPEG.call(this, f, e, n, i);
  };
})(Dt.API), Dt.API.processRGBA = function(r, t, e) {
  for (var n = r.data, i = n.length, s = new Uint8Array(i / 4 * 3), c = new Uint8Array(i / 4), o = 0, l = 0, f = 0; f < i; f += 4) {
    var d = n[f], b = n[f + 1], _ = n[f + 2], g = n[f + 3];
    s[o++] = d, s[o++] = b, s[o++] = _, c[l++] = g;
  }
  var y = this.__addimage__.arrayBufferToBinaryString(s);
  return { alpha: this.__addimage__.arrayBufferToBinaryString(c), data: y, index: t, alias: e, colorSpace: "DeviceRGB", bitsPerComponent: 8, width: r.width, height: r.height };
}, Dt.API.setLanguage = function(r) {
  return this.internal.languageSettings === void 0 && (this.internal.languageSettings = {}, this.internal.languageSettings.isSubscribed = !1), { af: "Afrikaans", sq: "Albanian", ar: "Arabic (Standard)", "ar-DZ": "Arabic (Algeria)", "ar-BH": "Arabic (Bahrain)", "ar-EG": "Arabic (Egypt)", "ar-IQ": "Arabic (Iraq)", "ar-JO": "Arabic (Jordan)", "ar-KW": "Arabic (Kuwait)", "ar-LB": "Arabic (Lebanon)", "ar-LY": "Arabic (Libya)", "ar-MA": "Arabic (Morocco)", "ar-OM": "Arabic (Oman)", "ar-QA": "Arabic (Qatar)", "ar-SA": "Arabic (Saudi Arabia)", "ar-SY": "Arabic (Syria)", "ar-TN": "Arabic (Tunisia)", "ar-AE": "Arabic (U.A.E.)", "ar-YE": "Arabic (Yemen)", an: "Aragonese", hy: "Armenian", as: "Assamese", ast: "Asturian", az: "Azerbaijani", eu: "Basque", be: "Belarusian", bn: "Bengali", bs: "Bosnian", br: "Breton", bg: "Bulgarian", my: "Burmese", ca: "Catalan", ch: "Chamorro", ce: "Chechen", zh: "Chinese", "zh-HK": "Chinese (Hong Kong)", "zh-CN": "Chinese (PRC)", "zh-SG": "Chinese (Singapore)", "zh-TW": "Chinese (Taiwan)", cv: "Chuvash", co: "Corsican", cr: "Cree", hr: "Croatian", cs: "Czech", da: "Danish", nl: "Dutch (Standard)", "nl-BE": "Dutch (Belgian)", en: "English", "en-AU": "English (Australia)", "en-BZ": "English (Belize)", "en-CA": "English (Canada)", "en-IE": "English (Ireland)", "en-JM": "English (Jamaica)", "en-NZ": "English (New Zealand)", "en-PH": "English (Philippines)", "en-ZA": "English (South Africa)", "en-TT": "English (Trinidad & Tobago)", "en-GB": "English (United Kingdom)", "en-US": "English (United States)", "en-ZW": "English (Zimbabwe)", eo: "Esperanto", et: "Estonian", fo: "Faeroese", fj: "Fijian", fi: "Finnish", fr: "French (Standard)", "fr-BE": "French (Belgium)", "fr-CA": "French (Canada)", "fr-FR": "French (France)", "fr-LU": "French (Luxembourg)", "fr-MC": "French (Monaco)", "fr-CH": "French (Switzerland)", fy: "Frisian", fur: "Friulian", gd: "Gaelic (Scots)", "gd-IE": "Gaelic (Irish)", gl: "Galacian", ka: "Georgian", de: "German (Standard)", "de-AT": "German (Austria)", "de-DE": "German (Germany)", "de-LI": "German (Liechtenstein)", "de-LU": "German (Luxembourg)", "de-CH": "German (Switzerland)", el: "Greek", gu: "Gujurati", ht: "Haitian", he: "Hebrew", hi: "Hindi", hu: "Hungarian", is: "Icelandic", id: "Indonesian", iu: "Inuktitut", ga: "Irish", it: "Italian (Standard)", "it-CH": "Italian (Switzerland)", ja: "Japanese", kn: "Kannada", ks: "Kashmiri", kk: "Kazakh", km: "Khmer", ky: "Kirghiz", tlh: "Klingon", ko: "Korean", "ko-KP": "Korean (North Korea)", "ko-KR": "Korean (South Korea)", la: "Latin", lv: "Latvian", lt: "Lithuanian", lb: "Luxembourgish", mk: "North Macedonia", ms: "Malay", ml: "Malayalam", mt: "Maltese", mi: "Maori", mr: "Marathi", mo: "Moldavian", nv: "Navajo", ng: "Ndonga", ne: "Nepali", no: "Norwegian", nb: "Norwegian (Bokmal)", nn: "Norwegian (Nynorsk)", oc: "Occitan", or: "Oriya", om: "Oromo", fa: "Persian", "fa-IR": "Persian/Iran", pl: "Polish", pt: "Portuguese", "pt-BR": "Portuguese (Brazil)", pa: "Punjabi", "pa-IN": "Punjabi (India)", "pa-PK": "Punjabi (Pakistan)", qu: "Quechua", rm: "Rhaeto-Romanic", ro: "Romanian", "ro-MO": "Romanian (Moldavia)", ru: "Russian", "ru-MO": "Russian (Moldavia)", sz: "Sami (Lappish)", sg: "Sango", sa: "Sanskrit", sc: "Sardinian", sd: "Sindhi", si: "Singhalese", sr: "Serbian", sk: "Slovak", sl: "Slovenian", so: "Somani", sb: "Sorbian", es: "Spanish", "es-AR": "Spanish (Argentina)", "es-BO": "Spanish (Bolivia)", "es-CL": "Spanish (Chile)", "es-CO": "Spanish (Colombia)", "es-CR": "Spanish (Costa Rica)", "es-DO": "Spanish (Dominican Republic)", "es-EC": "Spanish (Ecuador)", "es-SV": "Spanish (El Salvador)", "es-GT": "Spanish (Guatemala)", "es-HN": "Spanish (Honduras)", "es-MX": "Spanish (Mexico)", "es-NI": "Spanish (Nicaragua)", "es-PA": "Spanish (Panama)", "es-PY": "Spanish (Paraguay)", "es-PE": "Spanish (Peru)", "es-PR": "Spanish (Puerto Rico)", "es-ES": "Spanish (Spain)", "es-UY": "Spanish (Uruguay)", "es-VE": "Spanish (Venezuela)", sx: "Sutu", sw: "Swahili", sv: "Swedish", "sv-FI": "Swedish (Finland)", "sv-SV": "Swedish (Sweden)", ta: "Tamil", tt: "Tatar", te: "Teluga", th: "Thai", tig: "Tigre", ts: "Tsonga", tn: "Tswana", tr: "Turkish", tk: "Turkmen", uk: "Ukrainian", hsb: "Upper Sorbian", ur: "Urdu", ve: "Venda", vi: "Vietnamese", vo: "Volapuk", wa: "Walloon", cy: "Welsh", xh: "Xhosa", ji: "Yiddish", zu: "Zulu" }[r] !== void 0 && (this.internal.languageSettings.languageCode = r, this.internal.languageSettings.isSubscribed === !1 && (this.internal.events.subscribe("putCatalog", function() {
    this.internal.write("/Lang (" + this.internal.languageSettings.languageCode + ")");
  }), this.internal.languageSettings.isSubscribed = !0)), this;
}, fs = Dt.API, so = fs.getCharWidthsArray = function(r, t) {
  var e, n, i = (t = t || {}).font || this.internal.getFont(), s = t.fontSize || this.internal.getFontSize(), c = t.charSpace || this.internal.getCharSpace(), o = t.widths ? t.widths : i.metadata.Unicode.widths, l = o.fof ? o.fof : 1, f = t.kerning ? t.kerning : i.metadata.Unicode.kerning, d = f.fof ? f.fof : 1, b = t.doKerning !== !1, _ = 0, g = r.length, y = 0, x = o[0] || l, E = [];
  for (e = 0; e < g; e++) n = r.charCodeAt(e), typeof i.metadata.widthOfString == "function" ? E.push((i.metadata.widthOfGlyph(i.metadata.characterToGlyph(n)) + c * (1e3 / s) || 0) / 1e3) : (_ = b && xe(f[n]) === "object" && !isNaN(parseInt(f[n][y], 10)) ? f[n][y] / d : 0, E.push((o[n] || x) / l + _)), y = n;
  return E;
}, Rf = fs.getStringUnitWidth = function(r, t) {
  var e = (t = t || {}).fontSize || this.internal.getFontSize(), n = t.font || this.internal.getFont(), i = t.charSpace || this.internal.getCharSpace();
  return fs.processArabic && (r = fs.processArabic(r)), typeof n.metadata.widthOfString == "function" ? n.metadata.widthOfString(r, e, i) / e : so.apply(this, arguments).reduce(function(s, c) {
    return s + c;
  }, 0);
}, If = function(r, t, e, n) {
  for (var i = [], s = 0, c = r.length, o = 0; s !== c && o + t[s] < e; ) o += t[s], s++;
  i.push(r.slice(0, s));
  var l = s;
  for (o = 0; s !== c; ) o + t[s] > n && (i.push(r.slice(l, s)), o = 0, l = s), o += t[s], s++;
  return l !== s && i.push(r.slice(l, s)), i;
}, Ff = function(r, t, e) {
  e || (e = {});
  var n, i, s, c, o, l, f, d = [], b = [d], _ = e.textIndent || 0, g = 0, y = 0, x = r.split(" "), E = so.apply(this, [" ", e])[0];
  if (l = e.lineIndent === -1 ? x[0].length + 2 : e.lineIndent || 0) {
    var N = Array(l).join(" "), H = [];
    x.map(function(F) {
      (F = F.split(/\s*\n/)).length > 1 ? H = H.concat(F.map(function(et, Q) {
        return (Q && et.length ? `
` : "") + et;
      })) : H.push(F[0]);
    }), x = H, l = Rf.apply(this, [N, e]);
  }
  for (s = 0, c = x.length; s < c; s++) {
    var q = 0;
    if (n = x[s], l && n[0] == `
` && (n = n.substr(1), q = 1), _ + g + (y = (i = so.apply(this, [n, e])).reduce(function(F, et) {
      return F + et;
    }, 0)) > t || q) {
      if (y > t) {
        for (o = If.apply(this, [n, i, t - (_ + g), t]), d.push(o.shift()), d = [o.pop()]; o.length; ) b.push([o.shift()]);
        y = i.slice(n.length - (d[0] ? d[0].length : 0)).reduce(function(F, et) {
          return F + et;
        }, 0);
      } else d = [n];
      b.push(d), _ = y + l, g = E;
    } else d.push(n), _ += g + y, g = E;
  }
  return f = l ? function(F, et) {
    return (et ? N : "") + F.join(" ");
  } : function(F) {
    return F.join(" ");
  }, b.map(f);
}, fs.splitTextToSize = function(r, t, e) {
  var n, i = (e = e || {}).fontSize || this.internal.getFontSize(), s = (function(d) {
    if (d.widths && d.kerning) return { widths: d.widths, kerning: d.kerning };
    var b = this.internal.getFont(d.fontName, d.fontStyle), _ = "Unicode";
    return b.metadata[_] ? { widths: b.metadata[_].widths || { 0: 1 }, kerning: b.metadata[_].kerning || {} } : { font: b.metadata, fontSize: this.internal.getFontSize(), charSpace: this.internal.getCharSpace() };
  }).call(this, e);
  n = Array.isArray(r) ? r : String(r).split(/\r?\n/);
  var c = 1 * this.internal.scaleFactor * t / i;
  s.textIndent = e.textIndent ? 1 * e.textIndent * this.internal.scaleFactor / i : 0, s.lineIndent = e.lineIndent;
  var o, l, f = [];
  for (o = 0, l = n.length; o < l; o++) f = f.concat(Ff.apply(this, [n[o], c, s]));
  return f;
}, (function(r) {
  r.__fontmetrics__ = r.__fontmetrics__ || {};
  for (var t = "0123456789abcdef", e = "klmnopqrstuvwxyz", n = {}, i = {}, s = 0; s < 16; s++) n[e[s]] = t[s], i[t[s]] = e[s];
  var c = function(_) {
    return "0x" + parseInt(_, 10).toString(16);
  }, o = r.__fontmetrics__.compress = function(_) {
    var g, y, x, E, N = ["{"];
    for (var H in _) {
      if (g = _[H], isNaN(parseInt(H, 10)) ? y = "'" + H + "'" : (H = parseInt(H, 10), y = (y = c(H).slice(2)).slice(0, -1) + i[y.slice(-1)]), typeof g == "number") g < 0 ? (x = c(g).slice(3), E = "-") : (x = c(g).slice(2), E = ""), x = E + x.slice(0, -1) + i[x.slice(-1)];
      else {
        if (xe(g) !== "object") throw new Error("Don't know what to do with value type " + xe(g) + ".");
        x = o(g);
      }
      N.push(y + x);
    }
    return N.push("}"), N.join("");
  }, l = r.__fontmetrics__.uncompress = function(_) {
    if (typeof _ != "string") throw new Error("Invalid argument passed to uncompress.");
    for (var g, y, x, E, N = {}, H = 1, q = N, F = [], et = "", Q = "", X = _.length - 1, V = 1; V < X; V += 1) (E = _[V]) == "'" ? g ? (x = g.join(""), g = void 0) : g = [] : g ? g.push(E) : E == "{" ? (F.push([q, x]), q = {}, x = void 0) : E == "}" ? ((y = F.pop())[0][y[1]] = q, x = void 0, q = y[0]) : E == "-" ? H = -1 : x === void 0 ? n.hasOwnProperty(E) ? (et += n[E], x = parseInt(et, 16) * H, H = 1, et = "") : et += E : n.hasOwnProperty(E) ? (Q += n[E], q[x] = parseInt(Q, 16) * H, H = 1, x = void 0, Q = "") : Q += E;
    return N;
  }, f = { codePages: ["WinAnsiEncoding"], WinAnsiEncoding: l("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}") }, d = { Unicode: { Courier: f, "Courier-Bold": f, "Courier-BoldOblique": f, "Courier-Oblique": f, Helvetica: f, "Helvetica-Bold": f, "Helvetica-BoldOblique": f, "Helvetica-Oblique": f, "Times-Roman": f, "Times-Bold": f, "Times-BoldItalic": f, "Times-Italic": f } }, b = { Unicode: { "Courier-Oblique": l("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Times-BoldItalic": l("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"), "Helvetica-Bold": l("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"), Courier: l("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Courier-BoldOblique": l("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Times-Bold": l("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"), Symbol: l("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"), Helvetica: l("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"), "Helvetica-BoldOblique": l("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"), ZapfDingbats: l("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"), "Courier-Bold": l("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Times-Italic": l("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"), "Times-Roman": l("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"), "Helvetica-Oblique": l("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}") } };
  r.events.push(["addFont", function(_) {
    var g = _.font, y = b.Unicode[g.postScriptName];
    y && (g.metadata.Unicode = {}, g.metadata.Unicode.widths = y.widths, g.metadata.Unicode.kerning = y.kerning);
    var x = d.Unicode[g.postScriptName];
    x && (g.metadata.Unicode.encoding = x, g.encoding = x.codePages[0]);
  }]);
})(Dt.API), /**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  var t = function(e) {
    for (var n = e.length, i = new Uint8Array(n), s = 0; s < n; s++) i[s] = e.charCodeAt(s);
    return i;
  };
  r.API.events.push(["addFont", function(e) {
    var n = void 0, i = e.font, s = e.instance;
    if (!i.isStandardFont) {
      if (s === void 0) throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('" + i.postScriptName + "').");
      if (typeof (n = s.existsFileInVFS(i.postScriptName) === !1 ? s.loadFile(i.postScriptName) : s.getFileFromVFS(i.postScriptName)) != "string") throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('" + i.postScriptName + "').");
      (function(c, o) {
        o = /^\x00\x01\x00\x00/.test(o) ? t(o) : t(fo(o)), c.metadata = r.API.TTFFont.open(o), c.metadata.Unicode = c.metadata.Unicode || { encoding: {}, kerning: {}, widths: [] }, c.metadata.glyIdsUsed = [0];
      })(i, n);
    }
  }]);
})(Dt), Dt.API.addSvgAsImage = function(r, t, e, n, i, s, c, o) {
  if (isNaN(t) || isNaN(e)) throw Pe.error("jsPDF.addSvgAsImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");
  if (isNaN(n) || isNaN(i)) throw Pe.error("jsPDF.addSvgAsImage: Invalid measurements", arguments), new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");
  var l = document.createElement("canvas");
  l.width = n, l.height = i;
  var f = l.getContext("2d");
  f.fillStyle = "#fff", f.fillRect(0, 0, l.width, l.height);
  var d = { ignoreMouse: !0, ignoreAnimation: !0, ignoreDimensions: !0 }, b = this;
  return (Kt.canvg ? Promise.resolve(Kt.canvg) : import("./index.es-CvXp564e.mjs")).catch(function(_) {
    return Promise.reject(new Error("Could not load canvg: " + _));
  }).then(function(_) {
    return _.default ? _.default : _;
  }).then(function(_) {
    return _.fromString(f, r, d);
  }, function() {
    return Promise.reject(new Error("Could not load canvg."));
  }).then(function(_) {
    return _.render(d);
  }).then(function() {
    b.addImage(l.toDataURL("image/jpeg", 1), t, e, n, i, c, o);
  });
}, Dt.API.putTotalPages = function(r) {
  var t, e = 0;
  parseInt(this.internal.getFont().id.substr(1), 10) < 15 ? (t = new RegExp(r, "g"), e = this.internal.getNumberOfPages()) : (t = new RegExp(this.pdfEscape16(r, this.internal.getFont()), "g"), e = this.pdfEscape16(this.internal.getNumberOfPages() + "", this.internal.getFont()));
  for (var n = 1; n <= this.internal.getNumberOfPages(); n++) for (var i = 0; i < this.internal.pages[n].length; i++) this.internal.pages[n][i] = this.internal.pages[n][i].replace(t, e);
  return this;
}, Dt.API.viewerPreferences = function(r, t) {
  var e;
  r = r || {}, t = t || !1;
  var n, i, s, c = { HideToolbar: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, HideMenubar: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, HideWindowUI: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, FitWindow: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, CenterWindow: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, DisplayDocTitle: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.4 }, NonFullScreenPageMode: { defaultValue: "UseNone", value: "UseNone", type: "name", explicitSet: !1, valueSet: ["UseNone", "UseOutlines", "UseThumbs", "UseOC"], pdfVersion: 1.3 }, Direction: { defaultValue: "L2R", value: "L2R", type: "name", explicitSet: !1, valueSet: ["L2R", "R2L"], pdfVersion: 1.3 }, ViewArea: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, ViewClip: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, PrintArea: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, PrintClip: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, PrintScaling: { defaultValue: "AppDefault", value: "AppDefault", type: "name", explicitSet: !1, valueSet: ["AppDefault", "None"], pdfVersion: 1.6 }, Duplex: { defaultValue: "", value: "none", type: "name", explicitSet: !1, valueSet: ["Simplex", "DuplexFlipShortEdge", "DuplexFlipLongEdge", "none"], pdfVersion: 1.7 }, PickTrayByPDFSize: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.7 }, PrintPageRange: { defaultValue: "", value: "", type: "array", explicitSet: !1, valueSet: null, pdfVersion: 1.7 }, NumCopies: { defaultValue: 1, value: 1, type: "integer", explicitSet: !1, valueSet: null, pdfVersion: 1.7 } }, o = Object.keys(c), l = [], f = 0, d = 0, b = 0;
  function _(y, x) {
    var E, N = !1;
    for (E = 0; E < y.length; E += 1) y[E] === x && (N = !0);
    return N;
  }
  if (this.internal.viewerpreferences === void 0 && (this.internal.viewerpreferences = {}, this.internal.viewerpreferences.configuration = JSON.parse(JSON.stringify(c)), this.internal.viewerpreferences.isSubscribed = !1), e = this.internal.viewerpreferences.configuration, r === "reset" || t === !0) {
    var g = o.length;
    for (b = 0; b < g; b += 1) e[o[b]].value = e[o[b]].defaultValue, e[o[b]].explicitSet = !1;
  }
  if (xe(r) === "object") {
    for (i in r) if (s = r[i], _(o, i) && s !== void 0) {
      if (e[i].type === "boolean" && typeof s == "boolean") e[i].value = s;
      else if (e[i].type === "name" && _(e[i].valueSet, s)) e[i].value = s;
      else if (e[i].type === "integer" && Number.isInteger(s)) e[i].value = s;
      else if (e[i].type === "array") {
        for (f = 0; f < s.length; f += 1) if (n = !0, s[f].length === 1 && typeof s[f][0] == "number") l.push(String(s[f] - 1));
        else if (s[f].length > 1) {
          for (d = 0; d < s[f].length; d += 1) typeof s[f][d] != "number" && (n = !1);
          n === !0 && l.push([s[f][0] - 1, s[f][1] - 1].join(" "));
        }
        e[i].value = "[" + l.join(" ") + "]";
      } else e[i].value = e[i].defaultValue;
      e[i].explicitSet = !0;
    }
  }
  return this.internal.viewerpreferences.isSubscribed === !1 && (this.internal.events.subscribe("putCatalog", function() {
    var y, x = [];
    for (y in e) e[y].explicitSet === !0 && (e[y].type === "name" ? x.push("/" + y + " /" + e[y].value) : x.push("/" + y + " " + e[y].value));
    x.length !== 0 && this.internal.write(`/ViewerPreferences
<<
` + x.join(`
`) + `
>>`);
  }), this.internal.viewerpreferences.isSubscribed = !0), this.internal.viewerpreferences.configuration = e, this;
}, /** ====================================================================
 * @license
 * jsPDF XMP metadata plugin
 * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
(function(r) {
  var t = function() {
    var n = '<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="' + this.internal.__metadata__.namespaceuri + '"><jspdf:metadata>', i = unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')), s = unescape(encodeURIComponent(n)), c = unescape(encodeURIComponent(this.internal.__metadata__.metadata)), o = unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")), l = unescape(encodeURIComponent("</x:xmpmeta>")), f = s.length + c.length + o.length + i.length + l.length;
    this.internal.__metadata__.metadata_object_number = this.internal.newObject(), this.internal.write("<< /Type /Metadata /Subtype /XML /Length " + f + " >>"), this.internal.write("stream"), this.internal.write(i + s + c + o + l), this.internal.write("endstream"), this.internal.write("endobj");
  }, e = function() {
    this.internal.__metadata__.metadata_object_number && this.internal.write("/Metadata " + this.internal.__metadata__.metadata_object_number + " 0 R");
  };
  r.addMetadata = function(n, i) {
    return this.internal.__metadata__ === void 0 && (this.internal.__metadata__ = { metadata: n, namespaceuri: i || "http://jspdf.default.namespaceuri/" }, this.internal.events.subscribe("putCatalog", e), this.internal.events.subscribe("postPutResources", t)), this;
  };
})(Dt.API), (function(r) {
  var t = r.API, e = t.pdfEscape16 = function(s, c) {
    for (var o, l = c.metadata.Unicode.widths, f = ["", "0", "00", "000", "0000"], d = [""], b = 0, _ = s.length; b < _; ++b) {
      if (o = c.metadata.characterToGlyph(s.charCodeAt(b)), c.metadata.glyIdsUsed.push(o), c.metadata.toUnicode[o] = s.charCodeAt(b), l.indexOf(o) == -1 && (l.push(o), l.push([parseInt(c.metadata.widthOfGlyph(o), 10)])), o == "0") return d.join("");
      o = o.toString(16), d.push(f[4 - o.length], o);
    }
    return d.join("");
  }, n = function(s) {
    var c, o, l, f, d, b, _;
    for (d = `/CIDInit /ProcSet findresource begin
12 dict begin
begincmap
/CIDSystemInfo <<
  /Registry (Adobe)
  /Ordering (UCS)
  /Supplement 0
>> def
/CMapName /Adobe-Identity-UCS def
/CMapType 2 def
1 begincodespacerange
<0000><ffff>
endcodespacerange`, l = [], b = 0, _ = (o = Object.keys(s).sort(function(g, y) {
      return g - y;
    })).length; b < _; b++) c = o[b], l.length >= 100 && (d += `
` + l.length + ` beginbfchar
` + l.join(`
`) + `
endbfchar`, l = []), s[c] !== void 0 && s[c] !== null && typeof s[c].toString == "function" && (f = ("0000" + s[c].toString(16)).slice(-4), c = ("0000" + (+c).toString(16)).slice(-4), l.push("<" + c + "><" + f + ">"));
    return l.length && (d += `
` + l.length + ` beginbfchar
` + l.join(`
`) + `
endbfchar
`), d + `endcmap
CMapName currentdict /CMap defineresource pop
end
end`;
  };
  t.events.push(["putFont", function(s) {
    (function(c) {
      var o = c.font, l = c.out, f = c.newObject, d = c.putStream;
      if (o.metadata instanceof r.API.TTFFont && o.encoding === "Identity-H") {
        for (var b = o.metadata.Unicode.widths, _ = o.metadata.subset.encode(o.metadata.glyIdsUsed, 1), g = "", y = 0; y < _.length; y++) g += String.fromCharCode(_[y]);
        var x = f();
        d({ data: g, addLength1: !0, objectId: x }), l("endobj");
        var E = f();
        d({ data: n(o.metadata.toUnicode), addLength1: !0, objectId: E }), l("endobj");
        var N = f();
        l("<<"), l("/Type /FontDescriptor"), l("/FontName /" + ps(o.fontName)), l("/FontFile2 " + x + " 0 R"), l("/FontBBox " + r.API.PDFObject.convert(o.metadata.bbox)), l("/Flags " + o.metadata.flags), l("/StemV " + o.metadata.stemV), l("/ItalicAngle " + o.metadata.italicAngle), l("/Ascent " + o.metadata.ascender), l("/Descent " + o.metadata.decender), l("/CapHeight " + o.metadata.capHeight), l(">>"), l("endobj");
        var H = f();
        l("<<"), l("/Type /Font"), l("/BaseFont /" + ps(o.fontName)), l("/FontDescriptor " + N + " 0 R"), l("/W " + r.API.PDFObject.convert(b)), l("/CIDToGIDMap /Identity"), l("/DW 1000"), l("/Subtype /CIDFontType2"), l("/CIDSystemInfo"), l("<<"), l("/Supplement 0"), l("/Registry (Adobe)"), l("/Ordering (" + o.encoding + ")"), l(">>"), l(">>"), l("endobj"), o.objectNumber = f(), l("<<"), l("/Type /Font"), l("/Subtype /Type0"), l("/ToUnicode " + E + " 0 R"), l("/BaseFont /" + ps(o.fontName)), l("/Encoding /" + o.encoding), l("/DescendantFonts [" + H + " 0 R]"), l(">>"), l("endobj"), o.isAlreadyPutted = !0;
      }
    })(s);
  }]), t.events.push(["putFont", function(s) {
    (function(c) {
      var o = c.font, l = c.out, f = c.newObject, d = c.putStream;
      if (o.metadata instanceof r.API.TTFFont && o.encoding === "WinAnsiEncoding") {
        for (var b = o.metadata.rawData, _ = "", g = 0; g < b.length; g++) _ += String.fromCharCode(b[g]);
        var y = f();
        d({ data: _, addLength1: !0, objectId: y }), l("endobj");
        var x = f();
        d({ data: n(o.metadata.toUnicode), addLength1: !0, objectId: x }), l("endobj");
        var E = f();
        l("<<"), l("/Descent " + o.metadata.decender), l("/CapHeight " + o.metadata.capHeight), l("/StemV " + o.metadata.stemV), l("/Type /FontDescriptor"), l("/FontFile2 " + y + " 0 R"), l("/Flags 96"), l("/FontBBox " + r.API.PDFObject.convert(o.metadata.bbox)), l("/FontName /" + ps(o.fontName)), l("/ItalicAngle " + o.metadata.italicAngle), l("/Ascent " + o.metadata.ascender), l(">>"), l("endobj"), o.objectNumber = f();
        for (var N = 0; N < o.metadata.hmtx.widths.length; N++) o.metadata.hmtx.widths[N] = parseInt(o.metadata.hmtx.widths[N] * (1e3 / o.metadata.head.unitsPerEm));
        l("<</Subtype/TrueType/Type/Font/ToUnicode " + x + " 0 R/BaseFont/" + ps(o.fontName) + "/FontDescriptor " + E + " 0 R/Encoding/" + o.encoding + " /FirstChar 29 /LastChar 255 /Widths " + r.API.PDFObject.convert(o.metadata.hmtx.widths) + ">>"), l("endobj"), o.isAlreadyPutted = !0;
      }
    })(s);
  }]);
  var i = function(s) {
    var c, o = s.text || "", l = s.x, f = s.y, d = s.options || {}, b = s.mutex || {}, _ = b.pdfEscape, g = b.activeFontKey, y = b.fonts, x = g, E = "", N = 0, H = "", q = y[x].encoding;
    if (y[x].encoding !== "Identity-H") return { text: o, x: l, y: f, options: d, mutex: b };
    for (H = o, x = g, Array.isArray(o) && (H = o[0]), N = 0; N < H.length; N += 1) y[x].metadata.hasOwnProperty("cmap") && (c = y[x].metadata.cmap.unicode.codeMap[H[N].charCodeAt(0)]), c || H[N].charCodeAt(0) < 256 && y[x].metadata.hasOwnProperty("Unicode") ? E += H[N] : E += "";
    var F = "";
    return parseInt(x.slice(1)) < 14 || q === "WinAnsiEncoding" ? F = _(E, x).split("").map(function(et) {
      return et.charCodeAt(0).toString(16);
    }).join("") : q === "Identity-H" && (F = e(E, y[x])), b.isHex = !0, { text: F, x: l, y: f, options: d, mutex: b };
  };
  t.events.push(["postProcessText", function(s) {
    var c = s.text || "", o = [], l = { text: c, x: s.x, y: s.y, options: s.options, mutex: s.mutex };
    if (Array.isArray(c)) {
      var f = 0;
      for (f = 0; f < c.length; f += 1) Array.isArray(c[f]) && c[f].length === 3 ? o.push([i(Object.assign({}, l, { text: c[f][0] })).text, c[f][1], c[f][2]]) : o.push(i(Object.assign({}, l, { text: c[f] })).text);
      s.text = o;
    } else s.text = i(Object.assign({}, l, { text: c })).text;
  }]);
})(Dt), /**
 * @license
 * jsPDF virtual FileSystem functionality
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
(function(r) {
  var t = function() {
    return this.internal.vFS === void 0 && (this.internal.vFS = {}), !0;
  };
  r.existsFileInVFS = function(e) {
    return t.call(this), this.internal.vFS[e] !== void 0;
  }, r.addFileToVFS = function(e, n) {
    return t.call(this), this.internal.vFS[e] = n, this;
  }, r.getFileFromVFS = function(e) {
    return t.call(this), this.internal.vFS[e] !== void 0 ? this.internal.vFS[e] : null;
  };
})(Dt.API), /**
 * @license
 * Unicode Bidi Engine based on the work of Alex Shensis (@asthensis)
 * MIT License
 */
(function(r) {
  r.__bidiEngine__ = r.prototype.__bidiEngine__ = function(n) {
    var i, s, c, o, l, f, d, b = t, _ = [[0, 3, 0, 1, 0, 0, 0], [0, 3, 0, 1, 2, 2, 0], [0, 3, 0, 17, 2, 0, 1], [0, 3, 5, 5, 4, 1, 0], [0, 3, 21, 21, 4, 0, 1], [0, 3, 5, 5, 4, 2, 0]], g = [[2, 0, 1, 1, 0, 1, 0], [2, 0, 1, 1, 0, 2, 0], [2, 0, 2, 1, 3, 2, 0], [2, 0, 2, 33, 3, 1, 1]], y = { L: 0, R: 1, EN: 2, AN: 3, N: 4, B: 5, S: 6 }, x = { 0: 0, 5: 1, 6: 2, 7: 3, 32: 4, 251: 5, 254: 6, 255: 7 }, E = ["(", ")", "(", "<", ">", "<", "[", "]", "[", "{", "}", "{", "«", "»", "«", "‹", "›", "‹", "⁅", "⁆", "⁅", "⁽", "⁾", "⁽", "₍", "₎", "₍", "≤", "≥", "≤", "〈", "〉", "〈", "﹙", "﹚", "﹙", "﹛", "﹜", "﹛", "﹝", "﹞", "﹝", "﹤", "﹥", "﹤"], N = new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/), H = !1, q = 0;
    this.__bidiEngine__ = {};
    var F = function(A) {
      var C = A.charCodeAt(), M = C >> 8, D = x[M];
      return D !== void 0 ? b[256 * D + (255 & C)] : M === 252 || M === 253 ? "AL" : N.test(M) ? "L" : M === 8 ? "R" : "N";
    }, et = function(A) {
      for (var C, M = 0; M < A.length; M++) {
        if ((C = F(A.charAt(M))) === "L") return !1;
        if (C === "R") return !0;
      }
      return !1;
    }, Q = function(A, C, M, D) {
      var at, ot, ft, rt, ht = C[D];
      switch (ht) {
        case "L":
        case "R":
        case "LRE":
        case "RLE":
        case "LRO":
        case "RLO":
        case "PDF":
          H = !1;
          break;
        case "N":
        case "AN":
          break;
        case "EN":
          H && (ht = "AN");
          break;
        case "AL":
          H = !0, ht = "R";
          break;
        case "WS":
        case "BN":
          ht = "N";
          break;
        case "CS":
          D < 1 || D + 1 >= C.length || (at = M[D - 1]) !== "EN" && at !== "AN" || (ot = C[D + 1]) !== "EN" && ot !== "AN" ? ht = "N" : H && (ot = "AN"), ht = ot === at ? ot : "N";
          break;
        case "ES":
          ht = (at = D > 0 ? M[D - 1] : "B") === "EN" && D + 1 < C.length && C[D + 1] === "EN" ? "EN" : "N";
          break;
        case "ET":
          if (D > 0 && M[D - 1] === "EN") {
            ht = "EN";
            break;
          }
          if (H) {
            ht = "N";
            break;
          }
          for (ft = D + 1, rt = C.length; ft < rt && C[ft] === "ET"; ) ft++;
          ht = ft < rt && C[ft] === "EN" ? "EN" : "N";
          break;
        case "NSM":
          if (c && !o) {
            for (rt = C.length, ft = D + 1; ft < rt && C[ft] === "NSM"; ) ft++;
            if (ft < rt) {
              var Lt = A[D], vt = Lt >= 1425 && Lt <= 2303 || Lt === 64286;
              if (at = C[ft], vt && (at === "R" || at === "AL")) {
                ht = "R";
                break;
              }
            }
          }
          ht = D < 1 || (at = C[D - 1]) === "B" ? "N" : M[D - 1];
          break;
        case "B":
          H = !1, i = !0, ht = q;
          break;
        case "S":
          s = !0, ht = "N";
      }
      return ht;
    }, X = function(A, C, M) {
      var D = A.split("");
      return M && V(D, M, { hiLevel: q }), D.reverse(), C && C.reverse(), D.join("");
    }, V = function(A, C, M) {
      var D, at, ot, ft, rt, ht = -1, Lt = A.length, vt = 0, S = [], j = q ? g : _, z = [];
      for (H = !1, i = !1, s = !1, at = 0; at < Lt; at++) z[at] = F(A[at]);
      for (ot = 0; ot < Lt; ot++) {
        if (rt = vt, S[ot] = Q(A, z, S, ot), D = 240 & (vt = j[rt][y[S[ot]]]), vt &= 15, C[ot] = ft = j[vt][5], D > 0) if (D === 16) {
          for (at = ht; at < ot; at++) C[at] = 1;
          ht = -1;
        } else ht = -1;
        if (j[vt][6]) ht === -1 && (ht = ot);
        else if (ht > -1) {
          for (at = ht; at < ot; at++) C[at] = ft;
          ht = -1;
        }
        z[ot] === "B" && (C[ot] = 0), M.hiLevel |= ft;
      }
      s && (function(J, $, nt) {
        for (var lt = 0; lt < nt; lt++) if (J[lt] === "S") {
          $[lt] = q;
          for (var ct = lt - 1; ct >= 0 && J[ct] === "WS"; ct--) $[ct] = q;
        }
      })(z, C, Lt);
    }, I = function(A, C, M, D, at) {
      if (!(at.hiLevel < A)) {
        if (A === 1 && q === 1 && !i) return C.reverse(), void (M && M.reverse());
        for (var ot, ft, rt, ht, Lt = C.length, vt = 0; vt < Lt; ) {
          if (D[vt] >= A) {
            for (rt = vt + 1; rt < Lt && D[rt] >= A; ) rt++;
            for (ht = vt, ft = rt - 1; ht < ft; ht++, ft--) ot = C[ht], C[ht] = C[ft], C[ft] = ot, M && (ot = M[ht], M[ht] = M[ft], M[ft] = ot);
            vt = rt;
          }
          vt++;
        }
      }
    }, G = function(A, C, M) {
      var D = A.split(""), at = { hiLevel: q };
      return M || (M = []), V(D, M, at), (function(ot, ft, rt) {
        if (rt.hiLevel !== 0 && d) for (var ht, Lt = 0; Lt < ot.length; Lt++) ft[Lt] === 1 && (ht = E.indexOf(ot[Lt])) >= 0 && (ot[Lt] = E[ht + 1]);
      })(D, M, at), I(2, D, C, M, at), I(1, D, C, M, at), D.join("");
    };
    return this.__bidiEngine__.doBidiReorder = function(A, C, M) {
      if ((function(at, ot) {
        if (ot) for (var ft = 0; ft < at.length; ft++) ot[ft] = ft;
        o === void 0 && (o = et(at)), f === void 0 && (f = et(at));
      })(A, C), c || !l || f) if (c && l && o ^ f) q = o ? 1 : 0, A = X(A, C, M);
      else if (!c && l && f) q = o ? 1 : 0, A = G(A, C, M), A = X(A, C);
      else if (!c || o || l || f) {
        if (c && !l && o ^ f) A = X(A, C), o ? (q = 0, A = G(A, C, M)) : (q = 1, A = G(A, C, M), A = X(A, C));
        else if (c && o && !l && f) q = 1, A = G(A, C, M), A = X(A, C);
        else if (!c && !l && o ^ f) {
          var D = d;
          o ? (q = 1, A = G(A, C, M), q = 0, d = !1, A = G(A, C, M), d = D) : (q = 0, A = G(A, C, M), A = X(A, C), q = 1, d = !1, A = G(A, C, M), d = D, A = X(A, C));
        }
      } else q = 0, A = G(A, C, M);
      else q = o ? 1 : 0, A = G(A, C, M);
      return A;
    }, this.__bidiEngine__.setOptions = function(A) {
      A && (c = A.isInputVisual, l = A.isOutputVisual, o = A.isInputRtl, f = A.isOutputRtl, d = A.isSymmetricSwapping);
    }, this.__bidiEngine__.setOptions(n), this.__bidiEngine__;
  };
  var t = ["BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "S", "B", "S", "WS", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "B", "B", "B", "S", "WS", "N", "N", "ET", "ET", "ET", "N", "N", "N", "N", "N", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "BN", "BN", "BN", "BN", "BN", "BN", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "CS", "N", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "L", "N", "N", "BN", "N", "N", "ET", "ET", "EN", "EN", "N", "L", "N", "N", "N", "EN", "L", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "N", "N", "N", "N", "N", "ET", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "R", "NSM", "R", "NSM", "NSM", "R", "NSM", "NSM", "R", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "AN", "AN", "AN", "AN", "AN", "AN", "N", "N", "AL", "ET", "ET", "AL", "CS", "AL", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "ET", "AN", "AN", "AL", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "NSM", "NSM", "N", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "R", "R", "N", "N", "N", "N", "R", "N", "N", "N", "N", "N", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "BN", "BN", "BN", "L", "R", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "WS", "B", "LRE", "RLE", "PDF", "LRO", "RLO", "CS", "ET", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "CS", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "WS", "BN", "BN", "BN", "BN", "BN", "N", "LRI", "RLI", "FSI", "PDI", "BN", "BN", "BN", "BN", "BN", "BN", "EN", "L", "N", "N", "EN", "EN", "EN", "EN", "EN", "EN", "ES", "ES", "N", "N", "N", "L", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "ES", "ES", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "R", "NSM", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "ES", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "N", "R", "R", "R", "R", "R", "N", "R", "N", "R", "R", "N", "R", "R", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "CS", "N", "CS", "N", "N", "CS", "N", "N", "N", "N", "N", "N", "N", "N", "N", "ET", "N", "N", "ES", "ES", "N", "N", "N", "N", "N", "ET", "ET", "N", "N", "N", "N", "N", "AL", "AL", "AL", "AL", "AL", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "N", "BN", "N", "N", "N", "ET", "ET", "ET", "N", "N", "N", "N", "N", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "N", "N", "N", "ET", "ET", "N", "N", "N", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N"], e = new r.__bidiEngine__({ isInputVisual: !0 });
  r.API.events.push(["postProcessText", function(n) {
    var i = n.text;
    n.x, n.y;
    var s = n.options || {};
    n.mutex, s.lang;
    var c = [];
    if (s.isInputVisual = typeof s.isInputVisual != "boolean" || s.isInputVisual, e.setOptions(s), Object.prototype.toString.call(i) === "[object Array]") {
      var o = 0;
      for (c = [], o = 0; o < i.length; o += 1) Object.prototype.toString.call(i[o]) === "[object Array]" ? c.push([e.doBidiReorder(i[o][0]), i[o][1], i[o][2]]) : c.push([e.doBidiReorder(i[o])]);
      n.text = c;
    } else n.text = e.doBidiReorder(i);
    e.setOptions({ isInputVisual: !0 });
  }]);
})(Dt), Dt.API.TTFFont = (function() {
  function r(t) {
    var e;
    if (this.rawData = t, e = this.contents = new di(t), this.contents.pos = 4, e.readString(4) === "ttcf") throw new Error("TTCF not supported.");
    e.pos = 0, this.parse(), this.subset = new ep(this), this.registerTTF();
  }
  return r.open = function(t) {
    return new r(t);
  }, r.prototype.parse = function() {
    return this.directory = new U5(this.contents), this.head = new H5(this), this.name = new Y5(this), this.cmap = new C1(this), this.toUnicode = {}, this.hhea = new V5(this), this.maxp = new K5(this), this.hmtx = new X5(this), this.post = new G5(this), this.os2 = new W5(this), this.loca = new tp(this), this.glyf = new $5(this), this.ascender = this.os2.exists && this.os2.ascender || this.hhea.ascender, this.decender = this.os2.exists && this.os2.decender || this.hhea.decender, this.lineGap = this.os2.exists && this.os2.lineGap || this.hhea.lineGap, this.bbox = [this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax];
  }, r.prototype.registerTTF = function() {
    var t, e, n, i, s;
    if (this.scaleFactor = 1e3 / this.head.unitsPerEm, this.bbox = (function() {
      var c, o, l, f;
      for (f = [], c = 0, o = (l = this.bbox).length; c < o; c++) t = l[c], f.push(Math.round(t * this.scaleFactor));
      return f;
    }).call(this), this.stemV = 0, this.post.exists ? (n = 255 & (i = this.post.italic_angle), 32768 & (e = i >> 16) && (e = -(1 + (65535 ^ e))), this.italicAngle = +(e + "." + n)) : this.italicAngle = 0, this.ascender = Math.round(this.ascender * this.scaleFactor), this.decender = Math.round(this.decender * this.scaleFactor), this.lineGap = Math.round(this.lineGap * this.scaleFactor), this.capHeight = this.os2.exists && this.os2.capHeight || this.ascender, this.xHeight = this.os2.exists && this.os2.xHeight || 0, this.familyClass = (this.os2.exists && this.os2.familyClass || 0) >> 8, this.isSerif = (s = this.familyClass) === 1 || s === 2 || s === 3 || s === 4 || s === 5 || s === 7, this.isScript = this.familyClass === 10, this.flags = 0, this.post.isFixedPitch && (this.flags |= 1), this.isSerif && (this.flags |= 2), this.isScript && (this.flags |= 8), this.italicAngle !== 0 && (this.flags |= 64), this.flags |= 32, !this.cmap.unicode) throw new Error("No unicode cmap for font");
  }, r.prototype.characterToGlyph = function(t) {
    var e;
    return ((e = this.cmap.unicode) != null ? e.codeMap[t] : void 0) || 0;
  }, r.prototype.widthOfGlyph = function(t) {
    var e;
    return e = 1e3 / this.head.unitsPerEm, this.hmtx.forGlyph(t).advance * e;
  }, r.prototype.widthOfString = function(t, e, n) {
    var i, s, c, o;
    for (c = 0, s = 0, o = (t = "" + t).length; 0 <= o ? s < o : s > o; s = 0 <= o ? ++s : --s) i = t.charCodeAt(s), c += this.widthOfGlyph(this.characterToGlyph(i)) + n * (1e3 / e) || 0;
    return c * (e / 1e3);
  }, r.prototype.lineHeight = function(t, e) {
    var n;
    return e == null && (e = !1), n = e ? this.lineGap : 0, (this.ascender + n - this.decender) / 1e3 * t;
  }, r;
})();
var dn, di = (function() {
  function r(t) {
    this.data = t ?? [], this.pos = 0, this.length = this.data.length;
  }
  return r.prototype.readByte = function() {
    return this.data[this.pos++];
  }, r.prototype.writeByte = function(t) {
    return this.data[this.pos++] = t;
  }, r.prototype.readUInt32 = function() {
    return 16777216 * this.readByte() + (this.readByte() << 16) + (this.readByte() << 8) + this.readByte();
  }, r.prototype.writeUInt32 = function(t) {
    return this.writeByte(t >>> 24 & 255), this.writeByte(t >> 16 & 255), this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
  }, r.prototype.readInt32 = function() {
    var t;
    return (t = this.readUInt32()) >= 2147483648 ? t - 4294967296 : t;
  }, r.prototype.writeInt32 = function(t) {
    return t < 0 && (t += 4294967296), this.writeUInt32(t);
  }, r.prototype.readUInt16 = function() {
    return this.readByte() << 8 | this.readByte();
  }, r.prototype.writeUInt16 = function(t) {
    return this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
  }, r.prototype.readInt16 = function() {
    var t;
    return (t = this.readUInt16()) >= 32768 ? t - 65536 : t;
  }, r.prototype.writeInt16 = function(t) {
    return t < 0 && (t += 65536), this.writeUInt16(t);
  }, r.prototype.readString = function(t) {
    var e, n;
    for (n = [], e = 0; 0 <= t ? e < t : e > t; e = 0 <= t ? ++e : --e) n[e] = String.fromCharCode(this.readByte());
    return n.join("");
  }, r.prototype.writeString = function(t) {
    var e, n, i;
    for (i = [], e = 0, n = t.length; 0 <= n ? e < n : e > n; e = 0 <= n ? ++e : --e) i.push(this.writeByte(t.charCodeAt(e)));
    return i;
  }, r.prototype.readShort = function() {
    return this.readInt16();
  }, r.prototype.writeShort = function(t) {
    return this.writeInt16(t);
  }, r.prototype.readLongLong = function() {
    var t, e, n, i, s, c, o, l;
    return t = this.readByte(), e = this.readByte(), n = this.readByte(), i = this.readByte(), s = this.readByte(), c = this.readByte(), o = this.readByte(), l = this.readByte(), 128 & t ? -1 * (72057594037927940 * (255 ^ t) + 281474976710656 * (255 ^ e) + 1099511627776 * (255 ^ n) + 4294967296 * (255 ^ i) + 16777216 * (255 ^ s) + 65536 * (255 ^ c) + 256 * (255 ^ o) + (255 ^ l) + 1) : 72057594037927940 * t + 281474976710656 * e + 1099511627776 * n + 4294967296 * i + 16777216 * s + 65536 * c + 256 * o + l;
  }, r.prototype.writeLongLong = function(t) {
    var e, n;
    return e = Math.floor(t / 4294967296), n = 4294967295 & t, this.writeByte(e >> 24 & 255), this.writeByte(e >> 16 & 255), this.writeByte(e >> 8 & 255), this.writeByte(255 & e), this.writeByte(n >> 24 & 255), this.writeByte(n >> 16 & 255), this.writeByte(n >> 8 & 255), this.writeByte(255 & n);
  }, r.prototype.readInt = function() {
    return this.readInt32();
  }, r.prototype.writeInt = function(t) {
    return this.writeInt32(t);
  }, r.prototype.read = function(t) {
    var e, n;
    for (e = [], n = 0; 0 <= t ? n < t : n > t; n = 0 <= t ? ++n : --n) e.push(this.readByte());
    return e;
  }, r.prototype.write = function(t) {
    var e, n, i, s;
    for (s = [], n = 0, i = t.length; n < i; n++) e = t[n], s.push(this.writeByte(e));
    return s;
  }, r;
})(), U5 = (function() {
  var r;
  function t(e) {
    var n, i, s;
    for (this.scalarType = e.readInt(), this.tableCount = e.readShort(), this.searchRange = e.readShort(), this.entrySelector = e.readShort(), this.rangeShift = e.readShort(), this.tables = {}, i = 0, s = this.tableCount; 0 <= s ? i < s : i > s; i = 0 <= s ? ++i : --i) n = { tag: e.readString(4), checksum: e.readInt(), offset: e.readInt(), length: e.readInt() }, this.tables[n.tag] = n;
  }
  return t.prototype.encode = function(e) {
    var n, i, s, c, o, l, f, d, b, _, g, y, x;
    for (x in g = Object.keys(e).length, l = Math.log(2), b = 16 * Math.floor(Math.log(g) / l), c = Math.floor(b / l), d = 16 * g - b, (i = new di()).writeInt(this.scalarType), i.writeShort(g), i.writeShort(b), i.writeShort(c), i.writeShort(d), s = 16 * g, f = i.pos + s, o = null, y = [], e) for (_ = e[x], i.writeString(x), i.writeInt(r(_)), i.writeInt(f), i.writeInt(_.length), y = y.concat(_), x === "head" && (o = f), f += _.length; f % 4; ) y.push(0), f++;
    return i.write(y), n = 2981146554 - r(i.data), i.pos = o + 8, i.writeUInt32(n), i.data;
  }, r = function(e) {
    var n, i, s, c;
    for (e = R1.call(e); e.length % 4; ) e.push(0);
    for (s = new di(e), i = 0, n = 0, c = e.length; n < c; n = n += 4) i += s.readUInt32();
    return 4294967295 & i;
  }, t;
})(), z5 = {}.hasOwnProperty, Sn = function(r, t) {
  for (var e in t) z5.call(t, e) && (r[e] = t[e]);
  function n() {
    this.constructor = r;
  }
  return n.prototype = t.prototype, r.prototype = new n(), r.__super__ = t.prototype, r;
};
dn = (function() {
  function r(t) {
    var e;
    this.file = t, e = this.file.directory.tables[this.tag], this.exists = !!e, e && (this.offset = e.offset, this.length = e.length, this.parse(this.file.contents));
  }
  return r.prototype.parse = function() {
  }, r.prototype.encode = function() {
  }, r.prototype.raw = function() {
    return this.exists ? (this.file.contents.pos = this.offset, this.file.contents.read(this.length)) : null;
  }, r;
})();
var H5 = (function() {
  function r() {
    return r.__super__.constructor.apply(this, arguments);
  }
  return Sn(r, dn), r.prototype.tag = "head", r.prototype.parse = function(t) {
    return t.pos = this.offset, this.version = t.readInt(), this.revision = t.readInt(), this.checkSumAdjustment = t.readInt(), this.magicNumber = t.readInt(), this.flags = t.readShort(), this.unitsPerEm = t.readShort(), this.created = t.readLongLong(), this.modified = t.readLongLong(), this.xMin = t.readShort(), this.yMin = t.readShort(), this.xMax = t.readShort(), this.yMax = t.readShort(), this.macStyle = t.readShort(), this.lowestRecPPEM = t.readShort(), this.fontDirectionHint = t.readShort(), this.indexToLocFormat = t.readShort(), this.glyphDataFormat = t.readShort();
  }, r.prototype.encode = function(t) {
    var e;
    return (e = new di()).writeInt(this.version), e.writeInt(this.revision), e.writeInt(this.checkSumAdjustment), e.writeInt(this.magicNumber), e.writeShort(this.flags), e.writeShort(this.unitsPerEm), e.writeLongLong(this.created), e.writeLongLong(this.modified), e.writeShort(this.xMin), e.writeShort(this.yMin), e.writeShort(this.xMax), e.writeShort(this.yMax), e.writeShort(this.macStyle), e.writeShort(this.lowestRecPPEM), e.writeShort(this.fontDirectionHint), e.writeShort(t), e.writeShort(this.glyphDataFormat), e.data;
  }, r;
})(), zf = (function() {
  function r(t, e) {
    var n, i, s, c, o, l, f, d, b, _, g, y, x, E, N, H, q;
    switch (this.platformID = t.readUInt16(), this.encodingID = t.readShort(), this.offset = e + t.readInt(), b = t.pos, t.pos = this.offset, this.format = t.readUInt16(), this.length = t.readUInt16(), this.language = t.readUInt16(), this.isUnicode = this.platformID === 3 && this.encodingID === 1 && this.format === 4 || this.platformID === 0 && this.format === 4, this.codeMap = {}, this.format) {
      case 0:
        for (l = 0; l < 256; ++l) this.codeMap[l] = t.readByte();
        break;
      case 4:
        for (g = t.readUInt16(), _ = g / 2, t.pos += 6, s = (function() {
          var F, et;
          for (et = [], l = F = 0; 0 <= _ ? F < _ : F > _; l = 0 <= _ ? ++F : --F) et.push(t.readUInt16());
          return et;
        })(), t.pos += 2, x = (function() {
          var F, et;
          for (et = [], l = F = 0; 0 <= _ ? F < _ : F > _; l = 0 <= _ ? ++F : --F) et.push(t.readUInt16());
          return et;
        })(), f = (function() {
          var F, et;
          for (et = [], l = F = 0; 0 <= _ ? F < _ : F > _; l = 0 <= _ ? ++F : --F) et.push(t.readUInt16());
          return et;
        })(), d = (function() {
          var F, et;
          for (et = [], l = F = 0; 0 <= _ ? F < _ : F > _; l = 0 <= _ ? ++F : --F) et.push(t.readUInt16());
          return et;
        })(), i = (this.length - t.pos + this.offset) / 2, o = (function() {
          var F, et;
          for (et = [], l = F = 0; 0 <= i ? F < i : F > i; l = 0 <= i ? ++F : --F) et.push(t.readUInt16());
          return et;
        })(), l = N = 0, q = s.length; N < q; l = ++N) for (E = s[l], n = H = y = x[l]; y <= E ? H <= E : H >= E; n = y <= E ? ++H : --H) d[l] === 0 ? c = n + f[l] : (c = o[d[l] / 2 + (n - y) - (_ - l)] || 0) !== 0 && (c += f[l]), this.codeMap[n] = 65535 & c;
    }
    t.pos = b;
  }
  return r.encode = function(t, e) {
    var n, i, s, c, o, l, f, d, b, _, g, y, x, E, N, H, q, F, et, Q, X, V, I, G, A, C, M, D, at, ot, ft, rt, ht, Lt, vt, S, j, z, J, $, nt, lt, ct, bt, xt, Et;
    switch (D = new di(), c = Object.keys(t).sort(function(Pt, dt) {
      return Pt - dt;
    }), e) {
      case "macroman":
        for (x = 0, E = (function() {
          var Pt = [];
          for (y = 0; y < 256; ++y) Pt.push(0);
          return Pt;
        })(), H = { 0: 0 }, s = {}, at = 0, ht = c.length; at < ht; at++) H[ct = t[i = c[at]]] == null && (H[ct] = ++x), s[i] = { old: t[i], new: H[t[i]] }, E[i] = H[t[i]];
        return D.writeUInt16(1), D.writeUInt16(0), D.writeUInt32(12), D.writeUInt16(0), D.writeUInt16(262), D.writeUInt16(0), D.write(E), { charMap: s, subtable: D.data, maxGlyphID: x + 1 };
      case "unicode":
        for (C = [], b = [], q = 0, H = {}, n = {}, N = f = null, ot = 0, Lt = c.length; ot < Lt; ot++) H[et = t[i = c[ot]]] == null && (H[et] = ++q), n[i] = { old: et, new: H[et] }, o = H[et] - i, N != null && o === f || (N && b.push(N), C.push(i), f = o), N = i;
        for (N && b.push(N), b.push(65535), C.push(65535), G = 2 * (I = C.length), V = 2 * Math.pow(Math.log(I) / Math.LN2, 2), _ = Math.log(V / 2) / Math.LN2, X = 2 * I - V, l = [], Q = [], g = [], y = ft = 0, vt = C.length; ft < vt; y = ++ft) {
          if (A = C[y], d = b[y], A === 65535) {
            l.push(0), Q.push(0);
            break;
          }
          if (A - (M = n[A].new) >= 32768) for (l.push(0), Q.push(2 * (g.length + I - y)), i = rt = A; A <= d ? rt <= d : rt >= d; i = A <= d ? ++rt : --rt) g.push(n[i].new);
          else l.push(M - A), Q.push(0);
        }
        for (D.writeUInt16(3), D.writeUInt16(1), D.writeUInt32(12), D.writeUInt16(4), D.writeUInt16(16 + 8 * I + 2 * g.length), D.writeUInt16(0), D.writeUInt16(G), D.writeUInt16(V), D.writeUInt16(_), D.writeUInt16(X), nt = 0, S = b.length; nt < S; nt++) i = b[nt], D.writeUInt16(i);
        for (D.writeUInt16(0), lt = 0, j = C.length; lt < j; lt++) i = C[lt], D.writeUInt16(i);
        for (bt = 0, z = l.length; bt < z; bt++) o = l[bt], D.writeUInt16(o);
        for (xt = 0, J = Q.length; xt < J; xt++) F = Q[xt], D.writeUInt16(F);
        for (Et = 0, $ = g.length; Et < $; Et++) x = g[Et], D.writeUInt16(x);
        return { charMap: n, subtable: D.data, maxGlyphID: q + 1 };
    }
  }, r;
})(), C1 = (function() {
  function r() {
    return r.__super__.constructor.apply(this, arguments);
  }
  return Sn(r, dn), r.prototype.tag = "cmap", r.prototype.parse = function(t) {
    var e, n, i;
    for (t.pos = this.offset, this.version = t.readUInt16(), i = t.readUInt16(), this.tables = [], this.unicode = null, n = 0; 0 <= i ? n < i : n > i; n = 0 <= i ? ++n : --n) e = new zf(t, this.offset), this.tables.push(e), e.isUnicode && this.unicode == null && (this.unicode = e);
    return !0;
  }, r.encode = function(t, e) {
    var n, i;
    return e == null && (e = "macroman"), n = zf.encode(t, e), (i = new di()).writeUInt16(0), i.writeUInt16(1), n.table = i.data.concat(n.subtable), n;
  }, r;
})(), V5 = (function() {
  function r() {
    return r.__super__.constructor.apply(this, arguments);
  }
  return Sn(r, dn), r.prototype.tag = "hhea", r.prototype.parse = function(t) {
    return t.pos = this.offset, this.version = t.readInt(), this.ascender = t.readShort(), this.decender = t.readShort(), this.lineGap = t.readShort(), this.advanceWidthMax = t.readShort(), this.minLeftSideBearing = t.readShort(), this.minRightSideBearing = t.readShort(), this.xMaxExtent = t.readShort(), this.caretSlopeRise = t.readShort(), this.caretSlopeRun = t.readShort(), this.caretOffset = t.readShort(), t.pos += 8, this.metricDataFormat = t.readShort(), this.numberOfMetrics = t.readUInt16();
  }, r;
})(), W5 = (function() {
  function r() {
    return r.__super__.constructor.apply(this, arguments);
  }
  return Sn(r, dn), r.prototype.tag = "OS/2", r.prototype.parse = function(t) {
    if (t.pos = this.offset, this.version = t.readUInt16(), this.averageCharWidth = t.readShort(), this.weightClass = t.readUInt16(), this.widthClass = t.readUInt16(), this.type = t.readShort(), this.ySubscriptXSize = t.readShort(), this.ySubscriptYSize = t.readShort(), this.ySubscriptXOffset = t.readShort(), this.ySubscriptYOffset = t.readShort(), this.ySuperscriptXSize = t.readShort(), this.ySuperscriptYSize = t.readShort(), this.ySuperscriptXOffset = t.readShort(), this.ySuperscriptYOffset = t.readShort(), this.yStrikeoutSize = t.readShort(), this.yStrikeoutPosition = t.readShort(), this.familyClass = t.readShort(), this.panose = (function() {
      var e, n;
      for (n = [], e = 0; e < 10; ++e) n.push(t.readByte());
      return n;
    })(), this.charRange = (function() {
      var e, n;
      for (n = [], e = 0; e < 4; ++e) n.push(t.readInt());
      return n;
    })(), this.vendorID = t.readString(4), this.selection = t.readShort(), this.firstCharIndex = t.readShort(), this.lastCharIndex = t.readShort(), this.version > 0 && (this.ascent = t.readShort(), this.descent = t.readShort(), this.lineGap = t.readShort(), this.winAscent = t.readShort(), this.winDescent = t.readShort(), this.codePageRange = (function() {
      var e, n;
      for (n = [], e = 0; e < 2; e = ++e) n.push(t.readInt());
      return n;
    })(), this.version > 1)) return this.xHeight = t.readShort(), this.capHeight = t.readShort(), this.defaultChar = t.readShort(), this.breakChar = t.readShort(), this.maxContext = t.readShort();
  }, r;
})(), G5 = (function() {
  function r() {
    return r.__super__.constructor.apply(this, arguments);
  }
  return Sn(r, dn), r.prototype.tag = "post", r.prototype.parse = function(t) {
    var e, n, i;
    switch (t.pos = this.offset, this.format = t.readInt(), this.italicAngle = t.readInt(), this.underlinePosition = t.readShort(), this.underlineThickness = t.readShort(), this.isFixedPitch = t.readInt(), this.minMemType42 = t.readInt(), this.maxMemType42 = t.readInt(), this.minMemType1 = t.readInt(), this.maxMemType1 = t.readInt(), this.format) {
      case 65536:
      case 196608:
        break;
      case 131072:
        var s;
        for (n = t.readUInt16(), this.glyphNameIndex = [], s = 0; 0 <= n ? s < n : s > n; s = 0 <= n ? ++s : --s) this.glyphNameIndex.push(t.readUInt16());
        for (this.names = [], i = []; t.pos < this.offset + this.length; ) e = t.readByte(), i.push(this.names.push(t.readString(e)));
        return i;
      case 151552:
        return n = t.readUInt16(), this.offsets = t.read(n);
      case 262144:
        return this.map = (function() {
          var c, o, l;
          for (l = [], s = c = 0, o = this.file.maxp.numGlyphs; 0 <= o ? c < o : c > o; s = 0 <= o ? ++c : --c) l.push(t.readUInt32());
          return l;
        }).call(this);
    }
  }, r;
})(), J5 = function(r, t) {
  this.raw = r, this.length = r.length, this.platformID = t.platformID, this.encodingID = t.encodingID, this.languageID = t.languageID;
}, Y5 = (function() {
  function r() {
    return r.__super__.constructor.apply(this, arguments);
  }
  return Sn(r, dn), r.prototype.tag = "name", r.prototype.parse = function(t) {
    var e, n, i, s, c, o, l, f, d, b, _;
    for (t.pos = this.offset, t.readShort(), e = t.readShort(), o = t.readShort(), n = [], s = 0; 0 <= e ? s < e : s > e; s = 0 <= e ? ++s : --s) n.push({ platformID: t.readShort(), encodingID: t.readShort(), languageID: t.readShort(), nameID: t.readShort(), length: t.readShort(), offset: this.offset + o + t.readShort() });
    for (l = {}, s = d = 0, b = n.length; d < b; s = ++d) i = n[s], t.pos = i.offset, f = t.readString(i.length), c = new J5(f, i), l[_ = i.nameID] == null && (l[_] = []), l[i.nameID].push(c);
    this.strings = l, this.copyright = l[0], this.fontFamily = l[1], this.fontSubfamily = l[2], this.uniqueSubfamily = l[3], this.fontName = l[4], this.version = l[5];
    try {
      this.postscriptName = l[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
    } catch {
      this.postscriptName = l[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
    }
    return this.trademark = l[7], this.manufacturer = l[8], this.designer = l[9], this.description = l[10], this.vendorUrl = l[11], this.designerUrl = l[12], this.license = l[13], this.licenseUrl = l[14], this.preferredFamily = l[15], this.preferredSubfamily = l[17], this.compatibleFull = l[18], this.sampleText = l[19];
  }, r;
})(), K5 = (function() {
  function r() {
    return r.__super__.constructor.apply(this, arguments);
  }
  return Sn(r, dn), r.prototype.tag = "maxp", r.prototype.parse = function(t) {
    return t.pos = this.offset, this.version = t.readInt(), this.numGlyphs = t.readUInt16(), this.maxPoints = t.readUInt16(), this.maxContours = t.readUInt16(), this.maxCompositePoints = t.readUInt16(), this.maxComponentContours = t.readUInt16(), this.maxZones = t.readUInt16(), this.maxTwilightPoints = t.readUInt16(), this.maxStorage = t.readUInt16(), this.maxFunctionDefs = t.readUInt16(), this.maxInstructionDefs = t.readUInt16(), this.maxStackElements = t.readUInt16(), this.maxSizeOfInstructions = t.readUInt16(), this.maxComponentElements = t.readUInt16(), this.maxComponentDepth = t.readUInt16();
  }, r;
})(), X5 = (function() {
  function r() {
    return r.__super__.constructor.apply(this, arguments);
  }
  return Sn(r, dn), r.prototype.tag = "hmtx", r.prototype.parse = function(t) {
    var e, n, i, s, c, o, l;
    for (t.pos = this.offset, this.metrics = [], e = 0, o = this.file.hhea.numberOfMetrics; 0 <= o ? e < o : e > o; e = 0 <= o ? ++e : --e) this.metrics.push({ advance: t.readUInt16(), lsb: t.readInt16() });
    for (i = this.file.maxp.numGlyphs - this.file.hhea.numberOfMetrics, this.leftSideBearings = (function() {
      var f, d;
      for (d = [], e = f = 0; 0 <= i ? f < i : f > i; e = 0 <= i ? ++f : --f) d.push(t.readInt16());
      return d;
    })(), this.widths = (function() {
      var f, d, b, _;
      for (_ = [], f = 0, d = (b = this.metrics).length; f < d; f++) s = b[f], _.push(s.advance);
      return _;
    }).call(this), n = this.widths[this.widths.length - 1], l = [], e = c = 0; 0 <= i ? c < i : c > i; e = 0 <= i ? ++c : --c) l.push(this.widths.push(n));
    return l;
  }, r.prototype.forGlyph = function(t) {
    return t in this.metrics ? this.metrics[t] : { advance: this.metrics[this.metrics.length - 1].advance, lsb: this.leftSideBearings[t - this.metrics.length] };
  }, r;
})(), R1 = [].slice, $5 = (function() {
  function r() {
    return r.__super__.constructor.apply(this, arguments);
  }
  return Sn(r, dn), r.prototype.tag = "glyf", r.prototype.parse = function() {
    return this.cache = {};
  }, r.prototype.glyphFor = function(t) {
    var e, n, i, s, c, o, l, f, d, b;
    return t in this.cache ? this.cache[t] : (s = this.file.loca, e = this.file.contents, n = s.indexOf(t), (i = s.lengthOf(t)) === 0 ? this.cache[t] = null : (e.pos = this.offset + n, c = (o = new di(e.read(i))).readShort(), f = o.readShort(), b = o.readShort(), l = o.readShort(), d = o.readShort(), this.cache[t] = c === -1 ? new Q5(o, f, b, l, d) : new Z5(o, c, f, b, l, d), this.cache[t]));
  }, r.prototype.encode = function(t, e, n) {
    var i, s, c, o, l;
    for (c = [], s = [], o = 0, l = e.length; o < l; o++) i = t[e[o]], s.push(c.length), i && (c = c.concat(i.encode(n)));
    return s.push(c.length), { table: c, offsets: s };
  }, r;
})(), Z5 = (function() {
  function r(t, e, n, i, s, c) {
    this.raw = t, this.numberOfContours = e, this.xMin = n, this.yMin = i, this.xMax = s, this.yMax = c, this.compound = !1;
  }
  return r.prototype.encode = function() {
    return this.raw.data;
  }, r;
})(), Q5 = (function() {
  function r(t, e, n, i, s) {
    var c, o;
    for (this.raw = t, this.xMin = e, this.yMin = n, this.xMax = i, this.yMax = s, this.compound = !0, this.glyphIDs = [], this.glyphOffsets = [], c = this.raw; o = c.readShort(), this.glyphOffsets.push(c.pos), this.glyphIDs.push(c.readUInt16()), 32 & o; ) c.pos += 1 & o ? 4 : 2, 128 & o ? c.pos += 8 : 64 & o ? c.pos += 4 : 8 & o && (c.pos += 2);
  }
  return r.prototype.encode = function() {
    var t, e, n;
    for (e = new di(R1.call(this.raw.data)), t = 0, n = this.glyphIDs.length; t < n; ++t) e.pos = this.glyphOffsets[t];
    return e.data;
  }, r;
})(), tp = (function() {
  function r() {
    return r.__super__.constructor.apply(this, arguments);
  }
  return Sn(r, dn), r.prototype.tag = "loca", r.prototype.parse = function(t) {
    var e, n;
    return t.pos = this.offset, e = this.file.head.indexToLocFormat, this.offsets = e === 0 ? (function() {
      var i, s;
      for (s = [], n = 0, i = this.length; n < i; n += 2) s.push(2 * t.readUInt16());
      return s;
    }).call(this) : (function() {
      var i, s;
      for (s = [], n = 0, i = this.length; n < i; n += 4) s.push(t.readUInt32());
      return s;
    }).call(this);
  }, r.prototype.indexOf = function(t) {
    return this.offsets[t];
  }, r.prototype.lengthOf = function(t) {
    return this.offsets[t + 1] - this.offsets[t];
  }, r.prototype.encode = function(t, e) {
    for (var n = new Uint32Array(this.offsets.length), i = 0, s = 0, c = 0; c < n.length; ++c) if (n[c] = i, s < e.length && e[s] == c) {
      ++s, n[c] = i;
      var o = this.offsets[c], l = this.offsets[c + 1] - o;
      l > 0 && (i += l);
    }
    for (var f = new Array(4 * n.length), d = 0; d < n.length; ++d) f[4 * d + 3] = 255 & n[d], f[4 * d + 2] = (65280 & n[d]) >> 8, f[4 * d + 1] = (16711680 & n[d]) >> 16, f[4 * d] = (4278190080 & n[d]) >> 24;
    return f;
  }, r;
})(), ep = (function() {
  function r(t) {
    this.font = t, this.subset = {}, this.unicodes = {}, this.next = 33;
  }
  return r.prototype.generateCmap = function() {
    var t, e, n, i, s;
    for (e in i = this.font.cmap.tables[0].codeMap, t = {}, s = this.subset) n = s[e], t[e] = i[n];
    return t;
  }, r.prototype.glyphsFor = function(t) {
    var e, n, i, s, c, o, l;
    for (i = {}, c = 0, o = t.length; c < o; c++) i[s = t[c]] = this.font.glyf.glyphFor(s);
    for (s in e = [], i) (n = i[s]) != null && n.compound && e.push.apply(e, n.glyphIDs);
    if (e.length > 0) for (s in l = this.glyphsFor(e)) n = l[s], i[s] = n;
    return i;
  }, r.prototype.encode = function(t, e) {
    var n, i, s, c, o, l, f, d, b, _, g, y, x, E, N;
    for (i in n = C1.encode(this.generateCmap(), "unicode"), c = this.glyphsFor(t), g = { 0: 0 }, N = n.charMap) g[(l = N[i]).old] = l.new;
    for (y in _ = n.maxGlyphID, c) y in g || (g[y] = _++);
    return d = (function(H) {
      var q, F;
      for (q in F = {}, H) F[H[q]] = q;
      return F;
    })(g), b = Object.keys(d).sort(function(H, q) {
      return H - q;
    }), x = (function() {
      var H, q, F;
      for (F = [], H = 0, q = b.length; H < q; H++) o = b[H], F.push(d[o]);
      return F;
    })(), s = this.font.glyf.encode(c, x, g), f = this.font.loca.encode(s.offsets, x), E = { cmap: this.font.cmap.raw(), glyf: s.table, loca: f, hmtx: this.font.hmtx.raw(), hhea: this.font.hhea.raw(), maxp: this.font.maxp.raw(), post: this.font.post.raw(), name: this.font.name.raw(), head: this.font.head.encode(e) }, this.font.os2.exists && (E["OS/2"] = this.font.os2.raw()), this.font.directory.encode(E);
  }, r;
})();
Dt.API.PDFObject = (function() {
  var r;
  function t() {
  }
  return r = function(e, n) {
    return (Array(n + 1).join("0") + e).slice(-n);
  }, t.convert = function(e) {
    var n, i, s, c;
    if (Array.isArray(e)) return "[" + (function() {
      var o, l, f;
      for (f = [], o = 0, l = e.length; o < l; o++) n = e[o], f.push(t.convert(n));
      return f;
    })().join(" ") + "]";
    if (typeof e == "string") return "/" + e;
    if (e?.isString) return "(" + e + ")";
    if (e instanceof Date) return "(D:" + r(e.getUTCFullYear(), 4) + r(e.getUTCMonth(), 2) + r(e.getUTCDate(), 2) + r(e.getUTCHours(), 2) + r(e.getUTCMinutes(), 2) + r(e.getUTCSeconds(), 2) + "Z)";
    if ({}.toString.call(e) === "[object Object]") {
      for (i in s = ["<<"], e) c = e[i], s.push("/" + i + " " + t.convert(c));
      return s.push(">>"), s.join(`
`);
    }
    return "" + e;
  }, t;
})();
var zt, Vn = new Array(128).fill(void 0);
Vn.push(void 0, null, !0, !1);
var aa = Vn.length;
function Rr(r) {
  aa === Vn.length && Vn.push(Vn.length + 1);
  const t = aa;
  return aa = Vn[t], Vn[t] = r, t;
}
function kr(r) {
  return Vn[r];
}
function rp(r) {
  r < 132 || (Vn[r] = aa, aa = r);
}
function Wn(r) {
  const t = kr(r);
  return rp(r), t;
}
var ua = 0, ea = null;
function bo() {
  return (ea === null || ea.byteLength === 0) && (ea = new Uint8Array(zt.memory.buffer)), ea;
}
var wo = typeof TextEncoder < "u" ? new TextEncoder("utf-8") : { encode: () => {
  throw Error("TextEncoder not available");
} }, np = typeof wo.encodeInto == "function" ? function(r, t) {
  return wo.encodeInto(r, t);
} : function(r, t) {
  const e = wo.encode(r);
  return t.set(e), {
    read: r.length,
    written: e.length
  };
};
function Au(r, t, e) {
  if (e === void 0) {
    const o = wo.encode(r), l = t(o.length, 1) >>> 0;
    return bo().subarray(l, l + o.length).set(o), ua = o.length, l;
  }
  let n = r.length, i = t(n, 1) >>> 0;
  const s = bo();
  let c = 0;
  for (; c < n; c++) {
    const o = r.charCodeAt(c);
    if (o > 127)
      break;
    s[i + c] = o;
  }
  if (c !== n) {
    c !== 0 && (r = r.slice(c)), i = e(i, n, n = c + r.length * 3, 1) >>> 0;
    const o = bo().subarray(i + c, i + n), l = np(r, o);
    c += l.written, i = e(i, n, c, 1) >>> 0;
  }
  return ua = c, i;
}
function xu(r) {
  return r == null;
}
var ra = null;
function cr() {
  return (ra === null || ra.byteLength === 0) && (ra = new Int32Array(zt.memory.buffer)), ra;
}
var I1 = typeof TextDecoder < "u" ? new TextDecoder("utf-8", { ignoreBOM: !0, fatal: !0 }) : { decode: () => {
  throw Error("TextDecoder not available");
} };
typeof TextDecoder < "u" && I1.decode();
function vo(r, t) {
  return r = r >>> 0, I1.decode(bo().subarray(r, r + t));
}
function ip(r, t) {
  if (!(r instanceof t))
    throw new Error(`expected instance of ${t.name}`);
  return r.ptr;
}
function sp(r, t) {
  try {
    return r.apply(this, t);
  } catch (e) {
    zt.__wbindgen_exn_store(Rr(e));
  }
}
var Hf = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((r) => zt.__wbg_bbox_free(r >>> 0)), Tc = class F1 {
  static __wrap(t) {
    t = t >>> 0;
    const e = Object.create(F1.prototype);
    return e.__wbg_ptr = t, Hf.register(e, e.__wbg_ptr, e), e;
  }
  __destroy_into_raw() {
    const t = this.__wbg_ptr;
    return this.__wbg_ptr = 0, Hf.unregister(this), t;
  }
  free() {
    const t = this.__destroy_into_raw();
    zt.__wbg_bbox_free(t);
  }
  /**
  * @returns {number}
  */
  get x() {
    return zt.__wbg_get_bbox_x(this.__wbg_ptr);
  }
  /**
  * @param {number} arg0
  */
  set x(t) {
    zt.__wbg_set_bbox_x(this.__wbg_ptr, t);
  }
  /**
  * @returns {number}
  */
  get y() {
    return zt.__wbg_get_bbox_y(this.__wbg_ptr);
  }
  /**
  * @param {number} arg0
  */
  set y(t) {
    zt.__wbg_set_bbox_y(this.__wbg_ptr, t);
  }
  /**
  * @returns {number}
  */
  get width() {
    return zt.__wbg_get_bbox_width(this.__wbg_ptr);
  }
  /**
  * @param {number} arg0
  */
  set width(t) {
    zt.__wbg_set_bbox_width(this.__wbg_ptr, t);
  }
  /**
  * @returns {number}
  */
  get height() {
    return zt.__wbg_get_bbox_height(this.__wbg_ptr);
  }
  /**
  * @param {number} arg0
  */
  set height(t) {
    zt.__wbg_set_bbox_height(this.__wbg_ptr, t);
  }
}, Vf = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((r) => zt.__wbg_renderedimage_free(r >>> 0)), ap = class O1 {
  static __wrap(t) {
    t = t >>> 0;
    const e = Object.create(O1.prototype);
    return e.__wbg_ptr = t, Vf.register(e, e.__wbg_ptr, e), e;
  }
  __destroy_into_raw() {
    const t = this.__wbg_ptr;
    return this.__wbg_ptr = 0, Vf.unregister(this), t;
  }
  free() {
    const t = this.__destroy_into_raw();
    zt.__wbg_renderedimage_free(t);
  }
  /**
  * Get the PNG width
  * @returns {number}
  */
  get width() {
    return zt.renderedimage_width(this.__wbg_ptr) >>> 0;
  }
  /**
  * Get the PNG height
  * @returns {number}
  */
  get height() {
    return zt.renderedimage_height(this.__wbg_ptr) >>> 0;
  }
  /**
  * Write the image data to Uint8Array
  * @returns {Uint8Array}
  */
  asPng() {
    try {
      const i = zt.__wbindgen_add_to_stack_pointer(-16);
      zt.renderedimage_asPng(i, this.__wbg_ptr);
      var t = cr()[i / 4 + 0], e = cr()[i / 4 + 1], n = cr()[i / 4 + 2];
      if (n)
        throw Wn(e);
      return Wn(t);
    } finally {
      zt.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Get the RGBA pixels of the image
  * @returns {Uint8Array}
  */
  get pixels() {
    const t = zt.renderedimage_pixels(this.__wbg_ptr);
    return Wn(t);
  }
}, op = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((r) => zt.__wbg_resvg_free(r >>> 0)), cp = class {
  __destroy_into_raw() {
    const r = this.__wbg_ptr;
    return this.__wbg_ptr = 0, op.unregister(this), r;
  }
  free() {
    const r = this.__destroy_into_raw();
    zt.__wbg_resvg_free(r);
  }
  /**
  * @param {Uint8Array | string} svg
  * @param {string | undefined} [options]
  * @param {Array<any> | undefined} [custom_font_buffers]
  */
  constructor(r, t, e) {
    try {
      const l = zt.__wbindgen_add_to_stack_pointer(-16);
      var n = xu(t) ? 0 : Au(t, zt.__wbindgen_malloc, zt.__wbindgen_realloc), i = ua;
      zt.resvg_new(l, Rr(r), n, i, xu(e) ? 0 : Rr(e));
      var s = cr()[l / 4 + 0], c = cr()[l / 4 + 1], o = cr()[l / 4 + 2];
      if (o)
        throw Wn(c);
      return this.__wbg_ptr = s >>> 0, this;
    } finally {
      zt.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Get the SVG width
  * @returns {number}
  */
  get width() {
    return zt.resvg_width(this.__wbg_ptr);
  }
  /**
  * Get the SVG height
  * @returns {number}
  */
  get height() {
    return zt.resvg_height(this.__wbg_ptr);
  }
  /**
  * Renders an SVG in Wasm
  * @returns {RenderedImage}
  */
  render() {
    try {
      const n = zt.__wbindgen_add_to_stack_pointer(-16);
      zt.resvg_render(n, this.__wbg_ptr);
      var r = cr()[n / 4 + 0], t = cr()[n / 4 + 1], e = cr()[n / 4 + 2];
      if (e)
        throw Wn(t);
      return ap.__wrap(r);
    } finally {
      zt.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Output usvg-simplified SVG string
  * @returns {string}
  */
  toString() {
    let r, t;
    try {
      const i = zt.__wbindgen_add_to_stack_pointer(-16);
      zt.resvg_toString(i, this.__wbg_ptr);
      var e = cr()[i / 4 + 0], n = cr()[i / 4 + 1];
      return r = e, t = n, vo(e, n);
    } finally {
      zt.__wbindgen_add_to_stack_pointer(16), zt.__wbindgen_free(r, t, 1);
    }
  }
  /**
  * Calculate a maximum bounding box of all visible elements in this SVG.
  *
  * Note: path bounding box are approx values.
  * @returns {BBox | undefined}
  */
  innerBBox() {
    const r = zt.resvg_innerBBox(this.__wbg_ptr);
    return r === 0 ? void 0 : Tc.__wrap(r);
  }
  /**
  * Calculate a maximum bounding box of all visible elements in this SVG.
  * This will first apply transform.
  * Similar to `SVGGraphicsElement.getBBox()` DOM API.
  * @returns {BBox | undefined}
  */
  getBBox() {
    const r = zt.resvg_getBBox(this.__wbg_ptr);
    return r === 0 ? void 0 : Tc.__wrap(r);
  }
  /**
  * Use a given `BBox` to crop the svg. Currently this method simply changes
  * the viewbox/size of the svg and do not move the elements for simplicity
  * @param {BBox} bbox
  */
  cropByBBox(r) {
    ip(r, Tc), zt.resvg_cropByBBox(this.__wbg_ptr, r.__wbg_ptr);
  }
  /**
  * @returns {Array<any>}
  */
  imagesToResolve() {
    try {
      const n = zt.__wbindgen_add_to_stack_pointer(-16);
      zt.resvg_imagesToResolve(n, this.__wbg_ptr);
      var r = cr()[n / 4 + 0], t = cr()[n / 4 + 1], e = cr()[n / 4 + 2];
      if (e)
        throw Wn(t);
      return Wn(r);
    } finally {
      zt.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * @param {string} href
  * @param {Uint8Array} buffer
  */
  resolveImage(r, t) {
    try {
      const i = zt.__wbindgen_add_to_stack_pointer(-16), s = Au(r, zt.__wbindgen_malloc, zt.__wbindgen_realloc), c = ua;
      zt.resvg_resolveImage(i, this.__wbg_ptr, s, c, Rr(t));
      var e = cr()[i / 4 + 0], n = cr()[i / 4 + 1];
      if (n)
        throw Wn(e);
    } finally {
      zt.__wbindgen_add_to_stack_pointer(16);
    }
  }
};
async function up(r, t) {
  if (typeof Response == "function" && r instanceof Response) {
    if (typeof WebAssembly.instantiateStreaming == "function")
      try {
        return await WebAssembly.instantiateStreaming(r, t);
      } catch (n) {
        if (r.headers.get("Content-Type") != "application/wasm")
          console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", n);
        else
          throw n;
      }
    const e = await r.arrayBuffer();
    return await WebAssembly.instantiate(e, t);
  } else {
    const e = await WebAssembly.instantiate(r, t);
    return e instanceof WebAssembly.Instance ? { instance: e, module: r } : e;
  }
}
function lp() {
  const r = {};
  return r.wbg = {}, r.wbg.__wbg_new_28c511d9baebfa89 = function(t, e) {
    const n = new Error(vo(t, e));
    return Rr(n);
  }, r.wbg.__wbindgen_memory = function() {
    const t = zt.memory;
    return Rr(t);
  }, r.wbg.__wbg_buffer_12d079cc21e14bdb = function(t) {
    const e = kr(t).buffer;
    return Rr(e);
  }, r.wbg.__wbg_newwithbyteoffsetandlength_aa4a17c33a06e5cb = function(t, e, n) {
    const i = new Uint8Array(kr(t), e >>> 0, n >>> 0);
    return Rr(i);
  }, r.wbg.__wbindgen_object_drop_ref = function(t) {
    Wn(t);
  }, r.wbg.__wbg_new_63b92bc8671ed464 = function(t) {
    const e = new Uint8Array(kr(t));
    return Rr(e);
  }, r.wbg.__wbg_values_839f3396d5aac002 = function(t) {
    const e = kr(t).values();
    return Rr(e);
  }, r.wbg.__wbg_next_196c84450b364254 = function() {
    return sp(function(t) {
      const e = kr(t).next();
      return Rr(e);
    }, arguments);
  }, r.wbg.__wbg_done_298b57d23c0fc80c = function(t) {
    return kr(t).done;
  }, r.wbg.__wbg_value_d93c65011f51a456 = function(t) {
    const e = kr(t).value;
    return Rr(e);
  }, r.wbg.__wbg_instanceof_Uint8Array_2b3bbecd033d19f6 = function(t) {
    let e;
    try {
      e = kr(t) instanceof Uint8Array;
    } catch {
      e = !1;
    }
    return e;
  }, r.wbg.__wbindgen_string_get = function(t, e) {
    const n = kr(e), i = typeof n == "string" ? n : void 0;
    var s = xu(i) ? 0 : Au(i, zt.__wbindgen_malloc, zt.__wbindgen_realloc), c = ua;
    cr()[t / 4 + 1] = c, cr()[t / 4 + 0] = s;
  }, r.wbg.__wbg_new_16b304a2cfa7ff4a = function() {
    const t = new Array();
    return Rr(t);
  }, r.wbg.__wbindgen_string_new = function(t, e) {
    const n = vo(t, e);
    return Rr(n);
  }, r.wbg.__wbg_push_a5b05aedc7234f9f = function(t, e) {
    return kr(t).push(kr(e));
  }, r.wbg.__wbg_length_c20a40f15020d68a = function(t) {
    return kr(t).length;
  }, r.wbg.__wbg_set_a47bac70306a19a7 = function(t, e, n) {
    kr(t).set(kr(e), n >>> 0);
  }, r.wbg.__wbindgen_throw = function(t, e) {
    throw new Error(vo(t, e));
  }, r;
}
function fp(r, t) {
  return zt = r.exports, B1.__wbindgen_wasm_module = t, ra = null, ea = null, zt;
}
async function B1(r) {
  if (zt !== void 0)
    return zt;
  typeof r > "u" && (r = new URL("index_bg.wasm", void 0));
  const t = lp();
  (typeof r == "string" || typeof Request == "function" && r instanceof Request || typeof URL == "function" && r instanceof URL) && (r = fetch(r));
  const { instance: e, module: n } = await up(await r, t);
  return fp(e, n);
}
var hp = B1, Nu = !1, dp = async (r) => {
  if (Nu)
    throw new Error("Already initialized. The `initWasm()` function can be used only once.");
  await hp(await r), Nu = !0;
}, pp = class extends cp {
  /**
   * @param {Uint8Array | string} svg
   * @param {ResvgRenderOptions | undefined} options
   */
  constructor(r, t) {
    if (!Nu)
      throw new Error("Wasm has not been initialized. Call `initWasm()` function.");
    const e = t?.font;
    if (e && gp(e)) {
      const n = {
        ...t,
        font: {
          ...e,
          fontBuffers: void 0
        }
      };
      super(r, JSON.stringify(n), e.fontBuffers);
    } else
      super(r, JSON.stringify(t));
  }
};
function gp(r) {
  return Object.prototype.hasOwnProperty.call(r, "fontBuffers");
}
let Lu = !1;
async function km(r) {
  if (Lu)
    return;
  await dp(fetch(r || "https://unpkg.com/@resvg/resvg-wasm/index_bg.wasm")), Lu = !0;
}
function mp() {
  return Lu;
}
const Em = 1, ko = 1.03, ao = 3;
class Pm {
  s3BucketUrl;
  constructor(t) {
    this.s3BucketUrl = t;
  }
  async convertSVGToPng(t, e) {
    if (!mp())
      throw new Error(
        "Wasm has not been initialized. Call `initSVGUtils()` function before using convertSVGToPng."
      );
    const n = document.getElementById(t);
    if (n == null)
      return null;
    const [i, s] = Cu(
      e.format
    ), c = h2();
    let o = 0, l = 0;
    switch (e.format) {
      case "online-ig-story":
      case "online-ig-post":
        o = i * ao, l = s * ao;
        break;
      default:
        o = Math.trunc(
          i * ko * c * ao
        ), l = Math.trunc(
          s * ko * c * ao
        );
        break;
    }
    const f = n.cloneNode(!0);
    f.setAttribute("width", `${o}`), f.setAttribute("height", `${l}`), e.applyQRCodeRotation && this.applyRotationIfNeeded(f);
    const d = new XMLSerializer().serializeToString(f), b = {}, _ = new pp(d, b), g = await Promise.all(
      _.imagesToResolve().map(async (x) => {
        const N = await (await fetch(x)).arrayBuffer();
        return {
          url: x,
          buffer: new Uint8Array(N)
        };
      })
    );
    if (g.length > 0)
      for (const x of g) {
        const { url: E, buffer: N } = x;
        _.resolveImage(E, N);
      }
    return _.render().asPng();
  }
  async downloadPngFromS3(t, e = "download") {
    try {
      const n = `${this.s3BucketUrl}/${t}`, s = await (await fetch(n)).blob(), c = window.URL.createObjectURL(s), o = document.createElement("a");
      o.href = c, o.download = e || "image.png", document.body.appendChild(o), o.click(), document.body.removeChild(o), window.URL.revokeObjectURL(c);
    } catch (n) {
      console.error("Download failed:", n);
    }
  }
  applyRotationIfNeeded(t) {
    t.querySelectorAll(
      "#qr-code-img, .qr-code-img"
    ).forEach((n) => {
      const i = parseFloat(n.getAttribute("x") || "0"), s = parseFloat(n.getAttribute("y") || "0"), c = n.width?.baseVal?.value || parseFloat(n.getAttribute("width") || "0"), o = n.height?.baseVal?.value || parseFloat(n.getAttribute("height") || "0");
      if (!c || !o)
        return;
      const l = i + c / 2, f = s + o / 2;
      n.id = "", n.setAttribute("class", ""), n.setAttribute("transform", `rotate(-14.5 ${l} ${f})`);
    });
  }
}
class Cm {
  static async generatePDFFromPNG(t, e) {
    return this.generatePDFInner(t, e);
  }
  static async generateAndSavePDF(t, e, n) {
    (await this.generatePDFInner(t, e)).save(n);
  }
  static async generatePDFInner(t, e) {
    const i = await (await fetch(t)).blob(), s = await new Promise((_, g) => {
      const y = new FileReader();
      y.onloadend = () => _(y.result), y.onerror = g, y.readAsDataURL(i);
    }), [c, o] = Cu(e), l = Math.trunc(c * ko), f = Math.trunc(o * ko), d = c > o ? "landscape" : "portrait", b = new Dt({
      orientation: d,
      unit: "mm",
      format: [l, f],
      compress: !1,
      putOnlyUsedFonts: !0,
      floatPrecision: 16
    });
    return b.addImage(
      s,
      "PNG",
      0,
      0,
      l,
      f,
      void 0,
      "FAST"
    ), b;
  }
}
var Rm = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function bp(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var hs = {}, Mc, Wf;
function wp() {
  return Wf || (Wf = 1, Mc = function() {
    return typeof Promise == "function" && Promise.prototype && Promise.prototype.then;
  }), Mc;
}
var Dc = {}, fi = {}, Gf;
function Yi() {
  if (Gf) return fi;
  Gf = 1;
  let r;
  const t = [
    0,
    // Not used
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
  ];
  return fi.getSymbolSize = function(n) {
    if (!n) throw new Error('"version" cannot be null or undefined');
    if (n < 1 || n > 40) throw new Error('"version" should be in range from 1 to 40');
    return n * 4 + 17;
  }, fi.getSymbolTotalCodewords = function(n) {
    return t[n];
  }, fi.getBCHDigit = function(e) {
    let n = 0;
    for (; e !== 0; )
      n++, e >>>= 1;
    return n;
  }, fi.setToSJISFunction = function(n) {
    if (typeof n != "function")
      throw new Error('"toSJISFunc" is not a valid function.');
    r = n;
  }, fi.isKanjiModeEnabled = function() {
    return typeof r < "u";
  }, fi.toSJIS = function(n) {
    return r(n);
  }, fi;
}
var jc = {}, Jf;
function Tu() {
  return Jf || (Jf = 1, (function(r) {
    r.L = { bit: 1 }, r.M = { bit: 0 }, r.Q = { bit: 3 }, r.H = { bit: 2 };
    function t(e) {
      if (typeof e != "string")
        throw new Error("Param is not a string");
      switch (e.toLowerCase()) {
        case "l":
        case "low":
          return r.L;
        case "m":
        case "medium":
          return r.M;
        case "q":
        case "quartile":
          return r.Q;
        case "h":
        case "high":
          return r.H;
        default:
          throw new Error("Unknown EC Level: " + e);
      }
    }
    r.isValid = function(n) {
      return n && typeof n.bit < "u" && n.bit >= 0 && n.bit < 4;
    }, r.from = function(n, i) {
      if (r.isValid(n))
        return n;
      try {
        return t(n);
      } catch {
        return i;
      }
    };
  })(jc)), jc;
}
var qc, Yf;
function vp() {
  if (Yf) return qc;
  Yf = 1;
  function r() {
    this.buffer = [], this.length = 0;
  }
  return r.prototype = {
    get: function(t) {
      const e = Math.floor(t / 8);
      return (this.buffer[e] >>> 7 - t % 8 & 1) === 1;
    },
    put: function(t, e) {
      for (let n = 0; n < e; n++)
        this.putBit((t >>> e - n - 1 & 1) === 1);
    },
    getLengthInBits: function() {
      return this.length;
    },
    putBit: function(t) {
      const e = Math.floor(this.length / 8);
      this.buffer.length <= e && this.buffer.push(0), t && (this.buffer[e] |= 128 >>> this.length % 8), this.length++;
    }
  }, qc = r, qc;
}
var Uc, Kf;
function yp() {
  if (Kf) return Uc;
  Kf = 1;
  function r(t) {
    if (!t || t < 1)
      throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = t, this.data = new Uint8Array(t * t), this.reservedBit = new Uint8Array(t * t);
  }
  return r.prototype.set = function(t, e, n, i) {
    const s = t * this.size + e;
    this.data[s] = n, i && (this.reservedBit[s] = !0);
  }, r.prototype.get = function(t, e) {
    return this.data[t * this.size + e];
  }, r.prototype.xor = function(t, e, n) {
    this.data[t * this.size + e] ^= n;
  }, r.prototype.isReserved = function(t, e) {
    return this.reservedBit[t * this.size + e];
  }, Uc = r, Uc;
}
var zc = {}, Xf;
function _p() {
  return Xf || (Xf = 1, (function(r) {
    const t = Yi().getSymbolSize;
    r.getRowColCoords = function(n) {
      if (n === 1) return [];
      const i = Math.floor(n / 7) + 2, s = t(n), c = s === 145 ? 26 : Math.ceil((s - 13) / (2 * i - 2)) * 2, o = [s - 7];
      for (let l = 1; l < i - 1; l++)
        o[l] = o[l - 1] - c;
      return o.push(6), o.reverse();
    }, r.getPositions = function(n) {
      const i = [], s = r.getRowColCoords(n), c = s.length;
      for (let o = 0; o < c; o++)
        for (let l = 0; l < c; l++)
          o === 0 && l === 0 || // top-left
          o === 0 && l === c - 1 || // bottom-left
          o === c - 1 && l === 0 || i.push([s[o], s[l]]);
      return i;
    };
  })(zc)), zc;
}
var Hc = {}, $f;
function Ap() {
  if ($f) return Hc;
  $f = 1;
  const r = Yi().getSymbolSize, t = 7;
  return Hc.getPositions = function(n) {
    const i = r(n);
    return [
      // top-left
      [0, 0],
      // top-right
      [i - t, 0],
      // bottom-left
      [0, i - t]
    ];
  }, Hc;
}
var Vc = {}, Zf;
function xp() {
  return Zf || (Zf = 1, (function(r) {
    r.Patterns = {
      PATTERN000: 0,
      PATTERN001: 1,
      PATTERN010: 2,
      PATTERN011: 3,
      PATTERN100: 4,
      PATTERN101: 5,
      PATTERN110: 6,
      PATTERN111: 7
    };
    const t = {
      N1: 3,
      N2: 3,
      N3: 40,
      N4: 10
    };
    r.isValid = function(i) {
      return i != null && i !== "" && !isNaN(i) && i >= 0 && i <= 7;
    }, r.from = function(i) {
      return r.isValid(i) ? parseInt(i, 10) : void 0;
    }, r.getPenaltyN1 = function(i) {
      const s = i.size;
      let c = 0, o = 0, l = 0, f = null, d = null;
      for (let b = 0; b < s; b++) {
        o = l = 0, f = d = null;
        for (let _ = 0; _ < s; _++) {
          let g = i.get(b, _);
          g === f ? o++ : (o >= 5 && (c += t.N1 + (o - 5)), f = g, o = 1), g = i.get(_, b), g === d ? l++ : (l >= 5 && (c += t.N1 + (l - 5)), d = g, l = 1);
        }
        o >= 5 && (c += t.N1 + (o - 5)), l >= 5 && (c += t.N1 + (l - 5));
      }
      return c;
    }, r.getPenaltyN2 = function(i) {
      const s = i.size;
      let c = 0;
      for (let o = 0; o < s - 1; o++)
        for (let l = 0; l < s - 1; l++) {
          const f = i.get(o, l) + i.get(o, l + 1) + i.get(o + 1, l) + i.get(o + 1, l + 1);
          (f === 4 || f === 0) && c++;
        }
      return c * t.N2;
    }, r.getPenaltyN3 = function(i) {
      const s = i.size;
      let c = 0, o = 0, l = 0;
      for (let f = 0; f < s; f++) {
        o = l = 0;
        for (let d = 0; d < s; d++)
          o = o << 1 & 2047 | i.get(f, d), d >= 10 && (o === 1488 || o === 93) && c++, l = l << 1 & 2047 | i.get(d, f), d >= 10 && (l === 1488 || l === 93) && c++;
      }
      return c * t.N3;
    }, r.getPenaltyN4 = function(i) {
      let s = 0;
      const c = i.data.length;
      for (let l = 0; l < c; l++) s += i.data[l];
      return Math.abs(Math.ceil(s * 100 / c / 5) - 10) * t.N4;
    };
    function e(n, i, s) {
      switch (n) {
        case r.Patterns.PATTERN000:
          return (i + s) % 2 === 0;
        case r.Patterns.PATTERN001:
          return i % 2 === 0;
        case r.Patterns.PATTERN010:
          return s % 3 === 0;
        case r.Patterns.PATTERN011:
          return (i + s) % 3 === 0;
        case r.Patterns.PATTERN100:
          return (Math.floor(i / 2) + Math.floor(s / 3)) % 2 === 0;
        case r.Patterns.PATTERN101:
          return i * s % 2 + i * s % 3 === 0;
        case r.Patterns.PATTERN110:
          return (i * s % 2 + i * s % 3) % 2 === 0;
        case r.Patterns.PATTERN111:
          return (i * s % 3 + (i + s) % 2) % 2 === 0;
        default:
          throw new Error("bad maskPattern:" + n);
      }
    }
    r.applyMask = function(i, s) {
      const c = s.size;
      for (let o = 0; o < c; o++)
        for (let l = 0; l < c; l++)
          s.isReserved(l, o) || s.xor(l, o, e(i, l, o));
    }, r.getBestMask = function(i, s) {
      const c = Object.keys(r.Patterns).length;
      let o = 0, l = 1 / 0;
      for (let f = 0; f < c; f++) {
        s(f), r.applyMask(f, i);
        const d = r.getPenaltyN1(i) + r.getPenaltyN2(i) + r.getPenaltyN3(i) + r.getPenaltyN4(i);
        r.applyMask(f, i), d < l && (l = d, o = f);
      }
      return o;
    };
  })(Vc)), Vc;
}
var oo = {}, Qf;
function T1() {
  if (Qf) return oo;
  Qf = 1;
  const r = Tu(), t = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
  ], e = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
  ];
  return oo.getBlocksCount = function(i, s) {
    switch (s) {
      case r.L:
        return t[(i - 1) * 4 + 0];
      case r.M:
        return t[(i - 1) * 4 + 1];
      case r.Q:
        return t[(i - 1) * 4 + 2];
      case r.H:
        return t[(i - 1) * 4 + 3];
      default:
        return;
    }
  }, oo.getTotalCodewordsCount = function(i, s) {
    switch (s) {
      case r.L:
        return e[(i - 1) * 4 + 0];
      case r.M:
        return e[(i - 1) * 4 + 1];
      case r.Q:
        return e[(i - 1) * 4 + 2];
      case r.H:
        return e[(i - 1) * 4 + 3];
      default:
        return;
    }
  }, oo;
}
var Wc = {}, Qs = {}, th;
function Np() {
  if (th) return Qs;
  th = 1;
  const r = new Uint8Array(512), t = new Uint8Array(256);
  return (function() {
    let n = 1;
    for (let i = 0; i < 255; i++)
      r[i] = n, t[n] = i, n <<= 1, n & 256 && (n ^= 285);
    for (let i = 255; i < 512; i++)
      r[i] = r[i - 255];
  })(), Qs.log = function(n) {
    if (n < 1) throw new Error("log(" + n + ")");
    return t[n];
  }, Qs.exp = function(n) {
    return r[n];
  }, Qs.mul = function(n, i) {
    return n === 0 || i === 0 ? 0 : r[t[n] + t[i]];
  }, Qs;
}
var eh;
function Lp() {
  return eh || (eh = 1, (function(r) {
    const t = Np();
    r.mul = function(n, i) {
      const s = new Uint8Array(n.length + i.length - 1);
      for (let c = 0; c < n.length; c++)
        for (let o = 0; o < i.length; o++)
          s[c + o] ^= t.mul(n[c], i[o]);
      return s;
    }, r.mod = function(n, i) {
      let s = new Uint8Array(n);
      for (; s.length - i.length >= 0; ) {
        const c = s[0];
        for (let l = 0; l < i.length; l++)
          s[l] ^= t.mul(i[l], c);
        let o = 0;
        for (; o < s.length && s[o] === 0; ) o++;
        s = s.slice(o);
      }
      return s;
    }, r.generateECPolynomial = function(n) {
      let i = new Uint8Array([1]);
      for (let s = 0; s < n; s++)
        i = r.mul(i, new Uint8Array([1, t.exp(s)]));
      return i;
    };
  })(Wc)), Wc;
}
var Gc, rh;
function Sp() {
  if (rh) return Gc;
  rh = 1;
  const r = Lp();
  function t(e) {
    this.genPoly = void 0, this.degree = e, this.degree && this.initialize(this.degree);
  }
  return t.prototype.initialize = function(n) {
    this.degree = n, this.genPoly = r.generateECPolynomial(this.degree);
  }, t.prototype.encode = function(n) {
    if (!this.genPoly)
      throw new Error("Encoder not initialized");
    const i = new Uint8Array(n.length + this.degree);
    i.set(n);
    const s = r.mod(i, this.genPoly), c = this.degree - s.length;
    if (c > 0) {
      const o = new Uint8Array(this.degree);
      return o.set(s, c), o;
    }
    return s;
  }, Gc = t, Gc;
}
var Jc = {}, Yc = {}, Kc = {}, nh;
function M1() {
  return nh || (nh = 1, Kc.isValid = function(t) {
    return !isNaN(t) && t >= 1 && t <= 40;
  }), Kc;
}
var xn = {}, ih;
function D1() {
  if (ih) return xn;
  ih = 1;
  const r = "[0-9]+", t = "[A-Z $%*+\\-./:]+";
  let e = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
  e = e.replace(/u/g, "\\u");
  const n = "(?:(?![A-Z0-9 $%*+\\-./:]|" + e + `)(?:.|[\r
]))+`;
  xn.KANJI = new RegExp(e, "g"), xn.BYTE_KANJI = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g"), xn.BYTE = new RegExp(n, "g"), xn.NUMERIC = new RegExp(r, "g"), xn.ALPHANUMERIC = new RegExp(t, "g");
  const i = new RegExp("^" + e + "$"), s = new RegExp("^" + r + "$"), c = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
  return xn.testKanji = function(l) {
    return i.test(l);
  }, xn.testNumeric = function(l) {
    return s.test(l);
  }, xn.testAlphanumeric = function(l) {
    return c.test(l);
  }, xn;
}
var sh;
function Ki() {
  return sh || (sh = 1, (function(r) {
    const t = M1(), e = D1();
    r.NUMERIC = {
      id: "Numeric",
      bit: 1,
      ccBits: [10, 12, 14]
    }, r.ALPHANUMERIC = {
      id: "Alphanumeric",
      bit: 2,
      ccBits: [9, 11, 13]
    }, r.BYTE = {
      id: "Byte",
      bit: 4,
      ccBits: [8, 16, 16]
    }, r.KANJI = {
      id: "Kanji",
      bit: 8,
      ccBits: [8, 10, 12]
    }, r.MIXED = {
      bit: -1
    }, r.getCharCountIndicator = function(s, c) {
      if (!s.ccBits) throw new Error("Invalid mode: " + s);
      if (!t.isValid(c))
        throw new Error("Invalid version: " + c);
      return c >= 1 && c < 10 ? s.ccBits[0] : c < 27 ? s.ccBits[1] : s.ccBits[2];
    }, r.getBestModeForData = function(s) {
      return e.testNumeric(s) ? r.NUMERIC : e.testAlphanumeric(s) ? r.ALPHANUMERIC : e.testKanji(s) ? r.KANJI : r.BYTE;
    }, r.toString = function(s) {
      if (s && s.id) return s.id;
      throw new Error("Invalid mode");
    }, r.isValid = function(s) {
      return s && s.bit && s.ccBits;
    };
    function n(i) {
      if (typeof i != "string")
        throw new Error("Param is not a string");
      switch (i.toLowerCase()) {
        case "numeric":
          return r.NUMERIC;
        case "alphanumeric":
          return r.ALPHANUMERIC;
        case "kanji":
          return r.KANJI;
        case "byte":
          return r.BYTE;
        default:
          throw new Error("Unknown mode: " + i);
      }
    }
    r.from = function(s, c) {
      if (r.isValid(s))
        return s;
      try {
        return n(s);
      } catch {
        return c;
      }
    };
  })(Yc)), Yc;
}
var ah;
function kp() {
  return ah || (ah = 1, (function(r) {
    const t = Yi(), e = T1(), n = Tu(), i = Ki(), s = M1(), c = 7973, o = t.getBCHDigit(c);
    function l(_, g, y) {
      for (let x = 1; x <= 40; x++)
        if (g <= r.getCapacity(x, y, _))
          return x;
    }
    function f(_, g) {
      return i.getCharCountIndicator(_, g) + 4;
    }
    function d(_, g) {
      let y = 0;
      return _.forEach(function(x) {
        const E = f(x.mode, g);
        y += E + x.getBitsLength();
      }), y;
    }
    function b(_, g) {
      for (let y = 1; y <= 40; y++)
        if (d(_, y) <= r.getCapacity(y, g, i.MIXED))
          return y;
    }
    r.from = function(g, y) {
      return s.isValid(g) ? parseInt(g, 10) : y;
    }, r.getCapacity = function(g, y, x) {
      if (!s.isValid(g))
        throw new Error("Invalid QR Code version");
      typeof x > "u" && (x = i.BYTE);
      const E = t.getSymbolTotalCodewords(g), N = e.getTotalCodewordsCount(g, y), H = (E - N) * 8;
      if (x === i.MIXED) return H;
      const q = H - f(x, g);
      switch (x) {
        case i.NUMERIC:
          return Math.floor(q / 10 * 3);
        case i.ALPHANUMERIC:
          return Math.floor(q / 11 * 2);
        case i.KANJI:
          return Math.floor(q / 13);
        case i.BYTE:
        default:
          return Math.floor(q / 8);
      }
    }, r.getBestVersionForData = function(g, y) {
      let x;
      const E = n.from(y, n.M);
      if (Array.isArray(g)) {
        if (g.length > 1)
          return b(g, E);
        if (g.length === 0)
          return 1;
        x = g[0];
      } else
        x = g;
      return l(x.mode, x.getLength(), E);
    }, r.getEncodedBits = function(g) {
      if (!s.isValid(g) || g < 7)
        throw new Error("Invalid QR Code version");
      let y = g << 12;
      for (; t.getBCHDigit(y) - o >= 0; )
        y ^= c << t.getBCHDigit(y) - o;
      return g << 12 | y;
    };
  })(Jc)), Jc;
}
var Xc = {}, oh;
function Ep() {
  if (oh) return Xc;
  oh = 1;
  const r = Yi(), t = 1335, e = 21522, n = r.getBCHDigit(t);
  return Xc.getEncodedBits = function(s, c) {
    const o = s.bit << 3 | c;
    let l = o << 10;
    for (; r.getBCHDigit(l) - n >= 0; )
      l ^= t << r.getBCHDigit(l) - n;
    return (o << 10 | l) ^ e;
  }, Xc;
}
var $c = {}, Zc, ch;
function Pp() {
  if (ch) return Zc;
  ch = 1;
  const r = Ki();
  function t(e) {
    this.mode = r.NUMERIC, this.data = e.toString();
  }
  return t.getBitsLength = function(n) {
    return 10 * Math.floor(n / 3) + (n % 3 ? n % 3 * 3 + 1 : 0);
  }, t.prototype.getLength = function() {
    return this.data.length;
  }, t.prototype.getBitsLength = function() {
    return t.getBitsLength(this.data.length);
  }, t.prototype.write = function(n) {
    let i, s, c;
    for (i = 0; i + 3 <= this.data.length; i += 3)
      s = this.data.substr(i, 3), c = parseInt(s, 10), n.put(c, 10);
    const o = this.data.length - i;
    o > 0 && (s = this.data.substr(i), c = parseInt(s, 10), n.put(c, o * 3 + 1));
  }, Zc = t, Zc;
}
var Qc, uh;
function Cp() {
  if (uh) return Qc;
  uh = 1;
  const r = Ki(), t = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
  ];
  function e(n) {
    this.mode = r.ALPHANUMERIC, this.data = n;
  }
  return e.getBitsLength = function(i) {
    return 11 * Math.floor(i / 2) + 6 * (i % 2);
  }, e.prototype.getLength = function() {
    return this.data.length;
  }, e.prototype.getBitsLength = function() {
    return e.getBitsLength(this.data.length);
  }, e.prototype.write = function(i) {
    let s;
    for (s = 0; s + 2 <= this.data.length; s += 2) {
      let c = t.indexOf(this.data[s]) * 45;
      c += t.indexOf(this.data[s + 1]), i.put(c, 11);
    }
    this.data.length % 2 && i.put(t.indexOf(this.data[s]), 6);
  }, Qc = e, Qc;
}
var tu, lh;
function Rp() {
  if (lh) return tu;
  lh = 1;
  const r = Ki();
  function t(e) {
    this.mode = r.BYTE, typeof e == "string" ? this.data = new TextEncoder().encode(e) : this.data = new Uint8Array(e);
  }
  return t.getBitsLength = function(n) {
    return n * 8;
  }, t.prototype.getLength = function() {
    return this.data.length;
  }, t.prototype.getBitsLength = function() {
    return t.getBitsLength(this.data.length);
  }, t.prototype.write = function(e) {
    for (let n = 0, i = this.data.length; n < i; n++)
      e.put(this.data[n], 8);
  }, tu = t, tu;
}
var eu, fh;
function Ip() {
  if (fh) return eu;
  fh = 1;
  const r = Ki(), t = Yi();
  function e(n) {
    this.mode = r.KANJI, this.data = n;
  }
  return e.getBitsLength = function(i) {
    return i * 13;
  }, e.prototype.getLength = function() {
    return this.data.length;
  }, e.prototype.getBitsLength = function() {
    return e.getBitsLength(this.data.length);
  }, e.prototype.write = function(n) {
    let i;
    for (i = 0; i < this.data.length; i++) {
      let s = t.toSJIS(this.data[i]);
      if (s >= 33088 && s <= 40956)
        s -= 33088;
      else if (s >= 57408 && s <= 60351)
        s -= 49472;
      else
        throw new Error(
          "Invalid SJIS character: " + this.data[i] + `
Make sure your charset is UTF-8`
        );
      s = (s >>> 8 & 255) * 192 + (s & 255), n.put(s, 13);
    }
  }, eu = e, eu;
}
var ru = { exports: {} }, hh;
function Fp() {
  return hh || (hh = 1, (function(r) {
    var t = {
      single_source_shortest_paths: function(e, n, i) {
        var s = {}, c = {};
        c[n] = 0;
        var o = t.PriorityQueue.make();
        o.push(n, 0);
        for (var l, f, d, b, _, g, y, x, E; !o.empty(); ) {
          l = o.pop(), f = l.value, b = l.cost, _ = e[f] || {};
          for (d in _)
            _.hasOwnProperty(d) && (g = _[d], y = b + g, x = c[d], E = typeof c[d] > "u", (E || x > y) && (c[d] = y, o.push(d, y), s[d] = f));
        }
        if (typeof i < "u" && typeof c[i] > "u") {
          var N = ["Could not find a path from ", n, " to ", i, "."].join("");
          throw new Error(N);
        }
        return s;
      },
      extract_shortest_path_from_predecessor_list: function(e, n) {
        for (var i = [], s = n; s; )
          i.push(s), e[s], s = e[s];
        return i.reverse(), i;
      },
      find_path: function(e, n, i) {
        var s = t.single_source_shortest_paths(e, n, i);
        return t.extract_shortest_path_from_predecessor_list(
          s,
          i
        );
      },
      /**
       * A very naive priority queue implementation.
       */
      PriorityQueue: {
        make: function(e) {
          var n = t.PriorityQueue, i = {}, s;
          e = e || {};
          for (s in n)
            n.hasOwnProperty(s) && (i[s] = n[s]);
          return i.queue = [], i.sorter = e.sorter || n.default_sorter, i;
        },
        default_sorter: function(e, n) {
          return e.cost - n.cost;
        },
        /**
         * Add a new item to the queue and ensure the highest priority element
         * is at the front of the queue.
         */
        push: function(e, n) {
          var i = { value: e, cost: n };
          this.queue.push(i), this.queue.sort(this.sorter);
        },
        /**
         * Return the highest priority element in the queue.
         */
        pop: function() {
          return this.queue.shift();
        },
        empty: function() {
          return this.queue.length === 0;
        }
      }
    };
    r.exports = t;
  })(ru)), ru.exports;
}
var dh;
function Op() {
  return dh || (dh = 1, (function(r) {
    const t = Ki(), e = Pp(), n = Cp(), i = Rp(), s = Ip(), c = D1(), o = Yi(), l = Fp();
    function f(N) {
      return unescape(encodeURIComponent(N)).length;
    }
    function d(N, H, q) {
      const F = [];
      let et;
      for (; (et = N.exec(q)) !== null; )
        F.push({
          data: et[0],
          index: et.index,
          mode: H,
          length: et[0].length
        });
      return F;
    }
    function b(N) {
      const H = d(c.NUMERIC, t.NUMERIC, N), q = d(c.ALPHANUMERIC, t.ALPHANUMERIC, N);
      let F, et;
      return o.isKanjiModeEnabled() ? (F = d(c.BYTE, t.BYTE, N), et = d(c.KANJI, t.KANJI, N)) : (F = d(c.BYTE_KANJI, t.BYTE, N), et = []), H.concat(q, F, et).sort(function(X, V) {
        return X.index - V.index;
      }).map(function(X) {
        return {
          data: X.data,
          mode: X.mode,
          length: X.length
        };
      });
    }
    function _(N, H) {
      switch (H) {
        case t.NUMERIC:
          return e.getBitsLength(N);
        case t.ALPHANUMERIC:
          return n.getBitsLength(N);
        case t.KANJI:
          return s.getBitsLength(N);
        case t.BYTE:
          return i.getBitsLength(N);
      }
    }
    function g(N) {
      return N.reduce(function(H, q) {
        const F = H.length - 1 >= 0 ? H[H.length - 1] : null;
        return F && F.mode === q.mode ? (H[H.length - 1].data += q.data, H) : (H.push(q), H);
      }, []);
    }
    function y(N) {
      const H = [];
      for (let q = 0; q < N.length; q++) {
        const F = N[q];
        switch (F.mode) {
          case t.NUMERIC:
            H.push([
              F,
              { data: F.data, mode: t.ALPHANUMERIC, length: F.length },
              { data: F.data, mode: t.BYTE, length: F.length }
            ]);
            break;
          case t.ALPHANUMERIC:
            H.push([
              F,
              { data: F.data, mode: t.BYTE, length: F.length }
            ]);
            break;
          case t.KANJI:
            H.push([
              F,
              { data: F.data, mode: t.BYTE, length: f(F.data) }
            ]);
            break;
          case t.BYTE:
            H.push([
              { data: F.data, mode: t.BYTE, length: f(F.data) }
            ]);
        }
      }
      return H;
    }
    function x(N, H) {
      const q = {}, F = { start: {} };
      let et = ["start"];
      for (let Q = 0; Q < N.length; Q++) {
        const X = N[Q], V = [];
        for (let I = 0; I < X.length; I++) {
          const G = X[I], A = "" + Q + I;
          V.push(A), q[A] = { node: G, lastCount: 0 }, F[A] = {};
          for (let C = 0; C < et.length; C++) {
            const M = et[C];
            q[M] && q[M].node.mode === G.mode ? (F[M][A] = _(q[M].lastCount + G.length, G.mode) - _(q[M].lastCount, G.mode), q[M].lastCount += G.length) : (q[M] && (q[M].lastCount = G.length), F[M][A] = _(G.length, G.mode) + 4 + t.getCharCountIndicator(G.mode, H));
          }
        }
        et = V;
      }
      for (let Q = 0; Q < et.length; Q++)
        F[et[Q]].end = 0;
      return { map: F, table: q };
    }
    function E(N, H) {
      let q;
      const F = t.getBestModeForData(N);
      if (q = t.from(H, F), q !== t.BYTE && q.bit < F.bit)
        throw new Error('"' + N + '" cannot be encoded with mode ' + t.toString(q) + `.
 Suggested mode is: ` + t.toString(F));
      switch (q === t.KANJI && !o.isKanjiModeEnabled() && (q = t.BYTE), q) {
        case t.NUMERIC:
          return new e(N);
        case t.ALPHANUMERIC:
          return new n(N);
        case t.KANJI:
          return new s(N);
        case t.BYTE:
          return new i(N);
      }
    }
    r.fromArray = function(H) {
      return H.reduce(function(q, F) {
        return typeof F == "string" ? q.push(E(F, null)) : F.data && q.push(E(F.data, F.mode)), q;
      }, []);
    }, r.fromString = function(H, q) {
      const F = b(H, o.isKanjiModeEnabled()), et = y(F), Q = x(et, q), X = l.find_path(Q.map, "start", "end"), V = [];
      for (let I = 1; I < X.length - 1; I++)
        V.push(Q.table[X[I]].node);
      return r.fromArray(g(V));
    }, r.rawSplit = function(H) {
      return r.fromArray(
        b(H, o.isKanjiModeEnabled())
      );
    };
  })($c)), $c;
}
var ph;
function Bp() {
  if (ph) return Dc;
  ph = 1;
  const r = Yi(), t = Tu(), e = vp(), n = yp(), i = _p(), s = Ap(), c = xp(), o = T1(), l = Sp(), f = kp(), d = Ep(), b = Ki(), _ = Op();
  function g(Q, X) {
    const V = Q.size, I = s.getPositions(X);
    for (let G = 0; G < I.length; G++) {
      const A = I[G][0], C = I[G][1];
      for (let M = -1; M <= 7; M++)
        if (!(A + M <= -1 || V <= A + M))
          for (let D = -1; D <= 7; D++)
            C + D <= -1 || V <= C + D || (M >= 0 && M <= 6 && (D === 0 || D === 6) || D >= 0 && D <= 6 && (M === 0 || M === 6) || M >= 2 && M <= 4 && D >= 2 && D <= 4 ? Q.set(A + M, C + D, !0, !0) : Q.set(A + M, C + D, !1, !0));
    }
  }
  function y(Q) {
    const X = Q.size;
    for (let V = 8; V < X - 8; V++) {
      const I = V % 2 === 0;
      Q.set(V, 6, I, !0), Q.set(6, V, I, !0);
    }
  }
  function x(Q, X) {
    const V = i.getPositions(X);
    for (let I = 0; I < V.length; I++) {
      const G = V[I][0], A = V[I][1];
      for (let C = -2; C <= 2; C++)
        for (let M = -2; M <= 2; M++)
          C === -2 || C === 2 || M === -2 || M === 2 || C === 0 && M === 0 ? Q.set(G + C, A + M, !0, !0) : Q.set(G + C, A + M, !1, !0);
    }
  }
  function E(Q, X) {
    const V = Q.size, I = f.getEncodedBits(X);
    let G, A, C;
    for (let M = 0; M < 18; M++)
      G = Math.floor(M / 3), A = M % 3 + V - 8 - 3, C = (I >> M & 1) === 1, Q.set(G, A, C, !0), Q.set(A, G, C, !0);
  }
  function N(Q, X, V) {
    const I = Q.size, G = d.getEncodedBits(X, V);
    let A, C;
    for (A = 0; A < 15; A++)
      C = (G >> A & 1) === 1, A < 6 ? Q.set(A, 8, C, !0) : A < 8 ? Q.set(A + 1, 8, C, !0) : Q.set(I - 15 + A, 8, C, !0), A < 8 ? Q.set(8, I - A - 1, C, !0) : A < 9 ? Q.set(8, 15 - A - 1 + 1, C, !0) : Q.set(8, 15 - A - 1, C, !0);
    Q.set(I - 8, 8, 1, !0);
  }
  function H(Q, X) {
    const V = Q.size;
    let I = -1, G = V - 1, A = 7, C = 0;
    for (let M = V - 1; M > 0; M -= 2)
      for (M === 6 && M--; ; ) {
        for (let D = 0; D < 2; D++)
          if (!Q.isReserved(G, M - D)) {
            let at = !1;
            C < X.length && (at = (X[C] >>> A & 1) === 1), Q.set(G, M - D, at), A--, A === -1 && (C++, A = 7);
          }
        if (G += I, G < 0 || V <= G) {
          G -= I, I = -I;
          break;
        }
      }
  }
  function q(Q, X, V) {
    const I = new e();
    V.forEach(function(D) {
      I.put(D.mode.bit, 4), I.put(D.getLength(), b.getCharCountIndicator(D.mode, Q)), D.write(I);
    });
    const G = r.getSymbolTotalCodewords(Q), A = o.getTotalCodewordsCount(Q, X), C = (G - A) * 8;
    for (I.getLengthInBits() + 4 <= C && I.put(0, 4); I.getLengthInBits() % 8 !== 0; )
      I.putBit(0);
    const M = (C - I.getLengthInBits()) / 8;
    for (let D = 0; D < M; D++)
      I.put(D % 2 ? 17 : 236, 8);
    return F(I, Q, X);
  }
  function F(Q, X, V) {
    const I = r.getSymbolTotalCodewords(X), G = o.getTotalCodewordsCount(X, V), A = I - G, C = o.getBlocksCount(X, V), M = I % C, D = C - M, at = Math.floor(I / C), ot = Math.floor(A / C), ft = ot + 1, rt = at - ot, ht = new l(rt);
    let Lt = 0;
    const vt = new Array(C), S = new Array(C);
    let j = 0;
    const z = new Uint8Array(Q.buffer);
    for (let ct = 0; ct < C; ct++) {
      const bt = ct < D ? ot : ft;
      vt[ct] = z.slice(Lt, Lt + bt), S[ct] = ht.encode(vt[ct]), Lt += bt, j = Math.max(j, bt);
    }
    const J = new Uint8Array(I);
    let $ = 0, nt, lt;
    for (nt = 0; nt < j; nt++)
      for (lt = 0; lt < C; lt++)
        nt < vt[lt].length && (J[$++] = vt[lt][nt]);
    for (nt = 0; nt < rt; nt++)
      for (lt = 0; lt < C; lt++)
        J[$++] = S[lt][nt];
    return J;
  }
  function et(Q, X, V, I) {
    let G;
    if (Array.isArray(Q))
      G = _.fromArray(Q);
    else if (typeof Q == "string") {
      let at = X;
      if (!at) {
        const ot = _.rawSplit(Q);
        at = f.getBestVersionForData(ot, V);
      }
      G = _.fromString(Q, at || 40);
    } else
      throw new Error("Invalid data");
    const A = f.getBestVersionForData(G, V);
    if (!A)
      throw new Error("The amount of data is too big to be stored in a QR Code");
    if (!X)
      X = A;
    else if (X < A)
      throw new Error(
        `
The chosen QR Code version cannot contain this amount of data.
Minimum version required to store current data is: ` + A + `.
`
      );
    const C = q(X, V, G), M = r.getSymbolSize(X), D = new n(M);
    return g(D, X), y(D), x(D, X), N(D, V, 0), X >= 7 && E(D, X), H(D, C), isNaN(I) && (I = c.getBestMask(
      D,
      N.bind(null, D, V)
    )), c.applyMask(I, D), N(D, V, I), {
      modules: D,
      version: X,
      errorCorrectionLevel: V,
      maskPattern: I,
      segments: G
    };
  }
  return Dc.create = function(X, V) {
    if (typeof X > "u" || X === "")
      throw new Error("No input text");
    let I = t.M, G, A;
    return typeof V < "u" && (I = t.from(V.errorCorrectionLevel, t.M), G = f.from(V.version), A = c.from(V.maskPattern), V.toSJISFunc && r.setToSJISFunction(V.toSJISFunc)), et(X, G, I, A);
  }, Dc;
}
var nu = {}, iu = {}, gh;
function j1() {
  return gh || (gh = 1, (function(r) {
    function t(e) {
      if (typeof e == "number" && (e = e.toString()), typeof e != "string")
        throw new Error("Color should be defined as hex string");
      let n = e.slice().replace("#", "").split("");
      if (n.length < 3 || n.length === 5 || n.length > 8)
        throw new Error("Invalid hex color: " + e);
      (n.length === 3 || n.length === 4) && (n = Array.prototype.concat.apply([], n.map(function(s) {
        return [s, s];
      }))), n.length === 6 && n.push("F", "F");
      const i = parseInt(n.join(""), 16);
      return {
        r: i >> 24 & 255,
        g: i >> 16 & 255,
        b: i >> 8 & 255,
        a: i & 255,
        hex: "#" + n.slice(0, 6).join("")
      };
    }
    r.getOptions = function(n) {
      n || (n = {}), n.color || (n.color = {});
      const i = typeof n.margin > "u" || n.margin === null || n.margin < 0 ? 4 : n.margin, s = n.width && n.width >= 21 ? n.width : void 0, c = n.scale || 4;
      return {
        width: s,
        scale: s ? 4 : c,
        margin: i,
        color: {
          dark: t(n.color.dark || "#000000ff"),
          light: t(n.color.light || "#ffffffff")
        },
        type: n.type,
        rendererOpts: n.rendererOpts || {}
      };
    }, r.getScale = function(n, i) {
      return i.width && i.width >= n + i.margin * 2 ? i.width / (n + i.margin * 2) : i.scale;
    }, r.getImageWidth = function(n, i) {
      const s = r.getScale(n, i);
      return Math.floor((n + i.margin * 2) * s);
    }, r.qrToImageData = function(n, i, s) {
      const c = i.modules.size, o = i.modules.data, l = r.getScale(c, s), f = Math.floor((c + s.margin * 2) * l), d = s.margin * l, b = [s.color.light, s.color.dark];
      for (let _ = 0; _ < f; _++)
        for (let g = 0; g < f; g++) {
          let y = (_ * f + g) * 4, x = s.color.light;
          if (_ >= d && g >= d && _ < f - d && g < f - d) {
            const E = Math.floor((_ - d) / l), N = Math.floor((g - d) / l);
            x = b[o[E * c + N] ? 1 : 0];
          }
          n[y++] = x.r, n[y++] = x.g, n[y++] = x.b, n[y] = x.a;
        }
    };
  })(iu)), iu;
}
var mh;
function Tp() {
  return mh || (mh = 1, (function(r) {
    const t = j1();
    function e(i, s, c) {
      i.clearRect(0, 0, s.width, s.height), s.style || (s.style = {}), s.height = c, s.width = c, s.style.height = c + "px", s.style.width = c + "px";
    }
    function n() {
      try {
        return document.createElement("canvas");
      } catch {
        throw new Error("You need to specify a canvas element");
      }
    }
    r.render = function(s, c, o) {
      let l = o, f = c;
      typeof l > "u" && (!c || !c.getContext) && (l = c, c = void 0), c || (f = n()), l = t.getOptions(l);
      const d = t.getImageWidth(s.modules.size, l), b = f.getContext("2d"), _ = b.createImageData(d, d);
      return t.qrToImageData(_.data, s, l), e(b, f, d), b.putImageData(_, 0, 0), f;
    }, r.renderToDataURL = function(s, c, o) {
      let l = o;
      typeof l > "u" && (!c || !c.getContext) && (l = c, c = void 0), l || (l = {});
      const f = r.render(s, c, l), d = l.type || "image/png", b = l.rendererOpts || {};
      return f.toDataURL(d, b.quality);
    };
  })(nu)), nu;
}
var su = {}, bh;
function Mp() {
  if (bh) return su;
  bh = 1;
  const r = j1();
  function t(i, s) {
    const c = i.a / 255, o = s + '="' + i.hex + '"';
    return c < 1 ? o + " " + s + '-opacity="' + c.toFixed(2).slice(1) + '"' : o;
  }
  function e(i, s, c) {
    let o = i + s;
    return typeof c < "u" && (o += " " + c), o;
  }
  function n(i, s, c) {
    let o = "", l = 0, f = !1, d = 0;
    for (let b = 0; b < i.length; b++) {
      const _ = Math.floor(b % s), g = Math.floor(b / s);
      !_ && !f && (f = !0), i[b] ? (d++, b > 0 && _ > 0 && i[b - 1] || (o += f ? e("M", _ + c, 0.5 + g + c) : e("m", l, 0), l = 0, f = !1), _ + 1 < s && i[b + 1] || (o += e("h", d), d = 0)) : l++;
    }
    return o;
  }
  return su.render = function(s, c, o) {
    const l = r.getOptions(c), f = s.modules.size, d = s.modules.data, b = f + l.margin * 2, _ = l.color.light.a ? "<path " + t(l.color.light, "fill") + ' d="M0 0h' + b + "v" + b + 'H0z"/>' : "", g = "<path " + t(l.color.dark, "stroke") + ' d="' + n(d, f, l.margin) + '"/>', y = 'viewBox="0 0 ' + b + " " + b + '"', E = '<svg xmlns="http://www.w3.org/2000/svg" ' + (l.width ? 'width="' + l.width + '" height="' + l.width + '" ' : "") + y + ' shape-rendering="crispEdges">' + _ + g + `</svg>
`;
    return typeof o == "function" && o(null, E), E;
  }, su;
}
var wh;
function Dp() {
  if (wh) return hs;
  wh = 1;
  const r = wp(), t = Bp(), e = Tp(), n = Mp();
  function i(s, c, o, l, f) {
    const d = [].slice.call(arguments, 1), b = d.length, _ = typeof d[b - 1] == "function";
    if (!_ && !r())
      throw new Error("Callback required as last argument");
    if (_) {
      if (b < 2)
        throw new Error("Too few arguments provided");
      b === 2 ? (f = o, o = c, c = l = void 0) : b === 3 && (c.getContext && typeof f > "u" ? (f = l, l = void 0) : (f = l, l = o, o = c, c = void 0));
    } else {
      if (b < 1)
        throw new Error("Too few arguments provided");
      return b === 1 ? (o = c, c = l = void 0) : b === 2 && !c.getContext && (l = o, o = c, c = void 0), new Promise(function(g, y) {
        try {
          const x = t.create(o, l);
          g(s(x, c, l));
        } catch (x) {
          y(x);
        }
      });
    }
    try {
      const g = t.create(o, l);
      f(null, s(g, c, l));
    } catch (g) {
      f(g);
    }
  }
  return hs.create = t.create, hs.toCanvas = i.bind(null, e.render), hs.toDataURL = i.bind(null, e.renderToDataURL), hs.toString = i.bind(null, function(s, c, o) {
    return n.render(s, o);
  }), hs;
}
var jp = Dp();
const vh = /* @__PURE__ */ bp(jp);
function q1(r, t) {
  return function() {
    return r.apply(t, arguments);
  };
}
const { toString: qp } = Object.prototype, { getPrototypeOf: Mu } = Object, { iterator: Ro, toStringTag: U1 } = Symbol, Io = /* @__PURE__ */ ((r) => (t) => {
  const e = qp.call(t);
  return r[e] || (r[e] = e.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), pn = (r) => (r = r.toLowerCase(), (t) => Io(t) === r), Fo = (r) => (t) => typeof t === r, { isArray: As } = Array, ys = Fo("undefined");
function fa(r) {
  return r !== null && !ys(r) && r.constructor !== null && !ys(r.constructor) && Ir(r.constructor.isBuffer) && r.constructor.isBuffer(r);
}
const z1 = pn("ArrayBuffer");
function Up(r) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(r) : t = r && r.buffer && z1(r.buffer), t;
}
const zp = Fo("string"), Ir = Fo("function"), H1 = Fo("number"), ha = (r) => r !== null && typeof r == "object", Hp = (r) => r === !0 || r === !1, yo = (r) => {
  if (Io(r) !== "object")
    return !1;
  const t = Mu(r);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(U1 in r) && !(Ro in r);
}, Vp = (r) => {
  if (!ha(r) || fa(r))
    return !1;
  try {
    return Object.keys(r).length === 0 && Object.getPrototypeOf(r) === Object.prototype;
  } catch {
    return !1;
  }
}, Wp = pn("Date"), Gp = pn("File"), Jp = (r) => !!(r && typeof r.uri < "u"), Yp = (r) => r && typeof r.getParts < "u", Kp = pn("Blob"), Xp = pn("FileList"), $p = (r) => ha(r) && Ir(r.pipe);
function Zp() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const yh = Zp(), _h = typeof yh.FormData < "u" ? yh.FormData : void 0, Qp = (r) => {
  let t;
  return r && (_h && r instanceof _h || Ir(r.append) && ((t = Io(r)) === "formdata" || // detect form-data instance
  t === "object" && Ir(r.toString) && r.toString() === "[object FormData]"));
}, tg = pn("URLSearchParams"), [eg, rg, ng, ig] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map(pn), sg = (r) => r.trim ? r.trim() : r.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function da(r, t, { allOwnKeys: e = !1 } = {}) {
  if (r === null || typeof r > "u")
    return;
  let n, i;
  if (typeof r != "object" && (r = [r]), As(r))
    for (n = 0, i = r.length; n < i; n++)
      t.call(null, r[n], n, r);
  else {
    if (fa(r))
      return;
    const s = e ? Object.getOwnPropertyNames(r) : Object.keys(r), c = s.length;
    let o;
    for (n = 0; n < c; n++)
      o = s[n], t.call(null, r[o], o, r);
  }
}
function V1(r, t) {
  if (fa(r))
    return null;
  t = t.toLowerCase();
  const e = Object.keys(r);
  let n = e.length, i;
  for (; n-- > 0; )
    if (i = e[n], t === i.toLowerCase())
      return i;
  return null;
}
const qi = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, W1 = (r) => !ys(r) && r !== qi;
function Su() {
  const { caseless: r, skipUndefined: t } = W1(this) && this || {}, e = {}, n = (i, s) => {
    if (s === "__proto__" || s === "constructor" || s === "prototype")
      return;
    const c = r && V1(e, s) || s;
    yo(e[c]) && yo(i) ? e[c] = Su(e[c], i) : yo(i) ? e[c] = Su({}, i) : As(i) ? e[c] = i.slice() : (!t || !ys(i)) && (e[c] = i);
  };
  for (let i = 0, s = arguments.length; i < s; i++)
    arguments[i] && da(arguments[i], n);
  return e;
}
const ag = (r, t, e, { allOwnKeys: n } = {}) => (da(
  t,
  (i, s) => {
    e && Ir(i) ? Object.defineProperty(r, s, {
      value: q1(i, e),
      writable: !0,
      enumerable: !0,
      configurable: !0
    }) : Object.defineProperty(r, s, {
      value: i,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  },
  { allOwnKeys: n }
), r), og = (r) => (r.charCodeAt(0) === 65279 && (r = r.slice(1)), r), cg = (r, t, e, n) => {
  r.prototype = Object.create(t.prototype, n), Object.defineProperty(r.prototype, "constructor", {
    value: r,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(r, "super", {
    value: t.prototype
  }), e && Object.assign(r.prototype, e);
}, ug = (r, t, e, n) => {
  let i, s, c;
  const o = {};
  if (t = t || {}, r == null) return t;
  do {
    for (i = Object.getOwnPropertyNames(r), s = i.length; s-- > 0; )
      c = i[s], (!n || n(c, r, t)) && !o[c] && (t[c] = r[c], o[c] = !0);
    r = e !== !1 && Mu(r);
  } while (r && (!e || e(r, t)) && r !== Object.prototype);
  return t;
}, lg = (r, t, e) => {
  r = String(r), (e === void 0 || e > r.length) && (e = r.length), e -= t.length;
  const n = r.indexOf(t, e);
  return n !== -1 && n === e;
}, fg = (r) => {
  if (!r) return null;
  if (As(r)) return r;
  let t = r.length;
  if (!H1(t)) return null;
  const e = new Array(t);
  for (; t-- > 0; )
    e[t] = r[t];
  return e;
}, hg = /* @__PURE__ */ ((r) => (t) => r && t instanceof r)(typeof Uint8Array < "u" && Mu(Uint8Array)), dg = (r, t) => {
  const n = (r && r[Ro]).call(r);
  let i;
  for (; (i = n.next()) && !i.done; ) {
    const s = i.value;
    t.call(r, s[0], s[1]);
  }
}, pg = (r, t) => {
  let e;
  const n = [];
  for (; (e = r.exec(t)) !== null; )
    n.push(e);
  return n;
}, gg = pn("HTMLFormElement"), mg = (r) => r.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(e, n, i) {
  return n.toUpperCase() + i;
}), Ah = (({ hasOwnProperty: r }) => (t, e) => r.call(t, e))(Object.prototype), bg = pn("RegExp"), G1 = (r, t) => {
  const e = Object.getOwnPropertyDescriptors(r), n = {};
  da(e, (i, s) => {
    let c;
    (c = t(i, s, r)) !== !1 && (n[s] = c || i);
  }), Object.defineProperties(r, n);
}, wg = (r) => {
  G1(r, (t, e) => {
    if (Ir(r) && ["arguments", "caller", "callee"].indexOf(e) !== -1)
      return !1;
    const n = r[e];
    if (Ir(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + e + "'");
      });
    }
  });
}, vg = (r, t) => {
  const e = {}, n = (i) => {
    i.forEach((s) => {
      e[s] = !0;
    });
  };
  return As(r) ? n(r) : n(String(r).split(t)), e;
}, yg = () => {
}, _g = (r, t) => r != null && Number.isFinite(r = +r) ? r : t;
function Ag(r) {
  return !!(r && Ir(r.append) && r[U1] === "FormData" && r[Ro]);
}
const xg = (r) => {
  const t = new Array(10), e = (n, i) => {
    if (ha(n)) {
      if (t.indexOf(n) >= 0)
        return;
      if (fa(n))
        return n;
      if (!("toJSON" in n)) {
        t[i] = n;
        const s = As(n) ? [] : {};
        return da(n, (c, o) => {
          const l = e(c, i + 1);
          !ys(l) && (s[o] = l);
        }), t[i] = void 0, s;
      }
    }
    return n;
  };
  return e(r, 0);
}, Ng = pn("AsyncFunction"), Lg = (r) => r && (ha(r) || Ir(r)) && Ir(r.then) && Ir(r.catch), J1 = ((r, t) => r ? setImmediate : t ? ((e, n) => (qi.addEventListener(
  "message",
  ({ source: i, data: s }) => {
    i === qi && s === e && n.length && n.shift()();
  },
  !1
), (i) => {
  n.push(i), qi.postMessage(e, "*");
}))(`axios@${Math.random()}`, []) : (e) => setTimeout(e))(typeof setImmediate == "function", Ir(qi.postMessage)), Sg = typeof queueMicrotask < "u" ? queueMicrotask.bind(qi) : typeof process < "u" && process.nextTick || J1, kg = (r) => r != null && Ir(r[Ro]), ut = {
  isArray: As,
  isArrayBuffer: z1,
  isBuffer: fa,
  isFormData: Qp,
  isArrayBufferView: Up,
  isString: zp,
  isNumber: H1,
  isBoolean: Hp,
  isObject: ha,
  isPlainObject: yo,
  isEmptyObject: Vp,
  isReadableStream: eg,
  isRequest: rg,
  isResponse: ng,
  isHeaders: ig,
  isUndefined: ys,
  isDate: Wp,
  isFile: Gp,
  isReactNativeBlob: Jp,
  isReactNative: Yp,
  isBlob: Kp,
  isRegExp: bg,
  isFunction: Ir,
  isStream: $p,
  isURLSearchParams: tg,
  isTypedArray: hg,
  isFileList: Xp,
  forEach: da,
  merge: Su,
  extend: ag,
  trim: sg,
  stripBOM: og,
  inherits: cg,
  toFlatObject: ug,
  kindOf: Io,
  kindOfTest: pn,
  endsWith: lg,
  toArray: fg,
  forEachEntry: dg,
  matchAll: pg,
  isHTMLForm: gg,
  hasOwnProperty: Ah,
  hasOwnProp: Ah,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: G1,
  freezeMethods: wg,
  toObjectSet: vg,
  toCamelCase: mg,
  noop: yg,
  toFiniteNumber: _g,
  findKey: V1,
  global: qi,
  isContextDefined: W1,
  isSpecCompliantForm: Ag,
  toJSONObject: xg,
  isAsyncFn: Ng,
  isThenable: Lg,
  setImmediate: J1,
  asap: Sg,
  isIterable: kg
};
let Jt = class Y1 extends Error {
  static from(t, e, n, i, s, c) {
    const o = new Y1(t.message, e || t.code, n, i, s);
    return o.cause = t, o.name = t.name, t.status != null && o.status == null && (o.status = t.status), c && Object.assign(o, c), o;
  }
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(t, e, n, i, s) {
    super(t), Object.defineProperty(this, "message", {
      value: t,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }), this.name = "AxiosError", this.isAxiosError = !0, e && (this.code = e), n && (this.config = n), i && (this.request = i), s && (this.response = s, this.status = s.status);
  }
  toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: ut.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
};
Jt.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
Jt.ERR_BAD_OPTION = "ERR_BAD_OPTION";
Jt.ECONNABORTED = "ECONNABORTED";
Jt.ETIMEDOUT = "ETIMEDOUT";
Jt.ERR_NETWORK = "ERR_NETWORK";
Jt.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
Jt.ERR_DEPRECATED = "ERR_DEPRECATED";
Jt.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
Jt.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
Jt.ERR_CANCELED = "ERR_CANCELED";
Jt.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
Jt.ERR_INVALID_URL = "ERR_INVALID_URL";
const Eg = null;
function ku(r) {
  return ut.isPlainObject(r) || ut.isArray(r);
}
function K1(r) {
  return ut.endsWith(r, "[]") ? r.slice(0, -2) : r;
}
function au(r, t, e) {
  return r ? r.concat(t).map(function(i, s) {
    return i = K1(i), !e && s ? "[" + i + "]" : i;
  }).join(e ? "." : "") : t;
}
function Pg(r) {
  return ut.isArray(r) && !r.some(ku);
}
const Cg = ut.toFlatObject(ut, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function Oo(r, t, e) {
  if (!ut.isObject(r))
    throw new TypeError("target must be an object");
  t = t || new FormData(), e = ut.toFlatObject(
    e,
    {
      metaTokens: !0,
      dots: !1,
      indexes: !1
    },
    !1,
    function(x, E) {
      return !ut.isUndefined(E[x]);
    }
  );
  const n = e.metaTokens, i = e.visitor || d, s = e.dots, c = e.indexes, l = (e.Blob || typeof Blob < "u" && Blob) && ut.isSpecCompliantForm(t);
  if (!ut.isFunction(i))
    throw new TypeError("visitor must be a function");
  function f(y) {
    if (y === null) return "";
    if (ut.isDate(y))
      return y.toISOString();
    if (ut.isBoolean(y))
      return y.toString();
    if (!l && ut.isBlob(y))
      throw new Jt("Blob is not supported. Use a Buffer instead.");
    return ut.isArrayBuffer(y) || ut.isTypedArray(y) ? l && typeof Blob == "function" ? new Blob([y]) : Buffer.from(y) : y;
  }
  function d(y, x, E) {
    let N = y;
    if (ut.isReactNative(t) && ut.isReactNativeBlob(y))
      return t.append(au(E, x, s), f(y)), !1;
    if (y && !E && typeof y == "object") {
      if (ut.endsWith(x, "{}"))
        x = n ? x : x.slice(0, -2), y = JSON.stringify(y);
      else if (ut.isArray(y) && Pg(y) || (ut.isFileList(y) || ut.endsWith(x, "[]")) && (N = ut.toArray(y)))
        return x = K1(x), N.forEach(function(q, F) {
          !(ut.isUndefined(q) || q === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            c === !0 ? au([x], F, s) : c === null ? x : x + "[]",
            f(q)
          );
        }), !1;
    }
    return ku(y) ? !0 : (t.append(au(E, x, s), f(y)), !1);
  }
  const b = [], _ = Object.assign(Cg, {
    defaultVisitor: d,
    convertValue: f,
    isVisitable: ku
  });
  function g(y, x) {
    if (!ut.isUndefined(y)) {
      if (b.indexOf(y) !== -1)
        throw Error("Circular reference detected in " + x.join("."));
      b.push(y), ut.forEach(y, function(N, H) {
        (!(ut.isUndefined(N) || N === null) && i.call(t, N, ut.isString(H) ? H.trim() : H, x, _)) === !0 && g(N, x ? x.concat(H) : [H]);
      }), b.pop();
    }
  }
  if (!ut.isObject(r))
    throw new TypeError("data must be an object");
  return g(r), t;
}
function xh(r) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(r).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function Du(r, t) {
  this._pairs = [], r && Oo(r, this, t);
}
const X1 = Du.prototype;
X1.append = function(t, e) {
  this._pairs.push([t, e]);
};
X1.toString = function(t) {
  const e = t ? function(n) {
    return t.call(this, n, xh);
  } : xh;
  return this._pairs.map(function(i) {
    return e(i[0]) + "=" + e(i[1]);
  }, "").join("&");
};
function Rg(r) {
  return encodeURIComponent(r).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function $1(r, t, e) {
  if (!t)
    return r;
  const n = e && e.encode || Rg, i = ut.isFunction(e) ? {
    serialize: e
  } : e, s = i && i.serialize;
  let c;
  if (s ? c = s(t, i) : c = ut.isURLSearchParams(t) ? t.toString() : new Du(t, i).toString(n), c) {
    const o = r.indexOf("#");
    o !== -1 && (r = r.slice(0, o)), r += (r.indexOf("?") === -1 ? "?" : "&") + c;
  }
  return r;
}
class Nh {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, e, n) {
    return this.handlers.push({
      fulfilled: t,
      rejected: e,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    ut.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}
const ju = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1,
  legacyInterceptorReqResOrdering: !0
}, Ig = typeof URLSearchParams < "u" ? URLSearchParams : Du, Fg = typeof FormData < "u" ? FormData : null, Og = typeof Blob < "u" ? Blob : null, Bg = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Ig,
    FormData: Fg,
    Blob: Og
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, qu = typeof window < "u" && typeof document < "u", Eu = typeof navigator == "object" && navigator || void 0, Tg = qu && (!Eu || ["ReactNative", "NativeScript", "NS"].indexOf(Eu.product) < 0), Mg = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Dg = qu && window.location.href || "http://localhost", jg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: qu,
  hasStandardBrowserEnv: Tg,
  hasStandardBrowserWebWorkerEnv: Mg,
  navigator: Eu,
  origin: Dg
}, Symbol.toStringTag, { value: "Module" })), xr = {
  ...jg,
  ...Bg
};
function qg(r, t) {
  return Oo(r, new xr.classes.URLSearchParams(), {
    visitor: function(e, n, i, s) {
      return xr.isNode && ut.isBuffer(e) ? (this.append(n, e.toString("base64")), !1) : s.defaultVisitor.apply(this, arguments);
    },
    ...t
  });
}
function Ug(r) {
  return ut.matchAll(/\w+|\[(\w*)]/g, r).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function zg(r) {
  const t = {}, e = Object.keys(r);
  let n;
  const i = e.length;
  let s;
  for (n = 0; n < i; n++)
    s = e[n], t[s] = r[s];
  return t;
}
function Z1(r) {
  function t(e, n, i, s) {
    let c = e[s++];
    if (c === "__proto__") return !0;
    const o = Number.isFinite(+c), l = s >= e.length;
    return c = !c && ut.isArray(i) ? i.length : c, l ? (ut.hasOwnProp(i, c) ? i[c] = [i[c], n] : i[c] = n, !o) : ((!i[c] || !ut.isObject(i[c])) && (i[c] = []), t(e, n, i[c], s) && ut.isArray(i[c]) && (i[c] = zg(i[c])), !o);
  }
  if (ut.isFormData(r) && ut.isFunction(r.entries)) {
    const e = {};
    return ut.forEachEntry(r, (n, i) => {
      t(Ug(n), i, e, 0);
    }), e;
  }
  return null;
}
function Hg(r, t, e) {
  if (ut.isString(r))
    try {
      return (t || JSON.parse)(r), ut.trim(r);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (e || JSON.stringify)(r);
}
const pa = {
  transitional: ju,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [
    function(t, e) {
      const n = e.getContentType() || "", i = n.indexOf("application/json") > -1, s = ut.isObject(t);
      if (s && ut.isHTMLForm(t) && (t = new FormData(t)), ut.isFormData(t))
        return i ? JSON.stringify(Z1(t)) : t;
      if (ut.isArrayBuffer(t) || ut.isBuffer(t) || ut.isStream(t) || ut.isFile(t) || ut.isBlob(t) || ut.isReadableStream(t))
        return t;
      if (ut.isArrayBufferView(t))
        return t.buffer;
      if (ut.isURLSearchParams(t))
        return e.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
      let o;
      if (s) {
        if (n.indexOf("application/x-www-form-urlencoded") > -1)
          return qg(t, this.formSerializer).toString();
        if ((o = ut.isFileList(t)) || n.indexOf("multipart/form-data") > -1) {
          const l = this.env && this.env.FormData;
          return Oo(
            o ? { "files[]": t } : t,
            l && new l(),
            this.formSerializer
          );
        }
      }
      return s || i ? (e.setContentType("application/json", !1), Hg(t)) : t;
    }
  ],
  transformResponse: [
    function(t) {
      const e = this.transitional || pa.transitional, n = e && e.forcedJSONParsing, i = this.responseType === "json";
      if (ut.isResponse(t) || ut.isReadableStream(t))
        return t;
      if (t && ut.isString(t) && (n && !this.responseType || i)) {
        const c = !(e && e.silentJSONParsing) && i;
        try {
          return JSON.parse(t, this.parseReviver);
        } catch (o) {
          if (c)
            throw o.name === "SyntaxError" ? Jt.from(o, Jt.ERR_BAD_RESPONSE, this, null, this.response) : o;
        }
      }
      return t;
    }
  ],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: xr.classes.FormData,
    Blob: xr.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
ut.forEach(["delete", "get", "head", "post", "put", "patch"], (r) => {
  pa.headers[r] = {};
});
const Vg = ut.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Wg = (r) => {
  const t = {};
  let e, n, i;
  return r && r.split(`
`).forEach(function(c) {
    i = c.indexOf(":"), e = c.substring(0, i).trim().toLowerCase(), n = c.substring(i + 1).trim(), !(!e || t[e] && Vg[e]) && (e === "set-cookie" ? t[e] ? t[e].push(n) : t[e] = [n] : t[e] = t[e] ? t[e] + ", " + n : n);
  }), t;
}, Lh = /* @__PURE__ */ Symbol("internals"), Gg = (r) => !/[\r\n]/.test(r);
function Q1(r, t) {
  if (!(r === !1 || r == null)) {
    if (ut.isArray(r)) {
      r.forEach((e) => Q1(e, t));
      return;
    }
    if (!Gg(String(r)))
      throw new Error(`Invalid character in header content ["${t}"]`);
  }
}
function ta(r) {
  return r && String(r).trim().toLowerCase();
}
function Jg(r) {
  let t = r.length;
  for (; t > 0; ) {
    const e = r.charCodeAt(t - 1);
    if (e !== 10 && e !== 13)
      break;
    t -= 1;
  }
  return t === r.length ? r : r.slice(0, t);
}
function _o(r) {
  return r === !1 || r == null ? r : ut.isArray(r) ? r.map(_o) : Jg(String(r));
}
function Yg(r) {
  const t = /* @__PURE__ */ Object.create(null), e = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = e.exec(r); )
    t[n[1]] = n[2];
  return t;
}
const Kg = (r) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(r.trim());
function ou(r, t, e, n, i) {
  if (ut.isFunction(n))
    return n.call(this, t, e);
  if (i && (t = e), !!ut.isString(t)) {
    if (ut.isString(n))
      return t.indexOf(n) !== -1;
    if (ut.isRegExp(n))
      return n.test(t);
  }
}
function Xg(r) {
  return r.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, e, n) => e.toUpperCase() + n);
}
function $g(r, t) {
  const e = ut.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(r, n + e, {
      value: function(i, s, c) {
        return this[n].call(this, t, i, s, c);
      },
      configurable: !0
    });
  });
}
let Fr = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, e, n) {
    const i = this;
    function s(o, l, f) {
      const d = ta(l);
      if (!d)
        throw new Error("header name must be a non-empty string");
      const b = ut.findKey(i, d);
      (!b || i[b] === void 0 || f === !0 || f === void 0 && i[b] !== !1) && (Q1(o, l), i[b || l] = _o(o));
    }
    const c = (o, l) => ut.forEach(o, (f, d) => s(f, d, l));
    if (ut.isPlainObject(t) || t instanceof this.constructor)
      c(t, e);
    else if (ut.isString(t) && (t = t.trim()) && !Kg(t))
      c(Wg(t), e);
    else if (ut.isObject(t) && ut.isIterable(t)) {
      let o = {}, l, f;
      for (const d of t) {
        if (!ut.isArray(d))
          throw TypeError("Object iterator must return a key-value pair");
        o[f = d[0]] = (l = o[f]) ? ut.isArray(l) ? [...l, d[1]] : [l, d[1]] : d[1];
      }
      c(o, e);
    } else
      t != null && s(e, t, n);
    return this;
  }
  get(t, e) {
    if (t = ta(t), t) {
      const n = ut.findKey(this, t);
      if (n) {
        const i = this[n];
        if (!e)
          return i;
        if (e === !0)
          return Yg(i);
        if (ut.isFunction(e))
          return e.call(this, i, n);
        if (ut.isRegExp(e))
          return e.exec(i);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, e) {
    if (t = ta(t), t) {
      const n = ut.findKey(this, t);
      return !!(n && this[n] !== void 0 && (!e || ou(this, this[n], n, e)));
    }
    return !1;
  }
  delete(t, e) {
    const n = this;
    let i = !1;
    function s(c) {
      if (c = ta(c), c) {
        const o = ut.findKey(n, c);
        o && (!e || ou(n, n[o], o, e)) && (delete n[o], i = !0);
      }
    }
    return ut.isArray(t) ? t.forEach(s) : s(t), i;
  }
  clear(t) {
    const e = Object.keys(this);
    let n = e.length, i = !1;
    for (; n--; ) {
      const s = e[n];
      (!t || ou(this, this[s], s, t, !0)) && (delete this[s], i = !0);
    }
    return i;
  }
  normalize(t) {
    const e = this, n = {};
    return ut.forEach(this, (i, s) => {
      const c = ut.findKey(n, s);
      if (c) {
        e[c] = _o(i), delete e[s];
        return;
      }
      const o = t ? Xg(s) : String(s).trim();
      o !== s && delete e[s], e[o] = _o(i), n[o] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const e = /* @__PURE__ */ Object.create(null);
    return ut.forEach(this, (n, i) => {
      n != null && n !== !1 && (e[i] = t && ut.isArray(n) ? n.join(", ") : n);
    }), e;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, e]) => t + ": " + e).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...e) {
    const n = new this(t);
    return e.forEach((i) => n.set(i)), n;
  }
  static accessor(t) {
    const n = (this[Lh] = this[Lh] = {
      accessors: {}
    }).accessors, i = this.prototype;
    function s(c) {
      const o = ta(c);
      n[o] || ($g(i, c), n[o] = !0);
    }
    return ut.isArray(t) ? t.forEach(s) : s(t), this;
  }
};
Fr.accessor([
  "Content-Type",
  "Content-Length",
  "Accept",
  "Accept-Encoding",
  "User-Agent",
  "Authorization"
]);
ut.reduceDescriptors(Fr.prototype, ({ value: r }, t) => {
  let e = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => r,
    set(n) {
      this[e] = n;
    }
  };
});
ut.freezeMethods(Fr);
function cu(r, t) {
  const e = this || pa, n = t || e, i = Fr.from(n.headers);
  let s = n.data;
  return ut.forEach(r, function(o) {
    s = o.call(e, s, i.normalize(), t ? t.status : void 0);
  }), i.normalize(), s;
}
function td(r) {
  return !!(r && r.__CANCEL__);
}
let ga = class extends Jt {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(t, e, n) {
    super(t ?? "canceled", Jt.ERR_CANCELED, e, n), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
};
function ed(r, t, e) {
  const n = e.config.validateStatus;
  !e.status || !n || n(e.status) ? r(e) : t(
    new Jt(
      "Request failed with status code " + e.status,
      [Jt.ERR_BAD_REQUEST, Jt.ERR_BAD_RESPONSE][Math.floor(e.status / 100) - 4],
      e.config,
      e.request,
      e
    )
  );
}
function Zg(r) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(r);
  return t && t[1] || "";
}
function Qg(r, t) {
  r = r || 10;
  const e = new Array(r), n = new Array(r);
  let i = 0, s = 0, c;
  return t = t !== void 0 ? t : 1e3, function(l) {
    const f = Date.now(), d = n[s];
    c || (c = f), e[i] = l, n[i] = f;
    let b = s, _ = 0;
    for (; b !== i; )
      _ += e[b++], b = b % r;
    if (i = (i + 1) % r, i === s && (s = (s + 1) % r), f - c < t)
      return;
    const g = d && f - d;
    return g ? Math.round(_ * 1e3 / g) : void 0;
  };
}
function tm(r, t) {
  let e = 0, n = 1e3 / t, i, s;
  const c = (f, d = Date.now()) => {
    e = d, i = null, s && (clearTimeout(s), s = null), r(...f);
  };
  return [(...f) => {
    const d = Date.now(), b = d - e;
    b >= n ? c(f, d) : (i = f, s || (s = setTimeout(() => {
      s = null, c(i);
    }, n - b)));
  }, () => i && c(i)];
}
const Eo = (r, t, e = 3) => {
  let n = 0;
  const i = Qg(50, 250);
  return tm((s) => {
    const c = s.loaded, o = s.lengthComputable ? s.total : void 0, l = c - n, f = i(l), d = c <= o;
    n = c;
    const b = {
      loaded: c,
      total: o,
      progress: o ? c / o : void 0,
      bytes: l,
      rate: f || void 0,
      estimated: f && o && d ? (o - c) / f : void 0,
      event: s,
      lengthComputable: o != null,
      [t ? "download" : "upload"]: !0
    };
    r(b);
  }, e);
}, Sh = (r, t) => {
  const e = r != null;
  return [
    (n) => t[0]({
      lengthComputable: e,
      total: r,
      loaded: n
    }),
    t[1]
  ];
}, kh = (r) => (...t) => ut.asap(() => r(...t)), em = xr.hasStandardBrowserEnv ? /* @__PURE__ */ ((r, t) => (e) => (e = new URL(e, xr.origin), r.protocol === e.protocol && r.host === e.host && (t || r.port === e.port)))(
  new URL(xr.origin),
  xr.navigator && /(msie|trident)/i.test(xr.navigator.userAgent)
) : () => !0, rm = xr.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(r, t, e, n, i, s, c) {
      if (typeof document > "u") return;
      const o = [`${r}=${encodeURIComponent(t)}`];
      ut.isNumber(e) && o.push(`expires=${new Date(e).toUTCString()}`), ut.isString(n) && o.push(`path=${n}`), ut.isString(i) && o.push(`domain=${i}`), s === !0 && o.push("secure"), ut.isString(c) && o.push(`SameSite=${c}`), document.cookie = o.join("; ");
    },
    read(r) {
      if (typeof document > "u") return null;
      const t = document.cookie.match(new RegExp("(?:^|; )" + r + "=([^;]*)"));
      return t ? decodeURIComponent(t[1]) : null;
    },
    remove(r) {
      this.write(r, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function nm(r) {
  return typeof r != "string" ? !1 : /^([a-z][a-z\d+\-.]*:)?\/\//i.test(r);
}
function im(r, t) {
  return t ? r.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : r;
}
function rd(r, t, e) {
  let n = !nm(t);
  return r && (n || e == !1) ? im(r, t) : t;
}
const Eh = (r) => r instanceof Fr ? { ...r } : r;
function Wi(r, t) {
  t = t || {};
  const e = {};
  function n(f, d, b, _) {
    return ut.isPlainObject(f) && ut.isPlainObject(d) ? ut.merge.call({ caseless: _ }, f, d) : ut.isPlainObject(d) ? ut.merge({}, d) : ut.isArray(d) ? d.slice() : d;
  }
  function i(f, d, b, _) {
    if (ut.isUndefined(d)) {
      if (!ut.isUndefined(f))
        return n(void 0, f, b, _);
    } else return n(f, d, b, _);
  }
  function s(f, d) {
    if (!ut.isUndefined(d))
      return n(void 0, d);
  }
  function c(f, d) {
    if (ut.isUndefined(d)) {
      if (!ut.isUndefined(f))
        return n(void 0, f);
    } else return n(void 0, d);
  }
  function o(f, d, b) {
    if (b in t)
      return n(f, d);
    if (b in r)
      return n(void 0, f);
  }
  const l = {
    url: s,
    method: s,
    data: s,
    baseURL: c,
    transformRequest: c,
    transformResponse: c,
    paramsSerializer: c,
    timeout: c,
    timeoutMessage: c,
    withCredentials: c,
    withXSRFToken: c,
    adapter: c,
    responseType: c,
    xsrfCookieName: c,
    xsrfHeaderName: c,
    onUploadProgress: c,
    onDownloadProgress: c,
    decompress: c,
    maxContentLength: c,
    maxBodyLength: c,
    beforeRedirect: c,
    transport: c,
    httpAgent: c,
    httpsAgent: c,
    cancelToken: c,
    socketPath: c,
    responseEncoding: c,
    validateStatus: o,
    headers: (f, d, b) => i(Eh(f), Eh(d), b, !0)
  };
  return ut.forEach(Object.keys({ ...r, ...t }), function(d) {
    if (d === "__proto__" || d === "constructor" || d === "prototype") return;
    const b = ut.hasOwnProp(l, d) ? l[d] : i, _ = b(r[d], t[d], d);
    ut.isUndefined(_) && b !== o || (e[d] = _);
  }), e;
}
const nd = (r) => {
  const t = Wi({}, r);
  let { data: e, withXSRFToken: n, xsrfHeaderName: i, xsrfCookieName: s, headers: c, auth: o } = t;
  if (t.headers = c = Fr.from(c), t.url = $1(
    rd(t.baseURL, t.url, t.allowAbsoluteUrls),
    r.params,
    r.paramsSerializer
  ), o && c.set(
    "Authorization",
    "Basic " + btoa(
      (o.username || "") + ":" + (o.password ? unescape(encodeURIComponent(o.password)) : "")
    )
  ), ut.isFormData(e)) {
    if (xr.hasStandardBrowserEnv || xr.hasStandardBrowserWebWorkerEnv)
      c.setContentType(void 0);
    else if (ut.isFunction(e.getHeaders)) {
      const l = e.getHeaders(), f = ["content-type", "content-length"];
      Object.entries(l).forEach(([d, b]) => {
        f.includes(d.toLowerCase()) && c.set(d, b);
      });
    }
  }
  if (xr.hasStandardBrowserEnv && (n && ut.isFunction(n) && (n = n(t)), n || n !== !1 && em(t.url))) {
    const l = i && s && rm.read(s);
    l && c.set(i, l);
  }
  return t;
}, sm = typeof XMLHttpRequest < "u", am = sm && function(r) {
  return new Promise(function(e, n) {
    const i = nd(r);
    let s = i.data;
    const c = Fr.from(i.headers).normalize();
    let { responseType: o, onUploadProgress: l, onDownloadProgress: f } = i, d, b, _, g, y;
    function x() {
      g && g(), y && y(), i.cancelToken && i.cancelToken.unsubscribe(d), i.signal && i.signal.removeEventListener("abort", d);
    }
    let E = new XMLHttpRequest();
    E.open(i.method.toUpperCase(), i.url, !0), E.timeout = i.timeout;
    function N() {
      if (!E)
        return;
      const q = Fr.from(
        "getAllResponseHeaders" in E && E.getAllResponseHeaders()
      ), et = {
        data: !o || o === "text" || o === "json" ? E.responseText : E.response,
        status: E.status,
        statusText: E.statusText,
        headers: q,
        config: r,
        request: E
      };
      ed(
        function(X) {
          e(X), x();
        },
        function(X) {
          n(X), x();
        },
        et
      ), E = null;
    }
    "onloadend" in E ? E.onloadend = N : E.onreadystatechange = function() {
      !E || E.readyState !== 4 || E.status === 0 && !(E.responseURL && E.responseURL.indexOf("file:") === 0) || setTimeout(N);
    }, E.onabort = function() {
      E && (n(new Jt("Request aborted", Jt.ECONNABORTED, r, E)), E = null);
    }, E.onerror = function(F) {
      const et = F && F.message ? F.message : "Network Error", Q = new Jt(et, Jt.ERR_NETWORK, r, E);
      Q.event = F || null, n(Q), E = null;
    }, E.ontimeout = function() {
      let F = i.timeout ? "timeout of " + i.timeout + "ms exceeded" : "timeout exceeded";
      const et = i.transitional || ju;
      i.timeoutErrorMessage && (F = i.timeoutErrorMessage), n(
        new Jt(
          F,
          et.clarifyTimeoutError ? Jt.ETIMEDOUT : Jt.ECONNABORTED,
          r,
          E
        )
      ), E = null;
    }, s === void 0 && c.setContentType(null), "setRequestHeader" in E && ut.forEach(c.toJSON(), function(F, et) {
      E.setRequestHeader(et, F);
    }), ut.isUndefined(i.withCredentials) || (E.withCredentials = !!i.withCredentials), o && o !== "json" && (E.responseType = i.responseType), f && ([_, y] = Eo(f, !0), E.addEventListener("progress", _)), l && E.upload && ([b, g] = Eo(l), E.upload.addEventListener("progress", b), E.upload.addEventListener("loadend", g)), (i.cancelToken || i.signal) && (d = (q) => {
      E && (n(!q || q.type ? new ga(null, r, E) : q), E.abort(), E = null);
    }, i.cancelToken && i.cancelToken.subscribe(d), i.signal && (i.signal.aborted ? d() : i.signal.addEventListener("abort", d)));
    const H = Zg(i.url);
    if (H && xr.protocols.indexOf(H) === -1) {
      n(
        new Jt(
          "Unsupported protocol " + H + ":",
          Jt.ERR_BAD_REQUEST,
          r
        )
      );
      return;
    }
    E.send(s || null);
  });
}, om = (r, t) => {
  const { length: e } = r = r ? r.filter(Boolean) : [];
  if (t || e) {
    let n = new AbortController(), i;
    const s = function(f) {
      if (!i) {
        i = !0, o();
        const d = f instanceof Error ? f : this.reason;
        n.abort(
          d instanceof Jt ? d : new ga(d instanceof Error ? d.message : d)
        );
      }
    };
    let c = t && setTimeout(() => {
      c = null, s(new Jt(`timeout of ${t}ms exceeded`, Jt.ETIMEDOUT));
    }, t);
    const o = () => {
      r && (c && clearTimeout(c), c = null, r.forEach((f) => {
        f.unsubscribe ? f.unsubscribe(s) : f.removeEventListener("abort", s);
      }), r = null);
    };
    r.forEach((f) => f.addEventListener("abort", s));
    const { signal: l } = n;
    return l.unsubscribe = () => ut.asap(o), l;
  }
}, cm = function* (r, t) {
  let e = r.byteLength;
  if (e < t) {
    yield r;
    return;
  }
  let n = 0, i;
  for (; n < e; )
    i = n + t, yield r.slice(n, i), n = i;
}, um = async function* (r, t) {
  for await (const e of lm(r))
    yield* cm(e, t);
}, lm = async function* (r) {
  if (r[Symbol.asyncIterator]) {
    yield* r;
    return;
  }
  const t = r.getReader();
  try {
    for (; ; ) {
      const { done: e, value: n } = await t.read();
      if (e)
        break;
      yield n;
    }
  } finally {
    await t.cancel();
  }
}, Ph = (r, t, e, n) => {
  const i = um(r, t);
  let s = 0, c, o = (l) => {
    c || (c = !0, n && n(l));
  };
  return new ReadableStream(
    {
      async pull(l) {
        try {
          const { done: f, value: d } = await i.next();
          if (f) {
            o(), l.close();
            return;
          }
          let b = d.byteLength;
          if (e) {
            let _ = s += b;
            e(_);
          }
          l.enqueue(new Uint8Array(d));
        } catch (f) {
          throw o(f), f;
        }
      },
      cancel(l) {
        return o(l), i.return();
      }
    },
    {
      highWaterMark: 2
    }
  );
}, Ch = 64 * 1024, { isFunction: co } = ut, fm = (({ Request: r, Response: t }) => ({
  Request: r,
  Response: t
}))(ut.global), { ReadableStream: Rh, TextEncoder: Ih } = ut.global, Fh = (r, ...t) => {
  try {
    return !!r(...t);
  } catch {
    return !1;
  }
}, hm = (r) => {
  r = ut.merge.call(
    {
      skipUndefined: !0
    },
    fm,
    r
  );
  const { fetch: t, Request: e, Response: n } = r, i = t ? co(t) : typeof fetch == "function", s = co(e), c = co(n);
  if (!i)
    return !1;
  const o = i && co(Rh), l = i && (typeof Ih == "function" ? /* @__PURE__ */ ((y) => (x) => y.encode(x))(new Ih()) : async (y) => new Uint8Array(await new e(y).arrayBuffer())), f = s && o && Fh(() => {
    let y = !1;
    const x = new Rh(), E = new e(xr.origin, {
      body: x,
      method: "POST",
      get duplex() {
        return y = !0, "half";
      }
    }).headers.has("Content-Type");
    return x.cancel(), y && !E;
  }), d = c && o && Fh(() => ut.isReadableStream(new n("").body)), b = {
    stream: d && ((y) => y.body)
  };
  i && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((y) => {
    !b[y] && (b[y] = (x, E) => {
      let N = x && x[y];
      if (N)
        return N.call(x);
      throw new Jt(
        `Response type '${y}' is not supported`,
        Jt.ERR_NOT_SUPPORT,
        E
      );
    });
  });
  const _ = async (y) => {
    if (y == null)
      return 0;
    if (ut.isBlob(y))
      return y.size;
    if (ut.isSpecCompliantForm(y))
      return (await new e(xr.origin, {
        method: "POST",
        body: y
      }).arrayBuffer()).byteLength;
    if (ut.isArrayBufferView(y) || ut.isArrayBuffer(y))
      return y.byteLength;
    if (ut.isURLSearchParams(y) && (y = y + ""), ut.isString(y))
      return (await l(y)).byteLength;
  }, g = async (y, x) => {
    const E = ut.toFiniteNumber(y.getContentLength());
    return E ?? _(x);
  };
  return async (y) => {
    let {
      url: x,
      method: E,
      data: N,
      signal: H,
      cancelToken: q,
      timeout: F,
      onDownloadProgress: et,
      onUploadProgress: Q,
      responseType: X,
      headers: V,
      withCredentials: I = "same-origin",
      fetchOptions: G
    } = nd(y), A = t || fetch;
    X = X ? (X + "").toLowerCase() : "text";
    let C = om(
      [H, q && q.toAbortSignal()],
      F
    ), M = null;
    const D = C && C.unsubscribe && (() => {
      C.unsubscribe();
    });
    let at;
    try {
      if (Q && f && E !== "get" && E !== "head" && (at = await g(V, N)) !== 0) {
        let vt = new e(x, {
          method: "POST",
          body: N,
          duplex: "half"
        }), S;
        if (ut.isFormData(N) && (S = vt.headers.get("content-type")) && V.setContentType(S), vt.body) {
          const [j, z] = Sh(
            at,
            Eo(kh(Q))
          );
          N = Ph(vt.body, Ch, j, z);
        }
      }
      ut.isString(I) || (I = I ? "include" : "omit");
      const ot = s && "credentials" in e.prototype, ft = {
        ...G,
        signal: C,
        method: E.toUpperCase(),
        headers: V.normalize().toJSON(),
        body: N,
        duplex: "half",
        credentials: ot ? I : void 0
      };
      M = s && new e(x, ft);
      let rt = await (s ? A(M, G) : A(x, ft));
      const ht = d && (X === "stream" || X === "response");
      if (d && (et || ht && D)) {
        const vt = {};
        ["status", "statusText", "headers"].forEach((J) => {
          vt[J] = rt[J];
        });
        const S = ut.toFiniteNumber(rt.headers.get("content-length")), [j, z] = et && Sh(
          S,
          Eo(kh(et), !0)
        ) || [];
        rt = new n(
          Ph(rt.body, Ch, j, () => {
            z && z(), D && D();
          }),
          vt
        );
      }
      X = X || "text";
      let Lt = await b[ut.findKey(b, X) || "text"](
        rt,
        y
      );
      return !ht && D && D(), await new Promise((vt, S) => {
        ed(vt, S, {
          data: Lt,
          headers: Fr.from(rt.headers),
          status: rt.status,
          statusText: rt.statusText,
          config: y,
          request: M
        });
      });
    } catch (ot) {
      throw D && D(), ot && ot.name === "TypeError" && /Load failed|fetch/i.test(ot.message) ? Object.assign(
        new Jt(
          "Network Error",
          Jt.ERR_NETWORK,
          y,
          M,
          ot && ot.response
        ),
        {
          cause: ot.cause || ot
        }
      ) : Jt.from(ot, ot && ot.code, y, M, ot && ot.response);
    }
  };
}, dm = /* @__PURE__ */ new Map(), id = (r) => {
  let t = r && r.env || {};
  const { fetch: e, Request: n, Response: i } = t, s = [n, i, e];
  let c = s.length, o = c, l, f, d = dm;
  for (; o--; )
    l = s[o], f = d.get(l), f === void 0 && d.set(l, f = o ? /* @__PURE__ */ new Map() : hm(t)), d = f;
  return f;
};
id();
const Uu = {
  http: Eg,
  xhr: am,
  fetch: {
    get: id
  }
};
ut.forEach(Uu, (r, t) => {
  if (r) {
    try {
      Object.defineProperty(r, "name", { value: t });
    } catch {
    }
    Object.defineProperty(r, "adapterName", { value: t });
  }
});
const Oh = (r) => `- ${r}`, pm = (r) => ut.isFunction(r) || r === null || r === !1;
function gm(r, t) {
  r = ut.isArray(r) ? r : [r];
  const { length: e } = r;
  let n, i;
  const s = {};
  for (let c = 0; c < e; c++) {
    n = r[c];
    let o;
    if (i = n, !pm(n) && (i = Uu[(o = String(n)).toLowerCase()], i === void 0))
      throw new Jt(`Unknown adapter '${o}'`);
    if (i && (ut.isFunction(i) || (i = i.get(t))))
      break;
    s[o || "#" + c] = i;
  }
  if (!i) {
    const c = Object.entries(s).map(
      ([l, f]) => `adapter ${l} ` + (f === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let o = e ? c.length > 1 ? `since :
` + c.map(Oh).join(`
`) : " " + Oh(c[0]) : "as no adapter specified";
    throw new Jt(
      "There is no suitable adapter to dispatch the request " + o,
      "ERR_NOT_SUPPORT"
    );
  }
  return i;
}
const sd = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: gm,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: Uu
};
function uu(r) {
  if (r.cancelToken && r.cancelToken.throwIfRequested(), r.signal && r.signal.aborted)
    throw new ga(null, r);
}
function Bh(r) {
  return uu(r), r.headers = Fr.from(r.headers), r.data = cu.call(r, r.transformRequest), ["post", "put", "patch"].indexOf(r.method) !== -1 && r.headers.setContentType("application/x-www-form-urlencoded", !1), sd.getAdapter(r.adapter || pa.adapter, r)(r).then(
    function(n) {
      return uu(r), n.data = cu.call(r, r.transformResponse, n), n.headers = Fr.from(n.headers), n;
    },
    function(n) {
      return td(n) || (uu(r), n && n.response && (n.response.data = cu.call(
        r,
        r.transformResponse,
        n.response
      ), n.response.headers = Fr.from(n.response.headers))), Promise.reject(n);
    }
  );
}
const ad = "1.15.0", Bo = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((r, t) => {
  Bo[r] = function(n) {
    return typeof n === r || "a" + (t < 1 ? "n " : " ") + r;
  };
});
const Th = {};
Bo.transitional = function(t, e, n) {
  function i(s, c) {
    return "[Axios v" + ad + "] Transitional option '" + s + "'" + c + (n ? ". " + n : "");
  }
  return (s, c, o) => {
    if (t === !1)
      throw new Jt(
        i(c, " has been removed" + (e ? " in " + e : "")),
        Jt.ERR_DEPRECATED
      );
    return e && !Th[c] && (Th[c] = !0, console.warn(
      i(
        c,
        " has been deprecated since v" + e + " and will be removed in the near future"
      )
    )), t ? t(s, c, o) : !0;
  };
};
Bo.spelling = function(t) {
  return (e, n) => (console.warn(`${n} is likely a misspelling of ${t}`), !0);
};
function mm(r, t, e) {
  if (typeof r != "object")
    throw new Jt("options must be an object", Jt.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(r);
  let i = n.length;
  for (; i-- > 0; ) {
    const s = n[i], c = t[s];
    if (c) {
      const o = r[s], l = o === void 0 || c(o, s, r);
      if (l !== !0)
        throw new Jt(
          "option " + s + " must be " + l,
          Jt.ERR_BAD_OPTION_VALUE
        );
      continue;
    }
    if (e !== !0)
      throw new Jt("Unknown option " + s, Jt.ERR_BAD_OPTION);
  }
}
const Ao = {
  assertOptions: mm,
  validators: Bo
}, tn = Ao.validators;
let zi = class {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = {
      request: new Nh(),
      response: new Nh()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, e) {
    try {
      return await this._request(t, e);
    } catch (n) {
      if (n instanceof Error) {
        let i = {};
        Error.captureStackTrace ? Error.captureStackTrace(i) : i = new Error();
        const s = (() => {
          if (!i.stack)
            return "";
          const c = i.stack.indexOf(`
`);
          return c === -1 ? "" : i.stack.slice(c + 1);
        })();
        try {
          if (!n.stack)
            n.stack = s;
          else if (s) {
            const c = s.indexOf(`
`), o = c === -1 ? -1 : s.indexOf(`
`, c + 1), l = o === -1 ? "" : s.slice(o + 1);
            String(n.stack).endsWith(l) || (n.stack += `
` + s);
          }
        } catch {
        }
      }
      throw n;
    }
  }
  _request(t, e) {
    typeof t == "string" ? (e = e || {}, e.url = t) : e = t || {}, e = Wi(this.defaults, e);
    const { transitional: n, paramsSerializer: i, headers: s } = e;
    n !== void 0 && Ao.assertOptions(
      n,
      {
        silentJSONParsing: tn.transitional(tn.boolean),
        forcedJSONParsing: tn.transitional(tn.boolean),
        clarifyTimeoutError: tn.transitional(tn.boolean),
        legacyInterceptorReqResOrdering: tn.transitional(tn.boolean)
      },
      !1
    ), i != null && (ut.isFunction(i) ? e.paramsSerializer = {
      serialize: i
    } : Ao.assertOptions(
      i,
      {
        encode: tn.function,
        serialize: tn.function
      },
      !0
    )), e.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? e.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : e.allowAbsoluteUrls = !0), Ao.assertOptions(
      e,
      {
        baseUrl: tn.spelling("baseURL"),
        withXsrfToken: tn.spelling("withXSRFToken")
      },
      !0
    ), e.method = (e.method || this.defaults.method || "get").toLowerCase();
    let c = s && ut.merge(s.common, s[e.method]);
    s && ut.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (y) => {
      delete s[y];
    }), e.headers = Fr.concat(c, s);
    const o = [];
    let l = !0;
    this.interceptors.request.forEach(function(x) {
      if (typeof x.runWhen == "function" && x.runWhen(e) === !1)
        return;
      l = l && x.synchronous;
      const E = e.transitional || ju;
      E && E.legacyInterceptorReqResOrdering ? o.unshift(x.fulfilled, x.rejected) : o.push(x.fulfilled, x.rejected);
    });
    const f = [];
    this.interceptors.response.forEach(function(x) {
      f.push(x.fulfilled, x.rejected);
    });
    let d, b = 0, _;
    if (!l) {
      const y = [Bh.bind(this), void 0];
      for (y.unshift(...o), y.push(...f), _ = y.length, d = Promise.resolve(e); b < _; )
        d = d.then(y[b++], y[b++]);
      return d;
    }
    _ = o.length;
    let g = e;
    for (; b < _; ) {
      const y = o[b++], x = o[b++];
      try {
        g = y(g);
      } catch (E) {
        x.call(this, E);
        break;
      }
    }
    try {
      d = Bh.call(this, g);
    } catch (y) {
      return Promise.reject(y);
    }
    for (b = 0, _ = f.length; b < _; )
      d = d.then(f[b++], f[b++]);
    return d;
  }
  getUri(t) {
    t = Wi(this.defaults, t);
    const e = rd(t.baseURL, t.url, t.allowAbsoluteUrls);
    return $1(e, t.params, t.paramsSerializer);
  }
};
ut.forEach(["delete", "get", "head", "options"], function(t) {
  zi.prototype[t] = function(e, n) {
    return this.request(
      Wi(n || {}, {
        method: t,
        url: e,
        data: (n || {}).data
      })
    );
  };
});
ut.forEach(["post", "put", "patch"], function(t) {
  function e(n) {
    return function(s, c, o) {
      return this.request(
        Wi(o || {}, {
          method: t,
          headers: n ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: s,
          data: c
        })
      );
    };
  }
  zi.prototype[t] = e(), zi.prototype[t + "Form"] = e(!0);
});
let bm = class od {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let e;
    this.promise = new Promise(function(s) {
      e = s;
    });
    const n = this;
    this.promise.then((i) => {
      if (!n._listeners) return;
      let s = n._listeners.length;
      for (; s-- > 0; )
        n._listeners[s](i);
      n._listeners = null;
    }), this.promise.then = (i) => {
      let s;
      const c = new Promise((o) => {
        n.subscribe(o), s = o;
      }).then(i);
      return c.cancel = function() {
        n.unsubscribe(s);
      }, c;
    }, t(function(s, c, o) {
      n.reason || (n.reason = new ga(s, c, o), e(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const e = this._listeners.indexOf(t);
    e !== -1 && this._listeners.splice(e, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), e = (n) => {
      t.abort(n);
    };
    return this.subscribe(e), t.signal.unsubscribe = () => this.unsubscribe(e), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new od(function(i) {
        t = i;
      }),
      cancel: t
    };
  }
};
function wm(r) {
  return function(e) {
    return r.apply(null, e);
  };
}
function vm(r) {
  return ut.isObject(r) && r.isAxiosError === !0;
}
const Pu = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(Pu).forEach(([r, t]) => {
  Pu[t] = r;
});
function cd(r) {
  const t = new zi(r), e = q1(zi.prototype.request, t);
  return ut.extend(e, zi.prototype, t, { allOwnKeys: !0 }), ut.extend(e, t, null, { allOwnKeys: !0 }), e.create = function(i) {
    return cd(Wi(r, i));
  }, e;
}
const $e = cd(pa);
$e.Axios = zi;
$e.CanceledError = ga;
$e.CancelToken = bm;
$e.isCancel = td;
$e.VERSION = ad;
$e.toFormData = Oo;
$e.AxiosError = Jt;
$e.Cancel = $e.CanceledError;
$e.all = function(t) {
  return Promise.all(t);
};
$e.spread = wm;
$e.isAxiosError = vm;
$e.mergeConfig = Wi;
$e.AxiosHeaders = Fr;
$e.formToJSON = (r) => Z1(ut.isHTMLForm(r) ? new FormData(r) : r);
$e.getAdapter = sd.getAdapter;
$e.HttpStatusCode = Pu;
$e.default = $e;
const {
  Axios: Bm,
  AxiosError: Tm,
  CanceledError: Mm,
  isCancel: Dm,
  CancelToken: jm,
  VERSION: qm,
  all: Um,
  Cancel: zm,
  isAxiosError: Hm,
  spread: Vm,
  toFormData: Wm,
  AxiosHeaders: Gm,
  HttpStatusCode: Jm,
  formToJSON: Ym,
  getAdapter: Km,
  mergeConfig: Xm
} = $e, ym = 3, uo = {
  color: {
    dark: "#000"
  },
  width: 2048,
  margin: 0
};
class $m {
  config;
  svgCache;
  constructor(t) {
    this.config = t, this.svgCache = /* @__PURE__ */ new Map();
  }
  generateContainerId(t) {
    return `posa-svg-container-${t}`;
  }
  generateSVGId(t) {
    return `posa-svg-${t}`;
  }
  async fetchSVGData(t) {
    const e = kl(t, this.config), n = this.getFromCache(e);
    if (n)
      return this.log("SVGRenderer", "cache hit", e), n;
    try {
      const i = await this.fetchSVG(t, this.config), s = this.parseSVGFromS3(i.svg);
      return this.addToCache(e, s, !1), this.log("SVGRenderer", "cache miss", e), {
        svg: s,
        error: !1
      };
    } catch (i) {
      if (console.error(i), i.response && i.response.status && i.response.status === 404) {
        const c = {
          svg: null,
          error: !1
        };
        return this.addToCache(e, c.svg, c.error), c;
      }
      const s = {
        svg: null,
        error: !0
      };
      return this.addToCache(e, s.svg, s.error), s;
    }
  }
  getQRCodeOptions(t) {
    return {
      ...uo,
      color: {
        dark: this.getQRCodeDarkColor(t),
        light: t.posa?.flags?.qrCodeNoBg ? "#0000" : "#FFF"
      }
    };
  }
  getQRCodeDarkColor(t) {
    const e = t.posa?.flags;
    return e?.useBackgroundForQrCode ? t.colors?.background || uo.color.dark : e?.qrCodeNoBg ? t.colors?.accent ?? uo.color.dark : t.qrCodeColor || uo.color.dark;
  }
  async createDefaultQRCodeURL(t, e) {
    if (t && e.posa) {
      const n = d2({
        jetpackFrontEndURL: this.config.jetpackFrontEndURL,
        configID: t,
        place: na.PLV,
        posa: e.posa
      });
      return vh.toDataURL(n, this.getQRCodeOptions(e));
    }
    return vh.toDataURL(
      this.config.defaultUrlForQRCode,
      this.getQRCodeOptions(e)
    );
  }
  getLogoSrc(t) {
    return t ? `${this.config.s3BucketUrl}/jetpack/logos/${t}` : this.config.imagePlaceholderUrl;
  }
  async renderSVG(t) {
    const e = await this.fetchSVGData(t);
    if (!e || e.error || !e.svg)
      return null;
    const n = this.generateSVGId(t.posa._id), i = this.generateContainerId(t.posa._id), s = e.svg, l = new DOMParser().parseFromString(s, "image/svg+xml").getElementsByTagName("svg");
    if (!l.length)
      return null;
    const f = l[0];
    return f.setAttribute("width", "100%"), f.setAttribute("height", "auto"), f.setAttribute("preserveAspectRatio", "xMidYMid meet"), f.setAttribute("background-color", "0"), f.id = n, t.posa.isCustom && c2(
      t.posa,
      t.colors || Jd,
      f,
      this.config.log
    ), await this.renderLogoAndQRCode(t, f), {
      svgElement: f,
      svgId: n,
      containerId: i
    };
  }
  async renderLogoAndQRCode(t, e) {
    const {
      configId: n,
      qrCodeURL: i,
      logoZoom: s = 1,
      pegLogoX: c = !1,
      getLogoBase64ForWidthAndHeight: o
    } = t, l = i || await this.createDefaultQRCodeURL(n, t);
    s2(t, l, e), this.log("renderLogoAndQRCode", "logoSource", "function"), await r2(
      o,
      e,
      s,
      c
    );
  }
  async renderSVGToContainer(t, e) {
    const n = await this.renderSVG(e);
    if (!n)
      return null;
    const i = document.getElementById(t);
    return i && (i.innerHTML = "", i.appendChild(n.svgElement)), n;
  }
  getFromCache(t) {
    const e = this.svgCache.get(t);
    return e ? (e.timestamp = Date.now(), this.svgCache.delete(t), this.svgCache.set(t, e), { svg: e.svg, error: e.error }) : null;
  }
  log(...t) {
    this.config.log && console.log(t);
  }
  addToCache(t, e, n) {
    if (this.svgCache.size >= ym) {
      this.log("SVGRenderer", "cache clean");
      const i = this.svgCache.keys().next().value;
      i && this.svgCache.delete(i);
    }
    this.log("SVGRenderer", "addToCache", t), this.svgCache.set(t, {
      svg: e,
      error: n,
      timestamp: Date.now()
    });
  }
  async fetchSVG(t, e) {
    const n = kl(t, e);
    return {
      svg: (await $e(n, {
        headers: {
          "Content-Type": "text/plain"
        }
      })).data
    };
  }
  parseSVGFromS3(t) {
    if (!t)
      return "";
    t = t.replace(/<\?xml[^>]*\?>\s*/, ""), t = t.replace(/<!--[\s\S]*?-->/g, "");
    const e = t.match(/<svg[\s\S]*<\/svg>/);
    if (e == null)
      throw new Error("No SVG element found");
    let n = e[0];
    return n = n.replace(/\s*sodipodi:docname="[^"]*"/, ""), n = n.replace(/\n/g, " ").replace(/\s+/g, " ").replace(/>\s+</g, "><").replace(/\s+>/g, ">").replace(/<\s+/g, "<").trim(), n;
  }
}
export {
  t2 as A,
  o2 as B,
  Qd as C,
  Ar as D,
  kl as E,
  qh as F,
  Cm as G,
  ko as H,
  Pm as I,
  km as J,
  mp as K,
  Yd as L,
  $m as M,
  ao as R,
  Kd as S,
  Em as Z,
  xe as _,
  Jd as a,
  Am as b,
  Rm as c,
  Xd as d,
  Dh as e,
  jh as f,
  bp as g,
  na as h,
  Mh as i,
  r2 as j,
  s2 as k,
  a2 as l,
  i2 as m,
  Sl as n,
  c2 as o,
  xm as p,
  $d as q,
  n2 as r,
  Zd as s,
  e2 as t,
  h2 as u,
  Cu as v,
  d2 as w,
  Nm as x,
  Lm as y,
  Sm as z
};
